/**
 * opora-calc-core.js — Manifest-driven calculator shell (D4 UI).
 */
(function (global) {
  'use strict';

  var registry = {};
  var S = function () { return global.OporaCalcShared; };
  var CHIP_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>';

  function register(slug, def) { registry[slug] = def; }
  function get(slug) { return registry[slug]; }

  function parsePrefill() {
    var q = new URLSearchParams(global.location.search);
    var out = {};
    var raw = q.get('prefill');
    if (raw) {
      try { out = JSON.parse(decodeURIComponent(raw)) || {}; } catch (e) { out = {}; }
    }
    // Alias query params (Bid Generator → Stress-Test deep-link)
    var aliases = {
      monthlyRev: 'bid_total',
      laborPct: 'labor_pct',
      suppliesPct: 'supply_pct',
      overheadPct: 'overhead_pct',
      targetMargin: 'target_margin',
      state: 'state',
      bid_total: 'bid_total',
      labor_pct: 'labor_pct',
      supply_pct: 'supply_pct',
      overhead_pct: 'overhead_pct',
      target_margin: 'target_margin',
      // Per-Clean → Bill Rate deep-link
      baseWage: 'base_wage',
      loadedWage: 'loaded_wage',
      billRate: 'bill_rate',
      margin: 'target_margin',
      overhead: 'overhead_pct',
      base_wage: 'base_wage',
      loaded_wage: 'loaded_wage',
      bill_rate: 'bill_rate'
    };
    Object.keys(aliases).forEach(function (key) {
      if (!q.has(key)) return;
      var dest = aliases[key];
      if (out[dest] == null || out[dest] === '') out[dest] = q.get(key);
    });
    return out;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  var SIGNIN_URL = 'https://dashboard.oporasupply.com/';

  function isSignedIn() {
    if (global.OporaAccount && typeof global.OporaAccount.isSignedIn === 'function') {
      return global.OporaAccount.isSignedIn();
    }
    if (global.Clerk && global.Clerk.session) return true;
    if (global.__OPORA_SESSION__ && global.__OPORA_SESSION__.authed) return true;
    return false;
  }

  function requireSignedIn(reason) {
    if (isSignedIn()) return true;
    if (global.OporaAuth && typeof global.OporaAuth.openModal === 'function') {
      global.OporaAuth.openModal();
      return false;
    }
    if (global.Clerk && typeof global.Clerk.openSignIn === 'function') {
      global.Clerk.openSignIn();
      return false;
    }
    global.location.href = SIGNIN_URL;
    return false;
  }

  function captureRowHtml(/* slug */) {
    /* Flat export strip + fixed email modal (never expands the result card). */
    var icoPdf = '<svg class="calc-d4-capture-btn__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>';
    var icoSave = '<svg class="calc-d4-capture-btn__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>';
    var icoMail = '<svg class="calc-d4-capture-btn__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>';
    return (
      '<div class="calc-d4-capture calc-d4-capture--actions" data-calc-capture hidden>' +
        '<div class="calc-d4-capture-actions calc-d4-capture-actions--segmented" role="group" aria-label="Export utilities">' +
          '<button type="button" class="calc-d4-capture-btn" data-calc-pdf>' + icoPdf + '<span>Download PDF</span></button>' +
          '<button type="button" class="calc-d4-capture-btn" data-save>' + icoSave + '<span data-save-label>Save to Library</span></button>' +
          '<button type="button" class="calc-d4-capture-btn" data-calc-email-toggle aria-expanded="false" aria-haspopup="dialog">' + icoMail + '<span>Email Copy</span></button>' +
        '</div>' +
        '<div class="calc-d4-email-modal" data-calc-email-panel hidden>' +
          '<button type="button" class="calc-d4-email-modal__backdrop" data-calc-email-close aria-label="Close email dialog"></button>' +
          '<div class="calc-d4-email-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="calc-email-modal-title">' +
            '<form class="calc-d4-capture-form calc-d4-capture-form--modal" data-email-form>' +
              '<p class="calc-d4-capture-email-label" id="calc-email-modal-title">Email the PDF report</p>' +
              '<div class="calc-d4-capture-email-row">' +
                '<input type="email" required autocomplete="email" placeholder="karen.d@example.net" aria-label="Email" data-email-input />' +
              '</div>' +
              '<div class="calc-d4-email-modal__actions">' +
                '<button type="button" class="calc-d4-capture-email-cancel" data-calc-email-close>Cancel</button>' +
                '<button type="submit">Send</button>' +
              '</div>' +
            '</form>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function syncExportAuthUI(root) {
    var saveBtn = root.querySelector('[data-save]');
    if (!saveBtn) return;
    var label = saveBtn.querySelector('[data-save-label]');
    if (isSignedIn()) {
      saveBtn.classList.remove('calc-d4-export-btn--locked');
      if (label) label.textContent = 'Save to Library';
      else if (!saveBtn.querySelector('.calc-d4-capture-btn__icon')) saveBtn.textContent = 'Save to Library';
      saveBtn.removeAttribute('title');
    } else {
      // Invitation only — no padlock. Click opens Clerk.
      saveBtn.classList.remove('calc-d4-export-btn--locked');
      if (label) label.textContent = 'Save to Library';
      else if (!saveBtn.querySelector('.calc-d4-capture-btn__icon')) saveBtn.textContent = 'Save to Library';
      saveBtn.setAttribute('title', 'Free account to keep this run');
    }
  }

  function ensureCaptureUi(root, formCard, panel, slug) {
    if (!root) return null;
    var resultPanel = panel || root.querySelector('[data-calc-result]');
    var existing = root.querySelector('[data-calc-capture]');
    if (existing) {
      /* Upgrade legacy / inline-email SSR → flat strip + modal. */
      if (
        !existing.classList.contains('calc-d4-capture--actions') ||
        !existing.querySelector('.calc-d4-capture-actions--segmented') ||
        !existing.querySelector('.calc-d4-capture-btn__icon') ||
        !existing.querySelector('.calc-d4-email-modal') ||
        existing.querySelector('.calc-d4-capture-email')
      ) {
        var wasHidden = existing.hasAttribute('hidden') || existing.hidden;
        existing.outerHTML = captureRowHtml(slug);
        existing = root.querySelector('[data-calc-capture]');
        if (existing) existing.hidden = wasHidden;
      }
      // World-class: email/Save after aha — migrate legacy form-column capture into result.
      if (existing && resultPanel && !existing.closest('[data-calc-result]')) {
        resultPanel.appendChild(existing);
      }
      return root.querySelector('[data-calc-capture]');
    }
    if (resultPanel) {
      var row = resultPanel.querySelector('.calc-d4-export-row');
      if (row) row.outerHTML = captureRowHtml(slug);
      else resultPanel.insertAdjacentHTML('beforeend', captureRowHtml(slug));
    } else {
      var anchor = formCard || root.querySelector('[data-calc-form]');
      if (anchor) {
        var ctaRow = anchor.querySelector('.d4-cta-row');
        if (ctaRow) ctaRow.insertAdjacentHTML('afterend', captureRowHtml(slug));
        else anchor.insertAdjacentHTML('beforeend', captureRowHtml(slug));
      }
    }
    return root.querySelector('[data-calc-capture]');
  }

  function stripCalcActionBars(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.opora-ab, .opora-ab-top, .opora-ab--top').forEach(function (el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
  }

  /* Two-column work grid stays static; Related Tools sits full-width under it. */
  function normalizeHandShell(root) {
    if (!root || !root.querySelector) return null;
    var shell = root.querySelector('.d4-hand-shell');
    if (!shell) return null;

    if (!shell.querySelector('.d4-hand-work')) {
      var panel0 = shell.querySelector('.d4-hand-panel');
      var out0 = shell.querySelector('.d4-hand-out');
      if (panel0 && out0) {
        var work0 = document.createElement('div');
        work0.className = 'd4-hand-work';
        panel0.parentNode.insertBefore(work0, panel0);
        work0.appendChild(panel0);
        work0.appendChild(out0);
      }
    }

    var panel = shell.querySelector('.d4-hand-panel');
    var work = shell.querySelector('.d4-hand-work');
    if (!panel || !work) return shell;

    var after = shell.querySelector('.d4-hand-after');
    if (!after) {
      var looseHandoffs = shell.querySelector('.d4-hand-handoffs, .calc-d4-handoffs');
      var looseRuns = shell.querySelector('.d4-hand-runs');
      if (looseHandoffs || looseRuns) {
        after = document.createElement('div');
        after.className = 'd4-hand-after';
        if (looseRuns) after.appendChild(looseRuns);
        if (looseHandoffs) {
          looseHandoffs.classList.add('d4-hand-handoffs', 'calc-d4-handoffs');
          after.appendChild(looseHandoffs);
        }
      }
    }

    // Pull related/runs out of either column into a full-width band under the work grid.
    if (work) {
      Array.prototype.slice.call(work.querySelectorAll('.d4-hand-after, .d4-hand-handoffs, .calc-d4-handoffs, .d4-hand-runs')).forEach(function (el) {
        if (el.classList.contains('d4-hand-after')) {
          after = el;
          return;
        }
        if (!after) {
          after = document.createElement('div');
          after.className = 'd4-hand-after';
        }
        if (!el.closest('.d4-hand-after')) after.appendChild(el);
      });
    }
    if (panel) {
      Array.prototype.slice.call(panel.children).forEach(function (el) {
        if (
          el.classList.contains('d4-hand-after') ||
          el.classList.contains('d4-hand-handoffs') ||
          el.classList.contains('calc-d4-handoffs') ||
          el.classList.contains('d4-hand-runs')
        ) {
          if (el.classList.contains('d4-hand-after')) after = el;
          else {
            if (!after) {
              after = document.createElement('div');
              after.className = 'd4-hand-after';
            }
            after.appendChild(el);
          }
        }
      });
    }

    if (after) {
      if (work.nextSibling !== after) {
        if (work.nextSibling) shell.insertBefore(after, work.nextSibling);
        else shell.appendChild(after);
      }
    }

    return shell;
  }

  function shortHandoffDesc(text, maxLen) {
    var s = String(text || '').replace(/\s+/g, ' ').trim();
    var max = maxLen || 96;
    if (!s || s.length <= max) return s;
    var cut = s.lastIndexOf(' ', max);
    if (cut < Math.floor(max * 0.55)) cut = max;
    return s.slice(0, cut).replace(/[.,;:\s]+$/g, '') + '…';
  }

  function afterBandHtml(handoffs) {
    var links = (handoffs || []).map(function (h) {
      var desc = shortHandoffDesc(h.description);
      return '<a class="calc-d4-handoff-link" href="' + esc(h.url) + '">' +
        '<span class="calc-d4-handoff-title">' + esc(h.label) + '</span>' +
        (desc ? '<span class="calc-d4-handoff-desc">' + esc(desc) + '</span>' : '') +
        '</a>';
    }).join('');
    return '<div class="d4-hand-after">' +
      '<p class="d4-hand-runs" data-calc-run-block hidden><span data-calc-run-count></span> total runs on this calculator</p>' +
      '<div class="calc-d4-handoffs d4-hand-handoffs" aria-label="Related tools">' +
        '<p class="calc-d4-handoffs-label">Related tools</p>' +
        '<div class="d4-hand-handoffs-list">' + links + '</div>' +
        '<a class="d4-hand-handoffs-all" href="/pages/tools">All Opora Tools <span aria-hidden="true">→</span></a>' +
      '</div>' +
    '</div>';
  }

  function ensureAfterBand(root, handoffs) {
    if (!root || !root.querySelector) return;
    var shell = root.querySelector('.d4-hand-shell');
    var work = root.querySelector('.d4-hand-work');
    if (!shell || !work) return;
    if (shell.querySelector('.d4-hand-after')) return;
    work.insertAdjacentHTML('afterend', afterBandHtml(handoffs));
  }

  function bindStickyResult(root) {
    var out = root && root.querySelector ? root.querySelector('.d4-hand-out') : null;
    var panel = root && root.querySelector ? root.querySelector('[data-calc-result]') : null;
    if (!out || !panel) return;

    function sync() {
      if (window.matchMedia && window.matchMedia('(max-width: 820px)').matches) {
        out.classList.add('is-static');
        return;
      }
      var topGap = 20;
      var tooTall = panel.getBoundingClientRect().height > (window.innerHeight - topGap - 24);
      out.classList.toggle('is-static', !!tooTall);
    }

    sync();
    if (typeof ResizeObserver !== 'undefined') {
      try {
        var ro = new ResizeObserver(sync);
        ro.observe(panel);
        out._oporaStickyRo = ro;
      } catch (e) { /* noop */ }
    }
    window.addEventListener('resize', sync, { passive: true });
  }

  /** Result UI archetypes — shared chrome, different answer composition (from hand prototypes). */
  var CALC_ARCHETYPE = {
    'production-rate-calculator': 'staffing',
    'restroom-time-calculator': 'staffing',
    'day-porter-roi': 'staffing',
    'appa-inspection-report': 'staffing',
    'bill-rate-calculator': 'money',
    'bid-generator': 'money',
    'cleaning-bid-benchmarks': 'money',
    'per-clean-vs-hourly': 'money',
    'account-profitability-auditor': 'money',
    'tco-calculator': 'money',
    'equipment-roi-calculator': 'money',
    'job-costing-calculator': 'money',
    'churn-cost-calculator': 'money',
    'ebitda-estimator': 'money',
    'robot-roi-matcher': 'money',
    'equipment-financing-comparator': 'money',
    'franchise-comparison-matrix': 'money',
    'sales-tax-calculator': 'money',
    'insurance-comparison': 'money',
    '1099-vs-w2-calculator': 'money',
    'bid-stress-test': 'stress',
    'dilution-calculator': 'mix',
    'chemical-compatibility': 'verdict',
    'ppe-selector': 'verdict',
    'pad-selector': 'verdict',
    'floor-program-builder': 'verdict',
    'voc-compliance': 'verdict',
    'federal-rfp-filter': 'verdict',
    'osha-300-300a-log': 'verdict',
    'issa-447-lookup': 'lookup',
    'pfas-state-lookup': 'lookup',
    'epa-list-n-matcher': 'lookup',
    'sds-finder': 'lookup',
    'sales-script-picker': 'lookup',
    'tax-deduction-finder': 'lookup',
    'union-contract-lookup': 'lookup',
    'price-increase-letter': 'draft',
    'independent-contractor-agreement': 'draft',
    'client-onboarding-checklist': 'draft'
  };

  function calcArchetype(slug) {
    return CALC_ARCHETYPE[slug] || 'money';
  }

  function vulnerabilityGaugeHtml(result) {
    var level = result && result.vulnerability;
    if (!level && result && result.flag) {
      if (/loss|high/i.test(String(result.flag))) level = 'High';
      else if (/at-risk|medium|caution/i.test(String(result.flag))) level = 'Medium';
      else if (/ok|pass|low/i.test(String(result.flag))) level = 'Low';
    }
    if (!level) return '';
    var w = level === 'High' ? 92 : level === 'Medium' ? 58 : 22;
    var tone = level === 'High' ? 'bad' : level === 'Medium' ? 'warn' : 'ok';
    return '<div class="calc-d4-gauge" role="img" aria-label="' + esc(String(level)) + ' vulnerability">' +
      '<span class="calc-d4-gauge-label">Risk level</span>' +
      '<div class="calc-d4-gauge-track"><i class="calc-d4-gauge-fill calc-d4-gauge-fill--' + tone +
      '" style="width:' + w + '%"></i></div></div>';
  }

  function setResultExampleMode(panel, on, root) {
    if (!panel) return;
    panel.classList.toggle('calc-d4-result--example', !!on);
    panel.classList.add('d4-visible');
    var tag = panel.querySelector('[data-result-tag]');
    var sub = panel.querySelector('[data-result-sub]');
    if (tag) {
      tag.textContent = on ? 'Sample preview' : 'Your result';
      tag.classList.toggle('is-live', !on);
    }
    if (sub) {
      sub.textContent = on
        ? 'Example from defaults — tap Calculate for yours'
        : '';
      sub.hidden = !on;
    }
    // Legacy single-label header (pre-hand shell)
    var label = panel.querySelector('.d4-result-label');
    if (label && !tag) {
      if (!label.getAttribute('data-base-label')) {
        label.setAttribute('data-base-label', label.textContent || 'Result');
      }
      label.textContent = on
        ? 'Sample · ' + label.getAttribute('data-base-label')
        : label.getAttribute('data-base-label');
    }
    var scope = root || panel;
    var capture = scope.querySelector('[data-calc-capture]');
    if (capture) capture.hidden = !!on;
  }

  /** Hide result chrome + export actions when calculate returns invalid. */
  function clearInvalidCalcResult(panel, root) {
    if (!panel) return;
    panel.classList.remove('d4-visible');
    panel.classList.remove('calc-d4-result--example');
    delete panel.dataset.lastResult;
    var body = panel.querySelector('[data-calc-body]');
    if (body) body.innerHTML = '';
    var scope = root || panel;
    var capture = scope.querySelector('[data-calc-capture]');
    if (capture) capture.hidden = true;
  }

  /**
   * World-class shell copy (prototype spine).
   * H1 = tool title (SEO/clarity).
   * outcome → single lead under H1 (Sugarman curiosity + stake).
   * agree kept in data for handoff docs — not rendered in intro.
   * trust / soWhat / primary → result panel after aha.
   */
  var WC_META = {
    'production-rate-calculator': {
      outcome: 'Most bids miss on labor hours, not chemicals.',
      agree: 'Most bids miss on labor hours, not chemicals.',
      trust: 'Method: APPA-aligned appearance levels with conservative large-office blends. Fixtures assumed at density defaults, open Advanced to match your building. Not a bid guarantee; use as the labor backbone, then price.',
      soWhat: 'Plan crew size from these hours before you price the building.',
      primary: {
        label: 'Price this crew → Bill Rate Calculator',
        url: '/pages/bill-rate-calculator',
        hint: 'Next: turn headcount into a billable rate',
        secondary: { label: 'Or open Bid Generator with these hours', url: '/pages/bid-generator' }
      }
    },
    'bill-rate-calculator': {
      outcome: 'A low bill rate looks competitive until payroll week.',
      agree: 'A low bill rate looks competitive until payroll week.',
      trust: 'Uses loaded labor + overhead + target margin. Confirm local wages and burden before locking a contract.',
      soWhat: 'This is the rate that funds labor, OH, and your margin, not just the wage.',
      primary: {
        label: 'Build the bid → Bid Generator',
        url: '/pages/bid-generator',
        hint: 'Next: turn rate into a calendar-month price',
        secondary: { label: 'Already have a bid price? Check Margin Sentinel →', url: '/pages/margin-sentinel' }
      }
    },
    '1099-vs-w2-calculator': {
      outcome: '1099 looks cheaper until burden and misclassification risk show up on the invoice.',
      agree: '1099 looks cheaper until burden and misclassification risk show up on the invoice.',
      trust: 'Illustrative payroll burden and state classification risk. Not legal advice — confirm with counsel or a payroll provider before you post.',
      soWhat: 'Use the cost-neutral 1099 rate and risk band before you decide how to hire.',
      primary: {
        label: 'Screen the hire → Hire Right',
        url: '/pages/hire-right',
        hint: 'Next: hire against the classification you just confirmed',
        secondary: { label: 'Price loaded W-2 labor → Bill Rate', url: '/pages/bill-rate-calculator' }
      }
    },
    'bid-generator': {
      outcome: 'A pretty total dies when they ask how you staffed it.',
      agree: 'A pretty total dies when they ask how you staffed it.',
      trust: 'Illustrative bid math from your inputs. Not a formal proposal.',
      soWhat: 'Use this as the opening bid scaffold, then shock-test margin.',
      primary: {
        label: 'Stress-test this bid → Bid Stress-Test',
        url: '/pages/bid-stress-test',
        hint: 'Next: see if the margin survives wage or hour shock',
        secondary: { label: 'Need the full proposal? Open Bid Drafter →', url: '/pages/bid-drafter' }
      }
    },
    'bid-stress-test': {
      outcome: 'Winning bids die on wage bumps and hour creep.',
      agree: 'Winning bids die on wage bumps and hour creep, not on chemicals.',
      trust: 'Scenario shocks only. Re-run with your real contract clauses before signing.',
      soWhat: 'If margin collapses under a small shock, rebuild the bid before you submit.',
      primary: {
        label: 'Draft Bid with Statutory Wage Escalation Clause → Bid Drafter',
        url: '/pages/bid-drafter',
        hint: 'Next: lock escalation language before the next wage cycle',
        secondary: {
          label: 'Compare to market → Bid Benchmarks',
          url: '/pages/cleaning-bid-benchmarks'
        }
      }
    },
    'cleaning-bid-benchmarks': {
      outcome: 'Low looks aggressive until you lose money every night.',
      agree: 'Low looks aggressive until you lose money every night.',
      trust: 'Benchmark bands are illustrative ranges, not quotes. Local labor and scope drive the real floor.',
      soWhat: 'If you are below the healthy band, check hours and bill rate before you cut further.',
      primary: {
        // Default (no "your bid"): rebuild hours first
        label: 'Rebuild hours → Production Rate',
        url: '/pages/production-rate-calculator',
        hint: 'Next: confirm labor hours behind the $/sf',
        // In band → costed bid scaffold, then stress-test
        hintHealthy: 'In band — build the costed bid behind this $/sf',
        labelHealthy: 'Build the bid → Bid Generator',
        urlHealthy: '/pages/bid-generator',
        secondaryHealthy: {
          label: 'Or stress-test this number → Bid Stress-Test',
          url: '/pages/bid-stress-test'
        },
        // Out of band → fix hours, then costed bid
        hintAtRisk: 'Outside the band — rebuild hours before you cut or pad the bid',
        labelAtRisk: 'Rebuild hours → Production Rate',
        urlAtRisk: '/pages/production-rate-calculator',
        secondaryAtRisk: {
          label: 'Or build a costed bid → Bid Generator',
          url: '/pages/bid-generator'
        }
      }
    },
    'per-clean-vs-hourly': {
      outcome: 'Wrong model: you eat overtime, or the client feels nickeled.',
      agree: 'Wrong model: you eat overtime, or the client feels nickeled.',
      trust: 'Rates use loaded labor + overhead %, then true gross margin (not markup). Flat/per-clean need hour caps in the SOW.',
      soWhat: 'Choose the model you can explain on a walkthrough, then lock the hour cap before you quote.',
      primary: { label: 'Price the model → Bill Rate', url: '/pages/bill-rate-calculator', hint: 'Next: validate loaded labor and margin behind this rate' }
    },
    'job-costing-calculator': {
      outcome: 'Missing overhead is how winning accounts quietly lose money.',
      agree: 'Missing overhead is how "winning" accounts quietly lose money.',
      trust: 'Direct costs + overhead + target margin. Validate wage, supplies, and travel against your books.',
      soWhat: 'This bid price is the floor that still hits your target margin.',
      primary: {
        label: 'Set bill rate → Bill Rate Calculator',
        url: '/pages/bill-rate-calculator',
        hint: 'Next: align loaded labor with this job cost',
        secondary: {
          label: 'Audit account margin → Profitability',
          url: '/pages/account-profitability-auditor'
        }
      }
    },
    'restroom-time-calculator': {
      outcome: 'Restrooms eat the schedule. Fixtures drive the hours.',
      agree: 'Restrooms eat the schedule. Fixtures drive the hours, not square feet.',
      trust: 'ISSA 612 / APPA Level 2 standard fixture times. Adjust for heavy traffic or high soil loads.',
      soWhat: 'Fold these hours into building FTE, don’t leave restrooms as a hopeful buffer.',
      primary: {
        label: 'Staff the building → Production Rate',
        url: '/pages/production-rate-calculator',
        hint: 'Next: roll restroom time into total FTE',
        secondary: { label: 'Calculate chemical dilution → Dilution Calculator', url: '/pages/dilution-calculator' }
      }
    },
    'issa-447-lookup': {
      outcome: 'A task rate isn’t a crew plan. Still walk the building.',
      agree: 'A task rate isn’t a crew plan. Still walk the building.',
      trust: 'APPA Level 2 guide rates within ISSA 612 commercial production ranges — planning figures, not a licensed ISSA extract. Validate with a site time study.',
      soWhat: 'Use this rate as an input to building-level FTE, not as the whole bid.',
      primary: {
        label: 'Build building FTE → Production Rate',
        url: '/pages/production-rate-calculator',
        hint: 'Next: turn task rates into crew size',
        secondary: { label: 'Match pad to auto-scrubber → Floor Pad Selector', url: '/pages/pad-selector' }
      }
    },
    'dilution-calculator': {
      outcome: 'Concentrate in the bottle is not the working solution.',
      agree: 'Concentrate in the bottle is not the working solution.',
      trust: 'Ratio math only, always follow the product label for use dilution and dwell.',
      soWhat: 'Mix exactly this amount of concentrate for the container size you selected.',
      primary: {
        label: 'Check mix safety → Chem Compatibility',
        url: '/pages/chemical-compatibility',
        hint: 'Next: confirm you are not stacking incompatible chemistries',
        secondary: { label: 'Check VOC limits → VOC Compliance', url: '/pages/voc-compliance' }
      }
    },
    'chemical-compatibility': {
      outcome: 'Mixing guesses create hazards. SDS beats folklore.',
      agree: 'Mixing guesses create hazards. SDS beats folklore.',
      trust: 'Category-level HazCom guidance (GREEN / AMBER / RED), not a lab assay. When unsure, keep products separate and rinse between.',
      soWhat: 'Treat a conflict as a hard stop. Sequence: Clean → Rinse → Disinfect instead of improvising a mix.',
      primary: { label: 'Set use dilution → Dilution Calculator', url: '/pages/dilution-calculator', hint: 'Next: mix each product to labeled strength' }
    },
    'ppe-selector': {
      outcome: 'Gloves and goggles are cheaper than an exposure claim.',
      agree: 'Gloves and goggles are cheaper than an exposure claim.',
      trust: 'Category guidance, verify against the product SDS section 8 before first use.',
      soWhat: 'Stock this kit for the chemistry you selected, then train the crew once.',
      primary: {
        label: 'Confirm SDS → SDS Finder',
        url: '/pages/sds-finder',
        hint: 'Next: pull the current SDS for the product',
        secondary: { label: 'Also check VOC limits → VOC Compliance', url: '/pages/voc-compliance' }
      }
    },
    'pad-selector': {
      outcome: 'Wrong pad burns finish or leaves soil behind.',
      agree: 'Wrong pad burns finish or leaves soil, mechanical action is half the clean.',
      trust: 'Common industry color conventions plus melamine / DIP / SPP. Confirm machine speed and finish manufacturer guidance.',
      soWhat: 'Use this pad for the task/finish/speed pair you selected, swap if the finish softens.',
      primary: {
        label: 'Build the floor program → Floor Care',
        url: '/pages/floor-program-builder',
        hint: 'Next: set daily/periodic care around this pad',
        secondary: { label: 'Set chemical dilution → Dilution Calculator', url: '/pages/dilution-calculator' }
      }
    },
    'floor-program-builder': {
      outcome: 'Daily alkali without a plan quietly destroys floors.',
      agree: 'Daily alkali without a plan quietly destroys floors.',
      trust: 'Program template from floor type, traffic, and finish. Follow finish manufacturer recoat intervals and RPM limits.',
      soWhat: 'Run this cadence, then pick pads and chemistry that match each step.',
      primary: {
        label: 'Pick the pad → Floor Pad Selector',
        url: '/pages/pad-selector',
        hint: 'Next: match pad to scrub/polish steps',
        secondary: { label: 'Set chemical dilution → Dilution Calculator', url: '/pages/dilution-calculator' }
      }
    },
    'account-profitability-auditor': {
      outcome: 'Revenue without margin is just a busy loss.',
      agree: 'Revenue without margin is just a busy loss.',
      trust: 'Gross margin = revenue minus COGS (labor, supplies, equipment). Net operating margin subtracts overhead and risk. Threshold gates net. Reconcile to P&L monthly.',
      soWhat: 'Healthy accounts: defend margin against scope creep. Below threshold: re-audit hours or adjust the contract rate.',
      primary: {
        label: 'Price the fix → Bill Rate Calculator',
        url: '/pages/bill-rate-calculator',
        hint: 'Set the bill rate you’d use on the next bid',
        hintHealthy: 'Set the bill rate you’d use on the next bid',
        hintAtRisk: 'Labor looks like the leak, rebuild the rate before you renew',
        labelHealthy: 'Price the next bid → Bill Rate Calculator',
        labelAtRisk: 'Price the fix → Bill Rate Calculator',
        secondary: {
          label: 'Re-evaluate staffing hours → Restroom Time Calculator',
          url: '/pages/restroom-time-calculator'
        }
      }
    },
    'day-porter-roi': {
      outcome: 'Day coverage looks premium until you price the monthly delta.',
      agree: 'Day coverage looks premium until you price the monthly delta.',
      trust: 'Cost comparison from your wage and hour inputs. Quality/response value is separate from pure cost.',
      soWhat: 'Pick the lower-cost model that still meets the service promise you sold.',
      primary: {
        label: 'Audit account margin → Profitability',
        url: '/pages/account-profitability-auditor',
        hint: 'Next: see if the model still clears margin',
        secondary: {
          label: 'Check task production rates → Production Rate',
          url: '/pages/production-rate-calculator'
        }
      }
    },
    'churn-cost-calculator': {
      outcome: 'Churn costs you twice: lost revenue, then the sales cycle to replace it.',
      agree: 'Churn costs you twice: lost revenue, then the sales cycle to replace it.',
      trust: 'Illustrative replacement cost from your inputs. Track actual sales cycle for your vertical.',
      soWhat: 'If retention spend is cheaper than this churn cost, fund retention first.',
      primary: { label: 'Check account health → Profitability', url: '/pages/account-profitability-auditor', hint: 'Next: catch at-risk accounts before they churn' }
    },
    'appa-inspection-report': {
      outcome: 'If you can’t inspect it, you can’t defend it.',
      agree: 'If you can’t inspect it, you can’t defend it.',
      trust: 'APPA Custodial Operational Development levels (1 pristine → 5 neglect). Walkthrough notes, not a certification audit.',
      soWhat: 'Use gaps as a scope conversation, not a surprise invoice fight.',
      primary: {
        label: 'Staff to the level → Production Rate',
        url: '/pages/production-rate-calculator',
        hint: 'Next: match FTE to the appearance level you sell',
        hintHealthy: 'Scores meet the contracted level, lock FTE to that appearance',
        hintAtRisk: 'Critical or below-contract APPA score — rebuild hours before the next walkthrough',
        labelHealthy: 'Staff to the level → Production Rate',
        labelAtRisk: 'Fix the gap → Production Rate',
        secondary: {
          label: 'Build floor program for problem areas → Floor Care',
          url: '/pages/floor-program-builder'
        }
      }
    },
    'client-onboarding-checklist': {
      outcome: 'Most bad accounts were vague on day one.',
      agree: 'Most "bad accounts" were vague on day one.',
      trust: 'Operator checklist, adapt to your contract and insurance requirements.',
      soWhat: 'Close every open item before go-live, especially keys, access, and scope.',
      primary: {
        label: 'Confirm staffing → Production Rate',
        url: '/pages/production-rate-calculator',
        hint: 'Next: set FTE for the onboarded scope',
        secondary: { label: 'Pull site SDS binder → SDS Finder', url: '/pages/sds-finder' }
      }
    },
    'tco-calculator': {
      outcome: 'Sticker price hides the pads, downtime, and service years.',
      agree: 'Sticker price hides the pads, downtime, and service years.',
      trust: 'Illustrative TCO from purchase, consumables, and service inputs you enter.',
      soWhat: 'Compare net TCO to labor savings before you buy.',
      primary: {
        label: 'Check payback → Equipment ROI',
        url: '/pages/equipment-roi-calculator',
        hint: 'Next: see how fast labor savings repay the buy',
        secondary: {
          label: 'Match pad to scrubber → Floor Pad Selector',
          url: '/pages/pad-selector'
        }
      }
    },
    'equipment-roi-calculator': {
      outcome: 'Iron only pays when labor hours actually drop.',
      agree: 'Iron only pays when OpEx can fund it, and labor actually drops.',
      trust: 'Payback from labor-savings inputs. Validate hours removed on a time study.',
      soWhat: 'If payback is longer than your cash cushion, delay the buy or finance carefully.',
      primary: {
        label: 'Compare loan vs lease → Financing',
        url: '/pages/equipment-financing-comparator',
        hint: 'Next: pick the lower monthly path',
        secondary: {
          label: 'Audit total 5-yr costs → Equipment TCO',
          url: '/pages/tco-calculator'
        }
      }
    },
    'robot-roi-matcher': {
      outcome: 'Robots remove open-floor hours, not supervision.',
      agree: 'Robots don’t remove supervision. They remove open-floor hours.',
      trust: 'Illustrative payback vs manual labor inputs. Site readiness and downtime matter.',
      soWhat: 'Only proceed if payback clears and the floor plan is robot-friendly. Robots remove open-floor hours, not supervision.',
      primary: {
        label: 'Compare equipment ROI → Equipment ROI',
        url: '/pages/equipment-roi-calculator',
        hint: 'Next: compare robot vs conventional equipment',
        secondary: {
          label: 'Select floor pads → Floor Pad Selector',
          url: '/pages/pad-selector'
        }
      }
    },
    'equipment-financing-comparator': {
      outcome: 'Cash flow kills more buys than interest rate.',
      agree: 'Cash-flow kills more buys than interest rate.',
      trust: 'Monthly comparison from the rates and terms you enter, not a credit offer.',
      soWhat: 'Pick the path that fits monthly cash, then confirm payback still works.',
      primary: {
        label: 'Confirm payback → Equipment ROI',
        url: '/pages/equipment-roi-calculator',
        hint: 'Next: make sure labor savings still clear',
        secondary: {
          label: 'Audit total 5-yr costs → Equipment TCO',
          url: '/pages/tco-calculator'
        }
      }
    },
    'ebitda-estimator': {
      outcome: 'Buyers pay for transferable earnings, not founder hustle.',
      agree: 'Buyers pay for transferable earnings, not founder hustle.',
      trust: 'Back-of-envelope EV from adjusted EBITDA × illustrative multiples. Not a valuation opinion.',
      soWhat: 'Use the range to prioritize margin cleanup before a sale conversation.',
      primary: {
        label: 'Clean up accounts → Profitability',
        url: '/pages/account-profitability-auditor',
        hint: 'Next: raise earnings quality account by account',
        secondary: {
          label: 'Evaluate account churn risks → Churn Cost Calculator',
          url: '/pages/churn-cost-calculator'
        }
      }
    },
    'franchise-comparison-matrix': {
      outcome: 'Royalty is forever. Item 19 is not your P&L.',
      agree: 'Royalty is forever. Item 19 is a sample, not your P&L.',
      trust: 'Illustrative fee/royalty matrix. Read the FDD; Item 19 figures are not promises.',
      soWhat: 'Favor the year-1 fit you can fund, then stress real revenue after royalties. Royalty is forever; Item 19 is not your P&L.',
      primary: {
        label: 'Model job cost → Job Costing',
        url: '/pages/job-costing-calculator',
        hint: 'Next: see if unit economics clear royalties',
        secondary: {
          label: 'Audit account margin → Profitability',
          url: '/pages/account-profitability-auditor'
        }
      }
    },
    'federal-rfp-filter': {
      outcome: 'Wrong NAICS burns months of unpaid proposal time.',
      agree: 'Wrong NAICS or vehicle = months of unpaid proposal time.',
      trust: 'Deterministic FAR/SBA screen from your inputs. Verify SCA WD and size standards on SAM.gov / SBA before you bid.',
      soWhat: 'If fit is weak, walk away early and protect bid capacity.',
      primary: { label: 'Decode the RFP → RFP Decoder', url: '/pages/rfp-decoder', hint: 'Next: extract must-haves from the package' }
    },
    'price-increase-letter': {
      outcome: 'Silence until renewal is how you eat wage inflation.',
      agree: 'Silence until renewal is how you eat wage inflation.',
      trust: 'Letter scaffold only, confirm contract notice terms and local law.',
      soWhat: 'Send with the math behind the increase, not just a percentage.',
      primary: { label: 'Rebuild the rate → Bill Rate', url: '/pages/bill-rate-calculator', hint: 'Next: show the loaded-rate math in the letter' }
    },
    'sales-script-picker': {
      outcome: 'Most "too expensive" moments are scope clarity moments.',
      agree: 'Most "too expensive" moments are scope clarity moments.',
      trust: 'Sample scripts — adapt to your voice and proof.',
      soWhat: 'Use the Ask, then show math — do not open with a discount.',
      primary: {
        label: 'Re-scope this objection → Bid Stress-Test',
        url: '/pages/bid-stress-test',
        hint: 'Next: pressure-test the priced scope behind this objection'
      }
    },
    'independent-contractor-agreement': {
      outcome: 'Misclassification risk costs more than a W-2.',
      agree: 'Misclassification risk is more expensive than a W-2.',
      trust: 'Draft subcontract for counsel review — not legal advice and not a signed agreement until executed.',
      soWhat: 'Close insurance, scope, consideration, and tax points before the first shift.',
      primary: { label: 'Price the work → Job Costing', url: '/pages/job-costing-calculator', hint: 'Next: make sure the engagement still clears margin' }
    },
    'pfas-state-lookup': {
      outcome: 'Product bans move faster than carts get restocked.',
      agree: 'Product bans move faster than most carts get restocked.',
      trust: 'Status snapshot for planning, verify current statute and product lists before buying.',
      soWhat: 'If restricted, swap chemistry and update SDS binders now.',
      primary: { label: 'Check VOC too → VOC Compliance', url: '/pages/voc-compliance', hint: 'Next: confirm VOC limits for the same lineup' }
    },
    'voc-compliance': {
      outcome: 'The label can still fail the state VOC category.',
      agree: 'The label can still fail the state VOC category.',
      trust: 'Compares entered VOC to illustrative state category limits, confirm on current regulation.',
      soWhat: 'Non-compliant SKUs need a substitute before the next order. The label can still fail the state VOC category.',
      primary: {
        label: 'Find SDS → SDS Finder',
        url: '/pages/sds-finder',
        hint: 'Next: pull VOC data from the current SDS',
        hintHealthy: 'Within limit, pull the SDS so PPE and first aid match the SKU',
        hintAtRisk: 'Over limit, confirm the SDS and find a compliant substitute',
        labelHealthy: 'Find SDS → SDS Finder',
        labelAtRisk: 'Find a substitute SDS → SDS Finder',
        secondary: { label: 'Match PPE → PPE Selector', url: '/pages/ppe-selector' }
      }
    },
    'sales-tax-calculator': {
      outcome: 'Wrong service vs supply split gets expensive at audit time.',
      agree: 'Wrong service vs supply split gets expensive at audit time.',
      trust: 'Illustrative estimate only, not tax advice. Confirm with your CPA / state guidance.',
      soWhat: 'Use the estimate to set invoice line structure, then verify nexus rules. Wrong service vs supply split gets expensive at audit time.',
      primary: {
        label: 'Find deductions → Tax Deduction Finder',
        url: '/pages/tax-deduction-finder',
        hint: 'Next: see common BSC deduction categories',
        secondary: {
          label: 'Model total job cost → Job Costing',
          url: '/pages/job-costing-calculator'
        }
      }
    },
    'epa-list-n-matcher': {
      outcome: 'Skip labeled dwell and the kill claim dies with it.',
      agree: 'Skip labeled dwell and the kill claim dies with it.',
      trust: 'Sample List N-style examples for education, verify the live EPA List N entry before use.',
      soWhat: 'Shortlist candidates, then confirm EPA reg. no. and contact time on EPA.gov. Skip labeled dwell and the kill claim dies with it.',
      primary: {
        label: 'Set dilution → Dilution Calculator',
        url: '/pages/dilution-calculator',
        hint: 'Next: mix to the labeled use dilution',
        secondary: {
          label: 'Select PPE → PPE Selector',
          url: '/pages/ppe-selector'
        }
      }
    },
    'sds-finder': {
      outcome: 'Yesterday’s SDS is how crews get the wrong PPE.',
      agree: 'Yesterday’s SDS is how crews get the wrong PPE.',
      trust: 'Sample catalog search, always download the current SDS from the manufacturer.',
      soWhat: 'Open the SDS for PPE, first aid, and VOC, then stock the cart accordingly.',
      primary: {
        label: 'Match PPE → PPE Selector',
        url: '/pages/ppe-selector',
        hint: 'Next: kit PPE from SDS section 8',
        secondary: {
          label: 'Check chemical compatibility → Chemical Compatibility',
          url: '/pages/chemical-compatibility'
        }
      }
    },
    'insurance-comparison': {
      outcome: 'Cheap premium with a bad mod is not cheap.',
      agree: 'Cheap premium with a bad mod is not cheap.',
      trust: 'Quote comparison from premiums and mod you enter, confirm coverages on the binder.',
      soWhat: 'Pick the lower total that still meets contract minimums. Cheap premium with a bad mod is not cheap.',
      primary: {
        label: 'Check OSHA rates → OSHA 300 Log',
        url: '/pages/osha-300-300a-log',
        hint: 'Next: injuries drive mods over time',
        secondary: {
          label: 'Model job cost → Job Costing',
          url: '/pages/job-costing-calculator'
        }
      }
    },
    'osha-300-300a-log': {
      outcome: 'What you don’t measure shows up in workers’ comp.',
      agree: 'What you don’t measure shows up in workers’ comp.',
      trust: 'Standard OSHA formulas from hours and cases you enter. Keep the official forms for posting.',
      soWhat: 'TRIR and DART outperform industry benchmarks. Maintain current toolbox talks and safety protocols to protect workers\' comp mod.',
      primary: {
        label: 'Compare insurance → Insurance Comparison',
        url: '/pages/insurance-comparison',
        hint: 'Next: see how mods affect premium',
        hintHealthy: 'TRIR looks manageable, still check how your mod hits premium',
        hintAtRisk: 'TRIR is elevated, model the mod hit before renewal',
        labelHealthy: 'Compare insurance → Insurance Comparison',
        labelAtRisk: 'Model the mod hit → Insurance Comparison',
        secondary: {
          label: 'Filter federal RFPs → Federal RFP Filter',
          url: '/pages/federal-rfp-filter'
        }
      }
    },
    'tax-deduction-finder': {
      outcome: 'Missed write-offs are silent margin leaks.',
      agree: 'Missed write-offs are silent margin leaks.',
      trust: 'Category finder for discussion with your CPA, not tax advice.',
      soWhat: 'Bring the shortlist to your accountant with receipts and entity type. Missed write-offs are silent margin leaks.',
      primary: {
        label: 'Estimate invoice tax → Sales Tax',
        url: '/pages/sales-tax-calculator',
        hint: 'Next: separate taxability from deductions',
        secondary: {
          label: 'Estimate EBITDA → EBITDA Estimator',
          url: '/pages/ebitda-estimator'
        }
      }
    },
    'union-contract-lookup': {
      outcome: 'Bidding under scale is a lost award waiting to happen.',
      agree: 'Bidding under scale in a union market is a lost award waiting to happen.',
      trust: 'Samples drawn from published union scales, SCA wage determinations, and living-wage data; close enough to estimate and walk a building with, but confirm the agreement that governs the account before you price it.',
      soWhat: 'Use the compliant bill-rate floor from this sample scale, then verify the live CBA or SCA WD before you bid.',
      primary: {
        label: 'Cost the visit → Job Costing',
        url: '/pages/job-costing-calculator',
        hint: 'Next: fold this bill rate into a visit cost',
        secondary: {
          label: 'Open Bill Rate Calculator →',
          url: '/pages/bill-rate-calculator'
        }
      }
    }
  };

  var HAND_LEADS = Object.keys(WC_META).reduce(function (acc, slug) {
    // Lead under tool-name H1 = outcome curiosity (not agree alone).
    acc[slug] = WC_META[slug].outcome || WC_META[slug].agree;
    return acc;
  }, {});

  function getWcMeta(slug) {
    return WC_META[slug] || null;
  }

  function applyWcIntro(root, slug, def) {
    if (!root) return;
    var wc = getWcMeta(slug);
    var h1 = root.querySelector('.d4-tool-headline');
    var lead = root.querySelector('.d4-hand-lead');
    // Never overwrite H1 with outcome — keep tool name for SEO/clarity.
    if (h1 && def && def.title) {
      h1.textContent = def.title;
      h1.setAttribute('data-tool-name', def.title);
    }
    // Intro chrome: H1 + one lead only (drop brand / agree / deck).
    root.querySelectorAll('.d4-hand-brand, .d4-hand-agree, .d4-tool-deck').forEach(function (el) {
      el.remove();
    });
    if (!wc) return;
    var leadText = wc.outcome || wc.agree || '';
    if (!leadText) return;
    if (lead) lead.textContent = leadText;
    else if (h1 && h1.parentNode) {
      var p = document.createElement('p');
      p.className = 'd4-hand-lead';
      p.textContent = leadText;
      if (h1.nextSibling) h1.parentNode.insertBefore(p, h1.nextSibling);
      else h1.parentNode.appendChild(p);
    }
  }

  function ensureCardHeaders(root) {
    if (!root) return;
    var formCard = root.querySelector('[data-calc-form]');
    if (formCard && !formCard.querySelector('.d4-card-h')) {
      var fh = document.createElement('div');
      fh.className = 'd4-card-h';
      fh.textContent = 'Inputs';
      formCard.insertBefore(fh, formCard.firstChild);
    }
    var panel = root.querySelector('[data-calc-result]');
    if (panel && !panel.querySelector('.d4-card-h')) {
      var rh = document.createElement('div');
      rh.className = 'd4-card-h';
      rh.textContent = 'Your result';
      panel.insertBefore(rh, panel.firstChild);
    }
  }

  function resolvePrimaryHandoff(wc, result) {
    if (!wc || !wc.primary || !wc.primary.url) return null;
    var p = wc.primary;
    var flag = result && result.flag;
    var healthy = flag === 'Healthy' || flag === 'Market range' || flag === 'High Standard';
    var atRisk = flag === 'At-risk' || flag === 'Needs Review' || flag === 'Unhealthy' || flag === 'Loss' ||
      flag === 'Below market' || flag === 'Above market' || flag === 'Over limit' ||
      flag === 'Below mobilization floor' ||
      flag === 'Critical Deficiency' || flag === 'Below Contract' || flag === 'At Risk / Inattention';
    var hint = (result && result.handoffHint) || p.hint || '';
    var label = (result && result.handoffLabel) || p.label || '';
    var url = (result && result.handoffUrl) || p.url;
    var secondary = p.secondary || null;
    // State-aware handoff when WC_META defines healthy / at-risk variants
    if (flag && (p.hintHealthy || p.hintAtRisk || p.labelHealthy || p.labelAtRisk ||
        p.urlHealthy || p.urlAtRisk || p.secondaryHealthy || p.secondaryAtRisk)) {
      if (healthy) {
        hint = p.hintHealthy || hint;
        label = p.labelHealthy || label;
        url = p.urlHealthy || url;
        secondary = p.secondaryHealthy || secondary;
      } else if (atRisk) {
        hint = p.hintAtRisk || hint;
        label = p.labelAtRisk || label;
        url = p.urlAtRisk || url;
        secondary = p.secondaryAtRisk || secondary;
      }
    }
    // Per-result secondary (e.g. Federal RFP Filter → SAM.gov WD deep-link)
    if (result && result.handoffSecondary && result.handoffSecondary.url && result.handoffSecondary.label) {
      secondary = result.handoffSecondary;
    }
    // Per-result primary URL wins (e.g. Bid Generator → Stress-Test with serialized state)
    if (result && result.handoffUrl) url = result.handoffUrl;
    return { url: url, label: label, hint: hint, secondary: secondary };
  }

  function primaryHandoffHtml(wc, result) {
    var p = resolvePrimaryHandoff(wc, result);
    if (!p) return '';
    var html =
      '<div class="calc-d4-wc-live calc-d4-primary-handoff" data-calc-handoff>' +
        (p.hint ? '<p class="calc-d4-primary-hint">' + esc(p.hint) + '</p>' : '') +
        '<a class="calc-d4-primary-cta" href="' + esc(p.url) + '">' + esc(p.label) + '</a>';
    if (p.secondary && p.secondary.url && p.secondary.label) {
      html += '<a class="calc-d4-primary-secondary" data-calc-handoff-secondary href="' +
        esc(p.secondary.url) + '">' + esc(p.secondary.label) + '</a>';
    }
    html += '</div>';
    return html;
  }

  function wcTrustHtml(wc) {
    if (!wc || !wc.trust) return '';
    return '<p class="calc-d4-wc-live calc-d4-trust">' + esc(wc.trust) + '</p>';
  }

  function formatSoWhatText(text) {
    // Allow **bold** markers from dynamic soWhat builders; escape all else.
    return esc(text).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  }

  function wcSoWhatHtml(result, wc) {
    var text = (result && result.soWhat) || (wc && wc.soWhat) || '';
    if (!text) return '';
    return '<div class="calc-d4-wc-live calc-d4-so-what">' + formatSoWhatText(text) + '</div>';
  }

  function statusPillHtml(result) {
    var html = '';
    if (result && result.recommendationPill && result.recommendationPill.label) {
      var rp = result.recommendationPill;
      html += '<div class="calc-d4-wc-live calc-d4-status-block calc-d4-status-block--recommend">' +
        '<div class="calc-d4-pill calc-d4-pill--ok">' + esc(rp.label) + '</div>';
      if (rp.text) {
        html += '<p class="calc-d4-narrative calc-d4-status-text">' + esc(rp.text) + '</p>';
      }
      html += '</div>';
    }
    if (result.statusPill) {
      var sp = result.statusPill;
      var spClass = sp.level === 'ok' ? 'ok' : (sp.level === 'warn' ? 'warn' : 'bad');
      html += '<div class="calc-d4-wc-live calc-d4-status-block"><div class="calc-d4-pill calc-d4-pill--' + spClass + '">' + esc(sp.label) + '</div>';
      // Skip disclaimer text that duplicates the WC trust line under the pill
      if (sp.text && !/APPA-style level framing|Not a certification audit/i.test(String(sp.text))) {
        html += '<p class="calc-d4-narrative calc-d4-status-text">' + esc(sp.text) + '</p>';
      }
      html += '</div>';
      return html;
    }
    // VOC: compliance color lives on the 3-up Status card — never duplex a loose Over limit pill
    if (result && result.hideStatusPill) return html || '';
    if (html) return html;
    if (result.flag) {
      var pillClass = result.flag === 'Healthy' ? 'ok'
        : (result.flag === 'At-risk' || result.flag === 'Needs Review' ? 'warn' : 'bad');
      return '<div class="calc-d4-wc-live calc-d4-pill calc-d4-pill--' + pillClass + '">' + esc(result.flag) + '</div>';
    }
    return '';
  }

  function dwellHtml(result) {
    var d = result && result.dwell;
    if (!d || !d.label) return '';
    return '<div class="calc-d4-instruction calc-d4-dwell" role="note">' +
      '<span class="calc-d4-instruction-label">EPA / contact time</span>' +
      '<p class="calc-d4-instruction-text"><strong>' + esc(d.label) + '</strong> — ' + esc(d.text || '') + '</p></div>';
  }

  function alertBannerHtml(result) {
    var list = [];
    if (result && result.alertBanners && result.alertBanners.length) {
      list = result.alertBanners;
    } else if (result && result.alertBanner && result.alertBanner.text) {
      list = [result.alertBanner];
    }
    if (!list.length) return '';
    return list.map(function (b) {
      if (!b || !b.text) return '';
      var level = b.level === 'bad' ? 'bad' : 'warn';
      var html = '<div class="calc-d4-alert calc-d4-alert--' + level + '" role="status">' +
        (b.title ? '<p class="calc-d4-alert-title">' + esc(b.title) + '</p>' : '') +
        '<p class="calc-d4-alert-text">' + esc(b.text) + '</p>';
      if (b.actions && b.actions.length) {
        html += '<div class="calc-d4-alert-actions">';
        b.actions.forEach(function (a) {
          if (!a || a.days == null) return;
          html += '<button type="button" class="calc-d4-alert-action" data-notice-days="' +
            esc(String(a.days)) + '">' + esc(a.label || ('Set to ' + a.days + ' days')) + '</button>';
        });
        html += '</div>';
      }
      html += '</div>';
      return html;
    }).join('');
  }

  function topCopyToolbarHtml(result) {
    if (!result || !result.copyText || !result.copyTop) return '';
    return '<div class="calc-d4-clause-toolbar">' +
      '<span class="calc-d4-clause-toolbar-label">' + esc(result.copyToolbarLabel || 'Clauses') + '</span>' +
      '<div class="calc-d4-clause-toolbar-actions">' +
      '<button type="button" class="calc-d4-copy-script" data-copy-script>' +
      esc(result.copyLabel || 'Copy all') + '</button>' +
      '<span class="calc-d4-copy-status" data-copy-status hidden>Copied</span>' +
      '</div></div>';
  }

  function detailRowsHtml(rows) {
    if (!rows || !rows.length) return '';
    var html = '<div class="calc-d4-detail">';
    rows.forEach(function (row) {
      html += '<div class="calc-d4-detail-row">' +
        '<span class="calc-d4-detail-label">' + esc(row.label) + '</span>' +
        '<span class="calc-d4-detail-value">' + esc(row.value) + '</span>' +
        '</div>';
    });
    html += '</div>';
    return html;
  }

  function stressScenariosHtml(result) {
    var scenarios = result.scenarios || [];
    if (!scenarios.length) return '';
    var fmtP = S().fmtPct;
    var fmtM = S().fmt$;
    var target = result.target;
    var baseM = scenarios[0] && scenarios[0].margin != null ? scenarios[0].margin : 0;
    var worst = baseM;
    scenarios.forEach(function (s) {
      if (s.margin != null && s.margin < worst) worst = s.margin;
    });
    var scaleMax = Math.max(baseM, target != null ? target : 0, 1);
    function barPct(v) {
      var p = (v / scaleMax) * 100;
      return Math.max(0, Math.min(100, p));
    }

    var html = '<div class="calc-d4-stress">';
    html += '<p class="calc-d4-stress-label">Scenario margins</p>';
    html += '<div class="calc-d4-stress-bar" role="img" aria-label="Margin erosion from baseline to worst case">';
    html += '<div class="calc-d4-stress-bar-fill calc-d4-stress-bar-fill--base" style="width:' + barPct(baseM).toFixed(1) + '%"></div>';
    html += '<div class="calc-d4-stress-bar-fill calc-d4-stress-bar-fill--worst" style="width:' + barPct(worst).toFixed(1) + '%"></div>';
    if (target != null) {
      html += '<span class="calc-d4-stress-bar-target" style="left:' + barPct(target).toFixed(1) + '%" title="Target ' + esc(fmtP(target)) + '"></span>';
    }
    html += '</div>';
    html += '<div class="calc-d4-stress-bar-legend">' +
      '<span>Baseline ' + esc(fmtP(baseM)) + '</span>' +
      '<span>Worst ' + esc(fmtP(worst)) + '</span>' +
      (target != null ? '<span>Target ' + esc(fmtP(target)) + '</span>' : '') +
      '</div>';

    html += '<div class="calc-d4-stress-list">';
    scenarios.forEach(function (s, idx) {
      var below = s.belowTarget === true || (target != null && s.margin < target);
      var tone = idx === 0 ? 'base' : (below ? 'bad' : 'ok');
      var profit = s.profit != null ? s.profit : null;
      var delta = s.deltaPts;
      var pill;
      if (idx === 0) {
        pill = '<span class="calc-d4-pill calc-d4-pill--ok">baseline</span>';
      } else if (delta != null && !isNaN(delta)) {
        var dStr = (delta > 0 ? '+' : '') + Number(delta).toFixed(1) + ' pts';
        pill = '<span class="calc-d4-pill calc-d4-pill--' + (below ? 'bad' : 'ok') + '">' + esc(dStr) + '</span>';
      } else {
        pill = below
          ? '<span class="calc-d4-pill calc-d4-pill--bad">below target</span>'
          : '<span class="calc-d4-pill calc-d4-pill--ok">on target</span>';
      }
      html += '<div class="calc-d4-stress-row calc-d4-stress-row--' + tone + '">' +
        '<span class="calc-d4-stress-name">' + esc(s.name) + '</span>' +
        '<span class="calc-d4-stress-main">' +
          '<span class="calc-d4-stress-pct">' + esc(fmtP(s.margin)) + '</span>' +
          (profit != null
            ? '<span class="calc-d4-stress-cash">' + esc(fmtM(profit)) + '/mo</span>'
            : '') +
        '</span>' +
        pill +
        '</div>';
    });
    html += '</div>';

    if (result.remediation) {
      html += '<p class="calc-d4-stress-fix"><strong>Fix it:</strong> ' + esc(result.remediation) + '</p>';
    }
    html += '</div>';
    return html;
  }

  function scriptBeatPartsHtml(parts, fallback) {
    if (parts && parts.length) {
      return parts.map(function (p) {
        var t = esc(p && p.t != null ? p.t : '');
        if (!t) return '';
        return p.hl ? '<mark class="calc-d4-script-hl">' + t + '</mark>' : t;
      }).join('');
    }
    return esc(fallback || '');
  }

  function scriptPackHtml(result, def, wc) {
    var html = '';
    html += '<div class="calc-d4-script-pack">';
    html += '<div class="calc-d4-script-toolbar">';
    html += '<span class="calc-d4-script-toolbar-label">Script beats</span>';
    if (result.copyText) {
      html += '<div class="calc-d4-script-toolbar-actions">' +
        '<button type="button" class="calc-d4-copy-script" data-copy-script>' +
        esc(result.copyLabel || 'Copy script') + '</button>' +
        '<span class="calc-d4-copy-status" data-copy-status hidden>Copied</span>' +
        '</div>';
    }
    html += '</div>';

    html += '<div class="calc-d4-metrics calc-d4-script-head"><div class="calc-d4-metric">' +
      '<p class="calc-d4-metric-label">' + esc(def.primaryLabel || 'Script') + '</p>' +
      '<p class="calc-d4-metric-value calc-d4-metric-value--accent">' + esc(result.primary || '') + '</p></div>';
    if (result.secondary) {
      html += '<div class="calc-d4-metric"><p class="calc-d4-metric-label">' + esc(result.secondaryLabel || 'Context') + '</p>' +
        '<p class="calc-d4-metric-value calc-d4-script-secondary">' +
        (result.secondaryParts && result.secondaryParts.length
          ? scriptBeatPartsHtml(result.secondaryParts, result.secondary)
          : esc(result.secondary)) +
        '</p></div>';
    }
    html += '</div>';

    if (result.scriptBeats && result.scriptBeats.length) {
      html += '<div class="calc-d4-script-beats" aria-label="Script beats">';
      result.scriptBeats.forEach(function (b) {
        var label = esc(b.title || '');
        if (b.titleHl) {
          label += ' · <mark class="calc-d4-script-hl">' + esc(b.titleHl) + '</mark>';
        }
        html += '<article class="calc-d4-script-beat">' +
          '<p class="calc-d4-script-beat-label">' + label + '</p>' +
          '<p class="calc-d4-script-beat-text">' + scriptBeatPartsHtml(b.parts, b.detail) + '</p>' +
          '</article>';
      });
      html += '</div>';
    }

    // Demoted coaching strip (after the script, not before)
    html += wcSoWhatHtml(result, wc);
    html += '<p class="calc-d4-wc-live calc-d4-trust calc-d4-trust--quiet">' +
      esc((wc && wc.trust) || 'Sample scripts — adapt to your voice and proof.') + '</p>';
    html += '</div>';
    return html;
  }

  function bindCopyScript(body, copyText, label) {
    var btn = body.querySelector('[data-copy-script]');
    if (!btn || !copyText) return;
    var status = body.querySelector('[data-copy-status]');
    var idle = label || btn.textContent || 'Copy';
    btn.addEventListener('click', function () {
      function ok() {
        if (status) {
          status.hidden = false;
          setTimeout(function () { status.hidden = true; }, 1600);
        }
        btn.textContent = 'Copied';
        setTimeout(function () { btn.textContent = idle; }, 1600);
        if (global.OporaTools && global.OporaTools.showToast) {
          global.OporaTools.showToast('Copied', 'success');
        }
      }
      function fail() {
        if (global.OporaTools && global.OporaTools.showToast) {
          global.OporaTools.showToast('Copy failed — select the text manually', 'error');
        }
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(copyText).then(ok, function () {
          try {
            var ta = document.createElement('textarea');
            ta.value = copyText;
            ta.setAttribute('readonly', '');
            ta.style.cssText = 'position:fixed;left:-9999px;top:0';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            ok();
          } catch (e) { fail(); }
        });
      } else {
        fail();
      }
    });
  }

  function rangeBarHtml(bar) {
    if (!bar || bar.low == null || bar.high == null || bar.target == null) return '';
    var trackLow = Number(bar.trackLow != null ? bar.trackLow : bar.low);
    var trackHigh = Number(bar.trackHigh != null ? bar.trackHigh : bar.high);
    var target = Number(bar.target);
    var bandLow = Number(bar.low);
    var bandHigh = Number(bar.high);
    var marginMin = Number(bar.marginMin != null ? bar.marginMin : 12);
    var marginMax = Number(bar.marginMax != null ? bar.marginMax : 55);
    var marginNow = bar.margin != null ? Number(bar.margin) : null;
    var span = trackHigh - trackLow;
    // Interactive bid margin slider: thumb maps linearly on marginMin…marginMax
    // (divisor makes $-space non-linear; left% must hit the active GM mark, e.g. 35%).
    var pct;
    if (bar.thumbPct != null && isFinite(Number(bar.thumbPct))) {
      pct = Math.max(0, Math.min(100, Number(bar.thumbPct)));
    } else if (bar.positionBy === 'margin' && marginNow != null && marginMax > marginMin) {
      pct = Math.max(0, Math.min(100, ((marginNow - marginMin) / (marginMax - marginMin)) * 100));
    } else {
      pct = span > 0 ? Math.max(0, Math.min(100, ((target - trackLow) / span) * 100)) : 50;
    }
    var fillStyle;
    if (bar.fillLow != null && bar.fillHigh != null) {
      var fl = Number(bar.fillLow);
      var fh = Number(bar.fillHigh);
      var leftPct = span > 0 ? Math.max(0, Math.min(100, ((fl - trackLow) / span) * 100)) : 0;
      var widthPct = span > 0 ? Math.max(0, Math.min(100 - leftPct, ((fh - fl) / span) * 100)) : 100;
      fillStyle = 'left:' + leftPct.toFixed(1) + '%;width:' + widthPct.toFixed(1) + '%';
    } else {
      fillStyle = 'width:' + pct.toFixed(1) + '%';
    }
    var interactive = !!bar.interactive && bar.totalCost > 0;
    var showGm = interactive || !!bar.showGmLabels;
    var overflow = !!bar.overflow ||
      (isFinite(target) && isFinite(bandHigh) && target > bandHigh + 1e-9) ||
      (isFinite(target) && isFinite(bandLow) && target < bandLow - 1e-9);
    var marginTxt = bar.margin != null ? Number(bar.margin).toFixed(0) + '% GM' : '';
    var midEm = bar.markerLabel || 'Target';
    var titleHtml = bar.title
      ? '<p class="calc-d4-range-title">' + esc(bar.title) + '</p>'
      : '';
    var pillHtml = bar.contractPill
      ? '<p class="calc-d4-range-contract" data-range-contract>' + esc(bar.contractPill) + '</p>'
      : '';
    var lowEm = showGm ? ('Low · ' + String(marginMin) + '% GM') : 'Low';
    var highEm = showGm ? ('High · ' + String(marginMax) + '% GM') : 'High';
    return '<div class="calc-d4-range' + (interactive ? ' calc-d4-range--interactive' : '') +
      (overflow ? ' calc-d4-range--overflow' : '') + '" aria-label="Bid range"' +
      (interactive
        ? ' data-bid-range="1" data-total-cost="' + esc(String(bar.totalCost)) + '"' +
          ' data-track-low="' + esc(String(trackLow)) + '" data-track-high="' + esc(String(trackHigh)) + '"' +
          ' data-margin-min="' + esc(String(marginMin)) + '"' +
          ' data-margin-max="' + esc(String(marginMax)) + '"' +
          ' data-position-by="margin"' +
          (bar.passThroughBill != null
            ? ' data-passthrough-bill="' + esc(String(bar.passThroughBill)) + '"'
            : '')
        : '') + '>' +
      titleHtml +
      '<div class="calc-d4-range-track" data-range-track role="' + (interactive ? 'slider' : 'presentation') + '"' +
        (interactive
          ? ' tabindex="0" aria-valuemin="' + esc(String(marginMin)) + '"' +
            ' aria-valuemax="' + esc(String(marginMax)) + '"' +
            ' aria-valuenow="' + esc(String(bar.margin != null ? bar.margin : '')) + '"' +
            ' aria-valuetext="' + esc(marginTxt + ' · ' + (bar.targetLabel || '')) + '"' +
            ' aria-label="Target margin"'
          : '') + '>' +
        '<span class="calc-d4-range-fill" style="' + fillStyle + '"></span>' +
        '<span class="calc-d4-range-marker' + (overflow ? ' calc-d4-range-marker--overflow' : '') +
          '" style="left:' + pct.toFixed(1) + '%" title="' + esc(midEm) + '"></span>' +
      '</div>' +
      '<div class="calc-d4-range-labels">' +
        '<span><em>' + esc(lowEm) + '</em> ' + esc(bar.lowLabel || '') + '</span>' +
        '<span class="calc-d4-range-labels-target' + (overflow ? ' calc-d4-range-labels-target--overflow' : '') +
          '"><em>' + esc(midEm) +
          (marginTxt ? ' · ' + esc(marginTxt) : '') + '</em> ' + esc(bar.targetLabel || '') + '</span>' +
        '<span><em>' + esc(highEm) + '</em> ' + esc(bar.highLabel || '') + '</span>' +
      '</div>' +
      pillHtml +
      (bar.hint ? '<p class="calc-d4-range-hint' + (overflow ? ' calc-d4-range-hint--overflow' : '') + '">' +
        esc(bar.hint) + '</p>' : '') +
      '</div>';
  }

  function leakageProofHtml(proof) {
    if (!proof || proof.divisorBid == null || proof.flatMarkupBid == null) return '';
    var fmt = (S() && S().fmt$) || function (n) {
      return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    var m = Number(proof.margin);
    var mLabel = isFinite(m) ? m.toFixed(0) : '—';
    var leak = Number(proof.leak);
    var leakAbs = Math.abs(leak);
    var leakSigned = (leak >= 0 ? '' : '−') + fmt(leakAbs);
    return '<div class="calc-d4-leakage-proof" role="note">' +
      '<p class="calc-d4-leakage-proof__title">Gross margin protection</p>' +
      '<p class="calc-d4-leakage-proof__text">Bidding via a <strong>' + esc(mLabel) +
      '% divisor (' + esc(fmt(proof.divisorBid)) + ')</strong> protects you from flat markup leakage. ' +
      'A flat ' + esc(mLabel) + '% markup yields <strong>' + esc(fmt(proof.flatMarkupBid)) +
      '</strong>, leaking <strong>' + esc(leakSigned) + '/yr</strong> in uncollected margin.</p>' +
      '</div>';
  }

  function bindBidRangeBar(body, formCard, onMarginChange) {
    var rootEl = body && body.querySelector('[data-bid-range]');
    if (!rootEl || !formCard || typeof onMarginChange !== 'function') return;
    var track = rootEl.querySelector('[data-range-track]');
    var fill = rootEl.querySelector('.calc-d4-range-fill');
    var marker = rootEl.querySelector('.calc-d4-range-marker');
    var targetLabel = rootEl.querySelector('.calc-d4-range-labels-target');
    var contractEl = rootEl.querySelector('[data-range-contract]');
    if (!track) return;
    var totalCost = parseFloat(rootEl.getAttribute('data-total-cost'));
    var trackLow = parseFloat(rootEl.getAttribute('data-track-low'));
    var trackHigh = parseFloat(rootEl.getAttribute('data-track-high'));
    var marginMin = parseFloat(rootEl.getAttribute('data-margin-min'));
    var marginMax = parseFloat(rootEl.getAttribute('data-margin-max'));
    var passThrough = parseFloat(rootEl.getAttribute('data-passthrough-bill'));
    if (!(totalCost > 0) || !(trackHigh > trackLow)) return;
    var fmt = (global.OporaCalcShared && global.OporaCalcShared.fmt$) || function (n) {
      return '$' + Math.round(n).toLocaleString();
    };

    function marginFromClientX(clientX) {
      var rect = track.getBoundingClientRect();
      var x = Math.max(0, Math.min(1, (clientX - rect.left) / Math.max(1, rect.width)));
      // Linear on margin scale (matches thumb left%) — divisor $-space is non-linear
      var margin = marginMin + x * (marginMax - marginMin);
      if (isNaN(margin)) return null;
      return Math.round(Math.max(marginMin, Math.min(marginMax, margin)) * 10) / 10;
    }

    function previewMargin(margin) {
      if (margin == null) return;
      var bid = totalCost / (1 - margin / 100);
      var mSpan = marginMax - marginMin;
      var pct = mSpan > 0
        ? Math.max(0, Math.min(100, ((margin - marginMin) / mSpan) * 100))
        : 50;
      if (fill) fill.style.width = pct.toFixed(1) + '%';
      if (marker) marker.style.left = pct.toFixed(1) + '%';
      track.setAttribute('aria-valuenow', String(margin));
      track.setAttribute('aria-valuetext', margin.toFixed(0) + '% GM · ' + fmt(bid));
      if (targetLabel) {
        targetLabel.innerHTML = '<em>Target · ' + esc(margin.toFixed(0) + '% GM') + '</em> ' + esc(fmt(bid));
      }
      if (contractEl && isFinite(passThrough) && passThrough > 0) {
        var total = bid + passThrough;
        contractEl.textContent = 'Total contract value: ' + fmt(total) +
          ' (' + fmt(bid) + ' ops + ' + fmt(passThrough) + ' consumables)';
      }
    }

    function commitMargin(margin, record) {
      if (margin == null) return;
      var el = formCard.querySelector('[data-calc-field="margin_pct"]');
      if (!el) return;
      var next = String(margin);
      if (el.value === next && !record) return;
      el.value = next;
      onMarginChange({ margin: margin, record: !!record });
    }

    var dragging = false;
    var pending = null;
    function onPointerDown(e) {
      dragging = true;
      pending = marginFromClientX(e.clientX);
      previewMargin(pending);
      if (track.setPointerCapture && e.pointerId != null) {
        try { track.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      }
      e.preventDefault();
    }
    function onPointerMove(e) {
      if (!dragging) return;
      pending = marginFromClientX(e.clientX);
      previewMargin(pending);
      e.preventDefault();
    }
    function onPointerUp() {
      if (!dragging) return;
      dragging = false;
      commitMargin(pending, true);
      pending = null;
    }
    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('keydown', function (e) {
      var el = formCard.querySelector('[data-calc-field="margin_pct"]');
      var cur = el ? parseFloat(el.value) : marginMin;
      if (isNaN(cur)) cur = marginMin;
      var step = e.shiftKey ? 2 : 0.5;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
        commitMargin(Math.max(marginMin, Math.round((cur - step) * 10) / 10), true);
        e.preventDefault();
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
        commitMargin(Math.min(marginMax, Math.round((cur + step) * 10) / 10), true);
        e.preventDefault();
      } else if (e.key === 'Home') {
        commitMargin(marginMin, true);
        e.preventDefault();
      } else if (e.key === 'End') {
        commitMargin(marginMax, true);
        e.preventDefault();
      }
    });
  }

  function breakdownHtml(items) {
    if (!items || !items.length) return '';
    var html = '<div class="calc-d4-breakdown" aria-label="Production math">' +
      '<p class="calc-d4-breakdown-title">Production math</p><ul class="calc-d4-breakdown-list">';
    items.forEach(function (row) {
      html += '<li class="calc-d4-breakdown-row' + (row.emphasize ? ' calc-d4-breakdown-row--em' : '') + '">' +
        '<div class="calc-d4-breakdown-main">' +
          '<span class="calc-d4-breakdown-label">' + esc(row.label || '') + '</span>' +
          '<span class="calc-d4-breakdown-value">' + esc(row.value || '') + '</span>' +
        '</div>';
      if (row.hint) {
        html += '<p class="calc-d4-breakdown-hint">' + esc(row.hint) + '</p>';
      }
      html += '</li>';
    });
    html += '</ul></div>';
    return html;
  }

  function copyActionHtml(result) {
    if (!result || !result.copyText) return '';
    return '<div class="calc-d4-copy-actions">' +
      '<button type="button" class="calc-d4-copy-script" data-copy-script>' +
      esc(result.copyLabel || 'Copy summary') + '</button>' +
      '<span class="calc-d4-copy-status" data-copy-status hidden>Copied</span>' +
      '</div>';
  }

  function wireMixPctTotal(formCard, fieldIds) {
    if (!formCard || !fieldIds || !fieldIds.length) return;
    var panel = formCard.querySelector('[data-adv-panel]');
    if (!panel) return;
    var host = formCard.querySelector('[data-mix-pct-host]') || formCard.querySelector('[data-mix-pct-total]');
    if (!host) {
      host = document.createElement('p');
      host.className = 'calc-d4-mix-total';
      host.setAttribute('data-mix-pct-total', '');
      host.setAttribute('aria-live', 'polite');
      var fieldsRow = panel.querySelector('[data-mode-panel="simple"]') ||
        panel.querySelector('.calc-d4-surface-card') ||
        panel.querySelector('.calc-d4-advanced-fields') || panel;
      fieldsRow.appendChild(host);
    }
    function update() {
      var sum = 0;
      fieldIds.forEach(function (id) {
        var el = formCard.querySelector('[data-calc-field="' + id + '"]');
        var n = el ? parseFloat(el.value) : 0;
        if (!isNaN(n)) sum += n;
      });
      var rounded = Math.round(sum * 10) / 10;
      var ok = Math.abs(rounded - 100) < 0.5;
      var isChip = host.classList.contains('calc-d4-mix-chip');
      if (isChip) {
        host.textContent = ok ? 'Total ' + rounded + '%' : rounded + '% ≠ 100';
      } else {
        host.textContent = 'Surface mix total: ' + rounded + '%' + (ok ? '' : ' (should be 100%)');
      }
      host.classList.toggle('calc-d4-mix-total--ok', ok);
      host.classList.toggle('calc-d4-mix-chip--ok', ok);
      host.classList.toggle('calc-d4-mix-total--warn', !ok);
      host.classList.toggle('calc-d4-mix-chip--warn', !ok);
    }
    formCard.addEventListener('input', function (e) {
      if (!e.target || !e.target.getAttribute) return;
      var id = e.target.getAttribute('data-calc-field');
      if (id && fieldIds.indexOf(id) >= 0) update();
    }, true);
    formCard.addEventListener('change', function (e) {
      if (!e.target || !e.target.getAttribute) return;
      var id = e.target.getAttribute('data-calc-field');
      if (id && fieldIds.indexOf(id) >= 0) update();
    }, true);
    update();
  }

  function wireSampleFieldDefaults(root) {
    var sel = '[data-calc-field]';
    function markAll() {
      root.querySelectorAll(sel).forEach(function (el) {
        if (el.type === 'checkbox' || el.type === 'hidden' || el.type === 'radio') return;
        el.classList.add('is-sample');
      });
    }
    function clearOne(el) {
      if (el && el.classList) el.classList.remove('is-sample');
    }
    function clearAll() {
      root.querySelectorAll(sel).forEach(function (el) {
        el.classList.remove('is-sample');
      });
    }
    markAll();
    root.addEventListener('focusin', function (e) {
      if (e.target && e.target.matches && e.target.matches(sel)) clearOne(e.target);
    }, true);
    root.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches(sel)) clearOne(e.target);
    }, true);
    root.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches(sel)) clearOne(e.target);
    }, true);
    return { markAll: markAll, clearAll: clearAll, clearOne: clearOne };
  }

  function updateRunCountDisplays(root, slug, count) {
    var R = global.OporaCalcRuns;
    var min = R && R.MIN_DISPLAY != null ? R.MIN_DISPLAY : 0;
    var show = count != null && !isNaN(count) && Number(count) >= min;
    var text = show
      ? (R && typeof R.formatCount === 'function' ? R.formatCount(count) : String(count))
      : '';
    root.querySelectorAll('[data-calc-run-count]').forEach(function (el) {
      el.textContent = text;
      var card = el.closest ? el.closest('[data-calc-run-block]') : null;
      if (card) card.hidden = !show;
    });
  }

  function bindRunCounts(root, slug) {
    var nodes = root.querySelectorAll('[data-calc-run-count]');
    if (!nodes.length) return;
    if (global.OporaCalcRuns && global.OporaCalcRuns.bindDisplay) {
      global.OporaCalcRuns.bindDisplay(slug, nodes);
    }
  }

  function logCalcRun(root, slug, force) {
    if (!force && root._calcRunLogged) return;
    root._calcRunLogged = true;
    if (!global.OporaCalcRuns || typeof global.OporaCalcRuns.record !== 'function') return;
    global.OporaCalcRuns.record(slug, function (n) {
      updateRunCountDisplays(root, slug, n);
    });
  }

  function fieldInfoHtml(field) {
    var text = field.info || (field.hintAsTooltip ? field.hint : '');
    if (!text) return '';
    return '<button type="button" class="d4-f-info" aria-label="About ' + esc(field.label) + '" data-f-info>' +
      '<span class="d4-f-info__mark" aria-hidden="true">?</span>' +
      '<span class="d4-f-info__tip" role="tooltip">' + esc(text) + '</span>' +
      '</button>';
  }

  function fieldLabelHtml(field, id) {
    var info = fieldInfoHtml(field);
    var labelInner = '<span class="d4-f-label__text">' + esc(field.label) + '</span>';
    var label = id
      ? '<label class="d4-f-label" for="' + id + '">' + labelInner + '</label>'
      : '<span class="d4-f-label">' + labelInner + '</span>';
    if (!info) return label;
    return '<div class="d4-f-label-row">' + label + info + '</div>';
  }

  function fieldHintHtml(field) {
    if (field.info || field.hintAsTooltip) return '';
    return field.hint ? '<p class="d4-f-hint">' + esc(field.hint) + '</p>' : '';
  }

  function fieldInput(field, value, slug) {
    var id = 'calc-' + slug + '-' + field.id;
    var val = value !== undefined && value !== null ? value : (field.default !== undefined ? field.default : '');
    var hint = fieldHintHtml(field);
    var dataAttr = ' data-calc-field="' + esc(field.id) + '"';

    if (field.type === 'select') {
      var opts = (field.options || []).map(function (opt) {
        var sel = String(val) === String(opt.value) ? ' selected' : '';
        return '<option value="' + esc(opt.value) + '"' + sel + '>' + esc(opt.label) + '</option>';
      }).join('');
      return '<div class="d4-f-field">' + fieldLabelHtml(field, id) +
        '<select class="d4-f-select" id="' + id + '" name="' + esc(field.id) + '"' + dataAttr + '>' + opts + '</select>' + hint + '</div>';
    }
    if (field.type === 'ratio_chips') {
      var chips = (field.chips || []).map(function (r) {
        return '<button type="button" class="calc-d4-ratio-chip" data-ratio-chip="' + r + '" data-ratio-target="' + esc(field.target || 'ratio_str') + '">1:' + r + '</button>';
      }).join('');
      return '<div class="calc-d4-ratio-chips-wrap">' + fieldLabelHtml(field) +
        '<div class="calc-d4-ratio-chips" role="group" aria-label="' + esc(field.label) + '">' + chips + '</div>' + hint + '</div>';
    }
    if (field.type === 'container_chips') {
      var cchips = (field.presets || []).map(function (p) {
        return '<button type="button" class="calc-d4-ratio-chip calc-d4-container-chip" data-container-size="' + esc(p.size) +
          '" data-container-unit="' + esc(p.unit) + '">' + esc(p.label) + '</button>';
      }).join('');
      return '<div class="calc-d4-ratio-chips-wrap">' + fieldLabelHtml(field) +
        '<div class="calc-d4-ratio-chips" role="group" aria-label="' + esc(field.label) + '">' + cchips + '</div>' + hint + '</div>';
    }
    if (field.type === 'checkbox') {
      var chk = val || field.default ? ' checked' : '';
      return '<div class="d4-f-field d4-f-field--check"><label class="d4-f-label d4-f-label--check">' +
        '<input type="checkbox" id="' + id + '" name="' + esc(field.id) + '"' + dataAttr + chk + '> ' + esc(field.label) + '</label>' + hint + '</div>';
    }
    var type = field.type === 'text' ? 'text' : 'number';
    var attrs = ' class="d4-f-input" id="' + id + '" name="' + esc(field.id) + '" type="' + type + '"' + dataAttr;
    // Insurance Comparison: EMR always shows two decimals ("1.00") — browsers strip trailing zeros on number inputs
    if (String(slug || '') === 'insurance-comparison' && String(field.id || '') === 'wc_mod' &&
        val !== '' && val !== null && val !== undefined) {
      var emrN = Number(val);
      if (isFinite(emrN)) val = emrN.toFixed(2);
    }
    if (val !== '' && val !== null && val !== undefined) attrs += ' value="' + esc(val) + '"';
    if (field.min !== undefined) attrs += ' min="' + field.min + '"';
    if (field.max !== undefined) attrs += ' max="' + field.max + '"';
    if (field.step !== undefined) attrs += ' step="' + field.step + '"';
    if (field.placeholder) attrs += ' placeholder="' + esc(field.placeholder) + '"';
    return '<div class="d4-f-field">' + fieldLabelHtml(field, id) +
      '<input' + attrs + '>' + hint + '</div>';
  }

  function fieldWantsFullRow(field) {
    if (!field) return false;
    return field.type === 'checkbox' || field.type === 'textarea' || field.fullWidth === true;
  }

  function buildFieldGrids(fields, prefill, slug) {
    var html = '';
    var i = 0;
    while (i < fields.length) {
      var a = fields[i];
      if (fieldWantsFullRow(a)) {
        html += '<div class="d4-form-grid-2"><div class="calc-d4-grid-span">' +
          fieldInput(a, prefill[a.id], slug) + '</div></div>';
        i += 1;
        continue;
      }
      var b = fields[i + 1];
      html += '<div class="d4-form-grid-2">';
      html += fieldInput(a, prefill[a.id], slug);
      if (b && !fieldWantsFullRow(b)) {
        html += fieldInput(b, prefill[b.id], slug);
        i += 2;
      } else {
        i += 1;
      }
      html += '</div>';
    }
    return html;
  }

  function buildZoneBank(fields, prefill, slug) {
    if (!fields.length) return '';
    var html = '<div class="calc-d4-zone-bank">';
    fields.forEach(function (f) {
      html += fieldInput(f, prefill[f.id], slug);
    });
    html += '</div>';
    return html;
  }

  /** Production Rate: compact advanced — site · fixtures · mode-gated zone bank (not a 17-field stack). */
  function buildProductionAdvHtml(fields, prefill, slug) {
    var byId = {};
    (fields || []).forEach(function (f) { byId[f.id] = f; });
    function pick(ids) {
      return ids.map(function (id) { return byId[id]; }).filter(Boolean);
    }
    function section(label, inner) {
      if (!inner) return '';
      return '<div class="calc-d4-adv-section">' +
        '<span class="calc-d4-adv-section-label">' + esc(label) + '</span>' +
        inner +
        '</div>';
    }
    var site = pick(['shift_timing', 'soil_density', 'fte_divisor', 'labor_burden']);
    var fixtures = pick(['fixtures', 'min_per_fixture', 'fixture_density_sqft']);
    var pct = pick(['pct_carpet', 'pct_hard_floor', 'pct_restroom', 'pct_office', 'pct_common']);
    var sqft = pick(['sqft_carpet', 'sqft_hard_floor', 'sqft_restroom', 'sqft_office', 'sqft_common']);
    var html = '';
    html += section('Site modifiers', buildFieldGrids(site, prefill, slug));
    html += section('Restroom fixtures', fixtures.length
      ? ('<div class="d4-form-grid-3">' + fixtures.map(function (f) {
          return fieldInput(f, prefill[f.id], slug);
        }).join('') + '</div>')
      : '');
    html += '<div class="calc-d4-mode-panel" data-mode-panel="simple">' +
      section('Area mix %', buildZoneBank(pct, prefill, slug)) +
      '<p class="calc-d4-mix-total" data-mix-pct-total data-mix-pct-host aria-live="polite"></p>' +
      '</div>';
    html += '<div class="calc-d4-mode-panel" data-mode-panel="detailed" hidden>' +
      section('Area sqft', buildZoneBank(sqft, prefill, slug)) +
      '</div>';
    return html;
  }

  /** Bid Generator: grouped Advanced — surface mix card · labor · supplies. */
  function buildBidGeneratorAdvHtml(fields, prefill, slug) {
    var byId = {};
    (fields || []).forEach(function (f) { byId[f.id] = f; });
    function pick(ids) {
      return ids.map(function (id) { return byId[id]; }).filter(Boolean);
    }
    function section(label, inner) {
      if (!inner) return '';
      return '<div class="calc-d4-adv-section">' +
        '<span class="calc-d4-adv-section-label">' + esc(label) + '</span>' +
        inner +
        '</div>';
    }
    var surface = pick(['pct_carpet', 'pct_hard_floor', 'pct_restroom', 'pct_office', 'pct_common']);
    var fixtures = pick(['fixtures']);
    var labor = pick(['payroll_burden_pct', 'overhead_pct', 'day_porter_hrs_week']);
    var supplies = pick([
      'cleaning_supply_psf', 'consumable_psf', 'consumable_markup_pct',
      'equipment_annual', 'travel_allowance_mo'
    ]);
    var html = '';
    html += '<div class="calc-d4-surface-card" data-surface-mix-card data-surface-mix-auto="1">' +
      '<div class="calc-d4-surface-card__head">' +
        '<span class="calc-d4-adv-section-label">Space &amp; surface mix</span>' +
        '<span class="calc-d4-mix-chip" data-mix-pct-total data-mix-pct-host aria-live="polite">Total 100%</span>' +
      '</div>' +
      buildZoneBank(surface, prefill, slug) +
      (fixtures.length ? '<div class="calc-d4-surface-card__fixtures">' + buildFieldGrids(fixtures, prefill, slug) + '</div>' : '') +
      '</div>';
    html += section(
      'Labor & burden rates',
      buildFieldGrids(labor, prefill, slug) +
      '<div class="calc-d4-burden-decompose" data-burden-decompose>' +
        '<button type="button" class="calc-d4-burden-decompose__btn" data-burden-open aria-expanded="false">' +
          'Show state burden stack' +
        '</button>' +
        '<div class="calc-d4-burden-popover" data-burden-popover hidden>' +
          '<p class="calc-d4-burden-popover__using" data-burden-using></p>' +
          '<ul class="calc-d4-burden-popover__lines" data-burden-lines></ul>' +
          '<p class="calc-d4-burden-popover__total" data-burden-total></p>' +
          '<p class="calc-d4-burden-popover__note">Uses the State field above. Statutory + GL/PPE only — add benefits/PTO separately if you carry them (full loaded often 40–55%).</p>' +
          '<button type="button" class="calc-d4-burden-popover__apply" data-burden-apply>Apply to Payroll burden %</button>' +
        '</div>' +
      '</div>'
    );
    html += section('Supplies & direct expenses', buildFieldGrids(supplies, prefill, slug));
    return html;
  }

  function buildAdvFieldsHtml(slug, advFields, prefill) {
    if (slug === 'production-rate-calculator') {
      return buildProductionAdvHtml(advFields, prefill || {}, slug);
    }
    if (slug === 'bid-generator') {
      return buildBidGeneratorAdvHtml(advFields, prefill || {}, slug);
    }
    return buildFieldGrids(advFields, prefill || {}, slug);
  }

  var BID_SURFACE_MIX_BY_FACILITY = {
    office: { pct_carpet: 40, pct_hard_floor: 20, pct_restroom: 5, pct_office: 25, pct_common: 10 },
    industrial: { pct_carpet: 0, pct_hard_floor: 70, pct_restroom: 10, pct_office: 10, pct_common: 10 },
    medical: { pct_carpet: 15, pct_hard_floor: 25, pct_restroom: 20, pct_office: 30, pct_common: 10 },
    education: { pct_carpet: 30, pct_hard_floor: 35, pct_restroom: 10, pct_office: 15, pct_common: 10 },
    retail: { pct_carpet: 20, pct_hard_floor: 50, pct_restroom: 5, pct_office: 10, pct_common: 15 },
    hospitality: { pct_carpet: 45, pct_hard_floor: 20, pct_restroom: 10, pct_office: 15, pct_common: 10 },
    'multi-tenant': { pct_carpet: 35, pct_hard_floor: 25, pct_restroom: 8, pct_office: 22, pct_common: 10 }
  };

  function wireBidFacilitySurfaceMix(formCard) {
    if (!formCard) return;
    var facilityEl = formCard.querySelector('[data-calc-field="facility_type"]');
    var card = formCard.querySelector('[data-surface-mix-card]');
    if (!facilityEl || !card) return;
    var ids = ['pct_carpet', 'pct_hard_floor', 'pct_restroom', 'pct_office', 'pct_common'];

    function readMix() {
      var out = {};
      ids.forEach(function (id) {
        var el = formCard.querySelector('[data-calc-field="' + id + '"]');
        out[id] = el ? parseFloat(el.value) : NaN;
      });
      return out;
    }

    function mixMatches(preset) {
      if (!preset) return false;
      var cur = readMix();
      return ids.every(function (id) {
        return Math.abs((cur[id] || 0) - (preset[id] || 0)) < 0.51;
      });
    }

    function applyMix(preset) {
      if (!preset) return;
      ids.forEach(function (id) {
        var el = formCard.querySelector('[data-calc-field="' + id + '"]');
        if (!el) return;
        el.value = String(preset[id]);
        el.dispatchEvent(new Event('input', { bubbles: true }));
      });
      card.setAttribute('data-surface-mix-auto', '1');
    }

    var lastFacility = facilityEl.value;
    facilityEl.addEventListener('change', function () {
      var next = facilityEl.value;
      var prevPreset = BID_SURFACE_MIX_BY_FACILITY[lastFacility] || BID_SURFACE_MIX_BY_FACILITY.office;
      var auto = card.getAttribute('data-surface-mix-auto') !== '0';
      if (auto || mixMatches(prevPreset)) {
        applyMix(BID_SURFACE_MIX_BY_FACILITY[next] || BID_SURFACE_MIX_BY_FACILITY.office);
      }
      lastFacility = next;
    });

    formCard.addEventListener('input', function (e) {
      if (!e.target || !e.target.getAttribute) return;
      var id = e.target.getAttribute('data-calc-field');
      if (id && ids.indexOf(id) >= 0) {
        card.setAttribute('data-surface-mix-auto', '0');
      }
    }, true);
  }

  /** Soft tip under Restroom fixtures — blank tip + low-count realism badge. */
  function wireBidFixturesBlankTip(formCard) {
    if (!formCard) return;
    var el = formCard.querySelector('[data-calc-field="fixtures"]');
    if (!el) return;
    var wrap = el.closest ? el.closest('.d4-f-field') : null;
    if (!wrap) return;
    var TIP = 'Tip: Enter fixture count for higher labor precision.';
    var hintEl = wrap.querySelector('.d4-f-hint');
    if (!hintEl) {
      hintEl = document.createElement('p');
      hintEl.className = 'd4-f-hint';
      wrap.appendChild(hintEl);
    }
    var badge = wrap.querySelector('[data-fixture-soft-warn]');
    if (!badge) {
      badge = document.createElement('p');
      badge.className = 'calc-d4-fixture-warn';
      badge.setAttribute('data-fixture-soft-warn', '1');
      badge.hidden = true;
      wrap.appendChild(badge);
    }
    function sync() {
      var blank = String(el.value == null ? '' : el.value).trim() === '';
      hintEl.textContent = TIP;
      hintEl.hidden = !blank;
      var shared = S();
      var sqEl = formCard.querySelector('[data-calc-field="total_sqft"]');
      var facEl = formCard.querySelector('[data-calc-field="facility_type"]');
      var warn = shared && typeof shared.restroomFixtureSoftWarn === 'function'
        ? shared.restroomFixtureSoftWarn(
          sqEl ? sqEl.value : 0,
          facEl ? facEl.value : 'office',
          el.value
        )
        : null;
      if (warn) {
        badge.hidden = false;
        badge.textContent = warn;
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    }
    el.addEventListener('input', sync);
    el.addEventListener('change', sync);
    var sqWatch = formCard.querySelector('[data-calc-field="total_sqft"]');
    var facWatch = formCard.querySelector('[data-calc-field="facility_type"]');
    if (sqWatch) {
      sqWatch.addEventListener('input', sync);
      sqWatch.addEventListener('change', sync);
    }
    if (facWatch) facWatch.addEventListener('change', sync);
    sync();
  }

  /** Bill Rate: NY Downstate $17 advisory under Base wage (no auto-clamp). */
  function wireBillRateNyDownstateNote(formCard) {
    if (!formCard) return;
    var wageEl = formCard.querySelector('[data-calc-field="base_wage"]');
    var stateEl = formCard.querySelector('[data-calc-field="state"]');
    if (!wageEl || !stateEl) return;
    var wrap = wageEl.closest ? wageEl.closest('.d4-f-field') : null;
    if (!wrap) return;
    var badge = wrap.querySelector('[data-ny-downstate-note]');
    if (!badge) {
      badge = document.createElement('p');
      badge.className = 'calc-d4-fixture-warn';
      badge.setAttribute('data-ny-downstate-note', '1');
      badge.hidden = true;
      wrap.appendChild(badge);
    }
    function sync() {
      var st = String(stateEl.value || '').toUpperCase();
      var wage = Number(String(wageEl.value || '').replace(/,/g, ''));
      if (st === 'NY' && isFinite(wage) && wage > 0 && wage < 17) {
        badge.hidden = false;
        badge.textContent =
          'Note: $' + wage.toFixed(2) +
          '/hr meets Upstate NY minimum wage. If servicing NYC, Long Island, or Westchester County, the 2026 statutory floor is $17.00/hr.';
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    }
    wageEl.addEventListener('input', sync);
    wageEl.addEventListener('change', sync);
    stateEl.addEventListener('change', sync);
    sync();
  }

  /** Bid Generator: statutory wage floor badge + auto-clamp on blur/state change. */
  function wireBidWageFloor(formCard, opts) {
    if (!formCard) return;
    var wageEl = formCard.querySelector('[data-calc-field="base_wage"]');
    var stateEl = formCard.querySelector('[data-calc-field="state"]');
    if (!wageEl || !stateEl) return;
    var wrap = wageEl.closest ? wageEl.closest('.d4-f-field') : null;
    if (!wrap) return;
    var badge = wrap.querySelector('[data-wage-floor-warn]');
    if (!badge) {
      badge = document.createElement('p');
      badge.className = 'calc-d4-fixture-warn calc-d4-wage-floor-warn';
      badge.setAttribute('data-wage-floor-warn', '1');
      badge.hidden = true;
      wrap.appendChild(badge);
    }
    function sync(clamp) {
      var shared = S();
      if (!shared || typeof shared.applyStateWageFloor !== 'function') return;
      var check = shared.applyStateWageFloor(stateEl.value, wageEl.value);
      if (check && check.clamped && check.message) {
        badge.hidden = false;
        badge.textContent = check.message;
        if (clamp) {
          wageEl.value = String(check.wage);
          if (opts && opts.sampleFields && typeof opts.sampleFields.clearOne === 'function') {
            opts.sampleFields.clearOne(wageEl);
          }
        }
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    }
    wageEl.addEventListener('input', function () { sync(false); });
    wageEl.addEventListener('change', function () { sync(true); });
    stateEl.addEventListener('change', function () { sync(true); });
    sync(false);
  }

  /** Bid Generator: soft consumables $/sf outlier badge. */
  function wireBidConsumableWarn(formCard) {
    if (!formCard) return;
    var el = formCard.querySelector('[data-calc-field="consumable_psf"]');
    if (!el) return;
    var wrap = el.closest ? el.closest('.d4-f-field') : null;
    if (!wrap) return;
    var badge = wrap.querySelector('[data-consumable-soft-warn]');
    if (!badge) {
      badge = document.createElement('p');
      badge.className = 'calc-d4-fixture-warn';
      badge.setAttribute('data-consumable-soft-warn', '1');
      badge.hidden = true;
      wrap.appendChild(badge);
    }
    function sync() {
      var shared = S();
      var facEl = formCard.querySelector('[data-calc-field="facility_type"]');
      var warn = shared && typeof shared.consumablePsfSoftWarn === 'function'
        ? shared.consumablePsfSoftWarn(el.value, facEl ? facEl.value : 'office')
        : null;
      if (warn) {
        badge.hidden = false;
        badge.textContent = warn;
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    }
    el.addEventListener('input', sync);
    el.addEventListener('change', sync);
    var facWatch = formCard.querySelector('[data-calc-field="facility_type"]');
    if (facWatch) facWatch.addEventListener('change', sync);
    sync();
  }

  /** Bid Generator: burden stack from header State field (auto-applies on state change). */
  function wireBidBurdenDecompose(formCard, opts) {
    if (!formCard) return;
    var root = formCard.querySelector('[data-burden-decompose]');
    if (!root || root.getAttribute('data-wired') === '1') return;
    root.setAttribute('data-wired', '1');
    var openBtn = root.querySelector('[data-burden-open]');
    var pop = root.querySelector('[data-burden-popover]');
    var usingEl = root.querySelector('[data-burden-using]');
    var linesEl = root.querySelector('[data-burden-lines]');
    var totalEl = root.querySelector('[data-burden-total]');
    var applyBtn = root.querySelector('[data-burden-apply]');
    var stateEl = formCard.querySelector('[data-calc-field="state"]');
    var burEl = formCard.querySelector('[data-calc-field="payroll_burden_pct"]');
    var shared = S();
    if (!shared || typeof shared.decomposeJanitorialBurden !== 'function' || !stateEl) return;

    function currentState() {
      return String(stateEl.value || 'GA').toUpperCase();
    }

    function renderStack() {
      var st = currentState();
      var stack = shared.decomposeJanitorialBurden(st);
      if (usingEl) {
        usingEl.textContent = 'Stack for ' + st +
          (shared.regionFromState ? ' · ' + shared.regionFromState(st) + ' cost factor' : '');
      }
      if (linesEl) {
        linesEl.innerHTML = (stack.lines || []).map(function (line) {
          return '<li><span>' + esc(line.label) + '</span><strong>' +
            esc(String(line.value)) + '%</strong></li>';
        }).join('');
      }
      if (totalEl) {
        totalEl.innerHTML = 'Suggested payroll burden: <strong>' +
          esc(String(stack.totalPct)) + '%</strong>';
      }
      return stack;
    }

    function applyStack(record) {
      var stack = renderStack();
      if (!burEl) return stack;
      burEl.value = String(stack.totalPct);
      if (opts && opts.sampleFields && typeof opts.sampleFields.clearOne === 'function') {
        opts.sampleFields.clearOne(burEl);
      }
      if (opts && typeof opts.onApply === 'function') opts.onApply(record);
      return stack;
    }

    if (openBtn && pop) {
      openBtn.addEventListener('click', function () {
        var hide = !pop.hidden;
        pop.hidden = hide;
        openBtn.setAttribute('aria-expanded', hide ? 'false' : 'true');
        if (!hide) renderStack();
      });
    }
    stateEl.addEventListener('change', function () {
      if (opts && opts.sampleFields && typeof opts.sampleFields.clearOne === 'function') {
        opts.sampleFields.clearOne(stateEl);
      }
      applyStack(false);
      if (pop && !pop.hidden) renderStack();
    });
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        applyStack(true);
        if (pop) pop.hidden = true;
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      });
    }
    // Initial sync: state drives statutory burden so Region/State cannot diverge
    applyStack(false);
  }

  function wireFieldInfoTips(formCard) {
    if (!formCard || formCard._oporaInfoWired) return;
    formCard._oporaInfoWired = true;
    formCard.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.d4-f-info') : null;
      if (!btn || !formCard.contains(btn)) return;
      e.preventDefault();
      var open = btn.getAttribute('aria-expanded') === 'true';
      formCard.querySelectorAll('.d4-f-info[aria-expanded="true"]').forEach(function (b) {
        if (b !== btn) b.setAttribute('aria-expanded', 'false');
      });
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.d4-f-info')) return;
      formCard.querySelectorAll('.d4-f-info[aria-expanded="true"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function fieldVisibleForValues(field, values) {
    var rule = field && field.visibleWhen;
    if (!rule || !rule.id) return true;
    var cur = values[rule.id];
    if (rule.eq != null) return String(cur) === String(rule.eq);
    if (rule.in && rule.in.length) {
      return rule.in.some(function (v) { return String(cur) === String(v); });
    }
    return true;
  }

  function wireFieldVisibility(formCard, fields) {
    if (!formCard || !fields || !fields.length) return;
    var gated = fields.filter(function (f) { return f && f.visibleWhen; });
    if (!gated.length) return;
    function values() {
      var out = {};
      formCard.querySelectorAll('[data-calc-field]').forEach(function (el) {
        var id = el.getAttribute('data-calc-field');
        if (id) out[id] = el.value;
      });
      return out;
    }
    function sync() {
      var vals = values();
      gated.forEach(function (f) {
        var el = formCard.querySelector('[data-calc-field="' + f.id + '"]');
        if (!el) return;
        var wrap = el.closest ? el.closest('.d4-f-field') : null;
        var show = fieldVisibleForValues(f, vals);
        if (wrap) wrap.hidden = !show;
        el.disabled = !show;
      });
      var mode = vals.dilution_mode || 'ratio';
      var chipWrap = formCard.querySelector('.calc-d4-ratio-chips-wrap');
      if (chipWrap) chipWrap.hidden = mode !== 'ratio';
      // Hide the suggested-ratio chip row when not in Ratio mode
      formCard.querySelectorAll('.calc-d4-ratio-chips-section:not(.calc-d4-container-presets-section):not([data-dilution-mode-chips])').forEach(function (row) {
        if (row.querySelector('[data-ratio-chip]')) row.hidden = mode !== 'ratio';
      });
    }
    if (!formCard._oporaVisWired) {
      formCard._oporaVisWired = true;
      formCard.addEventListener('change', sync);
      formCard.addEventListener('input', sync);
    }
    sync();
  }

  /** Floor Program: finish + equipment follow FLOOR_DATABASE for the selected substrate index. */
  function wireFloorFinishOptions(formCard) {
    if (!formCard) return;
    var helpers = global.OporaFloorProgram;
    if (!helpers || typeof helpers.profile !== 'function') {
      if (!formCard._oporaFloorFinishRetry) {
        formCard._oporaFloorFinishRetry = true;
        setTimeout(function () { wireFloorFinishOptions(formCard); }, 50);
      }
      return;
    }

    function ensureEquipBanner() {
      var host = formCard.querySelector('[data-calc-field="primary_equipment"]');
      host = host && (host.closest('.d4-f-field') || host.parentNode);
      if (!host) return null;
      var banner = formCard.querySelector('[data-floor-equip-warn]');
      if (!banner) {
        banner = document.createElement('div');
        banner.className = 'calc-d4-alert calc-d4-alert--warn';
        banner.setAttribute('data-floor-equip-warn', '1');
        banner.setAttribute('role', 'status');
        banner.hidden = true;
        banner.innerHTML = '<p class="calc-d4-alert-text" data-floor-equip-warn-text></p>';
        if (host.parentNode) host.parentNode.insertBefore(banner, host.nextSibling);
        else formCard.appendChild(banner);
      }
      return banner;
    }

    function syncFinishAndEquipment(resetToPrimary) {
      var floorEl = formCard.querySelector('[data-calc-field="floor_type"]');
      var finishEl = formCard.querySelector('[data-calc-field="finish_status"]');
      var equipEl = formCard.querySelector('[data-calc-field="primary_equipment"]');
      if (!floorEl || !finishEl) return;
      var idx = parseInt(floorEl.value, 10);
      if (isNaN(idx)) idx = 0;
      var profile = helpers.profile(idx);
      var opts = helpers.finishOpts(idx) || [];
      var prevIdx = finishEl.getAttribute('data-floor-idx');
      var next;
      // Substrate change → always jump to that substrate's default finish
      if (resetToPrimary || prevIdx == null || String(prevIdx) !== String(idx)) {
        next = helpers.defaultFinish(idx) || (opts[0] && opts[0].value) || '';
      } else {
        next = helpers.clampFinish(idx, finishEl.value);
      }
      finishEl.innerHTML = opts.map(function (o) {
        var sel = String(o.value) === String(next) ? ' selected' : '';
        return '<option value="' + esc(o.value) + '"' + sel + '>' + esc(o.label) + '</option>';
      }).join('');
      finishEl.value = next;
      finishEl.setAttribute('data-floor-idx', String(idx));
      try {
        finishEl.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (eSync) { /* ignore */ }

      if (equipEl) {
        var rawEquip = equipEl.value;
        var clamped = helpers.clampEquipment(idx, rawEquip);
        var warn = '';
        if (clamped !== rawEquip) {
          equipEl.value = clamped;
          warn = helpers.equipmentWarning(idx, rawEquip) ||
            ('Equipment reset to a safe baseline for ' + (profile.name || 'this substrate') + '.');
        } else {
          warn = helpers.equipmentWarning(idx, rawEquip) || '';
        }
        var banner = ensureEquipBanner();
        if (banner) {
          var textEl = banner.querySelector('[data-floor-equip-warn-text]');
          if (warn) {
            if (textEl) textEl.textContent = warn;
            banner.hidden = false;
          } else {
            banner.hidden = true;
          }
        }
      }
    }

    if (!formCard._oporaFloorFinishDelegated) {
      formCard._oporaFloorFinishDelegated = true;
      formCard.addEventListener('change', function (e) {
        var t = e.target;
        if (!t) return;
        var field = t.getAttribute('data-calc-field');
        if (field === 'floor_type') {
          syncFinishAndEquipment(true);
        } else if (field === 'primary_equipment') {
          syncFinishAndEquipment(false);
        }
      });
    }
    syncFinishAndEquipment(false);
  }

  /** Pad Selector: finish options follow PAD_FINISH_OPTS for the selected floor string key. */
  function wirePadFinishOptions(formCard) {
    if (!formCard) return;
    var helpers = global.OporaPadSelector;
    if (!helpers || typeof helpers.finishOpts !== 'function') {
      if (!formCard._oporaPadFinishRetry) {
        formCard._oporaPadFinishRetry = true;
        setTimeout(function () { wirePadFinishOptions(formCard); }, 50);
      }
      return;
    }

    function syncPadFinish(resetToPrimary) {
      var floorEl = formCard.querySelector('[data-calc-field="floor_type"]');
      var finishEl = formCard.querySelector('[data-calc-field="finish_status"]');
      if (!floorEl || !finishEl) return;
      var floor = floorEl.value || 'VCT';
      var opts = helpers.finishOpts(floor) || [];
      var prevFloor = finishEl.getAttribute('data-pad-floor');
      var next;
      if (resetToPrimary || prevFloor == null || String(prevFloor) !== String(floor)) {
        next = helpers.defaultFinish(floor) || (opts[0] && opts[0].value) || '';
      } else {
        next = helpers.clampFinish(floor, finishEl.value);
      }
      finishEl.innerHTML = opts.map(function (o) {
        var sel = String(o.value) === String(next) ? ' selected' : '';
        return '<option value="' + esc(o.value) + '"' + sel + '>' + esc(o.label) + '</option>';
      }).join('');
      finishEl.value = next;
      finishEl.setAttribute('data-pad-floor', String(floor));
      try {
        finishEl.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (eSync) { /* ignore */ }
    }

    if (!formCard._oporaPadFinishDelegated) {
      formCard._oporaPadFinishDelegated = true;
      formCard.addEventListener('change', function (e) {
        var t = e.target;
        if (!t) return;
        if (t.getAttribute('data-calc-field') === 'floor_type') {
          syncPadFinish(true);
        }
      });
    }
    syncPadFinish(false);
  }

  /** Visible Ratio / Target PPM chips so healthcare operators do not miss PPM mode. */
  function ensureDilutionModeChips(formCard, sampleFields, runFn) {
    if (!formCard || formCard.querySelector('[data-dilution-mode-chips]')) return;
    var modeEl = formCard.querySelector('[data-calc-field="dilution_mode"]');
    if (!modeEl) return;
    var wrap = document.createElement('div');
    wrap.className = 'd4-form-row calc-d4-ratio-chips-section';
    wrap.setAttribute('data-dilution-mode-chips', '1');
    wrap.innerHTML =
      '<p class="calc-d4-mode-chip-label">Quick mode</p>' +
      '<div class="calc-d4-ratio-chips" role="group" aria-label="Dilution mode">' +
        '<button type="button" class="calc-d4-ratio-chip" data-dilution-mode-chip="ratio">Ratio (1:X)</button>' +
        '<button type="button" class="calc-d4-ratio-chip" data-dilution-mode-chip="ppm">Target PPM</button>' +
      '</div>';
    var modeGrid = modeEl.closest('.d4-form-grid-2') || modeEl.closest('.d4-f-field');
    if (modeGrid && modeGrid.parentNode) {
      modeGrid.parentNode.insertBefore(wrap, modeGrid.nextSibling);
    } else {
      formCard.insertBefore(wrap, formCard.firstChild);
    }
    function syncChips() {
      var mode = modeEl.value || 'ratio';
      wrap.querySelectorAll('[data-dilution-mode-chip]').forEach(function (b) {
        b.classList.toggle('calc-d4-ratio-chip--active', b.getAttribute('data-dilution-mode-chip') === mode);
      });
    }
    wrap.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-dilution-mode-chip]') : null;
      if (!btn) return;
      modeEl.value = btn.getAttribute('data-dilution-mode-chip');
      if (sampleFields && sampleFields.clearOne) sampleFields.clearOne(modeEl);
      modeEl.dispatchEvent(new Event('change', { bubbles: true }));
      syncChips();
      if (typeof runFn === 'function') runFn({ record: false });
    });
    modeEl.addEventListener('change', syncChips);
    syncChips();
  }

  function wireProductionModePanels(formCard) {
    if (!formCard) return;
    var modeEl = formCard.querySelector('[data-calc-field="mode"]');
    var panels = formCard.querySelectorAll('[data-mode-panel]');
    if (!modeEl || !panels.length) return;
    function sync() {
      var mode = modeEl.value === 'detailed' ? 'detailed' : 'simple';
      panels.forEach(function (p) {
        var show = p.getAttribute('data-mode-panel') === mode;
        p.hidden = !show;
      });
    }
    modeEl.addEventListener('change', sync);
    sync();
  }

  function buildFormRows(fields, prefill, sectionLabel, slug) {
    if (!fields.length) return '';
    return '<div class="d4-form-row"><span class="d4-form-section-label">' + esc(sectionLabel) + '</span>' +
      buildFieldGrids(fields, prefill, slug) + '</div>';
  }

  function collectInputs(formRoot, fields) {
    var out = {};
    fields.forEach(function (f) {
      var el = formRoot.querySelector('[data-calc-field="' + f.id + '"]');
      if (!el || el.disabled) return;
      if (f.type === 'checkbox') out[f.id] = el.checked;
      else out[f.id] = el.value;
    });
    return out;
  }

  function updateChips(chipRow, fields, formRoot) {
    if (!chipRow) return;
    var chips = [];
    fields.filter(function (f) { return !f.advanced && f.type !== 'checkbox'; }).slice(0, 3).forEach(function (f) {
      var el = formRoot.querySelector('[data-calc-field="' + f.id + '"]');
      var v = el ? el.value : f.default;
      if (v !== '' && v != null) chips.push(f.label.split('(')[0].trim() + ': ' + v);
    });
    chipRow.innerHTML = chips.map(function (c) {
      return '<span class="d4-smart-chip">' + CHIP_SVG + esc(c) + '</span>';
    }).join('');
  }

  /** Apply calculator-driven field hints (e.g. Auto: N fixture placeholder). */
  function applySyncFields(formRoot, sync) {
    if (!formRoot || !sync) return;
    Object.keys(sync).forEach(function (fid) {
      var el = formRoot.querySelector('[data-calc-field="' + fid + '"]');
      if (!el) return;
      var s = sync[fid] || {};
      if (s.placeholder != null) el.setAttribute('placeholder', s.placeholder);
      if (s.value != null) el.value = s.value;
      if (s.clearValue) {
        var cur = String(el.value == null ? '' : el.value).trim();
        // Clear blank/0 so the Auto: N placeholder is visible (avoids 0 vs 16 contradiction)
        if (cur === '' || cur === '0') el.value = '';
      }
      if (s.hint != null) {
        var wrap = el.closest ? el.closest('.d4-f-field') : null;
        var hintEl = wrap && wrap.querySelector('.d4-f-hint');
        if (hintEl) hintEl.textContent = s.hint;
        var tipEl = wrap && wrap.querySelector('.d4-f-info__tip');
        if (tipEl) tipEl.textContent = s.hint;
      }
    });
  }

  function renderResults(body, errPanel, panel, result, def, slug) {
    errPanel.classList.remove('d4-visible');
    errPanel.textContent = '';
    body.innerHTML = '';

    if (!result.valid) {
      var errList = result.errors;
      var errMsg = (errList && errList.length)
        ? errList.join(' ')
        : ((errList == null) ? 'Please correct invalid inputs.' : '');
      if (errMsg) {
        errPanel.textContent = errMsg;
        errPanel.classList.add('d4-visible');
      } else {
        errPanel.textContent = '';
        errPanel.classList.remove('d4-visible');
      }
      if (result.resultHint) {
        panel.classList.add('d4-visible');
        panel.classList.remove('calc-d4-result--example');
        var hintClass = 'd4-result-hint' + (result.resultHintLevel === 'warn' ? ' d4-result-hint--warn' : '');
        body.innerHTML = '<p class="' + hintClass + '">' + esc(result.resultHint) + '</p>';
      } else {
        panel.classList.remove('d4-visible');
        body.innerHTML = '';
      }
      panel.removeAttribute('data-pad');
      delete panel.dataset.lastResult;
      var capInvalid = panel.querySelector('[data-calc-capture]');
      if (capInvalid) capInvalid.hidden = true;
      return;
    }

    panel.classList.add('d4-visible');
    if (result.padKey) panel.setAttribute('data-pad', result.padKey);
    else panel.removeAttribute('data-pad');
    var archSlug = slug || (def && def.slug) || '';
    var archetype = calcArchetype(archSlug);
    panel.setAttribute('data-archetype', archetype);
    var wc = getWcMeta(archSlug);
    var html = '';

    // Script picker: beats-first layout (copy + demoted coaching)
    if (result.layout === 'script') {
      html += scriptPackHtml(result, def, wc);
      html += primaryHandoffHtml(wc, result);
      body.innerHTML = html;
      panel.dataset.lastResult = JSON.stringify(result);
      bindCopyScript(body, result.copyText, result.copyLabel);
      var captureScript = panel.querySelector('[data-calc-capture]');
      if (captureScript && captureScript.parentNode === panel) {
        panel.appendChild(captureScript);
      }
      return;
    }

    // 1) Aha metrics
    if (result.metrics && result.metrics.length) {
      var metricClass = 'calc-d4-metrics' + (result.metrics.length > 2 ? ' calc-d4-metrics--multi' : '') +
        (result.metrics.length >= 4 ? ' calc-d4-metrics--4' :
          (result.metrics.length === 3 ? ' calc-d4-metrics--3' : ''));
      html += '<div class="' + metricClass + '">';
      result.metrics.forEach(function (m) {
        var hero = m.hero ? ' calc-d4-metric--hero' : '';
        var toneCls = '';
        var accent = m.accent ? ' calc-d4-metric-value--accent' : '';
        if (m.tone === 'bad') {
          accent = ' calc-d4-metric-value--danger';
          toneCls = ' calc-d4-metric--tone-bad';
        } else if (m.tone === 'warn') {
          accent = ' calc-d4-metric-value--warn';
          toneCls = ' calc-d4-metric--tone-warn';
        } else if (m.tone === 'ok') {
          accent = ' calc-d4-metric-value--ok';
          toneCls = ' calc-d4-metric--tone-ok';
        }
        html += '<div class="calc-d4-metric' + hero + toneCls + '">' +
          '<p class="calc-d4-metric-label">' + esc(m.label) + '</p>' +
          '<p class="calc-d4-metric-value' + accent + '">' + esc(m.value) + '</p>';
        if (m.sub) html += '<p class="calc-d4-metric-sub">' + esc(m.sub) + '</p>';
        html += '</div>';
      });
      html += '</div>';
    } else if (result.primary) {
      html += '<div class="calc-d4-metrics calc-d4-metrics--verdict"><div class="calc-d4-metric">' +
        '<p class="calc-d4-metric-label">' + esc(def.primaryLabel || 'Result') + '</p>' +
        '<p class="calc-d4-metric-value calc-d4-metric-value--accent">' + esc(result.primary) + '</p></div>';
      if (result.secondary) {
        var secProse = String(result.secondary).length > 24 ? ' calc-d4-metric-value--prose' : '';
        html += '<div class="calc-d4-metric"><p class="calc-d4-metric-label">' + esc(result.secondaryLabel || 'Detail') + '</p>' +
          '<p class="calc-d4-metric-value' + secProse + '">' + esc(result.secondary) + '</p></div>';
      }
      html += '</div>';
    }

    // Stress / risk gauge (hand prototype archetype)
    if (archetype === 'stress' || result.vulnerability) {
      html += vulnerabilityGaugeHtml(result);
    }

    // 2) So-what callout
    html += wcSoWhatHtml(result, wc);

    // 2b) Risk / alert banner (e.g. ABC-test states)
    html += alertBannerHtml(result);

    // 3) Status pill under so-what
    html += statusPillHtml(result);
    html += dwellHtml(result);

    // 3b) Top copy toolbar (clause checklists, etc.)
    var copyAtTop = !!(result.copyText && result.copyTop);
    if (copyAtTop) html += topCopyToolbarHtml(result);

    // Mixing / bands / equiv (tool-specific, before trust)
    if (result.instruction) {
      html += '<div class="calc-d4-instruction" role="note">' +
        '<span class="calc-d4-instruction-label">Mixing instruction</span>' +
        '<p class="calc-d4-instruction-text">' + esc(result.instruction) + '</p></div>';
    }

    if (result.bands && result.bands.length) {
      html += '<div class="calc-d4-bands">';
      result.bands.forEach(function (b) {
        html += '<div class="calc-d4-band' + (b.target ? ' calc-d4-band--target' : '') + '">' +
          '<span class="calc-d4-band-label">' + esc(b.label) + '</span>' +
          '<strong class="calc-d4-band-value">' + esc(b.value) + '</strong></div>';
      });
      html += '</div>';
    }

    html += rangeBarHtml(result.rangeBar);
    html += leakageProofHtml(result.leakageProof);
    if (result.rateHint && result.rateHint.suggested != null) {
      var sug = Number(result.rateHint.suggested);
      var sugLabel = isFinite(sug) ? ('$' + sug.toFixed(2) + '/sqft') : 'suggested rate';
      html += '<div class="calc-d4-rate-hint" role="note">' +
        '<p class="calc-d4-rate-hint-text">' + esc(result.rateHint.message || 'Check your $/sqft/yr entry.') + '</p>' +
        '<button type="button" class="calc-d4-rate-hint-btn" data-apply-field="your_rate" data-apply-value="' +
          esc(String(sug)) + '">Use ' + esc(sugLabel) + '</button>' +
        '</div>';
    }
    html += breakdownHtml(result.breakdown);
    if (result.mixNote) {
      html += '<p class="calc-d4-mix-note">' + esc(result.mixNote) + '</p>';
    }

    if (result.equiv) {
      html += '<div class="calc-d4-equiv" aria-label="Dilution equivalents">' +
        '<div class="calc-d4-equiv-item"><span class="calc-d4-equiv-label">Ratio</span><span class="calc-d4-equiv-value">' + esc(result.equiv.ratio) + '</span></div>' +
        '<div class="calc-d4-equiv-item"><span class="calc-d4-equiv-label">Oz/gal</span><span class="calc-d4-equiv-value">' + esc(result.equiv.ozPerGal) + '</span></div>' +
        '<div class="calc-d4-equiv-item"><span class="calc-d4-equiv-label">Percent</span><span class="calc-d4-equiv-value">' + esc(result.equiv.percent) + '</span></div>' +
        '</div>';
    }

    // 4) Trust line (prototype: before detail)
    html += wcTrustHtml(wc);

    // 5) Detail rows / structured lists
    var rows = (result.rows || []).filter(function (row) {
      var lab = String(row.label || '');
      if (/^note$/i.test(lab)) return false;
      if (/disclaimer|methodology|seeds/i.test(lab)) return false;
      // Status / guidance live in the pill + CTA hint — don't repeat in the summary card
      if (/^(status|guidance)$/i.test(lab)) return false;
      if (/your annual \(if entered\)/i.test(lab) && (!row.value || row.value === '—')) return false;
      return true;
    });
    if ((!rows.length || !rows.some(function (row) {
      return (row.meta && row.meta.length) || row.ok !== undefined || row.warn;
    })) && result.clauses && result.clauses.length) {
      rows = result.clauses.map(function (c, i) {
        if (typeof c === 'string') {
          return { label: (i + 1) + '. Clause', value: '', meta: [{ k: 'Language', v: c }] };
        }
        return {
          label: (i + 1) + '. ' + (c.title || 'Clause'),
          value: '',
          meta: [{ k: 'Language', v: c.detail || c.text || '' }]
        };
      });
    }
    // If scenarios will render, drop duplicate plain rows with the same labels
    if (result.scenarios && result.scenarios.length && rows.length) {
      var scenarioNames = {};
      result.scenarios.forEach(function (s) {
        scenarioNames[String(s.name || '').toLowerCase()] = true;
      });
      rows = rows.filter(function (row) {
        return !scenarioNames[String(row.label || '').toLowerCase()];
      });
    }

    if (rows.length) {
      if (result.bands && result.bands.length) {
        var bandLabels = {};
        result.bands.forEach(function (b) { bandLabels[String(b.label || '').toLowerCase()] = true; });
        rows = rows.filter(function (row) {
          return !bandLabels[String(row.label || '').toLowerCase()];
        });
      }
      if (rows.length) {
        var hasCards = rows.some(function (row) { return row.meta && row.meta.length; });
        var hasChecks = rows.some(function (row) { return row.ok !== undefined || row.warn; });
        if (hasCards) {
          html += '<div class="calc-d4-compare-list">';
          rows.forEach(function (row) {
            html += '<article class="calc-d4-compare' + (row.target ? ' calc-d4-compare--target' : '') + '">';
            html += '<div class="calc-d4-compare-head"><span class="calc-d4-compare-name">' + esc(row.label) + '</span>';
            if (row.value) {
              var fitOk = /fit/i.test(String(row.value));
              html += '<span class="calc-d4-pill calc-d4-pill--' + (fitOk ? 'ok' : 'warn') + '">' + esc(row.value) + '</span>';
            }
            html += '</div><dl class="calc-d4-compare-meta">';
            (row.meta || []).forEach(function (m) {
              html += '<div><dt>' + esc(m.k) + '</dt><dd>' + esc(m.v) + '</dd></div>';
            });
            html += '</dl></article>';
          });
          html += '</div>';
        } else if (hasChecks) {
          html += '<ul class="calc-d4-checklist">';
          rows.forEach(function (row) {
            var tone = row.ok === false ? 'bad' : (row.warn ? 'warn' : 'ok');
            var mark = row.ok === false ? '✕' : (row.warn ? '!' : '✓');
            var stack = String(row.value || '').length > 28 ? ' calc-d4-check--stack' : '';
            html += '<li class="calc-d4-check calc-d4-check--' + tone + stack + '">' +
              '<span class="calc-d4-check-mark" aria-hidden="true">' + mark + '</span>' +
              '<span class="calc-d4-check-label">' + esc(row.label) + '</span>' +
              (row.value != null && row.value !== ''
                ? '<span class="calc-d4-check-value">' + esc(row.value) + '</span>'
                : '') +
              '</li>';
          });
          html += '</ul>';
        } else {
          html += detailRowsHtml(rows);
        }
      }
    }

    if (result.scenarios && result.scenarios.length) {
      html += stressScenariosHtml(result);
    }

    if (result.recommended) {
      html += '<p class="calc-d4-narrative"><strong>Recommended:</strong> ' + esc(result.recommended);
      if (result.reason) html += ': ' + esc(result.reason);
      html += '</p>';
    }

    var copyInLetter = false;
    if (result.narrative) {
      var structuredBody = rows && rows.some(function (row) {
        return (row.meta && row.meta.length) || row.ok !== undefined || row.warn;
      });
      var noteLabel = result.narrativeLabel || 'Note';
      var soWhatText = (result.soWhat || (wc && wc.soWhat) || '').trim();
      var narrativeDup = soWhatText && String(result.narrative).trim() === soWhatText;
      if (!narrativeDup) {
        if (result.narrative.indexOf('\n') >= 0 && !structuredBody) {
          copyInLetter = !!(result.copyText);
          html += '<div class="calc-d4-letter">';
          html += '<div class="calc-d4-letter-head">';
          html += '<span class="calc-d4-letter-label">' + esc(noteLabel === 'Note' ? 'Letter' : noteLabel) + '</span>';
          if (copyInLetter) {
            html += '<div class="calc-d4-letter-actions">' +
              '<button type="button" class="calc-d4-copy-script" data-copy-script>' +
              esc(result.copyLabel || 'Copy letter') + '</button>' +
              '<span class="calc-d4-copy-status" data-copy-status hidden>Copied</span>' +
              '</div>';
          }
          html += '</div>';
          html += '<pre class="calc-d4-narrative-block">' + esc(result.narrative) + '</pre>';
          html += '</div>';
        } else if (result.secondary || structuredBody || result.narrativeLabel) {
          html += '<p class="calc-d4-narrative"><strong>' + esc(noteLabel) + '</strong> ' + esc(result.narrative) + '</p>';
        } else {
          html += '<p class="calc-d4-narrative">' + esc(result.narrative) + '</p>';
        }
      }
    }

    // 6) Copy summary (when provided) + primary handoff
    if (!copyInLetter && !copyAtTop) html += copyActionHtml(result);
    html += primaryHandoffHtml(wc, result);

    body.innerHTML = html;
    panel.dataset.lastResult = JSON.stringify(result);
    if (result.copyText) bindCopyScript(body, result.copyText, result.copyLabel);

    // Ensure capture is last child of result panel (after body)
    var capture = panel.querySelector('[data-calc-capture]');
    if (capture && capture.parentNode === panel) {
      panel.appendChild(capture);
    }
  }

  /** ASCII thousands commas (never locale nbsp / thin-space separators). */
  function asciiCommaInt(n) {
    return String(Math.round(Number(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function isMoneyField(field) {
    if (!field) return false;
    if (field.type === 'currency') return true;
    var id = String(field.id || '');
    var lab = String(field.label || '');
    // Hours / counts are never currency — even when id contains "annual_" (annual_hours)
    if (/(^|_)(hours?|hrs?|days?|sqft|porters?|shift|qty|quantity|count|ratio|ppm|level)(_|$)/i.test(id) &&
      !/\$/.test(lab)) {
      return false;
    }
    if (/\$/.test(lab)) return true;
    if (/price\s*\/\s*range|price\s*band|price\s*range/i.test(lab)) return true;
    return /(^|_)(value|price|cost|amount|fee|revenue|wage|salary|contract_value|monthly|annual_(?:cost|spend|revenue|value|contract)|bill_rate|price_band)(_|$)/i
      .test(id);
  }

  function formatMoneyInputDisplay(raw, field) {
    var s = String(raw == null ? '' : raw).trim();
    if (!s) return '';
    var idLab = String((field && field.id) || '') + String((field && field.label) || '');
    var isPriceBand = /price_band|price\s*\/\s*range|range to mention/i.test(idLab);
    // Corridor: 2000-2500 — never parseFloat-truncate to the low end only
    if (isPriceBand) {
      var cleaned = s.replace(/[$,]/g, '').trim();
      var range = cleaned.match(/^(\d+(?:\.\d+)?)\s*(?:[-–—]|to)\s*(\d+(?:\.\d+)?)$/i);
      if (range) {
        var lo = parseFloat(range[1]);
        var hi = parseFloat(range[2]);
        if (!isNaN(lo) && !isNaN(hi) && lo > 0 && hi > 0) {
          if (hi < lo) {
            var swap = lo;
            lo = hi;
            hi = swap;
          }
          return '$' + Math.round(lo).toLocaleString('en-US') + '–$' +
            Math.round(hi).toLocaleString('en-US') + '/mo';
        }
      }
    }
    if (/\$/.test(s) || /\/\s*mo|per\s*month|range|–|—|\bto\b/i.test(s)) return s;
    var n = parseFloat(s.replace(/,/g, ''));
    if (isNaN(n) || !isFinite(n)) return s;
    var withCents = Math.abs(n - Math.round(n)) >= 1e-9;
    var num = withCents
      ? n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : asciiCommaInt(n);
    // Only price-band style fields get /mo; contract monthly rates stay $X,XXX.00
    var suffix = isPriceBand ? '/mo' : '';
    return '$' + num + suffix;
  }

  function isPercentField(field) {
    if (!field) return false;
    var lab = String(field.label || '');
    if (/\(%\)|percent/i.test(lab)) return true;
    return /(^|_)(pct|percent)(_|$)/i.test(String(field.id || ''));
  }

  function fieldDisplayValue(field, el) {
    if (!el) return '';
    if (field.type === 'checkbox') return el.checked ? 'Yes' : 'No';
    if (field.type === 'select') {
      var opt = el.options[el.selectedIndex];
      var selText = opt ? opt.textContent.trim() : el.value;
      // NAICS option labels: keep code ungrouped ("561720 — Janitorial…")
      if (/naics/i.test(String(field.id || '') + String(field.label || ''))) {
        return String(selText).replace(/\b(\d{2}),(\d{3})\b/g, '$1$2');
      }
      return selText;
    }
    // Insurance EMR / experience mod: always two actuarial decimals ("1.00") — text or number
    if (/(^|_)(wc_mod|emr)(_|$)/i.test(String(field.id || '')) ||
      /experience mod|\bemr\b/i.test(String(field.label || ''))) {
      var emrRaw = String(el.value == null ? '' : el.value).trim();
      if (!emrRaw) return '';
      var emrN = parseFloat(emrRaw.replace(/,/g, ''));
      if (!isNaN(emrN) && isFinite(emrN)) return emrN.toFixed(2);
      return emrRaw;
    }
    if (field.type === 'number' || field.type === 'currency') {
      var raw = String(el.value == null ? '' : el.value).trim();
      if (!raw) return '';
      var n = parseFloat(raw.replace(/,/g, ''));
      if (!isNaN(n) && isFinite(n)) {
        if (isMoneyField(field)) {
          // Standard money inputs: always cents. Text price bands use formatMoneyInputDisplay.
          return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
        // Calendar / log years: never thousands-comma (2026 not 2,026)
        if (/(^|_)(year|yr)(_|$)/i.test(String(field.id || '')) ||
          /\byear\b/i.test(String(field.label || ''))) {
          return String(Math.round(n));
        }
        var numStr;
        // Whole numbers get commas; keep decimals as entered (trimmed).
        if (Math.abs(n - Math.round(n)) < 1e-9) numStr = asciiCommaInt(n);
        else numStr = n.toLocaleString('en-US', { maximumFractionDigits: 4 });
        if (isPercentField(field) && numStr && !/%\s*$/.test(numStr)) return numStr + '%';
        // Operating hours: unit string, never a bare integer that assessors confuse with $
        if (/(^|_)(hours?|hrs?)(_|$)/i.test(String(field.id || '')) &&
          !/\$/.test(String(field.label || ''))) {
          if (/annual|year|yr|operating/i.test(String(field.id || '') + String(field.label || ''))) {
            return numStr + ' hrs/yr';
          }
          return numStr + ' hrs';
        }
        return numStr;
      }
    }
    // Text money fields (e.g. price_band "2345" → $2,345/mo)
    if (isMoneyField(field) && field.type === 'text') {
      return formatMoneyInputDisplay(el.value, field);
    }
    // Prose name / month fields — title-case for PDF audit + letter consistency
    if (field.type === 'text' &&
      /^(client_name|company_name|contractor_name|renewal_month)$/i.test(String(field.id || ''))) {
      var capFn = (global.OporaCalcShared && global.OporaCalcShared.capitalizeWords) || function (x) {
        return String(x || '').replace(/[A-Za-z][A-Za-z']*/g, function (w) {
          return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
        });
      };
      return capFn(el.value);
    }
    return el.value;
  }

  /** Strip LaTeX math fences / commands that assessors misread in PDF text streams. */
  function stripPdfLatexArtifacts(s) {
    var locked = [];
    var out = String(s == null ? '' : s)
      // Unicode ops → ASCII before fence logic (1–2×/week must never look like math mode)
      .replace(/×/g, 'x')
      .replace(/[–—]/g, '-')
      .replace(/→/g, '->')
      // Peel LaTeX text-style wrappers assessors invent: $\mathbf{\$77.73/hr}$
      .replace(/\\(?:mathbf|textbf|mathit|textit|mathrm|textrm|text|boldmath|bm)\s*\{([^{}]*)\}/gi, '$1')
      .replace(/\\(?:mathbf|textbf|mathit|textit|mathrm|textrm|text|boldmath|bm)\b/gi, '')
      // Lock real $amounts so $...$ fence logic cannot eat "$4,079.68 day vs $2,781"
      .replace(/\$\s*[\d,]+(?:\.\d+)?(?:\s*\/\s*(?:mo|yr|hr|sf(?:\s*\/\s*yr)?|day))?/gi, function (tok) {
        locked.push(String(tok).replace(/\s+/g, ''));
        return '\u0001CUR' + (locked.length - 1) + '\u0001';
      })
      .replace(/\$\$([\s\S]+?)\$\$/g, '$1')
      .replace(/\$([^$\n]+)\$/g, function (_m, inner) {
        var t = String(inner || '');
        // Currency-only tokens keep a leading $; unit / mix / cadence math never stays fenced
        if (/^\s*\\?\$?\s*[\d,]+(?:\.\d+)?(?:\s*\/\s*(?:mo|yr|hr))?\s*$/i.test(t) && !/[a-z]/i.test(t.replace(/\/(?:mo|yr|hr)/i, ''))) {
          return '$' + t.replace(/^\$+/, '').replace(/\\\$/g, '').trim();
        }
        return t
          .replace(/\\times/gi, ' x ')
          .replace(/\\cdot/gi, ' x ')
          .replace(/\\mathrm\{([^}]+)\}/g, '$1')
          .replace(/\\(?:mathbf|textbf|mathit|textit|textrm|text)\s*\{([^{}]*)\}/gi, '$1')
          .replace(/\\,/g, ' ')
          .replace(/\\ /g, ' ')
          .replace(/~/g, ' ');
      })
      // Cadence fences assessors invent: $1-2x/week.$ → 1-2x/week.
      .replace(/\$(\d[\d.\-]*\s*x?\s*\/\s*(?:day|week|mo|yr|hr)\.?)\$/gi, '$1')
      .replace(/\$(\d[\d.\-]*\s*-\s*\d[\d.\-]*\s*x?\s*\/\s*(?:day|week|mo|yr|hr)\.?)\$/gi, '$1')
      .replace(/(\d[\dx.\-\/]*(?:day|week|mo|yr|hr))\s*\.?\s*\$/gi, '$1')
      // Pad aggressiveness fences: $3/5$ → 3/5; (3/5) → 3 of 5
      // Never rewrite calendar year ranges: (2026/2028) stays (2026 / 2028)
      .replace(/\$(\d+(?:\.\d+)?\s*\/\s*\d+)\$/g, '$1')
      .replace(/\((\d+(?:\.\d+)?)\s*\/\s*(\d+)\)/g, function (_m, a, b) {
        if (/^(19|20)\d{2}$/.test(String(a)) && /^(19|20)\d{2}$/.test(String(b))) {
          return '(' + a + ' / ' + b + ')';
        }
        return a + ' of ' + b;
      })
      .replace(/\\times/gi, ' x ')
      .replace(/\\cdot/gi, ' x ')
      .replace(/\\mathrm\{([^}]+)\}/g, '$1')
      .replace(/\\(?:mathbf|textbf|mathit|textit|textrm|text)\s*\{([^{}]*)\}/gi, '$1')
      .replace(/(\d)\s*~\s*/g, '$1 ')
      .replace(/\s{2,}/g, ' ')
      .trim();
    return out.replace(/\u0001CUR(\d+)\u0001/g, function (_m, idx) {
      return locked[Number(idx)] || '';
    });
  }

  /**
   * Executive-summary card values: always plain "$77.73/hr" (never $\mathbf{\$…}$ fences).
   * Prefer extracting a currency+/unit token when present.
   */
  function plainPdfCardValue(val) {
    var t = stripPdfLatexArtifacts(String(val == null ? '' : val));
    t = t
      .replace(/\\(?:mathbf|textbf|mathit|textit|mathrm|textrm|text|boldmath|bm)\s*\{([^{}]*)\}/gi, '$1')
      .replace(/\\+\$/g, '$')
      .replace(/[{}]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    var rate = t.match(/([+\-−])?\s*\$?\s*([\d,]+(?:\.\d+)?)\s*\/\s*(hr|mo|yr|day)\b/i);
    if (rate && /^\s*[+\-−]?\$?[\d,]/.test(t) && t.length < 48) {
      var signR = rate[1] ? rate[1].replace('−', '-') : '';
      return signR + '$' + rate[2].replace(/\s+/g, '') + '/' + rate[3].toLowerCase();
    }
    // Preserve signed deltas + savings asides: -$6,761.01 (W-2 savings)
    var signedMoney = t.match(/^([+\-\u2212])\s*\$\s*([\d,]+(?:\.\d+)?)/);
    if (signedMoney && t.length < 72) {
      var sign = signedMoney[1] === '\u2212' ? '-' : signedMoney[1];
      var aside = '';
      var asideMatch = t.slice(signedMoney[0].length).match(/^\s*[\(\u00B7\-\u2013\u2014]\s*([^)\]]+?)\)?\s*$/);
      if (asideMatch) aside = String(asideMatch[1] || '').trim();
      return sign + '$' + signedMoney[2].replace(/\s+/g, '') + (aside ? (' (' + aside + ')') : '');
    }
    var money = t.match(/\$\s*([\d,]+(?:\.\d+)?)/);
    if (money && t.length < 48) {
      // Keep valuation brackets / compact $NM spans — never collapse "$1.17M - $1.56M" to "$1.17"
      if ((t.match(/\$/g) || []).length > 1 || /\$[\d,.]+\s*[MKB]\b/i.test(t)) {
        return formatPdfMetricValue(t);
      }
      return '$' + money[1].replace(/\s+/g, '');
    }
    return formatPdfMetricValue(t);
  }

  /**
   * jsPDF emits literal strings as `(plain text) Tj`. LLM assessors misread those PDF
   * delimiters as LaTeX math (`$1.920~oz/gal$`, `$267\times32$`). Force WinAnsi show
   * strings to hex `<…> Tj` at generation time (xref-safe) via postProcessText.
   */
  function patchPdfHexShowStrings(pdf) {
    if (!pdf || pdf.__oporaHexShow) return;
    pdf.__oporaHexShow = true;
    var ev = pdf.internal && pdf.internal.events;
    if (!ev || typeof ev.subscribe !== 'function') return;

    function toHex(str) {
      var s = String(str == null ? '' : str);
      var h = '';
      for (var i = 0; i < s.length; i++) {
        var c = s.charCodeAt(i);
        if (c > 255) c = 63; // '?'
        h += (c < 16 ? '0' : '') + c.toString(16);
      }
      return h;
    }

    function convertText(text) {
      if (typeof text === 'string') return toHex(text);
      if (!Array.isArray(text)) return text;
      return text.map(function (line) {
        if (typeof line === 'string') return toHex(line);
        if (Array.isArray(line) && typeof line[0] === 'string') {
          return [toHex(line[0]), line[1], line[2]];
        }
        return line;
      });
    }

    ev.subscribe('postProcessText', function (payload) {
      if (!payload || (payload.mutex && payload.mutex.isHex)) return;
      payload.text = convertText(payload.text);
      payload.mutex = payload.mutex || {};
      payload.mutex.isHex = true;
    });
  }

  /** Strip LaTeX / markdown money fences so PDF gets $3,222/mo not \$3,222 or $$…$$. */
  function cleanPdfPlain(s) {
    return stripPdfLatexArtifacts(String(s == null ? '' : s)
      // Subscripts before any paren neutralize / WinAnsi strip (H₂O₂ → H2O2, not HO)
      .replace(/[\u2080\u2081\u2082\u2083\u2084\u2085\u2086\u2087\u2088\u2089]/g, function (ch) {
        return String(ch.charCodeAt(0) - 0x2080);
      })
      .replace(/\\+\$(?=[\d])/g, '$')   // \$123 → $123
      .replace(/\\\$/g, '$')
      .replace(/\\([\\$()[\]])/g, '$1')
      .replace(/\$\$+/g, '$')
      .replace(/\$\\+\$/g, '$')
      // Collapse accidental math wrappers: $\$$3,222/mo$ or $3,222/mo$
      .replace(/\$\\\$\$/g, '$')
      // Assessor/LaTeX artefact: $=\$24.00/hr$ or $=$24.00$ → $24.00
      .replace(/\$=\s*\\?\$/g, '$')
      .replace(/\$=+\s*/g, '')
      .replace(/=\s*\\\$/g, '= $')
      .replace(/^\$\$([^$]+)\$\$$/g, '$$$1')
      .replace(/^\$([^$\n]+)\$$/g, function (_m, inner) {
        var t = String(inner || '');
        // Unit strings (oz/gal, x 32) must not keep a leading currency $
        if (/[a-z]/i.test(t) || /\\times|~|\sx\s/i.test(t)) {
          return t.replace(/^\$+/, '');
        }
        // Currency/math fence → single leading $
        return /[\d,]/.test(t) ? ('$' + t.replace(/^\$+/, '')) : t;
      }));
  }

  /** Replace (parentheticals) without leaving hyphen artefacts like "cost -pre-margin-". */
  function neutralizePdfParens(s) {
    var str = String(s == null ? '' : s);
    // Full-cell accounting credits stay as ($1,234.56) — never hyphenize or "approx"
    var creditFull = str.trim().match(/^\(\s*([+\-−]?\$?\s*[\d,]+(?:\.\d+)?(?:\s*\/\s*(?:mo|yr|hr))?)\s*\)$/);
    if (creditFull) {
      var amt = String(creditFull[1] || '').replace(/^[+\-−]\s*/, '').replace(/\s+/g, '');
      if (amt.charAt(0) !== '$') amt = '$' + amt;
      return '(' + amt + ')';
    }
    return str
      .replace(/\(([^)]*)\)/g, function (_m, inner) {
        inner = String(inner || '').trim();
        if (!inner) return '';
        // Keep pluralization markers: product(s), match(es)
        if (/^(s|es|ies)$/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Keep IRC subsection letters: §408(k), §168(k)
        if (/^[a-z]$/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Keep calendar-year asides: $2,560,000 (2026)
        if (/^(19|20)\d{2}$/.test(inner)) {
          return '(' + inner + ')';
        }
        // Keep year-range asides: (2026/2028), (2026 / 2028), (2026-2028)
        if (/^(19|20)\d{2}\s*[\/\-–—]\s*(19|20)\d{2}$/.test(inner)) {
          return '(' + inner.replace(/[–—]/g, '/').replace(/\s*\/\s*/, ' / ') + ')';
        }
        // Keep signed percent asides: (-10%), (+22%), (−5% vs National)
        if (/^[+\-−]?\d+(\.\d+)?%(?:\s+vs\s+[^)]+)?$/i.test(inner)) {
          return '(' + inner.replace(/[−]/g, '-') + ')';
        }
        // Keep rate-delta asides: (+5% / +$210.00/month)
        if (/^[+\-−]?\d+(\.\d+)?%\s*\/\s*[+\-−]?\$/i.test(inner)) {
          return '(' + inner.replace(/[−]/g, '-') + ')';
        }
        // Keep margin-divisor / OH-load formulas: (1 + 12% OH), (1 - 35% margin)
        // Note: no \b after % — % is non-word, so \b fails before a space ("12% OH")
        if (/^1\s*[+\-−]\s*\d+(\.\d+)?%/i.test(inner)) {
          return '(' + inner.replace(/[−]/g, '-') + ')';
        }
        // Keep loaded-labor build asides: ($24.00 loaded + 12% OH, priced to 35% gross margin)
        if (/^\$[\d,]+(?:\.\d+)?\s+loaded\b/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Keep short clause titles: (Annual Escalation), (CPI-U), (Amara's Law)
        if (/^[A-Za-z][A-Za-z0-9 .,&\/\-']{0,48}$/.test(inner) && !/\$/.test(inner)) {
          return '(' + inner + ')';
        }
        // Keep visit/cap asides: (18.67 visits x 3.50 hr cap)
        if (/^\d+(\.\d+)?\s+visits?\b/i.test(inner)) {
          return '(' + inner.replace(/[×∗]/g, 'x') + ')';
        }
        // Keep percent asides: QBI deduction (20%)
        if (/^\d+(\.\d+)?%$/.test(inner)) {
          return '(' + inner + ')';
        }
        // Keep FUTA / annualized asides: (annualized $42/FTE)
        if (/^annualized\b/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Keep premium-above-base asides: (13.3% above base)
        if (/^\d+(\.\d+)?%\s+above\s+base$/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Keep common-law factor asides: (20-factor)
        if (/^\d+-factor\b/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Keep savings asides: (W-2 savings), (1099 savings)
        if (/^(W-2|1099)\s+savings$/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Keep speed modifiers: (-20% speed), (+10% speed) — allow space after sign from prior sanitizers
        if (/^[+\-−]?\s*\d+(\.\d+)?%\s+speed$/i.test(inner)) {
          return '(' + inner.replace(/[−]/g, '-').replace(/^([+\-])\s+/, '$1') + ')';
        }
        // Keep hour-delta modifiers: (+30% hours)
        if (/^[+\-−]?\s*\d+(\.\d+)?%\s+hours?$/i.test(inner)) {
          return '(' + inner.replace(/[−]/g, '-').replace(/^([+\-])\s+/, '$1') + ')';
        }
        // Keep zone sqft asides: (26,000 sqft)
        if (/^[\d,]+\s*sqft$/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Keep day-hours callouts: (~24 day hours per service day)
        if (/^~?\d+(\.\d+)?\s+day\s+hours?\b/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Keep shift-hour asides: (8 hrs), (8.0 hrs), (8h), (8.0h), (8.0 hrs each)
        if (/^\d+(\.\d+)?\s*(?:h|hrs?|hours?)(?:\s+each)?$/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Dilution ratio asides: (1:128), (1:X)
        if (/^1\s*:\s*(?:\d+(\.\d+)?|X)$/i.test(inner) || /^\d+\s*:\s*\d+(\.\d+)?$/i.test(inner)) {
          return '(' + inner.replace(/\s+/g, '') + ')';
        }
        // Volume asides: (32 oz), (~508.0 oz)
        if (/^~?\d+(\.\d+)?\s*oz$/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Jug / container asides: (1-gal jug), (129 gal RTU)
        if (/^\d+(\.\d+)?-gal\b/i.test(inner) || /^\d+(\.\d+)?\s+gal\s+RTU$/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Chemical formulas: (H2O2), (NaOCl), (PAA) — ASCII or leftover subscripts
        if (/^[A-Za-z][A-Za-z0-9\u2080-\u2089]{0,12}$/.test(inner) && /[0-9\u2080-\u2089]/.test(inner)) {
          return '(' + inner + ')';
        }
        // Floor RPM asides: (match pad to speed: 175 scrub vs 1,500+ burnish)
        if (/^match pad to speed\b/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Pad / machine RPM bands on cards: (175-350 RPM), (175–350 RPM)
        if (/^\d+(\.\d+)?\s*[-–—]\s*\d+(\.\d+)?\s*RPM$/i.test(inner)) {
          return '(' + inner.replace(/[–—]/g, '-').replace(/\s+/g, ' ') + ')';
        }
        // Abrasive screen grit asides: (100-150 grit abrasive screen disc)
        if (/^\d+(\.\d+)?\s*[-–—]\s*\d+(\.\d+)?\s+grit\b/i.test(inner)) {
          return '(' + inner.replace(/[–—]/g, '-').replace(/\s+/g, ' ') + ')';
        }
        // Short pad role asides: (polish), (light clean), (buff)
        if (/^(polish|light clean|buff|spray buff|spray clean)$/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Accounting credits stay as ($N) — never hyphenize
        if (/^[+\-−]?\$[\d,]+(?:\.\d+)?(?:\s*\/\s*(?:mo|yr|hr))?$/i.test(inner)) {
          var creditAmt = inner.replace(/^[+\-−]\s*/, '').replace(/\s+/g, '');
          if (creditAmt.charAt(0) !== '$') creditAmt = '$' + creditAmt;
          return '(' + creditAmt + ')';
        }
        // Keep EBITDA / valuation multiples: (3.0x), (4.25x)
        if (/^\d+(\.\d+)?x$/i.test(inner)) {
          return '(' + inner + ')';
        }
        // Duration asides (non-hour) stay hyphenated so METRIC rows don't read as comma-collapsed lists
        if (/^\d+\s*(yr|yrs|year|years|mo|mos|month|months)$/i.test(inner)) {
          return ' - ' + inner;
        }
        // Other numeric asides → spaced dash (avoid ", $N" which looks like a broken template)
        if (/^[+\-~$\d]/.test(inner) || /\/(?:mo|yr|hr)\b/i.test(inner) || /hrs?\b/i.test(inner)) {
          return ' - ' + inner;
        }
        return ' - ' + inner;
      })
      // Only collapse mashed hyphens (a--b), never spaced emdash stand-ins (" -- " / " — ")
      .replace(/(\S)-{2,}(\S)/g, '$1-$2')
      .replace(/[^\S\r\n]{2,}/g, ' ')
      .replace(/\s+([,.:;])/g, '$1')
      .replace(/^[^\S\r\n]+|[^\S\r\n]+$/g, '');
  }

  /**
   * Ledger value for PDF/HTML tables. Credits / negatives use accounting parentheses.
   */
  function formatPdfLedgerValue(val, isCredit) {
    var n = Number(val);
    if (!isFinite(n)) return String(val == null ? '' : val);
    var abs = Math.abs(n);
    var money = (global.OporaCalcShared && typeof global.OporaCalcShared.fmt$ === 'function')
      ? global.OporaCalcShared.fmt$(abs)
      : ('$' + abs.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    if (isCredit || n < 0) return '(' + money + ')';
    return money;
  }

  /**
   * jsPDF wraps strings as (...); literal ( ) become \( \) in the content stream.
   * Keep $ plain ASCII — never emit backslash before dollar.
   * Always neutralize parentheses so assessors don't read \( as LaTeX.
   */
  function pdfMoneySafeText(s) {
    var t = neutralizePdfParens(cleanPdfPlain(s));
    // Final guard: no backslash immediately before $
    t = t.replace(/\\+\$/g, '$');
    return t;
  }

  /** Force a short currency token to plain $N,NNN[/mo] — never rewrite clause prose ($1M / $2M). */
  function plainPdfCurrencyToken(s) {
    var t = String(s == null ? '' : s).replace(/\\/g, '').trim();
    // Accounting credits stay parenthesized
    var credit = t.match(/^\(\s*\$?\s*([\d,]+(?:\.\d+)?)\s*(?:\/\s*(mo|yr|hr))?\s*\)$/i);
    if (credit) {
      return '($' + credit[1] + (credit[2] ? '/' + credit[2].toLowerCase() : '') + ')';
    }
    // Repair trailing dollar before parsing: 14,819.41$ → $14,819.41
    t = t.replace(/^(\+?)(\d[\d,]*(?:\.\d+)?)\$\s*(\/(?:mo|yr|hr))?$/i, function (_m, sign, num, suf) {
      return (sign || '') + '$' + num + (suf || '');
    });
    // Only pure money tokens (optional leading +/−), not "GL $1M per occurrence…"
    if (!/^[+\-−]?\$?\s*[\d,]+(?:\.\d+)?(?:\s*\/\s*(?:mo|yr|hr))?$/i.test(t)) {
      return pdfMoneySafeText(s).replace(/\\+\$/g, '$');
    }
    var m = t.match(/^([+\-−])?\s*\$?\s*([\d,]+(?:\.\d+)?)\s*(\/\s*mo|\/\s*yr|\/\s*hr)?/i);
    if (!m) return t.replace(/\\+\$/g, '$');
    var sign = m[1] ? m[1].replace('−', '-') : '';
    return sign + '$' + m[2] + (m[3] ? m[3].replace(/\s+/g, '') : '');
  }

  /** Comma-format large whole numbers in result strings — never mangle NAICS (6-digit) or years. */
  function formatPdfMetricValue(val) {
    var raw = stripPdfLatexArtifacts(String(val == null ? '' : val));
    var trimmed = ensurePdfDollarSigns(raw.trim());
    // Placeholder-only cells (dash / dots / ellipsis / n/a) → em dash (parity with web UI)
    if (!trimmed || /^[\s.\-_*=|]+$/.test(trimmed) ||
      /^[\u2010-\u2015\u2212\u2022\u2026\u00B7]+$/.test(trimmed) ||
      /^\.+$/.test(trimmed) ||
      /^n\/?a$/i.test(trimmed)) {
      return '\u2014';
    }
    // Approx hour tokens: always ASCII tilde + space (Helvetica ~ alone can look like a minus)
    if (/^[\-\u2212\u2013\u2014~]\s*[\d,]+(?:\.\d+)?\s*hrs?\b/i.test(trimmed)) {
      return trimmed.replace(/^[\-\u2212\u2013\u2014~]\s*/, '~ ');
    }
    // Fringe / money approx: never let "~$10" render as "-$10" in Helvetica
    // Only rewrite tilde / swung-dash — never ASCII minus on negative money (-$2,288)
    trimmed = trimmed
      .replace(/\bFringe\s*[~∼]\s*\$/gi, 'Fringe approx $')
      .replace(/(^|[\s|])[~∼]\s*(\$[\d,]+(?:\.\d+)?(?:\s*\/\s*hr)?)/gi, '$1approx $2')
      .replace(/\bapprox\s+approx\b/gi, 'approx');
    // Short currency tokens (leading or trailing $) — do not collapse "GL $1M … / $2M …" to "$1"
    // Keep accounting credits ($N) as parentheses (1099 overhead savings, etc.)
    if (/^\(\$[\d,]+(\.\d+)?\)$/i.test(trimmed)) {
      return trimmed;
    }
    if (/^[+\-−]?\$[\d,]+(\.\d+)?(\/(mo|yr|hr))?$/i.test(trimmed) ||
        /^\+?\d[\d,]*(?:\.\d+)?\$(\/(mo|yr|hr))?$/i.test(trimmed)) {
      return plainPdfCurrencyToken(trimmed);
    }
    var s = ensurePdfDollarSigns(pdfMoneySafeText(val));
    s = stripPdfLatexArtifacts(s);
    s = s
      .replace(/\bFringe\s*[~∼]\s*\$/gi, 'Fringe approx $')
      .replace(/(^|[\s|])[~∼]\s*(\$[\d,]+(?:\.\d+)?(?:\s*\/\s*hr)?)/gi, '$1approx $2')
      .replace(/\bapprox\s+approx\b/gi, 'approx');
    // Protect OSHA / CFR / Tax Code section numbers before any comma grouping
    s = s.replace(/\b((?:OSHA|CFR|29\s*CFR|Tax\s*Code)\s*§?\s*)(\d{2,4}(?:\.\d{1,4})+)\b/gi, function (_m, pref, num) {
      return pref + String(num).replace(/,/g, '');
    });
    // Lock dotted statute tokens (151.0045) so the "0045" tail is never regrouped to "45"
    var lockedStats = [];
    s = s.replace(/\b(\d{2,4}\.\d{2,4})\b/g, function (tok) {
      lockedStats.push(tok);
      return '\u0001STAT' + (lockedStats.length - 1) + '\u0001';
    });
    // Lock EPA Reg. Nos. (70627-60) — never thousands-comma the establishment number
    s = s.replace(/\b(\d{4,6}-\d{1,4})\b/g, function (tok) {
      lockedStats.push(tok);
      return '\u0001STAT' + (lockedStats.length - 1) + '\u0001';
    });
    // Lock IRC / section cites: IRC §3111, §179, §408(k), §199A — never 3,111
    s = s.replace(/\bIRC\s*§?\s*\d{3,4}[A-Za-z]?(?:\([a-z]\))?/gi, function (tok) {
      lockedStats.push(tok);
      return '\u0001STAT' + (lockedStats.length - 1) + '\u0001';
    });
    s = s.replace(/§\s*\d{3,4}[A-Za-z]?(?:\([a-z]\))?/g, function (tok) {
      lockedStats.push(tok);
      return '\u0001STAT' + (lockedStats.length - 1) + '\u0001';
    });
    s = s.replace(/\b(\d{4,})(\.\d+)?\b/g, function (m, whole, frac) {
      // OSHA / CFR-style sections: 1910.1030, 1910.147 — never comma-group
      if (frac && /^\.\d{1,4}$/.test(frac) && whole.length <= 4) return whole + frac;
      // Zero-padded statute tails (0045) — keep as-is
      if (!frac && /^0\d+$/.test(whole)) return whole;
      // NAICS / industry codes are exactly 6 digits with no decimal — leave ungrouped
      if (!frac && whole.length === 6) return whole;
      // Calendar years
      if (!frac && whole.length === 4) {
        var y = parseInt(whole, 10);
        if (y >= 1900 && y <= 2100) return whole;
      }
      var n = parseInt(whole, 10);
      if (isNaN(n)) return m;
      return asciiCommaInt(n) + (frac || '');
    });
    return s.replace(/\u0001STAT(\d+)\u0001/g, function (_m, idx) {
      return lockedStats[Number(idx)] || '';
    });
  }

  function stripMdLight(s) {
    return String(s == null ? '' : s)
      .replace(/\*\*([^*]+)\*\*/g, '$1')
      .replace(/__([^_]+)__/g, '$1')
      .replace(/\*([^*]+)\*/g, '$1')
      .replace(/`([^`]+)`/g, '$1')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /**
   * PDF Helvetica: keep callout/option dashes as spaced single hyphens (" - ").
   * Unicode emdash collapses; ASCII "--" looks unfinished in the text stream.
   * Money corridors ($2,000–$2,500/mo) keep a WinAnsi en-dash to match the web UI.
   */
  function protectPdfMoneyCorridors(s, bucket) {
    return String(s == null ? '' : s).replace(
      /(\$[\d,]+(?:\.\d+)?)\s*[\u2010-\u2015\u2212\-]\s*(\$[\d,]+(?:\.\d+)?(?:\s*\/\s*(?:mo|yr|hr))?)/gi,
      function (_m, a, b) {
        bucket.push(a + '\u2013' + b);
        // ASCII-only token — control chars (\u0001) get stripped by WinAnsi sanitize and leave "MC0"
        return '__OPORA_MC_' + (bucket.length - 1) + '__';
      }
    );
  }
  function restorePdfMoneyCorridors(s, bucket) {
    return String(s == null ? '' : s).replace(/__OPORA_MC_(\d+)__/g, function (_m, idx) {
      return bucket[Number(idx)] || '';
    });
  }

  function normalizePdfCalloutDash(s) {
    var bucket = [];
    var t = protectPdfMoneyCorridors(s, bucket);
    t = t
      .replace(/\s*[\u2010-\u2015\u2212]\s*/g, ' - ')
      .replace(/\s+--\s+/g, ' - ')
      .replace(/(\/(?:mo|yr|hr))\s*(?:--|[\-~])?\s*(?=then\b)/gi, '$1 - ');
    return restorePdfMoneyCorridors(t, bucket);
  }

  /** Repair trailing/escaped dollars and keep unit labels like "Equipment $/yr". */
  function ensurePdfDollarSigns(s) {
    return String(s == null ? '' : s)
      .replace(/\\+\$/g, '$')
      // 14,819.41\$ or 14,819.41$ → $14,819.41  (no trailing \b — $ is non-word)
      .replace(/\b(\d{1,3}(?:,\d{3})+(?:\.\d+)?|\d+\.\d{2})\s*\$/g, '$$$1')
      // Equipment S/yr / Equipment /yr → Equipment $/yr (and Travel $/mo)
      .replace(/\b(Equipment)\s+(?:S\s*)?\/\s*yr\b/gi, '$1 $/yr')
      .replace(/\b(Travel)\s+(?:S\s*)?\/\s*mo\b/gi, '$1 $/mo')
      .replace(/\b(Contractor supplies)\s+(?:S\s*)?\/\s*sf\s*\/\s*yr\b/gi, '$1 $/sf/yr')
      .replace(/\b(Paper\s*\/\s*soap)\s+(?:S\s*)?\/\s*sf\s*\/\s*yr\b/gi, '$1 $/sf/yr');
  }

  function collectPrintInputs(fields, formRoot) {
    var items = [];
    var values = {};
    (fields || []).forEach(function (f) {
      var el = formRoot && formRoot.querySelector('[data-calc-field="' + f.id + '"]');
      if (el) values[f.id] = el.type === 'checkbox' ? (el.checked ? '1' : '') : el.value;
    });
    var modeEl = formRoot && formRoot.querySelector('[data-calc-field="mode"]');
    var mode = modeEl ? String(modeEl.value || 'simple') : '';
    var dilMode = String(values.dilution_mode || 'ratio');
    (fields || []).forEach(function (f) {
      // Production Rate: only print the active mix mode (keeps PDF on one page)
      if (mode === 'simple' && /^sqft_/.test(f.id)) return;
      if (mode === 'detailed' && /^pct_/.test(f.id)) return;
      // Dilution / gated fields: print only what the active mode actually used
      if (f.visibleWhen && !fieldVisibleForValues(f, values)) return;
      if (f.id === 'ratio_str' && dilMode !== 'ratio') return;
      if (f.id === 'oz_per_gal' && dilMode !== 'ozpgal') return;
      if (f.id === 'percent_conc' && dilMode !== 'percent') return;
      if ((f.id === 'target_ppm' || f.id === 'conc_active_pct') && dilMode !== 'ppm') return;
      var el = formRoot && formRoot.querySelector('[data-calc-field="' + f.id + '"]');
      if (el && el.disabled) return;
      var val = fieldDisplayValue(f, el);
      var always =
        /^(client_name|contractor_name|company_name)$/i.test(String(f.id || '')) ||
        /^client\b/i.test(String(f.label || ''));
      if ((val === '' || val == null) && !always) return;
      // Skip zero-cost optional advanced when blank/zero (noise in PDF)
      if (f.id === 'concentrate_cost' && (val === '' || val === '0' || val === '$0.00' || Number(values.concentrate_cost) === 0)) {
        return;
      }
      var isClientName =
        /^(client_name|company_name|facility_name)$/i.test(String(f.id || '')) ||
        /^client\b/i.test(String(f.label || ''));
      var blankish = val === '' || val == null ||
        /^[\s.\-_*=|]+$/.test(String(val)) ||
        /^[\u2010-\u2015\u2212\u2022\u2026\u00B7]+$/.test(String(val).trim()) ||
        /^\.+$/.test(String(val).trim());
      if (blankish) {
        // Never print dash / ellipsis placeholders — assessors OCR them as junk glyphs
        val = isClientName ? 'Commercial Facility' : 'n/a';
      }
      var lab = String(f.label || f.id).split('(')[0].trim();
      // Keep unit slash before the period word (never "hoursday/")
      if (f.id === 'dp_shift') lab = 'Day porter hours/day';
      if (f.id === 'nc_hours') lab = 'Night crew hours/day';
      lab = lab
        .replace(/\bhours\s*day\s*\/?/gi, 'hours/day')
        .replace(/\bhrs\s*day\s*\/?/gi, 'hrs/day')
        .replace(/\b(hours|hrs)\s*\/\s*day\b/gi, '$1/day');
      items.push({ label: lab, value: String(val) });
    });
    return items;
  }

  function buildPdfFacilityLine(fields, formRoot) {
    if (!formRoot) return '';
    var clientEl = formRoot.querySelector(
      '[data-calc-field="facility_name"], [data-calc-field="client_name"], [data-calc-field="company_name"]'
    );
    var sqftEl = formRoot.querySelector('[data-calc-field="total_sqft"], [data-calc-field="cleanable_sqft"], [data-calc-field="sqft"]');
    var appaEl = formRoot.querySelector('[data-calc-field="appa_level"]');
    var bits = [];
    var clientName = clientEl ? String(clientEl.value || '').trim() : '';
    var placeholderName = !clientName ||
      /^account\s*\/\s*building/i.test(clientName) ||
      /\(enter name\)/i.test(clientName) ||
      /^client\s+facility$/i.test(clientName);
    if (clientName && !placeholderName) {
      bits.push(clientName);
    } else if (appaEl || clientEl) {
      // Never print the form placeholder into the PDF header
      bits.push('Commercial Facility');
    }
    if (sqftEl && sqftEl.value !== '' && sqftEl.value != null) {
      var n = parseFloat(sqftEl.value);
      bits.push((isNaN(n) ? sqftEl.value : Math.round(n).toLocaleString()) + ' SF');
    }
    if (appaEl && appaEl.value) {
      var appaLabel = fieldDisplayValue({ type: 'select', label: 'APPA' }, appaEl);
      bits.push(appaLabel || ('Level ' + appaEl.value));
    }
    return bits.length ? bits.join(' · ') : '';
  }

  function getCachedLeadEmail() {
    if (global.OporaLeadEmail && typeof global.OporaLeadEmail.get === 'function') {
      try { return String(global.OporaLeadEmail.get() || '').trim(); } catch (e) { return ''; }
    }
    return '';
  }

  function ensureJsPdf() {
    return new Promise(function (resolve, reject) {
      if (global.jspdf && global.jspdf.jsPDF) {
        resolve(global.jspdf.jsPDF);
        return;
      }
      var existing = document.getElementById('opora-jspdf-cdn');
      function finish() {
        if (global.jspdf && global.jspdf.jsPDF) resolve(global.jspdf.jsPDF);
        else reject(new Error('jsPDF failed to load'));
      }
      if (existing) {
        if (global.jspdf && global.jspdf.jsPDF) finish();
        else existing.addEventListener('load', finish);
        existing.addEventListener('error', function () { reject(new Error('jsPDF CDN error')); });
        setTimeout(finish, 2500);
        return;
      }
      var s = document.createElement('script');
      s.id = 'opora-jspdf-cdn';
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.async = true;
      s.onload = finish;
      s.onerror = function () { reject(new Error('jsPDF CDN failed')); };
      (document.head || document.documentElement).appendChild(s);
    });
  }

  /** Normalize secondary / meta lines for PDF cards (pipes survive WinAnsi; · does not). */
  function formatPdfMetaLine(s) {
    return String(s == null ? '' : s)
      .replace(/\s*[·•|]+\s*/g, ' | ')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  /**
   * Main deliverable artifact for PDF — scripts, letters, clauses, or multi-line copyText.
   * Suite-wide: any calc that returns scriptBeats / clauses / letter narrative / long copyText.
   */
  function collectPdfArtifact(last, slug) {
    if (!last) return null;
    // Bid Generator: copyText is a web clipboard helper — never print as PDF artifact
    if (String(slug || '') === 'bid-generator') return null;
    // Per-Clean: copyText is scope-clause clipboard — structured PDF sections render instead
    if (String(slug || '') === 'per-clean-vs-hourly') return null;
    // Price Increase: formal letter PDF path — never GENERATED LETTER grey box
    if (String(slug || '') === 'price-increase-letter') return null;
    // ICA: formal agreement PDF path — never GENERATED CLAUSES beat dump
    if (String(slug || '') === 'independent-contractor-agreement') return null;
    if (last.scriptBeats && last.scriptBeats.length) {
      return {
        title: 'GENERATED SCRIPT',
        beats: last.scriptBeats.map(function (b) {
          var label = String(b.title || 'Beat').toUpperCase();
          if (b.titleHl) label += ' · ' + String(b.titleHl);
          var text = b.detail || '';
          if (!text && b.parts && b.parts.length) {
            text = b.parts.map(function (p) { return p && p.t != null ? String(p.t) : ''; }).join('');
          }
          return { label: label, text: String(text || '').trim() };
        }).filter(function (b) { return !!b.text; })
      };
    }
    // Clause checklists (ICA, etc.) — structured beats beat flat copyText for PDF layout
    if (last.clauses && last.clauses.length) {
      return {
        title: 'GENERATED CLAUSES',
        beats: last.clauses.map(function (c, i) {
          return {
            label: (i + 1) + '. ' + String(c.title || 'Clause').toUpperCase(),
            text: String(c.detail || c.text || '').trim()
          };
        }).filter(function (b) { return !!b.text; })
      };
    }
    var copy = String(last.copyText || '');
    var copyLab = String(last.copyLabel || '').toLowerCase();
    var narrative = String(last.narrative || '');
    if (copy && copyLab.indexOf('letter') >= 0) {
      return { title: 'GENERATED LETTER', body: pdfMoneySafeText(copy) };
    }
    if (narrative.indexOf('\n') >= 0 && /dear\s+/i.test(narrative)) {
      return { title: 'GENERATED LETTER', body: pdfMoneySafeText(narrative) };
    }
    if (copy.indexOf('\n') >= 0 && copy.length > 60) {
      var title = copyLab.indexOf('script') >= 0 ? 'GENERATED SCRIPT'
        : (copyLab.indexOf('letter') >= 0 ? 'GENERATED LETTER'
          : (copyLab.indexOf('clause') >= 0 ? 'GENERATED CLAUSES' : 'GENERATED COPY'));
      return { title: title, body: pdfMoneySafeText(copy) };
    }
    // PPE: always print compliance notes (Routine + High) — never require multiline
    if (String(slug || '') === 'ppe-selector') {
      var ppeNotes = [];
      if (Array.isArray(last.complianceNotes) && last.complianceNotes.length) {
        last.complianceNotes.forEach(function (n) {
          var t = String(n || '').replace(/\s+/g, ' ').trim();
          if (t) ppeNotes.push(t);
        });
      } else if (narrative.trim()) {
        narrative.split(/\n+/).forEach(function (chunk) {
          var t = String(chunk || '').replace(/\s+/g, ' ').trim();
          if (t) ppeNotes.push(t);
        });
      }
      if (ppeNotes.length) {
        var respVal = '';
        if (Array.isArray(last.rows)) {
          last.rows.forEach(function (r) {
            if (/^respiratory/i.test(String((r && r.label) || ''))) {
              respVal = String((r && r.value) || '');
            }
          });
        }
        if (!respVal && Array.isArray(last.metrics)) {
          last.metrics.forEach(function (m) {
            if (/respiratory/i.test(String((m && m.label) || ''))) {
              respVal = String((m && m.value) || '');
            }
          });
        }
        var cites134 = !!(last.respiratorRequired) ||
          /cartridge|respirator|scba|1910\.134/i.test(respVal) ||
          ppeNotes.some(function (n) {
            return /1910\.134|respirator program|cartridge/i.test(String(n || ''));
          });
        return {
          // 1910.134 only when respiratory protection is actually prescribed
          title: cites134
            ? 'SAFETY & COMPLIANCE NOTES - 29 CFR 1910.134'
            : 'SAFETY & COMPLIANCE NOTES - OSHA 29 CFR 1910 (PPE & CONTROLS)',
          body: ppeNotes.join('\n'),
          bullets: ppeNotes
        };
      }
      return null;
    }
    if (narrative.indexOf('\n') >= 0 && narrative.length > 60 &&
      narrative.trim() !== String(last.soWhat || '').trim()) {
      return { title: 'GENERATED COPY', body: pdfMoneySafeText(narrative) };
    }
    return null;
  }

  function collectCalcPdfModel(opts) {
    var last = opts.result || {};
    var wc = getWcMeta(opts.slug) || {};
    var cards = [];
    if (last.metrics && last.metrics.length) {
      last.metrics.forEach(function (m) {
        var val = plainPdfCardValue(m.value || '');
        if ((String(opts.slug || '') === 'client-onboarding-checklist' ||
            String(opts.slug || '') === 'job-costing-calculator') && m.sub) {
          val = val + ' (' + plainPdfCardValue(m.sub) + ')';
        }
        var card = { label: m.label || 'Result', value: val };
        if (m.tone) card.tone = m.tone;
        // EBITDA / Churn / Robot ROI / Equipment Financing / PFAS / Franchise / VOC: keep web subtext as a separate PDF card line
        if ((String(opts.slug || '') === 'ebitda-estimator' ||
            String(opts.slug || '') === 'churn-cost-calculator' ||
            String(opts.slug || '') === 'robot-roi-matcher' ||
            String(opts.slug || '') === 'equipment-financing-comparator' ||
            String(opts.slug || '') === 'pfas-state-lookup' ||
            String(opts.slug || '') === 'franchise-comparison-matrix' ||
            String(opts.slug || '') === 'voc-compliance' ||
            String(opts.slug || '') === 'sales-tax-calculator' ||
            String(opts.slug || '') === 'epa-list-n-matcher' ||
            String(opts.slug || '') === 'insurance-comparison' ||
            String(opts.slug || '') === 'sds-finder' ||
            String(opts.slug || '') === 'tax-deduction-finder' ||
            String(opts.slug || '') === 'osha-300-300a-log' ||
            String(opts.slug || '') === 'union-contract-lookup') && m.sub) {
          card.sub = plainPdfCardValue(m.sub);
        }
        cards.push(card);
      });
    } else if (last.primary) {
      var primaryCard = { label: 'Primary result', value: plainPdfCardValue(last.primary) };
      if (String(opts.slug || '') === 'federal-rfp-filter' && last.statusPill && last.statusPill.level) {
        primaryCard.tone = last.statusPill.level;
      }
      cards.push(primaryCard);
      // HazCom severity only when severityTier is set (Chem Compatibility) —
      // never reuse statusPill color names (e.g. pad "Green") as SEVERITY.
      if (last.severityTier && last.statusPill && last.statusPill.label) {
        var sev = last.severityTier + ' · ' + last.statusPill.label;
        cards.push({ label: 'Severity', value: sev });
      } else if (last.secondary) {
        cards.push({
          label: formatPdfMetaLine(last.secondaryLabel || 'Detail'),
          value: formatPdfMetaLine(last.secondary)
        });
      }
    }
    // Bill Rate: mirror web BASE | LOADED | BILL bands (not single primary card)
    if (String(opts.slug || '') === 'bill-rate-calculator' && last.bands && last.bands.length) {
      cards = last.bands.slice(0, 3).map(function (b) {
        var lab = String(b.label || 'Result');
        if (/^base$/i.test(lab)) lab = 'Base wage';
        else if (/^loaded$/i.test(lab)) lab = 'Loaded wage';
        else if (/^bill$/i.test(lab)) lab = 'Recommended Bill Rate';
        var card = { label: lab, value: plainPdfCardValue(b.value || '') };
        if (b.target) card.target = true;
        return card;
      });
      // Guarantee 3 cards even if bands were truncated upstream
      if (cards.length < 3 && last.primary) {
        while (cards.length < 2) cards.push({ label: '—', value: '—' });
        cards[2] = {
          label: 'Recommended Bill Rate',
          value: plainPdfCardValue(last.primary),
          target: true
        };
      }
    }
    var artifact = collectPdfArtifact(last, opts.slug);
    var pdfMode = String(opts.pdfMode || '').toLowerCase();
    var isBidGen = String(opts.slug || '') === 'bid-generator';
    var isClientPdf = isBidGen && pdfMode === 'client';
    var isInternalPdf = isBidGen && (pdfMode === 'internal' || !pdfMode);
    // Prefer explicit recommendation (1099 vs W-2) over risk band for the primary PDF badge
    var statusBadge = (last.recommendationPill && last.recommendationPill.label)
      ? String(last.recommendationPill.label)
      : ((last.statusPill && last.statusPill.label)
        ? String(last.statusPill.label)
        : (last.flag
          ? String(last.flag === 'At-risk' ? 'Needs Review' : last.flag)
          : ''));
    var statusBadgeLevel = (last.recommendationPill && last.recommendationPill.label)
      ? String(last.recommendationPill.level || 'ok')
      : ((last.statusPill && last.statusPill.level)
        ? String(last.statusPill.level)
        : '');
    var riskBadge = '';
    var riskBadgeLevel = '';
    if (last.recommendationPill && last.recommendationPill.label &&
        last.statusPill && last.statusPill.label) {
      riskBadge = String(last.statusPill.label);
      riskBadgeLevel = String(last.statusPill.level || '');
    }
    var guidanceText = normalizePdfCalloutDash(stripMdLight(
      last.handoffHint ||
      (last.rows || []).reduce(function (found, row) {
        return found || (/^guidance$/i.test(String(row.label || '')) ? String(row.value || '') : '');
      }, '') ||
      ''
    ));
    // Pad Selector / APPA Inspection: never leak web CTA / handoff hint into the PDF
    if (String(opts.slug || '') === 'pad-selector' ||
        String(opts.slug || '') === 'appa-inspection-report') {
      guidanceText = '';
    }
    // Client Onboarding: restore operational directive as PDF guidance callout
    if (String(opts.slug || '') === 'client-onboarding-checklist') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'Close every open item before go-live, especially keys, access, and scope.'
      ));
    }
    // Robot ROI: restore payback / site-readiness directive above METRIC table
    if (String(opts.slug || '') === 'robot-roi-matcher') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'Only proceed if payback clears and the floor plan is robot-friendly. Robots remove open-floor hours, not supervision.'
      ));
    }
    // Equipment Financing: restore cash-flow directive above METRIC table
    if (String(opts.slug || '') === 'equipment-financing-comparator') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'Pick the path that fits monthly cash, then confirm payback still works. Cash flow kills more buys than interest rate.'
      ));
    }
    // PFAS State Lookup: restore SDS / chemistry swap directive above METRIC table
    if (String(opts.slug || '') === 'pfas-state-lookup') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'If restricted, swap chemistry and update SDS binders now. Product bans move faster than carts get restocked.'
      ));
    }
    // Franchise Comparison: restore year-1 / royalty directive above brand matrix
    if (String(opts.slug || '') === 'franchise-comparison-matrix') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'Favor the year-1 fit you can fund, then stress real revenue after royalties. Royalty is forever; Item 19 is not your P&L.'
      ));
    }
    // VOC Compliance: restore SDS / substitute directive above METRIC table
    if (String(opts.slug || '') === 'voc-compliance') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'Non-compliant SKUs need a substitute before the next order. The label can still fail the state VOC category.'
      ));
      // Status color lives on the 3-up Compliance card — never duplex a loose Over limit pill
      statusBadge = '';
      riskBadge = '';
    }
    // EPA List N: restore EPA.gov / dwell directive above match matrix
    if (String(opts.slug || '') === 'epa-list-n-matcher') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'Shortlist candidates, then confirm EPA reg. no. and contact time on EPA.gov. Skip labeled dwell and the kill claim dies with it.'
      ));
    }
    // Sales Tax: restore invoice-line / nexus directive above KEY RESULTS
    if (String(opts.slug || '') === 'sales-tax-calculator') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'Use the estimate to set invoice line structure, then verify nexus rules. Wrong service vs supply split gets expensive at audit time.'
      ));
    }
    // Insurance Comparison: restore contract-minimums / mod directive above KEY RESULTS
    if (String(opts.slug || '') === 'insurance-comparison') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'Pick the lower total that still meets contract minimums. Cheap premium with a bad mod is not cheap.'
      ));
    }
    // Tax Deduction Finder: restore CPA shortlist directive above deduction matrix
    if (String(opts.slug || '') === 'tax-deduction-finder') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'Bring the shortlist to your accountant with receipts and entity type. Missed write-offs are silent margin leaks.'
      ));
      // Entity context lives on the 3-up cards — never duplex S-Corp · 2026 pill
      statusBadge = '';
      riskBadge = '';
    }
    // SDS Finder: restore PPE / cart-stock directive above PRODUCT ATTRIBUTE table
    if (String(opts.slug || '') === 'sds-finder') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'Open the SDS for PPE, first aid, and VOC, then stock the cart accordingly. Yesterday\'s SDS is how crews get the wrong PPE.'
      ));
    }
    // OSHA 300 / 300A: restore TRIR/DART directive above KEY RESULTS; status on Card 3 only
    if (String(opts.slug || '') === 'osha-300-300a-log') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'TRIR and DART outperform industry benchmarks. Maintain current toolbox talks and safety protocols to protect workers\' comp mod.'
      ));
      statusBadge = '';
      riskBadge = '';
    }
    // Union Contract Lookup: restore bill-rate-floor directive above CBA LABOR SPECIFICATION
    if (String(opts.slug || '') === 'union-contract-lookup') {
      guidanceText = normalizePdfCalloutDash(stripMdLight(
        last.soWhat || (wc && wc.soWhat) ||
        'Use the compliant bill-rate floor from this sample scale, then verify the live CBA or SCA WD before you bid.'
      ));
      // Mode context lives on cards / Auto-switched warn only — never loose CBA Union pill
      if (!(last.statusPill && last.statusPill.label && /auto-switched/i.test(String(last.statusPill.label)))) {
        statusBadge = '';
        riskBadge = '';
      }
    }
    var rowItems = (last.rows || []).filter(function (row) {
      var lab = String(row.label || '');
      if (!lab) return false;
      if (/^note$/i.test(lab)) return false;
      if (/disclaimer|methodology|seeds/i.test(lab)) return false;
      // Dedicated PDF badge / guidance callouts — skip duplicate METRIC rows
      if (statusBadge && /^status$/i.test(lab)) return false;
      if (guidanceText && /^guidance$/i.test(lab)) return false;
      // Floor Program: Surface safety row → dedicated PDF callout (avoid duplicate)
      if (/^surface safety$/i.test(lab) && (last.safetyWarning || last.narrative)) return false;
      // Floor Program: daily/interim/restorative → dedicated matrix (avoid duplicate METRIC dump)
      if (String(opts.slug || '') === 'floor-program-builder' && last.maintenanceMatrix && last.maintenanceMatrix.length) {
        if (/^(daily|interim|restorative)\s+maintenance$/i.test(lab)) return false;
      }
      // Artifact already holds the full checklist / script — do not duplicate under METRIC
      if (artifact && last.clauses && last.clauses.length && /^\d+\.\s/.test(lab)) return false;
      if (artifact && artifact.beats && artifact.beats.length && /^\d+\.\s/.test(lab)) return false;
      if (artifact && row.meta && row.meta.length && !row.value &&
        row.meta.some(function (m) { return /^language$/i.test(String(m.k || '')); })) {
        return false;
      }
      return !!(row.value || (row.meta && row.meta.length));
    }).map(function (row) {
      var metaBits = (row.meta && row.meta.length)
        ? row.meta.map(function (m) {
            return (m.k ? m.k + ': ' : '') + (m.v || '');
          }).join(' | ')
        : '';
      var base = String(row.value == null ? '' : row.value).trim();
      // Prefer meta detail when present (Franchise cards, etc.) — never drop Fee/Royalty/Yr1
      var combined = metaBits
        ? (base ? (base + ' | ' + metaBits) : metaBits)
        : base;
      var val = formatPdfMetricValue(combined);
      // Checklist rows: encode ok/warn so PDF Pair status is never ambiguous
      // Federal RFP Filter: fail rows are compliance blockers to clear — not chem "PROHIBITED"
      // Chemical Compatibility: values already say Forbidden / Incompatible — never append [PROHIBITED]
      if (String(opts.slug || '') === 'chemical-compatibility') {
        /* keep val as authored */
      } else if (row.ok === false) {
        if (String(opts.slug || '') === 'federal-rfp-filter') {
          val = val + ' (Action Required)';
        } else {
          val = val + ' [PROHIBITED]';
        }
      } else if (row.warn) {
        val = val + ' [CAUTION]';
      } else if (row.ok === true && /pair/i.test(String(row.label || ''))) {
        val = val + ' [OK]';
      }
      return { label: row.label, value: val, emphasize: !!row.emphasize };
    });
    // HazCom only: hazard prose under severity (never for pad color pills)
    if (last.severityTier && last.statusPill && last.secondary) {
      rowItems.unshift({
        label: formatPdfMetaLine(last.secondaryLabel || 'Hazard detail'),
        value: formatPdfMetricValue(last.secondary)
      });
    }
    // Clause / script tools: METRIC table empty when GENERATED * is present (1-page budget)
    if (artifact && ((last.clauses && last.clauses.length) || (last.scriptBeats && last.scriptBeats.length))) {
      rowItems = [];
    }
    // Day Porter: restore 3-up cards (Day / Night / Delta); keep METRIC rows + hour label repair
    if (String(opts.slug || '') === 'day-porter-roi') {
      if (last.metrics && last.metrics.length) {
        cards = last.metrics.slice(0, 3).map(function (m) {
          var val = plainPdfCardValue(m.value || '');
          if (m.sub) val = val + ' (' + plainPdfCardValue(m.sub) + ')';
          var card = { label: m.label || 'Result', value: val };
          if (m.tone) card.tone = m.tone;
          return card;
        });
      }
      rowItems = rowItems.map(function (row) {
        var lab = String(row.label || '')
          .replace(/\bhours\s*day\s*\/?/gi, 'hours/day')
          .replace(/\bhrs\s*day\s*\/?/gi, 'hrs/day')
          .replace(/\b(hours|hrs)\s*\/\s*day\b/gi, '$1/day');
        return { label: lab, value: row.value };
      });
    }

    var narrative = normalizePdfCalloutDash(stripMdLight(last.soWhat || ''));
    // Client Onboarding / Robot ROI / Equipment Financing / Franchise / PFAS / VOC / Sales Tax: soWhat is the guidance callout — do not duplex as narrative
    if (String(opts.slug || '') === 'client-onboarding-checklist' ||
        String(opts.slug || '') === 'robot-roi-matcher' ||
        String(opts.slug || '') === 'equipment-financing-comparator' ||
        String(opts.slug || '') === 'franchise-comparison-matrix' ||
        String(opts.slug || '') === 'pfas-state-lookup' ||
        String(opts.slug || '') === 'voc-compliance' ||
        String(opts.slug || '') === 'sales-tax-calculator' ||
        String(opts.slug || '') === 'epa-list-n-matcher' ||
        String(opts.slug || '') === 'insurance-comparison' ||
        String(opts.slug || '') === 'sds-finder' ||
        String(opts.slug || '') === 'tax-deduction-finder' ||
        String(opts.slug || '') === 'osha-300-300a-log' ||
        String(opts.slug || '') === 'union-contract-lookup') {
      narrative = '';
    }
    // PFAS: hard-stop soWhat duplex even if a later branch reassigns narrative
    if (String(opts.slug || '') === 'pfas-state-lookup') {
      narrative = '';
    }
    // Pad Selector PDF: conflict + remedy once — never duplex the same paragraph
    if (String(opts.slug || '') === 'pad-selector') {
      var padConflict = normalizePdfCalloutDash(stripMdLight(last.conflictReason || last.soWhat || ''));
      var padRemedy = normalizePdfCalloutDash(stripMdLight(last.remapRemedy || ''));
      var padAlertTitle = last.alertBanner && last.alertBanner.title
        ? String(last.alertBanner.title).trim()
        : '';
      function padNorm(s) {
        return String(s || '').toLowerCase().replace(/\s+/g, ' ').replace(/[.!?]+$/g, '').trim();
      }
      var cN = padNorm(padConflict);
      var rN = padNorm(padRemedy);
      if (padConflict && padRemedy && cN && rN && cN !== rN &&
          cN.indexOf(rN) < 0 && rN.indexOf(cN) < 0) {
        var conflictBlock = padConflict;
        if (padAlertTitle && padConflict.toLowerCase().indexOf(padAlertTitle.toLowerCase()) !== 0) {
          conflictBlock = padAlertTitle + ': ' + padConflict;
        }
        narrative = conflictBlock +
          (/[.!?]$/.test(conflictBlock) ? ' ' : '. ') + padRemedy;
      } else if (padConflict) {
        narrative = (padAlertTitle && padConflict.toLowerCase().indexOf(padAlertTitle.toLowerCase()) !== 0)
          ? (padAlertTitle + ': ' + padConflict)
          : padConflict;
      } else if (padRemedy) {
        narrative = padRemedy;
      }
    }
    var method = normalizePdfCalloutDash(stripMdLight(last.mixNote || last.trust || wc.trust || '')
      .replace(/^(methodology|method)\s*:\s*/i, ''));
    var breakdown = last.breakdown || [];
    var breakTitle = opts.slug === 'production-rate-calculator'
      ? 'Zone-by-zone production math'
      : 'Detail breakdown';
    var inputItems = collectPrintInputs(opts.fields, opts.formRoot);
    // Equipment Financing: loan/lease terms print as "N mos"
    if (String(opts.slug || '') === 'equipment-financing-comparator' && inputItems && inputItems.length) {
      inputItems = inputItems.map(function (item) {
        var lab = String(item.label || '');
        if (/term \(months\)/i.test(lab) || /loan term|lease term/i.test(lab)) {
          var raw = String(item.value || '').replace(/\s*mos?\b/i, '').trim();
          var tn = Number(raw);
          if (isFinite(tn)) {
            return { label: item.label, value: String(Math.round(tn)) + ' mos' };
          }
        }
        return item;
      });
    }
    // Day Porter: both daily-hour inputs print as "N.N hrs" (never bare "8" vs "6 hrs")
    if (String(opts.slug || '') === 'day-porter-roi' && inputItems && inputItems.length) {
      inputItems = inputItems.map(function (item) {
        var lab = String(item.label || '');
        if (/hours\/day/i.test(lab)) {
          var raw = String(item.value || '').replace(/\s*hrs?\b/i, '').trim();
          var hn = Number(raw);
          if (isFinite(hn)) {
            return { label: item.label, value: hn.toFixed(1) + ' hrs' };
          }
        }
        return item;
      });
    }
    // Sales Tax: local add-on always two-place percent ("0.40%") — never drift to "0.4%"
    if (String(opts.slug || '') === 'sales-tax-calculator' && inputItems && inputItems.length) {
      inputItems = inputItems.map(function (item) {
        var lab = String(item.label || '');
        if (/local add-on/i.test(lab)) {
          var raw = String(item.value || '').replace(/%/g, '').trim();
          var pn = Number(raw);
          if (isFinite(pn)) {
            return { label: item.label, value: pn.toFixed(2) + '%' };
          }
        }
        return item;
      });
    }
    // Insurance Comparison: EMR always two decimal places ("1.00") — never bare "1"
    if (String(opts.slug || '') === 'insurance-comparison' && inputItems && inputItems.length) {
      inputItems = inputItems.map(function (item) {
        var lab = String(item.label || '');
        if (/experience mod|wc mod|\bemr\b/i.test(lab)) {
          var raw = String(item.value || '').trim();
          var pn = Number(raw);
          if (isFinite(pn)) {
            return { label: item.label, value: pn.toFixed(2) };
          }
        }
        return item;
      });
    }
    // Floor Program: never print stale finish label from a desynced <select>
    if (String(opts.slug || '') === 'floor-program-builder' && inputItems && inputItems.length) {
      var finishFromResult = '';
      (last.rows || []).forEach(function (row) {
        if (/^traffic\s*\/\s*finish$/i.test(String(row.label || ''))) {
          var bits = String(row.value || '').split('|');
          if (bits.length > 1) finishFromResult = bits[1].replace(/^\s+|\s+$/g, '');
        }
      });
      if (!finishFromResult && last.metrics && last.metrics[0] && last.metrics[0].value) {
        var mbits = String(last.metrics[0].value).split('\u00B7');
        if (mbits.length < 2) mbits = String(last.metrics[0].value).split('·');
        if (mbits.length > 1) finishFromResult = mbits[1].replace(/^\s+|\s+$/g, '');
      }
      if (finishFromResult) {
        inputItems = inputItems.map(function (item) {
          if (/^finish status$/i.test(String(item.label || ''))) {
            return { label: item.label, value: finishFromResult };
          }
          return item;
        });
      }
    }
    // Pad Selector: YOUR INPUTS lubrication must match remapped Dry path (not stale damp select)
    if (String(opts.slug || '') === 'pad-selector' && inputItems && inputItems.length && last.lubeLabel) {
      inputItems = inputItems.map(function (item) {
        if (/^lubrication/i.test(String(item.label || ''))) {
          return { label: item.label, value: String(last.lubeLabel) };
        }
        return item;
      });
    }
    var leakageProof = null;
    var staffingLines = null;
    var docAudience = '';

    // Bid Generator dual-mode PDF shaping (client proposal vs internal estimating)
    if (isClientPdf) {
      artifact = null;
      docAudience = 'Client proposal summary';
      narrative = normalizePdfCalloutDash(stripMdLight(last.soWhatClient || last.soWhat || ''));
      method = 'Scope-based commercial cleaning proposal. Pricing reflects service frequency and appearance level. Not a formal contract.';
      cards = (last.metrics || []).slice(0, 2).map(function (m, idx) {
        var lab = String(m.label || 'Result');
        if (/annual/i.test(lab)) lab = 'Annual investment';
        if (/monthly/i.test(lab)) lab = 'Monthly investment';
        return { label: lab, value: plainPdfCardValue(m.value || '') };
      });
      if (!cards.length && last.primary) {
        cards = [{ label: 'Annual investment', value: plainPdfCardValue(last.primary) }];
      }
      rowItems = (last.pdfScopeRows || []).map(function (row) {
        return { label: row.label, value: formatPdfMetricValue(row.value) };
      });
      breakdown = [];
      breakTitle = 'Scope of work';
      inputItems = inputItems.filter(function (item) {
        var lab = String(item.label || '').toLowerCase();
        return !(/wage|burden|margin|overhead|markup|supplies \$|paper|soap|equipment|travel|porter|payroll/i.test(lab));
      });
      statusBadge = '';
      riskBadge = '';
      guidanceText = '';
    } else if (isBidGen) {
      artifact = null;
      docAudience = isInternalPdf ? 'Internal estimating worksheet — contractor eyes only' : '';
      if (last.leakageProof) leakageProof = last.leakageProof;
      if (last.staffingPdf) {
        var st = last.staffingPdf;
        var fmtN = function (n, d) {
          return Number(n).toLocaleString('en-US', {
            maximumFractionDigits: d != null ? d : 1,
            minimumFractionDigits: d != null ? d : 0
          });
        };
        staffingLines = [
          {
            label: 'Annual / monthly hours',
            value: '~' + Math.round(st.annualHours || 0).toLocaleString() + ' hrs/yr · ~' +
              Math.round(st.monthlyHours || 0).toLocaleString() + ' hrs/mo'
          },
          {
            label: 'Crew sizing',
            value: (st.crew || 0) + ' cleaner' + ((st.crew || 0) === 1 ? '' : 's') +
              ' × ~' + fmtN(st.hrsPerNight / Math.max(1, st.crew || 1), 1) +
              ' hrs/night (cap ' + fmtN(st.shiftCap, 1) + ' hrs)'
          },
          {
            label: 'Production speed',
            value: '~' + Math.round(st.prodSqftHr || 0).toLocaleString() + ' sqft/hr · ' +
              Math.round(st.cleansPerYear || 0) + ' cleans/yr'
          }
        ];
        if (st.fixtures > 0) {
          staffingLines.push({
            label: 'Restroom fixtures',
            value: String(Math.round(st.fixtures)) + ' fixtures in scope'
          });
        }
      }
    }

    var srcUrl = String(opts.srcUrl || (global.location && global.location.href) || 'https://oporasupply.com');
    var facilityNameRaw = '';
    if (opts.formRoot) {
      var facEl = opts.formRoot.querySelector(
        '[data-calc-field="facility_name"], [data-calc-field="client_name"], [data-calc-field="company_name"]'
      );
      facilityNameRaw = facEl ? String(facEl.value || '').trim() : '';
    }

    // Bid Stress-Test: scenario matrix + Fix-it must appear on the PDF (not cards-only)
    var scenarioRows = null;
    var remediationPdf = '';
    if (String(opts.slug || '') === 'bid-stress-test' && last.scenarios && last.scenarios.length) {
      var fmt$Pdf = (typeof S === 'function' && S() && S().fmt$)
        ? S().fmt$
        : function (n) {
            return '$' + Number(n).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
          };
      scenarioRows = last.scenarios.map(function (s, i) {
        var impact = i === 0
          ? 'Baseline'
          : ((s.deltaPts >= 0 ? '+' : '') + Number(s.deltaPts).toFixed(1) + ' pts');
        return {
          scenario: String(s.name || ''),
          profit: fmt$Pdf(s.profit) + '/mo',
          margin: s.margin != null ? Number(s.margin).toFixed(1) + '%' : '—',
          impact: impact,
          below: !!s.belowTarget
        };
      });
      remediationPdf = String(last.remediation || '');
      cards = cards.map(function (c, idx) {
        var tone = '';
        if (last.metrics && last.metrics[idx] && last.metrics[idx].tone) {
          tone = last.metrics[idx].tone;
        } else if (idx === 0) {
          var v = last.vulnerability || '';
          tone = v === 'High' ? 'bad' : v === 'Medium' ? 'warn' : 'ok';
        }
        if (tone) c.tone = tone;
        return c;
      });
      // Hero card already states High/Moderate/Low risk — skip duplicate status pill
      statusBadge = '';
      riskBadge = '';
    }

    // Floor Program: structured 3-tier maintenance matrix on PDF
    var maintenanceMatrix = null;
    if (String(opts.slug || '') === 'floor-program-builder' && last.maintenanceMatrix && last.maintenanceMatrix.length) {
      maintenanceMatrix = last.maintenanceMatrix.slice(0, 3).map(function (row) {
        return {
          tier: String(row.tier || ''),
          frequency: String(row.frequency || ''),
          tool: String(row.tool || ''),
          procedure: String(row.procedure || '')
        };
      });
    }

    // Per-Clean vs Hourly: structured comparison + SOW (never orphaned inputs-only PDF)
    var compareRows = null;
    var sowClauses = null;
    var pageTitlePdf = opts.title || 'Opora Calculator';
    if (String(opts.slug || '') === 'per-clean-vs-hourly') {
      artifact = null;
      pageTitlePdf = 'Per-Clean vs Hourly vs Flat Evaluation';
      // Never print web CTA chrome ("Next: validate…") into the static PDF
      guidanceText = '';
      if (last.pdfFacilityBits && last.pdfFacilityBits.length) {
        facilityNameRaw = facilityNameRaw || '';
      }
      if (last.pdfCompareRows && last.pdfCompareRows.length) {
        compareRows = last.pdfCompareRows;
      }
      if (last.sowClauses && last.sowClauses.length) {
        sowClauses = last.sowClauses.slice();
      }
      // Drop raw meta-dump METRIC rows — dedicated sections replace them
      rowItems = [];
      if (last.metrics && last.metrics.length) {
        cards = last.metrics.slice(0, 3).map(function (m) {
          var val = plainPdfCardValue(m.value || '');
          if (m.sub) val = val + ' · ' + plainPdfCardValue(m.sub);
          return { label: m.label || 'Result', value: val };
        });
      } else if (last.primary) {
        cards = [{ label: 'Recommended', value: plainPdfCardValue(last.primary) }];
      }
    }

    // Franchise Comparison: structured brand matrix (never pipe-dump METRIC rows)
    var franchiseBrandRows = null;
    if (String(opts.slug || '') === 'franchise-comparison-matrix') {
      if (last.pdfFranchiseRows && last.pdfFranchiseRows.length) {
        franchiseBrandRows = last.pdfFranchiseRows;
      }
      rowItems = [];
    }

    // EPA List N: structured 4-col match matrix (never pipe-dump METRIC rows)
    var epaMatchRows = null;
    if (String(opts.slug || '') === 'epa-list-n-matcher') {
      if (last.pdfEpaMatchRows && last.pdfEpaMatchRows.length) {
        epaMatchRows = last.pdfEpaMatchRows;
      }
      rowItems = [];
    }

    // Tax Deduction Finder: structured 4-col deduction matrix (never pipe-dump METRIC rows)
    var taxDeductRows = null;
    if (String(opts.slug || '') === 'tax-deduction-finder') {
      if (last.pdfTaxDeductRows && last.pdfTaxDeductRows.length) {
        taxDeductRows = last.pdfTaxDeductRows;
      }
      rowItems = [];
    }

    var facilityLine = buildPdfFacilityLine(opts.fields, opts.formRoot);
    if (String(opts.slug || '') === 'per-clean-vs-hourly' && last.pdfFacilityBits && last.pdfFacilityBits.length) {
      facilityLine = last.pdfFacilityBits.join(' | ');
    }
    // Federal RFP Filter has no facility SF — never inherit Bid Gen / Benchmarks defaults
    if (String(opts.slug || '') === 'federal-rfp-filter') {
      facilityLine = last.pdfHeaderMeta
        ? formatPdfMetaLine(last.pdfHeaderMeta)
        : '';
    }
    // Sales Script: company_name is rep firm, not Facility — use Target | Rep Firm | Focus
    if (String(opts.slug || '') === 'sales-script-picker') {
      guidanceText = ''; // never leak "Next: pressure-test…" web CTA into PDF
      facilityLine = last.pdfHeaderMeta
        ? formatPdfMetaLine(last.pdfHeaderMeta)
        : '';
    }

    // Price Increase Letter: client-sendable formal letter — strip dashboard chrome
    var formalLetter = null;
    if (String(opts.slug || '') === 'price-increase-letter' && last.formalLetter) {
      formalLetter = last.formalLetter;
      cards = [];
      rowItems = [];
      inputItems = [];
      artifact = null;
      narrative = '';
      method = '';
      statusBadge = '';
      riskBadge = '';
      guidanceText = '';
      facilityLine = '';
      pageTitlePdf = 'Notice of Service Rate Adjustment';
    }

    // Independent Contractor Agreement: executable draft PDF — strip dashboard chrome
    var formalAgreement = null;
    if (String(opts.slug || '') === 'independent-contractor-agreement' && last.formalAgreement) {
      formalAgreement = last.formalAgreement;
      cards = [];
      rowItems = [];
      inputItems = [];
      artifact = null;
      narrative = '';
      method = '';
      statusBadge = '';
      riskBadge = '';
      guidanceText = '';
      facilityLine = last.pdfHeaderMeta
        ? formatPdfMetaLine(last.pdfHeaderMeta)
        : ((last.secondary && formatPdfMetaLine(last.secondary)) || '');
      pageTitlePdf = 'Independent Contractor Agreement';
    }

      return {
      slug: opts.slug || 'calculator',
      pdfMode: pdfMode || '',
      docAudience: docAudience,
      facilityName: facilityNameRaw,
      pageTitle: pageTitlePdf,
      dateStr: new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
      facility: facilityLine,
      cleanUrl: srcUrl.replace(/[?&]preview_theme_id=\d+/g, '').replace(/\?$/, ''),
      cards: cards.slice(0, 4),
      // PFAS / VOC / Sales Tax / EPA List N / Insurance / SDS / OSHA: never ship soWhat as narrative (callout-only)
      narrative: (String(opts.slug || '') === 'pfas-state-lookup' ||
        String(opts.slug || '') === 'voc-compliance' ||
        String(opts.slug || '') === 'sales-tax-calculator' ||
        String(opts.slug || '') === 'epa-list-n-matcher' ||
        String(opts.slug || '') === 'insurance-comparison' ||
        String(opts.slug || '') === 'sds-finder' ||
        String(opts.slug || '') === 'tax-deduction-finder' ||
        String(opts.slug || '') === 'osha-300-300a-log' ||
        String(opts.slug || '') === 'union-contract-lookup') ? '' : narrative,
      artifact: artifact,
      formalLetter: formalLetter,
      formalAgreement: formalAgreement,
      // Back-compat for any callers still reading letterBody
      letterBody: artifact && !artifact.beats ? (artifact.body || '') : '',
      method: method,
      methodInFooter: opts.slug === 'chemical-compatibility' ||
        opts.slug === 'floor-program-builder' ||
        opts.slug === 'pad-selector' ||
        opts.slug === 'ppe-selector' ||
        opts.slug === 'restroom-time-calculator' ||
        opts.slug === 'issa-447-lookup' ||
        opts.slug === 'appa-inspection-report' ||
        opts.slug === 'client-onboarding-checklist' ||
        opts.slug === 'day-porter-roi' ||
        opts.slug === 'job-costing-calculator' ||
        opts.slug === 'churn-cost-calculator' ||
        opts.slug === 'voc-compliance' ||
        opts.slug === 'epa-list-n-matcher' ||
        opts.slug === 'insurance-comparison' ||
        opts.slug === 'tax-deduction-finder',
      safetyWarning: (function () {
        // PPE protects the worker — never promote narrative into "Surface safety:" orange box
        if (String(opts.slug || '') === 'ppe-selector') return '';
        return normalizePdfCalloutDash(stripPdfLatexArtifacts(stripMdLight(
          last.safetyWarning ||
          ((last.narrativeLabel && /safety/i.test(String(last.narrativeLabel))) ? last.narrative : '') ||
          ''
        )));
      })(),
      // Status badge + scope guidance (APPA Inspection and other flagged tools)
      statusBadge: statusBadge,
      statusBadgeLevel: statusBadgeLevel,
      riskBadge: riskBadge,
      riskBadgeLevel: riskBadgeLevel,
      guidance: guidanceText,
      rowItems: rowItems,
      breakdown: breakdown,
      breakTitle: breakTitle,
      inputItems: inputItems,
      leakageProof: leakageProof,
      staffingLines: staffingLines,
      scenarioRows: scenarioRows,
      maintenanceMatrix: maintenanceMatrix,
      remediation: remediationPdf,
      compareRows: compareRows,
      franchiseBrandRows: franchiseBrandRows,
      epaMatchRows: epaMatchRows,
      taxDeductRows: taxDeductRows,
      sowClauses: sowClauses,
      hazcomBrief: last.hazcomBrief || null,
      padKey: last.padKey ? String(last.padKey) : '',
      mixingInstruction: last.instruction ? String(last.instruction) : '',
      dwellCallout: (last.dwell && (last.dwell.label || last.dwell.text))
        ? {
            label: String(last.dwell.label || 'EPA / contact time'),
            text: String(last.dwell.text || last.dwell.short || '')
          }
        : null
    };
  }

  /** Edge-parity: real .pdf file via jsPDF (same engine as SOW / Bid Generator).
   *  opts.save (default true) · opts.returnBase64 → { filename, base64 } for email attach. */
  function writeCalcJsPdf(jsPDF, model, opts) {
    opts = opts || {};
    var BRAND = [1, 105, 111];
    var TEXT = [15, 18, 23];
    var MUTED = [71, 85, 105];
    var LINE = [226, 232, 240];
    var LINE_SOFT = [241, 245, 249];
    var denseArtifact = !!(model.artifact && model.artifact.beats && model.artifact.beats.length >= 8);
    var rowCount = (model.rowItems && model.rowItems.length) || 0;
    var inputCount = (model.inputItems && model.inputItems.length) || 0;
    var isChemCompat = String(model.slug || '') === 'chemical-compatibility';
    var isDilution = String(model.slug || '') === 'dilution-calculator';
    var isFloorProgram = String(model.slug || '') === 'floor-program-builder';
    var isPadSelector = String(model.slug || '') === 'pad-selector';
    var isPpeSelector = String(model.slug || '') === 'ppe-selector';
    var isRestroomTime = String(model.slug || '') === 'restroom-time-calculator';
    var isIssa447Lookup = String(model.slug || '') === 'issa-447-lookup';
    var isAppaInspection = String(model.slug || '') === 'appa-inspection-report';
    var isClientOnboarding = String(model.slug || '') === 'client-onboarding-checklist';
    var isDayPorterRoi = String(model.slug || '') === 'day-porter-roi';
    var isAccountProfit = String(model.slug || '') === 'account-profitability-auditor';
    var isTcoCalc = String(model.slug || '') === 'tco-calculator';
    var isJobCosting = String(model.slug || '') === 'job-costing-calculator';
    var isEquipmentRoi = String(model.slug || '') === 'equipment-roi-calculator';
    var isChurnCost = String(model.slug || '') === 'churn-cost-calculator';
    var isEbitdaEst = String(model.slug || '') === 'ebitda-estimator';
    var isRobotRoi = String(model.slug || '') === 'robot-roi-matcher';
    var isEquipFinanc = String(model.slug || '') === 'equipment-financing-comparator';
    var isPfasLookup = String(model.slug || '') === 'pfas-state-lookup';
    var isFranchiseCompare = String(model.slug || '') === 'franchise-comparison-matrix';
    var isVocCompliance = String(model.slug || '') === 'voc-compliance';
    var isSalesTax = String(model.slug || '') === 'sales-tax-calculator';
    var isEpaListN = String(model.slug || '') === 'epa-list-n-matcher';
    var isSdsFinder = String(model.slug || '') === 'sds-finder';
    var isInsuranceCompare = String(model.slug || '') === 'insurance-comparison';
    var isTaxDeduct = String(model.slug || '') === 'tax-deduction-finder';
    var isOsha300 = String(model.slug || '') === 'osha-300-300a-log';
    var isUnionLookup = String(model.slug || '') === 'union-contract-lookup';
    /** Pad Selector PDF: map padKey → fill / border / ink (mirrors web data-pad swatches). */
    function padPdfPalette(key) {
      var k = String(key || '').toLowerCase();
      if (k === 'red') return { fill: [253, 236, 234], draw: [198, 40, 40], ink: [183, 28, 28], swatch: [198, 40, 40] };
      if (k === 'blue') return { fill: [227, 242, 253], draw: [21, 101, 192], ink: [13, 71, 161], swatch: [21, 101, 192] };
      if (k === 'green') return { fill: [232, 245, 233], draw: [46, 125, 50], ink: [27, 94, 32], swatch: [46, 125, 50] };
      if (k === 'brown') return { fill: [239, 235, 233], draw: [109, 76, 65], ink: [78, 52, 46], swatch: [109, 76, 65] };
      if (k === 'tan') return { fill: [246, 238, 227], draw: [210, 180, 140], ink: [93, 64, 55], swatch: [210, 180, 140] };
      if (k === 'black') return { fill: [241, 239, 234], draw: [26, 26, 26], ink: [26, 26, 26], swatch: [26, 26, 26] };
      if (k === 'white') return { fill: [243, 241, 236], draw: [189, 183, 173], ink: [26, 26, 26], swatch: [255, 255, 255] };
      if (k === 'diamond') return { fill: [241, 245, 249], draw: [100, 116, 139], ink: [51, 65, 85], swatch: [148, 163, 184] };
      // neutral / brush / extractors
      return { fill: [248, 250, 252], draw: [203, 213, 225], ink: [51, 65, 85], swatch: [148, 163, 184] };
    }
    /** Infer pad key from card/pill label so Alternative (Green) gets green chrome, not Primary blue. */
    function padKeyFromLabel(colorName) {
      var s = String(colorName || '');
      return /melamine/i.test(s) ? 'white'
        : /maroon|spp/i.test(s) ? 'brown'
        : /diamond/i.test(s) ? 'diamond'
        : /microfiber|mop|brush|horsehair|nylon|cylindrical|vacuum|extraction|screen|encapsul/i.test(s) ? 'neutral'
        : /tan|burnish|hog|aqua/i.test(s) ? 'tan'
        : /white/i.test(s) ? 'white'
        : /black/i.test(s) ? 'black'
        : /brown/i.test(s) ? 'brown'
        : /green/i.test(s) ? 'green'
        : /blue/i.test(s) ? 'blue'
        : /red/i.test(s) ? 'red'
        : 'neutral';
    }
    var padPalette = isPadSelector ? padPdfPalette(model.padKey) : null;
    // Dense pack for long P&L / checklist tables so threshold + inputs stay on page 1
    var densePack = denseArtifact ||
      model.slug === 'account-profitability-auditor' ||
      isChemCompat ||
      isFloorProgram ||
      isPadSelector ||
      isPpeSelector ||
      isRestroomTime ||
      isIssa447Lookup ||
      isAppaInspection ||
      isClientOnboarding ||
      isDayPorterRoi ||
      isAccountProfit ||
      isTcoCalc ||
      isJobCosting ||
      isEquipmentRoi ||
      isChurnCost ||
      isEbitdaEst ||
      isRobotRoi ||
      isEquipFinanc ||
      isPfasLookup ||
      isFranchiseCompare ||
      isVocCompliance ||
      isSalesTax ||
      isEpaListN ||
      isInsuranceCompare ||
      isTaxDeduct ||
      isSdsFinder ||
      isOsha300 ||
      isUnionLookup ||
      rowCount >= 10 ||
      (rowCount >= 8 && inputCount >= 6) ||
      (inputCount >= 12 &&
        ((model.breakdown && model.breakdown.length >= 5) || !!(model.artifact && model.artifact.body)));
    // 1.25 leading sitewide for calc PDFs (readable + fits typical reports on 1 page)
    var LH = 1.25;
    var pdf = new jsPDF({ unit: 'pt', format: 'letter', orientation: 'portrait' });
    patchPdfHexShowStrings(pdf);
    pdf.setLineHeightFactor(LH);
    var pageW = pdf.internal.pageSize.getWidth();
    var pageH = pdf.internal.pageSize.getHeight();
    // Slightly tighter margins (~10.5mm) so 1.25 line spacing still fits typical reports on 1 page
    var marginL = 30;
    var marginR = 30;
    var contentW = pageW - marginL - marginR;
    var bottom = pageH - (densePack ? 26 : 38);
    var pageTop = densePack ? 20 : 28;
    var y = pageTop;
    if (String(model.slug || '') === 'bill-rate-calculator' ||
        String(model.slug || '') === 'independent-contractor-agreement' ||
        String(model.slug || '') === '1099-vs-w2-calculator' ||
        String(model.slug || '') === 'production-rate-calculator' ||
        isChemCompat ||
        isDilution ||
        isFloorProgram ||
        isPadSelector ||
        isPpeSelector ||
        isRestroomTime ||
        isIssa447Lookup ||
        isAppaInspection ||
        isClientOnboarding ||
        isDayPorterRoi ||
        isAccountProfit ||
        isTcoCalc ||
        isJobCosting ||
        isChurnCost ||
        isEquipFinanc ||
        isPfasLookup) {
      bottom = pageH - (isChemCompat ? 50 : 54);
    }
    if (isChemCompat || isFloorProgram || isPadSelector || isPpeSelector) {
      pageTop = isFloorProgram ? 16 : (isPadSelector || isPpeSelector ? 16 : 18);
      y = pageTop;
      marginL = isFloorProgram || isPadSelector || isPpeSelector ? 26 : 28;
      marginR = isFloorProgram || isPadSelector || isPpeSelector ? 26 : 28;
      contentW = pageW - marginL - marginR;
      if (isFloorProgram || isPadSelector || isPpeSelector) bottom = pageH - 50;
    }
    if (isRestroomTime) {
      // Reserve full §5 footer band so ISSA table / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isIssa447Lookup) {
      // Reserve §5 footer band so production matrix / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isAppaInspection) {
      // Reserve §5 footer band so APPA levels placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isClientOnboarding) {
      // Reserve §5 footer band so milestones placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isDayPorterRoi) {
      // Reserve §5 footer band so trade-off matrix / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isAccountProfit) {
      // Reserve §5 footer band so P&L benchmarks placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isTcoCalc) {
      // Reserve §5 footer band so lifecycle placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isEquipmentRoi) {
      // Reserve §5 footer band so payback placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isJobCosting) {
      // Reserve §5 footer band so bidding benchmarks placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isEbitdaEst) {
      // Reserve §5 footer band so M&A multiples placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isChurnCost) {
      // Reserve §5 footer band so retention placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isRobotRoi) {
      // Reserve §5 footer band so AMR feasibility placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isEquipFinanc) {
      // Reserve §5 footer band so financing placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isPfasLookup) {
      // Reserve §5 footer band so PFAS risk placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isFranchiseCompare) {
      // Reserve §5 footer band so franchise trade-off placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isVocCompliance) {
      // Reserve §5 footer band so VOC category placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isSalesTax) {
      // Reserve §5 footer band so sales-taxability placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isEpaListN) {
      // Reserve §5 footer band so Spaulding hierarchy placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isInsuranceCompare) {
      // Reserve §5 footer band so insurance/EMR placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isTaxDeduct) {
      // Reserve §5 footer band so entity tax placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isSdsFinder) {
      // Reserve §5 footer band so HazCom PPE placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isOsha300) {
      // Reserve §5 footer band so OSHA recordkeeping placard / methodology never paint over it
      bottom = pageH - 58;
    }
    if (isUnionLookup) {
      // Reserve §5 footer band so SEIU/SCA bidding placard / methodology never paint over it
      bottom = pageH - 58;
    }

    function lineH(fontSize) {
      return (fontSize || 10) * LH;
    }

    /** Draw text lines with explicit leading — avoids jsPDF array-text baseline drift across columns. */
    function writePdfLines(lines, x, startY, lh) {
      if (!lines || !lines.length) return startY;
      var yy = startY;
      for (var li = 0; li < lines.length; li++) {
        var ln = lines[li];
        if (ln == null || ln === '') {
          yy += lh;
          continue;
        }
        pdf.text(String(ln), x, yy);
        yy += lh;
      }
      return yy;
    }

    function ensureSpace(need) {
      if (y + need <= bottom) return;
      pdf.addPage();
      y = pageTop;
    }

    function safe(s) {
      var corridorBucket = [];
      var cleaned = protectPdfMoneyCorridors(cleanPdfPlain(s), corridorBucket)
        // Lone placeholder en/em dash (e.g. Rate/sqft when area blank) — park before hyphen expand
        .replace(/^[\u2013\u2014]$/, '\u0001EMDASH\u0001')
        .replace(/[\u2018\u2019\u2032]/g, "'")
        // Low-9 quote is often a faux thousands comma — keep numeric grouping as ASCII ','
        .replace(/(\d)\u201A(\d)/g, function (_m, a, b) { return a + ',' + b; })
        .replace(/[\u201C\u201D]/g, '"')
        // Cadence arrows (→ / ->) — park through hyphen expand; restore as WinAnsi en-dash
        // (Helvetica has no →; en-dash is the printable stand-in for Daily → Interim → …)
        .replace(/\s*(?:→|->|⇒|\u21D2|\u2794|\u279C)\s*/g, '\u0001ARR\u0001')
        // Multiplication / division / comparisons — Helvetica-safe ASCII before WinAnsi strip
        .replace(/[\u00D7\u2715\u2716]/g, 'x')
        .replace(/\u00F7/g, '/')
        .replace(/\u2264/g, '<=')
        .replace(/\u2265/g, '>=')
        // Unicode subscripts → ASCII so H₂O₂ survives Helvetica (else becomes "HO")
        .replace(/[\u2080\u2081\u2082\u2083\u2084\u2085\u2086\u2087\u2088\u2089]/g, function (ch) {
          return String(ch.charCodeAt(0) - 0x2080);
        })
        .replace(/[\u00B7\u2022\u2023\u2219]/g, '|')
        .replace(/\s*\|\s*/g, ' | ')
        .replace(/\u2022/g, '-')
        // Locale thousands separators (nbsp / thin / Arabic) → ASCII comma before WinAnsi strip
        .replace(/(\d)[\u00A0\u202F\u2007\u2008\u2009\u200A\u2060\u066C](\d)/g, function (_m, a, b) {
          return a + ',' + b;
        })
        // Signed numeric prefixes (−20%, −15) → tight ASCII minus BEFORE spaced-dash expand
        // Otherwise "(−20% speed)" becomes "( - 20% speed)" → methodology " - - 20% speed"
        .replace(/([(\s|]|^)[\u2212\u2013\u2014](?=\d)/g, '$1-')
        // Spaced single hyphen — Helvetica-safe (no Unicode emdash, no raw "--")
        .replace(/\s*[\u2010-\u2015\u2212]\s*/g, ' - ')
        .replace(/\s+--\s+/g, ' - ')
        // Restore cadence arrows as a spaced en-dash (Helvetica-safe stand-in for →)
        // Never collapse to ASCII "-" or "->"
        .replace(/\u0001ARR\u0001/g, '\u2013')
        .replace(/\u0001EMDASH\u0001/g, '\u2013')
        // Keep section sign (WinAnsi 0xA7) + en-dash (0x96) for statute cites / money corridors / cadence arrows
        .replace(/[^\x09\x0A\x0D\x20-\x7E\u00A7\u2013]/g, function (ch) {
          // jsPDF core fonts only reliably render WinAnsi; strip leftovers that explode as spaced glyphs
          if (ch === '\u00A0') return ' ';
          return '';
        })
        // Re-space cadence en-dashes after strip (Daily–Interim–Restorative → Daily – Interim – Restorative)
        .replace(/([A-Za-z])\u2013([A-Za-z])/g, '$1 \u2013 $2')
        // Keep unit suffixes from running into the next word (/mothen, /daythen)
        // But never split /month or /monthly into "/mo nth"
        .replace(/(\/(?:mo|yr|hr|day))(?!(?:nth|nthly))(?=[A-Za-z])/gi, '$1 ')
        // Repair accidental "/mo nth" from older exports / OCR
        .replace(/\/mo\s+nth(ly)?\b/gi, '/month$1')
        // Repair mashed unit labels assessors OCR as "hoursday/" (must stay "hours/day")
        .replace(/\bhours\s*day\s*\/?/gi, 'hours/day')
        .replace(/\bhrs\s*day\s*\/?/gi, 'hrs/day')
        .replace(/\b(hours|hrs)\s*\/\s*day\b/gi, '$1/day')
        // Compound equipment hyphens: Walk-behind / Ride-on (never "Walkbehind -scrubber")
        .replace(/\b(Walk|Ride)\s*behind\s*-\s*/gi, '$1-behind ')
        .replace(/\b(Walk|Ride)\s*-\s*(behind|on)\b/gi, '$1-$2')
        .replace(/\b([A-Za-z]+)\s+-\s*(behind|on)\b/gi, '$1-$2')
        // Cleanable sqft can mis-render as "soft" in some PDF viewers — dotted form stays unambiguous
        .replace(/\b([Cc]leanable) sqft\b/g, '$1 sq. ft.')
        .replace(/\b(Total cleanable) sqft\b/g, '$1 sq. ft.')
        // Approx hours: Helvetica tilde can look like a hyphen — force ASCII ~ + space before hour counts
        .replace(/(^|[\s|])[\-~](?=\s*\d[\d,]*(?:\.\d+)?\s*hrs?\b)/g, '$1~ ')
        .replace(/(^|[\s|])~\s*(?=\d)/g, '$1~ ');
      cleaned = restorePdfMoneyCorridors(cleaned, corridorBucket);
      // Formal letters / agreements keep natural parentheses; dashboard PDFs neutralize for jsPDF
      var out = (formalOnly || agreementOnly) ? cleaned : neutralizePdfParens(cleaned);
      // Callout: "/mo - then" with spaces (never "/mo- then" or "/mo-- then")
      out = out.replace(
        /(\/(?:mo|yr|hr|day))\s*(?:--|[\-~])?\s*(?=then\b)/gi,
        '$1 - '
      );
      out = ensurePdfDollarSigns(out);
      return out;
    }

    /** Values/prose with $ — plain $N tokens only (no \\$ / math fences). */
    function safeMoney(s) {
      var t = String(s == null ? '' : s)
        .replace(/\\+\$/g, '$')
        .replace(/\$\\\$\$/g, '$')
        .replace(/\$\$+/g, '$');
      // Normalize every short currency-like token to plain $3,222/mo (skip $1M / $2M style)
      t = t.replace(/\$[\d,]+(?:\.\d+)?(?![A-Za-z\d])(?:\s*\/\s*(?:mo|yr|hr))?/gi, function (tok) {
        return plainPdfCurrencyToken(tok);
      });
      // Also catch trailing-dollar flips before other passes
      t = ensurePdfDollarSigns(t);
      // Formal letters / IC agreements must keep legal parentheses — never run pdfMoneySafeText
      // (that helper always neutralizePdfParens, which turns ("Company") into - "Company").
      if (formalOnly || agreementOnly) {
        return ensurePdfDollarSigns(safe(t));
      }
      return ensurePdfDollarSigns(safe(pdfMoneySafeText(t)));
    }

    function writeWrapped(text, x, fontSize, fontStyle, color, maxW) {
      var fs = fontSize || 10;
      var lh = lineH(fs);
      pdf.setFont('helvetica', fontStyle || 'normal');
      pdf.setFontSize(fs);
      pdf.setTextColor(color[0], color[1], color[2]);
      var raw = String(text == null ? '' : text);
      var cleaned = raw.indexOf('$') >= 0 ? safeMoney(raw) : safe(raw);
      cleaned = normalizePdfCalloutDash(cleaned);
      var lines = pdf.splitTextToSize(cleaned, maxW || contentW);
      ensureSpace(lines.length * lh + 2);
      pdf.text(lines, x, y);
      y += lines.length * lh;
      return lines.length;
    }

    // —— Formal client letter (Price Increase) — not a calculator dashboard ——
    var formalOnly = !!(model.formalLetter && model.formalLetter.paragraphs && model.formalLetter.paragraphs.length);
    var agreementOnly = !!(model.formalAgreement && model.formalAgreement.articles && model.formalAgreement.articles.length);
    if (formalOnly) {
      var fl = model.formalLetter;
      var letterFs = 11;
      var letterLh = letterFs * 1.35;
      if (pdf.setLineHeightFactor) pdf.setLineHeightFactor(1.35);

      // Letterhead
      pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.rect(0, 0, pageW, 3, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(14);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text(safe(fl.letterhead || 'Contractor'), marginL, y);
      y += 8;
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      pdf.text('Janitorial / Facilities Services', marginL, y);
      y += 6;
      pdf.setDrawColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.setLineWidth(0.9);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 18;

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(letterFs);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      pdf.text(safe(fl.dateLabel || model.dateStr), marginL, y);
      y += letterLh * 1.6;

      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(9);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      pdf.text('VIA ELECTRONIC DELIVERY', marginL, y);
      y += letterLh * 1.15;

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(letterFs);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      pdf.text(safe(fl.client || ''), marginL, y);
      y += letterLh;
      pdf.text('Attn: Facilities / Property Management', marginL, y);
      y += letterLh * 1.6;

      pdf.setFont('helvetica', 'bold');
      var reLines = pdf.splitTextToSize('RE: ' + safe(fl.reLine || 'NOTICE OF SERVICE RATE ADJUSTMENT'), contentW);
      pdf.text(reLines, marginL, y);
      y += reLines.length * letterLh + letterLh * 0.6;

      pdf.setFont('helvetica', 'normal');
      pdf.text(safe(fl.salutation || 'Dear Team,'), marginL, y);
      y += letterLh * 1.4;

      (fl.paragraphs || []).forEach(function (para) {
        var t = safeMoney(String(para || ''));
        if (!t) {
          y += letterLh * 0.5;
          return;
        }
        var lines = pdf.splitTextToSize(t, contentW);
        ensureSpace(lines.length * letterLh + letterLh);
        pdf.text(lines, marginL, y);
        y += lines.length * letterLh + letterLh * 0.55;
      });

      y += letterLh * 0.4;
      pdf.text(safe(fl.closer || 'Sincerely,'), marginL, y);
      y += letterLh * 2.2;
      pdf.setFont('helvetica', 'bold');
      pdf.text(safe(fl.signerName || ''), marginL, y);
      y += letterLh;
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      pdf.text(safe(fl.signerTitle || 'Account Manager / Operations'), marginL, y);
      y += letterLh * 2;

      // Client acknowledgment block
      ensureSpace(70);
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 14;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(10);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      pdf.text('AGREED & ACCEPTED', marginL, y);
      y += letterLh * 1.2;
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(letterFs);
      pdf.text(safe(fl.acceptClient || fl.client || ''), marginL, y);
      y += letterLh * 1.8;
      pdf.text('By: _________________________________     Date: ____________________', marginL, y);
      y += letterLh * 1.5;
      pdf.text('Name / Title: ___________________________________________________', marginL, y);
    }

    // —— Formal subcontract agreement (Independent Contractor) ——
    if (agreementOnly) {
      var fa = model.formalAgreement;
      // Two-line footer reserve; balanced 2-page spread (readable leading, not crammed page-1)
      bottom = pageH - 54;
      var artFs = 9;
      var artLh = artFs * 1.35; // body: 1.25–1.5 range
      var headFs = 9;
      var headLh = headFs * 2;  // article titles: ~2× leading
      if (pdf.setLineHeightFactor) pdf.setLineHeightFactor(1.35);

      function drawAgreementBrandBand() {
        pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
        pdf.rect(0, 0, pageW, 3, 'F');
      }

      drawAgreementBrandBand();
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8.5);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text('OPORA SUPPLY', marginL, y);
      y += 12;
      pdf.setFontSize(12);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      var agTitle = pdf.splitTextToSize(safe(fa.title || 'INDEPENDENT CONTRACTOR AGREEMENT'), contentW);
      pdf.text(agTitle, marginL, y);
      y += agTitle.length * (12 * 1.35) + 4;
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      pdf.text(safe(fa.subtitle || 'Draft for counsel review'), marginL, y);
      y += 10;
      pdf.setDrawColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.setLineWidth(0.9);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 12;

      pdf.setFontSize(artFs);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      pdf.text('Effective date: ' + safe(fa.dateLabel || model.dateStr), marginL, y);
      y += artLh * 1.15;
      if (fa.partiesLine) {
        var partyLines = pdf.splitTextToSize('Parties: ' + safe(fa.partiesLine), contentW);
        pdf.text(partyLines, marginL, y);
        y += partyLines.length * artLh + 4;
      }
      if (fa.facilityLine) {
        var facLines = pdf.splitTextToSize('Facility: ' + safe(fa.facilityLine), contentW);
        pdf.text(facLines, marginL, y);
        y += facLines.length * artLh + 8;
      }

      // Page 1 = Arts 1–9; Page 2 = Arts 10+ + EXECUTION (no signature-only orphan page)
      var pageBreakAfterArt = 9; // 1-based
      (fa.articles || []).forEach(function (art, ai) {
        var artNum = ai + 1;
        if (artNum === pageBreakAfterArt + 1) {
          pdf.addPage();
          y = pageTop;
          drawAgreementBrandBand();
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(8);
          pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
          pdf.text('OPORA SUPPLY', marginL, y);
          y += 10;
          pdf.setFontSize(9);
          pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
          pdf.text(safe((fa.title || 'INDEPENDENT CONTRACTOR AGREEMENT') + ' (continued)'), marginL, y);
          y += 12;
          pdf.setDrawColor(BRAND[0], BRAND[1], BRAND[2]);
          pdf.setLineWidth(0.6);
          pdf.line(marginL, y, pageW - marginR, y);
          y += 12;
        }

        var head = artNum + '. ' + String(art.title || 'Article').toUpperCase();
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(headFs);
        pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
        var headLines = pdf.splitTextToSize(safe(head), contentW);
        ensureSpace(headLines.length * headLh + artLh * 2);
        if (ai > 0 && artNum !== pageBreakAfterArt + 1) y += 6;
        pdf.text(headLines, marginL, y);
        y += headLines.length * headLh;
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(artFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        var bodyLines = pdf.splitTextToSize(safeMoney(String(art.detail || '')), contentW);
        ensureSpace(bodyLines.length * artLh + 4);
        y = writePdfLines(bodyLines, marginL, y, artLh);
        y += 2;
      });

      // EXECUTION shares page 2 with Arts 10–14
      var sigCount = (fa.signatures || []).length;
      var execBlockH = 22 + (sigCount * 56);
      y += 8;
      ensureSpace(execBlockH);
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 10;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(10);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      pdf.text('EXECUTION', marginL, y);
      y += headLh;

      (fa.signatures || []).forEach(function (sig) {
        ensureSpace(52);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(8);
        pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
        pdf.text(safe(sig.heading || 'PARTY'), marginL, y);
        y += artLh;
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(8.5);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        (sig.lines || []).forEach(function (ln) {
          pdf.text(safe(ln), marginL, y);
          y += artLh;
        });
        y += 6;
      });
    }

    if (!formalOnly && !agreementOnly) {
    // Brand header
    pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.rect(0, 0, pageW, 3, 'F');
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(8.5);
    pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.text('OPORA SUPPLY', marginL, y);
    // Clear brand line before 15pt title (dense 1.25 leading was too tight → overlap)
    y += 8.5 + (densePack ? 12 : 10);
    pdf.setFontSize(15);
    pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
    var titleLines = pdf.splitTextToSize(safe(model.pageTitle), contentW * 0.58);
    pdf.text(titleLines, marginL, y);
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(8.5);
    pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
    var metaX = pageW - marginR;
    pdf.text('Run date: ' + safe(model.dateStr), metaX, y - 2, { align: 'right' });
    if (model.facility) {
      // Federal / Sales Script headers are already labeled meta — do not prefix Facility:
      var metaLine = (String(model.slug || '') === 'federal-rfp-filter' ||
        String(model.slug || '') === 'sales-script-picker' ||
        String(model.slug || '') === 'independent-contractor-agreement')
        ? safe(model.facility)
        : ('Facility: ' + safe(model.facility));
      pdf.setFontSize(7.5);
      var metaLines = pdf.splitTextToSize(metaLine, contentW * 0.42);
      pdf.text(metaLines, metaX, y + lineH(8.5), { align: 'right' });
      pdf.setFontSize(8.5);
    }
    if (model.docAudience) {
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text(safe(model.docAudience), marginL, y + lineH(titleLines.length > 1 ? 15 : 12));
      y += lineH(8) + 4;
    }
    y += Math.max(titleLines.length * lineH(15), lineH(15) + 4);
    pdf.setDrawColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.setLineWidth(1);
    pdf.line(marginL, y, pageW - marginR, y);
    y += densePack ? 10 : 14;

    // Executive summary
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(8);
    pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.text('EXECUTIVE SUMMARY', marginL, y);
    y += lineH(8) + (isFloorProgram ? 1 : 2);

    /** Result cards: equal height, adaptive value type, real padding (no clip). */
    if (model.cards && model.cards.length) {
      // Benchmarks, Per-Clean, Bill Rate need 3 summary cards; default stays 2-up for 1-page budget
      var maxCards = (model.slug === 'cleaning-bid-benchmarks' ||
        model.slug === 'per-clean-vs-hourly' ||
        model.slug === 'bill-rate-calculator' ||
        model.slug === '1099-vs-w2-calculator' ||
        model.slug === 'floor-program-builder' ||
        model.slug === 'pad-selector' ||
        model.slug === 'ppe-selector' ||
        model.slug === 'restroom-time-calculator' ||
        model.slug === 'issa-447-lookup' ||
        model.slug === 'appa-inspection-report' ||
        model.slug === 'client-onboarding-checklist' ||
        model.slug === 'day-porter-roi' ||
        model.slug === 'account-profitability-auditor' ||
        model.slug === 'tco-calculator' ||
        model.slug === 'equipment-roi-calculator' ||
        model.slug === 'job-costing-calculator' ||
        model.slug === 'churn-cost-calculator' ||
        model.slug === 'ebitda-estimator' ||
        model.slug === 'robot-roi-matcher' ||
        model.slug === 'equipment-financing-comparator' ||
        model.slug === 'pfas-state-lookup' ||
        model.slug === 'franchise-comparison-matrix' ||
        model.slug === 'voc-compliance' ||
        model.slug === 'sales-tax-calculator' ||
        model.slug === 'epa-list-n-matcher' ||
        model.slug === 'insurance-comparison' ||
        model.slug === 'tax-deduction-finder' ||
        model.slug === 'sds-finder' ||
        model.slug === 'osha-300-300a-log' ||
        model.slug === 'union-contract-lookup')
        ? 3
        : (model.slug === 'dilution-calculator' ? 4 : 2);
      var nCards = Math.min(maxCards, model.cards.length);
      var cardGap = (isChemCompat || isFloorProgram || isPadSelector || isPpeSelector) ? 7 : 10;
      var cardPadX = (isChemCompat || isFloorProgram || isPadSelector || isPpeSelector) ? 8 : 12;
      var cardPadY = isChemCompat ? 6 : (isFloorProgram || isPadSelector || isPpeSelector ? 5 : (densePack ? 7 : 11));
      var cardW = (contentW - cardGap * (nCards - 1)) / nCards;
      var labelFs = 7;
      var labelBand = (isFloorProgram || isPadSelector || isPpeSelector) ? 10 : (densePack ? 11 : 14); // space reserved under top padding for LABEL
      var layouts = [];
      var maxCardH = 0;
      for (var ci = 0; ci < nCards; ci++) {
        var rawVal = plainPdfCardValue(model.cards[ci].value);
        var innerW = cardW - cardPadX * 2;
        var chosenFs = densePack ? 12 : 14;
        var chosenLines = [];
        var sizeOpts = rawVal.length > 42 || rawVal.split(/\s+/).length > 5
          ? [12, 11, 10, 9]
          : (densePack ? [12, 11, 10] : [14, 12, 11, 10]);
        // TCO 3-up: long lifecycle $ strings need a tighter start size so they stay in-card
        if (isTcoCalc && rawVal.length >= 8) {
          sizeOpts = densePack ? [11, 10, 9, 8] : [12, 11, 10, 9, 8];
        }
        // EBITDA valuation bracket ("$1.17M - $1.56M") needs smaller type to fit 3-up
        if (isEbitdaEst && (rawVal.length >= 10 || /\$[\d.]+M/i.test(rawVal))) {
          sizeOpts = densePack ? [10, 9, 8, 7] : [11, 10, 9, 8];
        }
        for (var si = 0; si < sizeOpts.length; si++) {
          chosenFs = sizeOpts[si];
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(chosenFs);
          chosenLines = pdf.splitTextToSize(rawVal, innerW).slice(0, 3);
          if (isTcoCalc || isEbitdaEst) {
            if (chosenLines.length <= 1 || chosenFs <= 8) break;
          } else if (chosenLines.length <= 2 || chosenFs <= 10) {
            break;
          }
        }
        var valBlockH = chosenLines.length * (densePack ? chosenFs * 1.25 : lineH(chosenFs));
        var subFs = 6.5;
        var subLinesOut = [];
        var subBlockH = 0;
        if ((isEbitdaEst || isChurnCost || isRobotRoi || isEquipFinanc || isPfasLookup || isFranchiseCompare || isVocCompliance || isSalesTax || isEpaListN || isSdsFinder || isInsuranceCompare || isTaxDeduct || isOsha300 || isUnionLookup) && model.cards[ci] && model.cards[ci].sub) {
          var subRaw = String(model.cards[ci].sub || '').trim();
          if (subRaw) {
            pdf.setFont('helvetica', 'normal');
            pdf.setFontSize(subFs);
            subLinesOut = pdf.splitTextToSize(subRaw, innerW).slice(0, 2);
            subBlockH = 3 + Math.max(1, subLinesOut.length) * (subFs * 1.15);
          }
        }
        var h = cardPadY + labelBand + 4 + valBlockH + subBlockH + cardPadY;
        var minCardH = (isFloorProgram || isPadSelector || isPpeSelector) ? 36 : (densePack ? 42 : 56);
        if ((isEbitdaEst || isChurnCost || isRobotRoi || isEquipFinanc || isPfasLookup || isFranchiseCompare || isVocCompliance || isSalesTax || isEpaListN || isSdsFinder || isInsuranceCompare || isTaxDeduct || isOsha300 || isUnionLookup) && subBlockH) minCardH = Math.max(minCardH, 52);
        if (h < minCardH) h = minCardH;
        layouts.push({
          label: safe(String(model.cards[ci].label || '').toUpperCase()),
          lines: chosenLines,
          fs: chosenFs,
          valBlockH: valBlockH,
          subLines: subLinesOut,
          subFs: subFs,
          subBlockH: subBlockH
        });
        if (h > maxCardH) maxCardH = h;
      }
      ensureSpace(maxCardH + 10);
      for (var i = 0; i < nCards; i++) {
        var cx = marginL + i * (cardW + cardGap);
        var lay = layouts[i];
        var isTargetCard = !!(model.cards[i] && model.cards[i].target);
        var cardLab = String((model.cards[i] && model.cards[i].label) || '');
        var isPadNameCard = isPadSelector && /primary pad|dip maintenance|alternative/i.test(cardLab);
        // Per-card palette: Alternative "Green" → green fill/swatch/ink (not Primary blue)
        var cardPadPalette = isPadNameCard
          ? padPdfPalette(padKeyFromLabel((model.cards[i] && model.cards[i].value) || ''))
          : null;
        if (isPadNameCard && cardPadPalette) {
          pdf.setFillColor(cardPadPalette.fill[0], cardPadPalette.fill[1], cardPadPalette.fill[2]);
          pdf.setDrawColor(cardPadPalette.draw[0], cardPadPalette.draw[1], cardPadPalette.draw[2]);
        } else if (isTargetCard) {
          pdf.setFillColor(240, 253, 250); // teal-50
          pdf.setDrawColor(153, 246, 228); // teal-200
        } else {
          pdf.setFillColor(248, 250, 252);
          pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        }
        pdf.setLineWidth(0.7);
        pdf.roundedRect(cx, y, cardW, maxCardH, 5, 5, 'FD');
        // Pad swatch chip (left of label) — Primary, Alternative, and DIP
        if (isPadNameCard && cardPadPalette) {
          var sw = 7;
          var swX = cx + cardPadX;
          var swY = y + cardPadY + 2;
          pdf.setFillColor(cardPadPalette.swatch[0], cardPadPalette.swatch[1], cardPadPalette.swatch[2]);
          pdf.setDrawColor(cardPadPalette.draw[0], cardPadPalette.draw[1], cardPadPalette.draw[2]);
          pdf.setLineWidth(0.6);
          pdf.roundedRect(swX, swY, sw, sw, 1.5, 1.5, 'FD');
        }
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(labelFs);
        pdf.setTextColor(isTargetCard ? 19 : 100, isTargetCard ? 78 : 116, isTargetCard ? 74 : 139);
        var labelX = cx + cardPadX;
        if (isPadNameCard && cardPadPalette) {
          labelX = cx + cardPadX + 10;
        }
        pdf.text(lay.label, labelX, y + cardPadY + 8);
        // Vertically center value (+ optional sub) in the remaining band under the label
        var valueTop = y + cardPadY + labelBand + 4;
        var totalValH = lay.valBlockH + (lay.subBlockH || 0);
        var valueBand = maxCardH - (cardPadY + labelBand + 4) - cardPadY;
        var valueY = valueTop + Math.max(0, (valueBand - totalValH) / 2) + lay.fs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(lay.fs);
        var cardTone = (model.cards[i] && model.cards[i].tone) || '';
        var valRgb = BRAND;
        if (isChemCompat) {
          // HazCom QRS: verdict + severity stay neutral black (not brand/rose/amber)
          valRgb = TEXT;
        } else if (isPadNameCard && cardPadPalette) {
          valRgb = cardPadPalette.ink;
        } else if (cardTone === 'bad') valRgb = [225, 29, 72]; // rose-600
        else if (cardTone === 'warn') valRgb = [217, 119, 6]; // amber-600
        else if (cardTone === 'ok') valRgb = [5, 150, 105]; // emerald-600
        pdf.setTextColor(valRgb[0], valRgb[1], valRgb[2]);
        pdf.text(lay.lines, cx + cardPadX, valueY);
        if (lay.subLines && lay.subLines.length) {
          var subY = valueY + lay.valBlockH + 2;
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(lay.subFs || 6.5);
          pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
          writePdfLines(lay.subLines, cx + cardPadX, subY, (lay.subFs || 6.5) * 1.15);
        }
      }
      y += maxCardH + (isChemCompat ? 8 : (isFloorProgram ? 8 : (isPfasLookup ? 8 : (densePack ? 14 : 12))));
    }

    // PFAS / VOC / Sales Tax / EPA List N / SDS / OSHA: soWhat lives only in the slate guidance callout — never duplex as plain narrative
    if (isPfasLookup || isVocCompliance || isSalesTax || isEpaListN || isSdsFinder || isInsuranceCompare || isTaxDeduct || isOsha300 || isUnionLookup) {
      model.narrative = '';
    } else if (model.guidance && model.narrative) {
      // Generic guard: identical soWhat/guidance strings must not print twice
      var nDup = String(model.narrative || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var gDup = String(model.guidance || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (nDup && gDup && (nDup === gDup || gDup.indexOf(nDup) === 0 || nDup.indexOf(gDup) === 0)) {
        model.narrative = '';
      }
    }

    if (model.narrative && !denseArtifact) {
      // Extra gap so soWhat never collides with card bottoms
      y += isFloorProgram ? 2 : (densePack ? 4 : 0);
      writeWrapped(model.narrative, marginL, isFloorProgram ? 8 : (densePack ? 8 : 9), 'normal', TEXT, contentW);
      y += isFloorProgram ? 3 : (densePack ? 3 : 6);
    }

    // Status badge + scope guidance (e.g. APPA Inspection Healthy / Needs Review)
    if (model.statusBadge || model.riskBadge || model.guidance) {
      y += densePack ? 2 : 4;
      function drawPdfStatusBadge(badgeText, badgeLevel) {
        var badge = String(badgeText || '').trim();
        if (!badge) return;
        var level = String(badgeLevel || '').toLowerCase();
        var isOk = level === 'ok' ||
          /within healthy|healthy band|^healthy\b|market range|meets|compliant|low risk|recommended path|\d+\s*fit\b/i.test(badge);
        var isWarn = level === 'warn' ||
          /needs review|at-risk|caution|warn|remapped|none fit|over limit|moderate risk/i.test(badge);
        if (level === 'bad') {
          isOk = false;
          isWarn = false;
        }
        var badgeFs = densePack ? 8 : 9;
        var badgePadX = 10;
        var badgePadY = densePack ? 5 : 6;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(badgeFs);
        var padChip = !!(isPadSelector && padPalette && level !== 'bad' &&
          !(level === 'warn' || /needs review|at-risk|caution|warn|remapped|none fit|over limit|moderate risk|hard block|do not proceed/i.test(badge)));
        var badgeW = pdf.getTextWidth(badge) + badgePadX * 2 + (padChip ? 11 : 0);
        // Explicit box height from pad + glyph (LH can under-clear vs roundedRect bottom)
        var badgeH = badgeFs + badgePadY * 2 + 4;
        ensureSpace(badgeH + 14);
        if (isOk) {
          // Neutral slate for in-band / healthy — never rose
          pdf.setFillColor(241, 245, 249);
          pdf.setDrawColor(203, 213, 225);
          pdf.setTextColor(51, 65, 85);
          // Recommendation path: emerald so W-2 vs 1099 choice reads first
          if (/recommended path/i.test(badge)) {
            pdf.setFillColor(236, 253, 245);
            pdf.setDrawColor(167, 243, 208);
            pdf.setTextColor(4, 120, 87);
          }
        } else if (isWarn) {
          pdf.setFillColor(255, 251, 235);
          pdf.setDrawColor(245, 158, 11);
          pdf.setTextColor(146, 64, 14);
        } else {
          pdf.setFillColor(255, 241, 242);
          pdf.setDrawColor(253, 164, 175);
          pdf.setTextColor(190, 18, 60);
        }
        // Chem Compat: keep Caution / Danger badges slate + black text
        if (isChemCompat) {
          pdf.setFillColor(241, 245, 249);
          pdf.setDrawColor(203, 213, 225);
          pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        }
        // Pad Selector: pad-name pill uses pad color (Remapped / Hard block keep warn/bad)
        if (isPadSelector && padPalette && !isWarn && level !== 'bad' &&
            !/hard block|remapped|do not proceed/i.test(badge)) {
          pdf.setFillColor(padPalette.fill[0], padPalette.fill[1], padPalette.fill[2]);
          pdf.setDrawColor(padPalette.draw[0], padPalette.draw[1], padPalette.draw[2]);
          pdf.setTextColor(padPalette.ink[0], padPalette.ink[1], padPalette.ink[2]);
        }
        pdf.setLineWidth(0.8);
        var badgeDrawW = Math.min(badgeW, contentW);
        // Pad Selector: center Remapped / Hard block / pad-name status chip under the summary
        var badgeX = isPadSelector ? (marginL + (contentW - badgeDrawW) / 2) : marginL;
        pdf.roundedRect(badgeX, y, badgeDrawW, badgeH, 3, 3, 'FD');
        // Center swatch + label as a group; vertically align cap-height midline with the dot
        var showPadChip = !!(isPadSelector && padPalette && !isWarn && level !== 'bad' &&
            !/hard block|remapped|do not proceed/i.test(badge));
        var bSw = 6;
        var bGap = 5;
        var textW = pdf.getTextWidth(safe(badge));
        var innerW = textW + (showPadChip ? (bSw + bGap) : 0);
        var innerX = badgeX + Math.max(badgePadX * 0.5, (badgeDrawW - innerW) / 2);
        var badgeMidY = y + badgeH / 2;
        var badgeTextX = innerX;
        var badgeTextY = badgeMidY + badgeFs * 0.32;
        if (showPadChip) {
          var bSwY = badgeMidY - bSw / 2;
          pdf.setFillColor(padPalette.swatch[0], padPalette.swatch[1], padPalette.swatch[2]);
          pdf.setDrawColor(padPalette.draw[0], padPalette.draw[1], padPalette.draw[2]);
          pdf.setLineWidth(0.5);
          pdf.roundedRect(innerX, bSwY, bSw, bSw, 1.2, 1.2, 'FD');
          badgeTextX = innerX + bSw + bGap;
          pdf.setTextColor(padPalette.ink[0], padPalette.ink[1], padPalette.ink[2]);
        }
        pdf.text(safe(badge), badgeTextX, badgeTextY);
        // Clear methodology / next band — prior LH-based height let the box sit on the next line
        y += badgeH + (densePack ? 6 : 8);
      }
      if (model.statusBadge) {
        drawPdfStatusBadge(model.statusBadge, model.statusBadgeLevel);
      }
      if (model.riskBadge) {
        drawPdfStatusBadge(model.riskBadge, model.riskBadgeLevel);
      }
      if (model.guidance) {
        if (isClientOnboarding || isRobotRoi || isEquipFinanc || isPfasLookup || isFranchiseCompare || isVocCompliance || isSalesTax || isEpaListN || isSdsFinder || isInsuranceCompare || isTaxDeduct || isOsha300 || isUnionLookup) {
          var gFs = densePack ? 8 : 8.5;
          var gLh = gFs * 1.2;
          var gPad = densePack ? 7 : 8;
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(gFs);
          var gLines = pdf.splitTextToSize(safe(model.guidance), contentW - gPad * 2);
          var gH = gPad * 2 + Math.max(1, gLines.length) * gLh;
          ensureSpace(gH + 4);
          pdf.setFillColor(248, 250, 252);
          pdf.setDrawColor(226, 232, 240);
          pdf.setLineWidth(0.8);
          pdf.roundedRect(marginL, y, contentW, gH, 3, 3, 'FD');
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(gFs);
          pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
          writePdfLines(gLines, marginL + gPad, y + gPad + gFs * 0.75, gLh);
          // Franchise / Sales Tax / EPA List N / SDS / Insurance: extra air so Methodology never sits on the callout bottom edge
          y += gH + ((isFranchiseCompare || isSalesTax || isEpaListN || isSdsFinder || isInsuranceCompare || isTaxDeduct || isOsha300 || isUnionLookup) ? (densePack ? 10 : 12) : (densePack ? 4 : 6));
        } else {
          writeWrapped(model.guidance, marginL, densePack ? 8 : 9, 'bold', TEXT, contentW);
          y += densePack ? 3 : 6;
        }
      }
    }

    // Dilution: anti-foam mixing box under summary (before methodology)
    if (isDilution && model.mixingInstruction) {
      var mixBody = String(model.mixingInstruction || '').replace(/\s+/g, ' ').trim();
      if (mixBody) {
        y += densePack ? 4 : 6;
        var mixFs = densePack ? 8 : 9;
        var mixLh = mixFs * 1.25;
        var mixPad = densePack ? 8 : 10;
        var mixHeadFs = 7;
        var mixHeadLh = mixHeadFs * 1.25;
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(mixFs);
        var mixLines = pdf.splitTextToSize(safe(mixBody), contentW - mixPad * 2);
        // Head + 1.25 leading to body + wrapped body lines
        var mixH = mixPad * 2 + mixHeadLh + Math.max(1, mixLines.length) * mixLh;
        ensureSpace(mixH + 4);
        pdf.setFillColor(240, 249, 255); // sky-50
        pdf.setDrawColor(186, 230, 253); // sky-200
        pdf.setLineWidth(1);
        pdf.roundedRect(marginL, y, contentW, mixH, 3, 3, 'FD');
        var mixHeadY = y + mixPad + mixHeadFs * 0.75;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(mixHeadFs);
        pdf.setTextColor(12, 74, 110); // sky-900
        pdf.text('MIXING INSTRUCTION', marginL + mixPad, mixHeadY);
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(mixFs);
        pdf.setTextColor(8, 47, 73); // sky-950
        writePdfLines(mixLines, marginL + mixPad, mixHeadY + mixHeadLh, mixLh);
        y += mixH + (densePack ? 4 : 6);
      }
    }

    if (model.method && !model.methodInFooter) {
      var methodLine = String(model.method || '').replace(/\s+/g, ' ').replace(/\.+$/, '').trim();
      if (methodLine) {
        var isAccountProfitMethod = String(model.slug || '') === 'account-profitability-auditor';
        // 1099 vs W-2 / Dilution / Account Profitability / Franchise / Sales Tax: breathe under badges/callout before Methodology
        if (String(model.slug || '') === '1099-vs-w2-calculator' ||
            String(model.slug || '') === 'dilution-calculator' ||
            isAccountProfitMethod ||
            isFranchiseCompare ||
            isSalesTax ||
            isSdsFinder ||
            isOsha300 ||
            isUnionLookup) {
          y += isAccountProfitMethod ? (densePack ? 8 : 10)
            : (isFranchiseCompare || isSalesTax || isSdsFinder || isOsha300 || isUnionLookup) ? (densePack ? 6 : 8)
            : (densePack ? 4 : 6);
        }
        writeWrapped('Methodology: ' + methodLine + '.', marginL, densePack ? 7 : 8, 'normal', MUTED, contentW);
        // Account Profitability: extra air before METRIC so methodology is not glued to the table
        y += isAccountProfitMethod ? (densePack ? 8 : 10) : (densePack ? 2 : 4);
      }
    }

    /** Full-width deliverable band — letter, script beats, or long copyText (suite-wide). */
    function drawGeneratedArtifact(artifact) {
      if (!artifact) return;
      var title = safe(artifact.title || 'GENERATED COPY');
      var manyBeats = !!(artifact.beats && artifact.beats.length >= 8);
      // Dense clause checklists: tighter leading so YOUR INPUTS stays on page 1
      var letterFs = manyBeats ? 8 : 9;
      var letterLh = manyBeats ? letterFs * 1.28 : lineH(letterFs);
      var padX = 12;
      var stageFs = manyBeats ? 7 : 7.5;
      var stageLh = manyBeats ? stageFs * 1.2 : lineH(stageFs);
      var beatGap = manyBeats ? 2.5 : 6;
      var headGap = manyBeats ? 5 : 8;
      var afterGap = manyBeats ? 6 : 10;

      function drawSectionHead() {
        ensureSpace(24);
        y += manyBeats ? 5 : 8;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(manyBeats ? 7.5 : 8);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        pdf.text(title, marginL, y);
        y += headGap;
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.6);
        pdf.line(marginL, y, pageW - marginR, y);
        y += manyBeats ? 7 : 10;
      }

      if (artifact.beats && artifact.beats.length) {
        drawSectionHead();
        artifact.beats.forEach(function (beat, bi) {
          var stage = safe(String(beat.label || '').toUpperCase());
          var body = String(beat.text || '');
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(stageFs);
          var stageLines = pdf.splitTextToSize(stage, contentW);
          ensureSpace(stageLines.length * stageLh + letterLh * 2);
          if (bi > 0) y += beatGap;
          pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
          pdf.text(stageLines, marginL, y);
          y += stageLines.length * stageLh + (manyBeats ? 1.5 : 3);
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(letterFs);
          pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
          body.split(/\n/).forEach(function (para) {
            var t = safeMoney(para);
            if (!t) {
              y += letterLh * 0.35;
              return;
            }
            var lines = pdf.splitTextToSize(t, contentW);
            ensureSpace(lines.length * letterLh + 2);
            pdf.text(lines, marginL, y);
            y += lines.length * letterLh;
          });
        });
        y += afterGap;
        return;
      }

      var body = artifact.body || '';
      if (!body && !(artifact.bullets && artifact.bullets.length)) return;
      // PPE compliance notes: scannable ASCII bullets (Helvetica has no • — renders as ?)
      if (artifact.bullets && artifact.bullets.length &&
          (String(model.slug || '') === 'ppe-selector' ||
            /compliance notes/i.test(String(artifact.title || '')))) {
        var ppeBullets = artifact.bullets.map(function (b) {
          return String(b || '').replace(/\s+/g, ' ').trim();
        }).filter(Boolean);
        if (!ppeBullets.length) return;
        var ppeFs = isPpeSelector ? 7.5 : 8.5;
        var ppeLh = ppeFs * 1.1;
        var ppePad = isPpeSelector ? 6 : 8;
        var ppeBulletGutter = 9;
        var ppeInnerW = contentW - ppePad * 2 - ppeBulletGutter;
        var ppeTitle = safe(artifact.title || 'SAFETY & COMPLIANCE NOTES');
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(7);
        var ppeTitleLines = pdf.splitTextToSize(ppeTitle, contentW - ppePad * 2);
        var ppeTitleH = Math.max(1, ppeTitleLines.length) * 9;
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(ppeFs);
        var ppeRows = ppeBullets.map(function (b) {
          return pdf.splitTextToSize(safeMoney(b), ppeInnerW);
        });
        var ppeTextH = 0;
        ppeRows.forEach(function (lines, bi) {
          ppeTextH += Math.max(1, lines.length) * ppeLh;
          if (bi < ppeRows.length - 1) ppeTextH += 1.5;
        });
        // Title band + gap so body never collides with the header
        var ppeLabelBand = ppeTitleH + 8;
        var ppeBoxH = ppePad + ppeLabelBand + ppeTextH + ppePad;
        ensureSpace(ppeBoxH + 4);
        y += isPpeSelector ? 3 : 6;
        pdf.setFillColor(248, 250, 252);
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.7);
        pdf.roundedRect(marginL, y, contentW, ppeBoxH, 3, 3, 'FD');
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(7);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(ppeTitleLines, marginL + ppePad, y + ppePad + 7, 9);
        var ppeY = y + ppePad + ppeLabelBand;
        ppeRows.forEach(function (lines) {
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(ppeFs);
          pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
          // ASCII hyphen — Helvetica-safe (• becomes ?)
          pdf.text('-', marginL + ppePad, ppeY);
          pdf.text(lines, marginL + ppePad + ppeBulletGutter, ppeY);
          ppeY += Math.max(1, lines.length) * ppeLh + 1.5;
        });
        y += ppeBoxH + (isPpeSelector ? 4 : 8);
        return;
      }
      if (!body) return;
      // GENERATED COPY box: never dense-cram — readable size + hard 1.25 leading
      var padTop = 11;
      var padBot = 12;
      var labelBand = 16;
      var letterFsBody = Math.max(letterFs || 9, 9);
      var letterLhFactor = 1.25;
      var letterLhBody = letterFsBody * letterLhFactor;
      var innerW = contentW - padX * 2;
      var prevArtifactLh = pdf.getLineHeightFactor ? pdf.getLineHeightFactor() : LH;
      if (pdf.setLineHeightFactor) pdf.setLineHeightFactor(letterLhFactor);
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(letterFsBody);
      var lineRows = [];
      String(body).split(/\n/).forEach(function (para) {
        var t = safeMoney(para);
        if (!t) {
          lineRows.push(null);
          return;
        }
        pdf.splitTextToSize(t, innerW).forEach(function (ln) { lineRows.push(ln); });
      });
      var textH = 0;
      lineRows.forEach(function (ln) {
        textH += ln == null ? letterLhBody * 0.5 : letterLhBody;
      });
      var boxH = padTop + labelBand + textH + padBot;
      // Long letters/scripts may need a page break — draw header then flow text without one giant clip box
      if (boxH > (bottom - y - 20) || boxH > 280) {
        drawSectionHead();
        lineRows.forEach(function (ln) {
          if (ln == null) {
            y += letterLhBody * 0.5;
            return;
          }
          ensureSpace(letterLhBody + 2);
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(letterFsBody);
          pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
          pdf.text(ln, marginL, y);
          y += letterLhBody;
        });
        if (pdf.setLineHeightFactor) pdf.setLineHeightFactor(prevArtifactLh);
        y += densePack ? 5 : 10;
        return;
      }
      ensureSpace(boxH + (densePack ? 6 : 14));
      y += densePack ? 5 : 10;
      pdf.setFillColor(248, 250, 252);
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.7);
      pdf.roundedRect(marginL, y, contentW, boxH, 5, 5, 'FD');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(stageFs);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      pdf.text(title, marginL + padX, y + padTop + 7);
      var cursorY = y + padTop + labelBand + letterFsBody * 0.72;
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(letterFsBody);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      lineRows.forEach(function (ln) {
        if (ln == null) {
          cursorY += letterLhBody * 0.5;
          return;
        }
        pdf.text(ln, marginL + padX, cursorY);
        cursorY += letterLhBody;
      });
      if (pdf.setLineHeightFactor) pdf.setLineHeightFactor(prevArtifactLh);
      y += boxH + (densePack ? 5 : 12);
    }

    drawGeneratedArtifact(model.artifact || (model.letterBody ? { title: 'GENERATED LETTER', body: model.letterBody } : null));

    /**
     * Section label bound to the block below (title + rule + tight gap).
     * Avoids floating headers that read as part of the previous table.
     */
    function drawPdfSectionTitle(label, gapBefore) {
      var before = gapBefore != null ? gapBefore : (isFloorProgram ? 8 : (densePack ? 10 : 14));
      // Pad Selector: section titles +6% vs densePack 7.5
      var fs = isPadSelector ? 8 : (isFloorProgram ? 7 : (densePack ? 7.5 : 8));
      var titleLh = fs * 1.15;
      y += before;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(fs);
      // Wrap long placard titles so the rule sits under the last line (not mid-overflow)
      var titleLines = pdf.splitTextToSize(safe(String(label || '')), contentW);
      ensureSpace(Math.max(1, titleLines.length) * titleLh + 28);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      writePdfLines(titleLines, marginL, y, titleLh);
      y += Math.max(1, titleLines.length) * titleLh;
      // Rule under last baseline — same pattern as GENERATED COPY / brand divider
      y += Math.max(2, fs * 0.25);
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      // Fixed gap from rule to table/prose (keeps title on its section)
      y += isPadSelector ? 5.3 : 5;
    }

    /** Internal estimating: gross-margin protection + crew sizing (drawn after cost table). */
    function drawLeakageAndStaffing() {
      if (model.leakageProof && model.leakageProof.divisorBid != null) {
        var proof = model.leakageProof;
        var fmt = function (n) {
          return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };
        var m = Number(proof.margin);
        var mLabel = isFinite(m) ? m.toFixed(0) : '—';
        var leak = Number(proof.leak);
        var leakAbs = Math.abs(leak);
        var leakSigned = (leak >= 0 ? '' : '-') + fmt(leakAbs);
        var body = 'Bidding via a ' + mLabel + '% divisor (' + fmt(proof.divisorBid) +
          ') protects you from flat markup leakage. A flat ' + mLabel +
          '% markup yields ' + fmt(proof.flatMarkupBid) + ', leaking ' + leakSigned +
          '/yr in uncollected margin.';
        drawPdfSectionTitle('GROSS MARGIN PROTECTION', densePack ? 10 : 14);
        // Extra air under the title so the leakage proof doesn't crowd the header
        y += densePack ? 4 : 6;
        writeWrapped(body, marginL, densePack ? 7.5 : 8.5, 'normal', TEXT, contentW);
        y += densePack ? 2 : 4;
      }
      if (model.staffingLines && model.staffingLines.length) {
        drawPdfSectionTitle('CREW SIZING & SHIFT CAPACITY', densePack ? 10 : 14);
        drawKvTable(model.staffingLines, 'METRIC', 'VALUE', true);
      }
    }

    /** Shared 2-col key/value table (metrics + inputs). */
    function drawKvTable(rows, headLeft, headRight, skipTopGap) {
      if (!rows || !rows.length) return;
      if (!skipTopGap) y += densePack ? 2 : 6;
      var cellPadX = densePack ? 6 : 8;
      // Tight 2-col ledger: label flexes, value column fixed (~140pt) — no empty mid track
      // Client Onboarding punch-list: narrow PHASE, wide OPERATIONAL STANDARD
      var valW = isClientOnboarding
        ? Math.min(Math.floor(contentW * 0.68), contentW - 90)
        : Math.min(140, Math.max(96, contentW * 0.28));
      var labW = contentW - valW;
      // Pad Selector: +6% over prior 7.7 / 1.1 (still 1-page with spare bottom room)
      var bodyFs = isPadSelector ? 8.16 : (isPpeSelector ? 7.5 : ((isFloorProgram) ? 7 : (densePack ? 7.5 : 8.5)));
      // Bill Rate / 1099 / Production Rate / Chem Compat / Dilution / Floor / Pad / PPE: lock leading so METRIC / INPUT rows never collide
      var spacedKvPdf = String(model.slug || '') === 'bill-rate-calculator' ||
        String(model.slug || '') === '1099-vs-w2-calculator' ||
        String(model.slug || '') === 'production-rate-calculator' ||
        isChemCompat ||
        isDilution ||
        isFloorProgram ||
        isPadSelector ||
        isPpeSelector;
      var bodyLh = spacedKvPdf
        ? (bodyFs * (isPpeSelector ? 1.1 : (isPadSelector ? 1.166 : (isChemCompat || isFloorProgram ? 1.15 : 1.25))))
        : lineH(bodyFs);
      var rowPad = isPfasLookup
        ? 2
        : (spacedKvPdf
          ? (isChemCompat ? 5 : (isPpeSelector ? 2.2 : (isPadSelector ? 2.65 : (isFloorProgram ? 3 : 8))))
          : (densePack ? 3 : 9));
      var headH = isPfasLookup
        ? 11
        : (isPpeSelector ? 11.5 : (isPadSelector ? 12.7 : ((isFloorProgram) ? 11 : (densePack ? 12 : 18))));
      function kvValueLines(raw) {
        var v = safeMoney(formatPdfMetricValue(raw || ''));
        if (!v) return [''];
        // Force single line for compact money / percent / rate tokens (incl. credits -$N / ($N))
        if (
          v.length <= 28 ||
          /^\d+(\.\d+)?%$/.test(v) ||
          /^-?\$[\d,]+(\.\d+)?(\/(mo|yr|hr|sf))?$/i.test(v) ||
          /^\+?\$[\d,]+(\.\d+)?(\/(mo|yr|hr))?$/i.test(v) ||
          /^\(\$[\d,]+(\.\d+)?\)$/i.test(v)
        ) {
          return [v];
        }
        return pdf.splitTextToSize(v, valW - cellPadX * 2);
      }
      ensureSpace(headH + 4);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, headH, 'F');
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.5);
      pdf.line(marginL, y + headH, pageW - marginR, y + headH);
      // Hairline between label / value columns so the header never reads as empty mid-cells
      pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
      pdf.setLineWidth(0.3);
      pdf.line(marginL + labW, y + 3, marginL + labW, y + headH - 3);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(isPadSelector || isPpeSelector ? 7.95 : 7);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      pdf.text(headLeft || 'METRIC', marginL + cellPadX, y + (isPadSelector || isPpeSelector ? 9 : (densePack ? 9 : 12)));
      if (isClientOnboarding) {
        pdf.text(headRight || 'VALUE', marginL + labW + cellPadX, y + (densePack ? 9 : 12));
      } else {
        pdf.text(headRight || 'VALUE', pageW - marginR - cellPadX, y + (isPadSelector || isPpeSelector ? 9 : (densePack ? 9 : 12)), { align: 'right' });
      }
      y += headH;
      rows.forEach(function (row, idx) {
        var emphasize = !!row.emphasize ||
          (spacedKvPdf && /bill rate\s*@/i.test(String(row.label || '')));
        pdf.setFont('helvetica', emphasize ? 'bold' : 'normal');
        pdf.setFontSize(bodyFs);
        var l1 = pdf.splitTextToSize(safe(row.label || ''), labW - cellPadX * 2).slice(0, 3);
        pdf.setFont('helvetica', 'bold');
        // Long meta pipes (franchise Fee | Royalty | Yr1 | Item 19) need a 4th wrap line
        // Pad Selector DIP sequences need full step list — never truncate mid-step
        var maxValLines = String(row.value || '').length > 64 ? 4 : 3;
        if (isPadSelector && /DIP restoration/i.test(String(row.label || ''))) {
          maxValLines = 16;
        } else if (isPadSelector && String(row.value || '').length > 120) {
          maxValLines = 8;
        }
        var l2 = kvValueLines(row.value || '').slice(0, maxValLines);
        // Enforce a hard row box so adjacent monthlies never share a baseline
        var rh = Math.max(l1.length, l2.length) * bodyLh + rowPad;
        var minRh = bodyFs * (isPpeSelector ? 1.1 : (isPadSelector ? 1.166 : (spacedKvPdf ? 1.25 : 1))) + rowPad +
          (isPadSelector || isPpeSelector ? 0.53 : (densePack ? 2 : 4));
        if (rh < minRh) rh = minRh;
        ensureSpace(rh);
        if (emphasize) {
          pdf.setFillColor(240, 253, 250);
          pdf.rect(marginL, y, contentW, rh, 'F');
        } else if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var textY = y + rowPad * 0.5 + bodyFs * 0.78;
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL + labW, y + 1, marginL + labW, y + rh - 1);
        pdf.setFont('helvetica', emphasize ? 'bold' : 'normal');
        pdf.setFontSize(bodyFs);
        pdf.setTextColor(emphasize ? TEXT[0] : MUTED[0], emphasize ? TEXT[1] : MUTED[1], emphasize ? TEXT[2] : MUTED[2]);
        writePdfLines(l1, marginL + cellPadX, textY, bodyLh);
        // VALUE column: right-aligned like the on-page result grid
        // Client Onboarding: left-align long operational standards
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(emphasize ? BRAND[0] : TEXT[0], emphasize ? BRAND[1] : TEXT[1], emphasize ? BRAND[2] : TEXT[2]);
        var valRightX = pageW - marginR - cellPadX;
        var valLeftX = marginL + labW + cellPadX;
        var vy = textY;
        for (var vi = 0; vi < l2.length; vi++) {
          if (isClientOnboarding) {
            pdf.text(String(l2[vi] == null ? '' : l2[vi]), valLeftX, vy);
          } else {
            pdf.text(String(l2[vi] == null ? '' : l2[vi]), valRightX, vy, { align: 'right' });
          }
          vy += bodyLh;
        }
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.4);
        pdf.line(marginL, y + rh, pageW - marginR, y + rh);
        y += rh;
      });
    }

    function drawSummaryTable(rows) {
      if (isClientOnboarding) {
        drawKvTable(rows, 'PHASE / STAGE', 'MANDATORY OPERATIONAL STANDARD');
      } else {
        drawKvTable(rows, 'METRIC', 'VALUE');
      }
    }

    /** Inputs: prefer single KV table so long chemistry labels cannot spill into the next column. */
    function drawInputsGrid(rows, skipTopGap) {
      if (!rows || !rows.length) return;
      // Always use the 2-col KV table for ≤12 rows (Dilution + most calcs). The dual
      // side-by-side grid collapses when chemistry / product names wrap.
      if (rows.length <= 12) {
        drawKvTable(rows, 'INPUT', 'VALUE', !!skipTopGap);
        return;
      }
      if (!skipTopGap) y += densePack ? 2 : 4;
      var colGap = isFloorProgram ? 10 : (densePack ? 12 : 16);
      var colW = (contentW - colGap) / 2;
      var inputFs = isFloorProgram ? 7 : (densePack ? 7.5 : 8);
      // Must match pdf.setLineHeightFactor(LH) so wrapped labels cannot spill into the next row
      var inputLh = isFloorProgram ? inputFs * 1.15 : lineH(inputFs);
      var labColW = colW * 0.42;
      var valColW = colW * 0.58 - 4;
      var rowPad = isFloorProgram ? 3 : (densePack ? 4 : 7);
      for (var i = 0; i < rows.length; i += 2) {
        var pair = [rows[i], rows[i + 1]];
        var maxLines = 1;
        var prepared = pair.map(function (row) {
          if (!row) return null;
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(inputFs);
          var labs = pdf.splitTextToSize(safe(row.label), labColW - 2);
          pdf.setFont('helvetica', 'bold');
          var vals = pdf.splitTextToSize(safeMoney(formatPdfMetricValue(row.value)), valColW);
          maxLines = Math.max(maxLines, labs.length, vals.length);
          return { labs: labs.slice(0, 2), vals: vals.slice(0, 2) };
        });
        var rowH = maxLines * inputLh + rowPad;
        ensureSpace(rowH + 2);
        for (var col = 0; col < 2; col++) {
          var x0 = marginL + col * (colW + colGap);
          pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
          pdf.setLineWidth(0.4);
          pdf.line(x0, y + rowH, x0 + colW, y + rowH);
          var prep = prepared[col];
          if (!prep) continue;
          var textY = y + rowPad * 0.45 + inputFs * 0.78;
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(inputFs);
          pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
          writePdfLines(prep.labs, x0, textY, inputLh);
          pdf.setFont('helvetica', 'bold');
          pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
          writePdfLines(prep.vals, x0 + labColW + 4, textY, inputLh);
        }
        y += rowH;
      }
    }

    // Dense packs with GENERATED COPY: skip duplicate METRIC table (saves vertical budget)
    // PPE: always keep the kit specification table (Body / Foot / Respiratory) — never replace with OSHA ref
    if (isPpeSelector || !(densePack && model.artifact && model.artifact.body)) {
      if ((isPfasLookup || isSalesTax || isSdsFinder || isInsuranceCompare || isOsha300 || isUnionLookup) && model.rowItems && model.rowItems.length) {
        // Teal section title glued to METRIC table (same rhythm as YOUR INPUTS / placard)
        drawPdfSectionTitle('KEY RESULTS', 8);
        drawKvTable(
          model.rowItems,
          isUnionLookup ? 'CBA LABOR SPECIFICATION'
            : (isOsha300 ? 'OSHA LOG METRIC'
              : (isSdsFinder ? 'PRODUCT ATTRIBUTE' : (isInsuranceCompare ? 'COVERAGE / METRIC' : 'METRIC'))),
          'VALUE',
          true
        );
      } else {
        drawSummaryTable(model.rowItems);
      }
    }

    // Franchise Comparison: multi-column brand matrix (never pipe-concat METRIC dump)
    if (isFranchiseCompare && model.franchiseBrandRows && model.franchiseBrandRows.length) {
      // Keep Item 19 as spaced ASCII " - " — safe() money corridors would rewrite to en-dash → "?"
      function franchiseItem19Plain(s) {
        return String(s == null ? '' : s)
          .replace(/[\u2010-\u2015\u2212]/g, ' - ')
          .replace(/\s+-\s+/g, ' - ')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      drawPdfSectionTitle('FRANCHISE BRAND COMPARISON', densePack ? 8 : 12);
      // Fixed col widths + shared leading keep left edges aligned; money cols right-aligned
      var fbCols = {
        brand: Math.floor(contentW * 0.15),
        status: Math.floor(contentW * 0.10),
        fee: Math.floor(contentW * 0.15),
        royalty: Math.floor(contentW * 0.12),
        year1: Math.floor(contentW * 0.15),
        item19: 0
      };
      fbCols.item19 = contentW - fbCols.brand - fbCols.status - fbCols.fee - fbCols.royalty - fbCols.year1;
      // ~Day Porter readability (~7.8pt body); headers scale with it
      var fbFs = 7.8;
      var fbLh = fbFs * 1.18;
      var fbPad = 2.4;
      var fbInset = 3;
      var fbHeadH = 16;
      var fbHeadFs = 7.0;
      ensureSpace(fbHeadH + 4);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, fbHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(fbHeadFs);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var fbHy = y + 10.5;
      var fbX = marginL + fbInset;
      pdf.text('FRANCHISE BRAND', fbX, fbHy);
      fbX += fbCols.brand;
      pdf.text('STATUS', fbX, fbHy);
      fbX += fbCols.status;
      // Money headers sit at the right edge of each numeric column
      pdf.text('INITIAL FEE', marginL + fbCols.brand + fbCols.status + fbCols.fee - fbInset, fbHy, { align: 'right' });
      pdf.text('ROYALTY+AD', marginL + fbCols.brand + fbCols.status + fbCols.fee + fbCols.royalty - fbInset, fbHy, { align: 'right' });
      pdf.text('YEAR-1 COST', marginL + fbCols.brand + fbCols.status + fbCols.fee + fbCols.royalty + fbCols.year1 - fbInset, fbHy, { align: 'right' });
      pdf.text('FDD ITEM 19 RANGE', pageW - marginR - fbInset, fbHy, { align: 'right' });
      y += fbHeadH;
      model.franchiseBrandRows.forEach(function (row) {
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(fbFs);
        var bLines = pdf.splitTextToSize(safe(row.brand || ''), fbCols.brand - fbInset * 2).slice(0, 2);
        pdf.setFont('helvetica', 'normal');
        var sLines = pdf.splitTextToSize(safe(row.status || ''), fbCols.status - fbInset * 2).slice(0, 2);
        var fLines = pdf.splitTextToSize(safeMoney(row.fee || ''), fbCols.fee - fbInset * 2).slice(0, 2);
        var rLines = pdf.splitTextToSize(safe(row.royalty || ''), fbCols.royalty - fbInset * 2).slice(0, 2);
        var yLines = pdf.splitTextToSize(safeMoney(row.year1 || ''), fbCols.year1 - fbInset * 2).slice(0, 2);
        var iLines = pdf.splitTextToSize(franchiseItem19Plain(row.item19 || ''), fbCols.item19 - fbInset * 2).slice(0, 2);
        var rh = Math.max(bLines.length, sLines.length, fLines.length, rLines.length, yLines.length, iLines.length, 1) * fbLh + fbPad * 2;
        ensureSpace(rh + 2);
        if (row.recommended) {
          pdf.setFillColor(236, 253, 245);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + fbPad + fbFs * 0.72;
        var xx = marginL + fbInset;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(fbFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(bLines, xx, ty, fbLh);
        xx += fbCols.brand;
        pdf.setFont('helvetica', /fits/i.test(String(row.status || '')) ? 'bold' : 'normal');
        pdf.setTextColor(
          /fits/i.test(String(row.status || '')) ? BRAND[0] : MUTED[0],
          /fits/i.test(String(row.status || '')) ? BRAND[1] : MUTED[1],
          /fits/i.test(String(row.status || '')) ? BRAND[2] : MUTED[2]
        );
        writePdfLines(sLines, xx, ty, fbLh);
        // Numeric columns: right-aligned to column right edge (shared baseline)
        function writeFranRight(lines, colRightX, ink) {
          var yy = ty;
          pdf.setFont('helvetica', ink && ink.bold ? 'bold' : 'normal');
          pdf.setFontSize(fbFs);
          if (ink && ink.rgb) {
            pdf.setTextColor(ink.rgb[0], ink.rgb[1], ink.rgb[2]);
          }
          for (var li = 0; li < lines.length; li++) {
            pdf.text(String(lines[li] == null ? '' : lines[li]), colRightX, yy, { align: 'right' });
            yy += fbLh;
          }
        }
        var feeRight = marginL + fbCols.brand + fbCols.status + fbCols.fee - fbInset;
        var royRight = feeRight + fbCols.royalty;
        var yr1Right = royRight + fbCols.year1;
        var i19Right = pageW - marginR - fbInset;
        writeFranRight(fLines, feeRight, { rgb: TEXT });
        writeFranRight(rLines, royRight, { rgb: MUTED });
        writeFranRight(yLines, yr1Right, { bold: true, rgb: BRAND });
        writeFranRight(iLines, i19Right, { rgb: MUTED });
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += densePack ? 4 : 6;
    }

    // EPA List N: structured 4-col disinfectant matrix (never pipe-concat METRIC dump)
    if (isEpaListN && model.epaMatchRows && model.epaMatchRows.length) {
      var pathogenTitle = '';
      if (model.cards && model.cards[0] && model.cards[0].value) {
        pathogenTitle = String(model.cards[0].value || '').trim();
      }
      var epaMatchTitle = pathogenTitle
        ? ('EPA-REGISTERED DISINFECTANT FORMULATIONS (' + pathogenTitle.toUpperCase() + ')')
        : 'EPA-REGISTERED DISINFECTANT FORMULATIONS';
      drawPdfSectionTitle(epaMatchTitle, densePack ? 8 : 12);
      var emCols = {
        product: Math.floor(contentW * 0.34),
        epa: Math.floor(contentW * 0.18),
        chem: Math.floor(contentW * 0.28),
        dwell: 0
      };
      emCols.dwell = contentW - emCols.product - emCols.epa - emCols.chem;
      var emFs = 7.8;
      var emLh = emFs * 1.18;
      var emPad = 2.4;
      var emInset = 3;
      var emHeadH = 16;
      var emHeadFs = 7.0;
      ensureSpace(emHeadH + 4);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, emHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(emHeadFs);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var emHy = y + 10.5;
      pdf.text('COMMERCIAL PRODUCT', marginL + emInset, emHy);
      pdf.text('EPA REG. NO.', marginL + emCols.product + emInset, emHy);
      pdf.text('ACTIVE CHEMISTRY', marginL + emCols.product + emCols.epa + emInset, emHy);
      pdf.text('DWELL TIME', pageW - marginR - emInset, emHy, { align: 'right' });
      y += emHeadH;
      function epaCellPlain(s) {
        return String(s == null ? '' : s)
          .replace(/[\u2010-\u2015\u2212]/g, '-')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      model.epaMatchRows.forEach(function (row, idx) {
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(emFs);
        var pLines = pdf.splitTextToSize(epaCellPlain(row.product), emCols.product - emInset * 2).slice(0, 3);
        pdf.setFont('helvetica', 'normal');
        var eLines = pdf.splitTextToSize(epaCellPlain(row.epa), emCols.epa - emInset * 2).slice(0, 2);
        var cLines = pdf.splitTextToSize(epaCellPlain(row.chemistry), emCols.chem - emInset * 2).slice(0, 3);
        var dLines = pdf.splitTextToSize(epaCellPlain(row.dwell), emCols.dwell - emInset * 2).slice(0, 2);
        var rh = Math.max(pLines.length, eLines.length, cLines.length, dLines.length, 1) * emLh + emPad * 2;
        ensureSpace(rh + 2);
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + emPad + emFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(emFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(pLines, marginL + emInset, ty, emLh);
        pdf.setFont('helvetica', 'normal');
        writePdfLines(eLines, marginL + emCols.product + emInset, ty, emLh);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(cLines, marginL + emCols.product + emCols.epa + emInset, ty, emLh);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
        var dwellRight = pageW - marginR - emInset;
        var dyy = ty;
        for (var di = 0; di < dLines.length; di++) {
          pdf.text(String(dLines[di] || ''), dwellRight, dyy, { align: 'right' });
          dyy += emLh;
        }
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += densePack ? 4 : 6;
    }

    // Tax Deduction Finder: structured 4-col deduction matrix (never pipe-concat METRIC dump)
    if (isTaxDeduct && model.taxDeductRows && model.taxDeductRows.length) {
      var entityTitle = '';
      if (model.cards && model.cards[0] && model.cards[0].value) {
        entityTitle = String(model.cards[0].value || '').trim();
      }
      var taxMatchTitle = entityTitle
        ? ('IDENTIFIED COMMERCIAL CUSTODIAL TAX DEDUCTIONS (' + entityTitle.toUpperCase() + ')')
        : 'IDENTIFIED COMMERCIAL CUSTODIAL TAX DEDUCTIONS';
      drawPdfSectionTitle(taxMatchTitle, densePack ? 8 : 12);
      var tdCols = {
        cat: Math.floor(contentW * 0.26),
        irc: Math.floor(contentW * 0.14),
        lim: Math.floor(contentW * 0.22),
        rule: 0
      };
      tdCols.rule = contentW - tdCols.cat - tdCols.irc - tdCols.lim;
      var tdFs = 7.4;
      var tdLh = tdFs * 1.16;
      var tdPad = 2.2;
      var tdInset = 3;
      var tdHeadH = 16;
      var tdHeadFs = 6.6;
      ensureSpace(tdHeadH + 4);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, tdHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(tdHeadFs);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var tdHy = y + 10.5;
      pdf.text('DEDUCTION CATEGORY', marginL + tdInset, tdHy);
      pdf.text('IRC CODE', marginL + tdCols.cat + tdInset, tdHy);
      pdf.text('2026 LIMIT', marginL + tdCols.cat + tdCols.irc + tdInset, tdHy);
      pdf.text('CUSTODIAL OPERATIONAL RULE', marginL + tdCols.cat + tdCols.irc + tdCols.lim + tdInset, tdHy);
      y += tdHeadH;
      function taxCellPlain(str) {
        return String(str == null ? '' : str)
          .replace(/§/g, 'Sec. ')
          .replace(/[\u2010-\u2015\u2212]/g, '-')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      model.taxDeductRows.forEach(function (row, idx) {
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(tdFs);
        var cLines = pdf.splitTextToSize(taxCellPlain(row.category), tdCols.cat - tdInset * 2).slice(0, 3);
        pdf.setFont('helvetica', 'normal');
        var iLines = pdf.splitTextToSize(taxCellPlain(row.irc), tdCols.irc - tdInset * 2).slice(0, 2);
        var lLines = pdf.splitTextToSize(taxCellPlain(row.limit), tdCols.lim - tdInset * 2).slice(0, 3);
        var rLines = pdf.splitTextToSize(taxCellPlain(row.rule), tdCols.rule - tdInset * 2).slice(0, 4);
        var rh = Math.max(cLines.length, iLines.length, lLines.length, rLines.length, 1) * tdLh + tdPad * 2;
        ensureSpace(rh + 2);
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + tdPad + tdFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(tdFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(cLines, marginL + tdInset, ty, tdLh);
        pdf.setFont('helvetica', 'normal');
        writePdfLines(iLines, marginL + tdCols.cat + tdInset, ty, tdLh);
        pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
        writePdfLines(lLines, marginL + tdCols.cat + tdCols.irc + tdInset, ty, tdLh);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(rLines, marginL + tdCols.cat + tdCols.irc + tdCols.lim + tdInset, ty, tdLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += densePack ? 4 : 6;
    }

    // Dilution: EPA wet-contact dwell callout after METRIC
    if (isDilution && model.dwellCallout) {
      var dc = model.dwellCallout;
      var dwellLabel = String(dc.label || 'EPA / contact time').trim();
      var dwellText = String(dc.text || '').replace(/\s+/g, ' ').trim();
      var dwellBody = dwellText
        ? (dwellLabel + ' — ' + dwellText)
        : dwellLabel;
      if (dwellBody) {
        y += densePack ? 6 : 8;
        var dwellFs = densePack ? 8 : 9;
        var dwellLh = dwellFs * 1.25;
        var dwellPad = densePack ? 8 : 10;
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(dwellFs);
        var dwellLines = pdf.splitTextToSize(
          safe('EPA Wet Contact Dwell: ' + dwellBody),
          contentW - dwellPad * 2
        );
        var dwellH = dwellPad * 2 + Math.max(1, dwellLines.length) * dwellLh;
        ensureSpace(dwellH + 4);
        pdf.setFillColor(255, 251, 235); // amber-50
        pdf.setDrawColor(253, 230, 138); // amber-200
        pdf.setLineWidth(1);
        pdf.roundedRect(marginL, y, contentW, dwellH, 3, 3, 'FD');
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(dwellFs);
        pdf.setTextColor(120, 53, 15); // amber-900
        writePdfLines(dwellLines, marginL + dwellPad, y + dwellPad + dwellFs * 0.75, dwellLh);
        y += dwellH + (densePack ? 4 : 6);
      }
    }

    // Surface / HazCom safety callout (Floor Program, Pad Selector, etc.) — always after metric table
    if (model.safetyWarning) {
      var sw = String(model.safetyWarning || '').replace(/\s+/g, ' ').trim();
      if (sw) {
        y += isFloorProgram ? 4 : (isPadSelector ? 6 : (densePack ? 8 : 10));
        var swFs = isFloorProgram ? 7.5 : (isPadSelector ? 8 : (densePack ? 8 : 9));
        var swLh = isFloorProgram ? swFs * 1.15 : (isPadSelector ? swFs * 1.25 : lineH(swFs));
        // Pad Selector: extra inset so bold wrap never kisses the amber stroke
        var swPad = isFloorProgram ? 6 : (isPadSelector ? 12 : (densePack ? 8 : 10));
        // Measure wrap with the same bold face used to paint — normal→bold overflow was clipping right edge
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(swFs);
        var swInnerW = contentW - swPad * 2;
        var swLines = pdf.splitTextToSize(safe('Surface safety: ' + sw), swInnerW);
        var swH = swPad * 2 + Math.max(1, swLines.length) * swLh;
        ensureSpace(swH + 4);
        pdf.setFillColor(255, 247, 237); // amber wash
        pdf.setDrawColor(234, 88, 12);
        pdf.setLineWidth(1.2);
        pdf.roundedRect(marginL, y, contentW, swH, 3, 3, 'FD');
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(swFs);
        pdf.setTextColor(154, 52, 18);
        writePdfLines(swLines, marginL + swPad, y + swPad + swFs * 0.75, swLh);
        y += swH + (isFloorProgram ? 3 : (isPadSelector ? 5 : (densePack ? 4 : 6)));
      }
    }

    if (model.breakdown && model.breakdown.length) {
      drawPdfSectionTitle(
        String(model.breakTitle || 'Detail breakdown').toUpperCase(),
        densePack ? 10 : 14
      );
      var hasHints = model.breakdown.some(function (row) {
        return !!(row && row.hint && String(row.hint).trim());
      });
      // 2-col when notes are empty — avoid a blank center/third track
      var col1 = hasHints ? contentW * 0.28 : contentW * 0.62;
      var col2 = hasHints ? contentW * 0.30 : contentW * 0.38;
      var col3 = hasHints ? contentW * 0.42 : 0;
      var brFs = densePack ? 7.5 : 8;
      var brLhFactor = 1.25;
      var brLh = brFs * brLhFactor;
      var brPad = densePack ? 3.5 : 8;
      var prevLhFactor = pdf.internal.getLineHeightFactor ? pdf.internal.getLineHeightFactor() : 1.15;
      if (pdf.setLineHeightFactor) pdf.setLineHeightFactor(brLhFactor);
      if (hasHints) {
        var brHeadH = densePack ? 13 : 18;
        ensureSpace(brHeadH + 4);
        pdf.setFillColor(248, 250, 252);
        pdf.rect(marginL, y, contentW, brHeadH, 'F');
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(7);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        pdf.text('ZONE / LINE', marginL + 5, y + (densePack ? 9 : 12));
        pdf.text('HOURS / VALUE', marginL + col1 + 5, y + (densePack ? 9 : 12));
        pdf.text('NOTES', marginL + col1 + col2 + 5, y + (densePack ? 9 : 12));
        y += brHeadH + 1;
      } else {
        var brHeadH2 = densePack ? 12 : 18;
        ensureSpace(brHeadH2 + 4);
        pdf.setFillColor(248, 250, 252);
        pdf.rect(marginL, y, contentW, brHeadH2, 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, y + brHeadH2, pageW - marginR, y + brHeadH2);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(7);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        pdf.text('METRIC', marginL + 5, y + (densePack ? 9 : 12));
        pdf.text('VALUE', pageW - marginR - 5, y + (densePack ? 9 : 12), { align: 'right' });
        y += brHeadH2;
      }
      model.breakdown.forEach(function (row, idx) {
        var isTotal = !!(row && row.emphasize);
        pdf.setFont('helvetica', isTotal ? 'bold' : 'normal');
        pdf.setFontSize(brFs);
        var l1 = pdf.splitTextToSize(safe(row.label || ''), col1 - 8).slice(0, 2);
        var l2 = pdf.splitTextToSize(safeMoney(formatPdfMetricValue(row.value || '')), col2 - 8).slice(0, 1);
        var l3 = (!hasHints || isTotal)
          ? []
          : pdf.splitTextToSize(safeMoney(formatPdfMetricValue(row.hint || '')), col3 - 8).slice(0, 2);
        var lineCount = Math.max(l1.length || 1, l2.length || 1, l3.length || 1);
        var rh = lineCount * brLh + brPad;
        if (isTotal) rh = Math.max(rh, brLh + brPad);
        ensureSpace(rh + 2);
        var rowTop = y;
        if (isTotal || idx % 2 === 1) {
          pdf.setFillColor(isTotal ? 248 : 252, isTotal ? 250 : 252, isTotal ? 252 : 253);
          pdf.rect(marginL, rowTop - 1, contentW, rh, 'F');
        }
        // Shared first-line baseline for all columns (manual lines → no array-text drift)
        var textY = rowTop + brPad * 0.45 + brFs * 0.72;
        pdf.setFont('helvetica', isTotal ? 'bold' : 'normal');
        pdf.setFontSize(brFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(l1, marginL + 5, textY, brLh);
        if (hasHints) {
          writePdfLines(l2, marginL + col1 + 5, textY, brLh);
          if (!isTotal && l3.length) {
            pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
            writePdfLines(l3, marginL + col1 + col2 + 5, textY, brLh);
          }
        } else {
          // 2-col: value right-aligned in the fixed value track
          pdf.setFont('helvetica', 'bold');
          var valRightX = pageW - marginR - 5;
          var vy = textY;
          for (var vi = 0; vi < l2.length; vi++) {
            pdf.text(String(l2[vi] == null ? '' : l2[vi]), valRightX, vy, { align: 'right' });
            vy += brLh;
          }
        }
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(isTotal ? 0.7 : 0.4);
        pdf.line(marginL, rowTop + rh - 1, pageW - marginR, rowTop + rh - 1);
        y = rowTop + rh;
      });
      if (pdf.setLineHeightFactor) pdf.setLineHeightFactor(prevLhFactor);
    }

    drawLeakageAndStaffing();

    // Per-Clean vs Hourly: comparison matrix + SOW clauses (before inputs audit trail)
    if (model.compareRows && model.compareRows.length) {
      drawPdfSectionTitle('3-MODEL COMPARISON', densePack ? 10 : 14);
      var pcCol = {
        model: contentW * 0.18,
        rate: contentW * 0.20,
        monthly: contentW * 0.20,
        creep: contentW * 0.22,
        ot: contentW * 0.20
      };
      var pcFs = densePack ? 7 : 7.5;
      var pcLh = lineH(pcFs);
      var pcPad = densePack ? 3.5 : 5;
      var pcHeadH = densePack ? 13 : 15;
      ensureSpace(pcHeadH + 4);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, pcHeadH, 'F');
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.5);
      pdf.line(marginL, y + pcHeadH, pageW - marginR, y + pcHeadH);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.5);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var hx = marginL + 4;
      pdf.text('MODEL', hx, y + (densePack ? 9 : 10));
      hx += pcCol.model;
      pdf.text('RATE', hx, y + (densePack ? 9 : 10));
      hx += pcCol.rate;
      pdf.text('EST. MONTHLY', hx, y + (densePack ? 9 : 10));
      hx += pcCol.monthly;
      pdf.text('SCOPE CREEP RISK', hx, y + (densePack ? 9 : 10));
      hx += pcCol.creep;
      pdf.text('OT EXPOSURE', hx, y + (densePack ? 9 : 10));
      y += pcHeadH;
      model.compareRows.forEach(function (row) {
        var mLines = pdf.splitTextToSize(safe(row.model || ''), pcCol.model - 8).slice(0, 2);
        var cLines = pdf.splitTextToSize(safe(row.creep || ''), pcCol.creep - 8).slice(0, 2);
        var oLines = pdf.splitTextToSize(safe(row.ot || ''), pcCol.ot - 8).slice(0, 2);
        var rh = Math.max(mLines.length, cLines.length, oLines.length, 1) * pcLh + pcPad;
        ensureSpace(rh + 2);
        var rowTop = y;
        if (row.recommended) {
          pdf.setFillColor(236, 253, 245);
          pdf.rect(marginL, rowTop - 1, contentW, rh, 'F');
        }
        var textY = rowTop + pcPad * 0.45 + pcFs * 0.72;
        var xx = marginL + 4;
        pdf.setFont('helvetica', row.recommended ? 'bold' : 'normal');
        pdf.setFontSize(pcFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(mLines, xx, textY, pcLh);
        xx += pcCol.model;
        pdf.setFont('helvetica', 'bold');
        pdf.text(safeMoney(row.rate || ''), xx, textY);
        xx += pcCol.rate;
        pdf.text(safeMoney(row.monthly || ''), xx, textY);
        xx += pcCol.monthly;
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(cLines, xx, textY, pcLh);
        xx += pcCol.creep;
        writePdfLines(oLines, xx, textY, pcLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.4);
        pdf.line(marginL, rowTop + rh - 1, pageW - marginR, rowTop + rh - 1);
        y = rowTop + rh;
      });
    }

    if (model.sowClauses && model.sowClauses.length) {
      y += densePack ? 8 : 10;
      drawPdfSectionTitle('SCOPE-PROTECTION CONTRACT LANGUAGE', densePack ? 8 : 12);
      var sowFs = densePack ? 7.5 : 8;
      var sowLh = lineH(sowFs);
      var sowPad = densePack ? 8 : 10;
      var sowBody = model.sowClauses.map(function (c, i) {
        return (i + 1) + '. ' + String(c || '').replace(/\s+/g, ' ').trim();
      }).join('\n\n');
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(sowFs);
      var sowLines = [];
      String(sowBody).split(/\n/).forEach(function (para) {
        var t = safeMoney(para);
        if (!t) {
          sowLines.push(null);
          return;
        }
        pdf.splitTextToSize(t, contentW - sowPad * 2).forEach(function (ln) {
          sowLines.push(ln);
        });
      });
      var sowTextH = 0;
      sowLines.forEach(function (ln) {
        sowTextH += ln == null ? sowLh * 0.45 : sowLh;
      });
      var sowH = sowPad * 2 + sowTextH;
      ensureSpace(sowH + 4);
      pdf.setFillColor(240, 253, 250);
      pdf.setDrawColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.setLineWidth(1.1);
      pdf.roundedRect(marginL, y, contentW, sowH, 3, 3, 'FD');
      var sowY = y + sowPad + sowFs * 0.75;
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(sowFs);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      sowLines.forEach(function (ln) {
        if (ln == null) {
          sowY += sowLh * 0.45;
          return;
        }
        pdf.text(ln, marginL + sowPad, sowY);
        sowY += sowLh;
      });
      y += sowH + (densePack ? 4 : 6);
    }

    // Floor Program: 3-tier maintenance calendar (fills lower page)
    if (isFloorProgram && model.maintenanceMatrix && model.maintenanceMatrix.length) {
      drawPdfSectionTitle('MAINTENANCE PROGRAM MATRIX', 8);
      var mxFs = 6.5;
      var mxLh = mxFs * 1.15;
      var mxPad = 3;
      var mxCols = {
        tier: Math.floor(contentW * 0.18),
        freq: Math.floor(contentW * 0.18),
        tool: Math.floor(contentW * 0.2),
        proc: 0
      };
      mxCols.proc = contentW - mxCols.tier - mxCols.freq - mxCols.tool;
      var mxHeadH = 11;
      ensureSpace(mxHeadH + 36);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, mxHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var mxHy = y + 8;
      pdf.text('TIER', marginL + 4, mxHy);
      pdf.text('FREQUENCY', marginL + mxCols.tier + 4, mxHy);
      pdf.text('TOOL / PAD', marginL + mxCols.tier + mxCols.freq + 4, mxHy);
      pdf.text('PROCEDURE', marginL + mxCols.tier + mxCols.freq + mxCols.tool + 4, mxHy);
      y += mxHeadH;
      model.maintenanceMatrix.forEach(function (row, idx) {
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(mxFs);
        var tLines = pdf.splitTextToSize(safe(row.tier || ''), mxCols.tier - 8).slice(0, 2);
        pdf.setFont('helvetica', 'normal');
        var fLines = pdf.splitTextToSize(safe(row.frequency || ''), mxCols.freq - 8).slice(0, 2);
        var toolLines = pdf.splitTextToSize(safe(row.tool || ''), mxCols.tool - 8).slice(0, 2);
        var pLines = pdf.splitTextToSize(safe(row.procedure || ''), mxCols.proc - 8).slice(0, 3);
        var rh = Math.max(tLines.length, fLines.length, toolLines.length, pLines.length, 1) * mxLh + mxPad * 2;
        ensureSpace(rh + 2);
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + mxPad + mxFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(mxFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(tLines, marginL + 4, ty, mxLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(fLines, marginL + mxCols.tier + 4, ty, mxLh);
        writePdfLines(toolLines, marginL + mxCols.tier + mxCols.freq + 4, ty, mxLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(pLines, marginL + mxCols.tier + mxCols.freq + mxCols.tool + 4, ty, mxLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 3;
    }

    if (model.inputItems && model.inputItems.length) {
      drawPdfSectionTitle('YOUR INPUTS', (isPfasLookup || isVocCompliance || isSalesTax || isEpaListN || isSdsFinder || isInsuranceCompare || isTaxDeduct || isOsha300 || isUnionLookup) ? 10 : ((isFloorProgram || isPadSelector || isPpeSelector) ? 5 : (densePack ? 10 : 14)));
      drawInputsGrid(model.inputItems, true);
    }

    // Sales Tax: custodial taxability / service-supply separation matrix fills lower dead space
    if (isSalesTax) {
      drawPdfSectionTitle('COMMERCIAL CUSTODIAL SALES TAXABILITY & INVOICING SEPARATION RULES', 10);
      var stRef = [
        {
          cat: 'Commercial Janitorial Services',
          tax: 'Taxable in ~20 States',
          rule: 'Taxable as real property service (e.g., TX, NY, PA, OH, CT). Non-taxable pure service in CA, IL, FL.',
          req: 'In taxable states, total contract labor is subject to combined state and local tax based on facility address.'
        },
        {
          cat: 'Consumable Cleaning Supplies',
          tax: 'Generally Taxable',
          rule: 'Trash liners, hand soaps, roll towels, and toilet tissue passed through to clients.',
          req: 'Must be separately line-itemed on customer invoices. Use resale exemption certificate when purchasing from distributor.'
        },
        {
          cat: 'Post-Construction Rough Cleans',
          tax: 'State Dependent',
          rule: 'Debris removal prior to final finishes is often classified as non-taxable capital construction labor.',
          req: 'Contractor must obtain a signed Contractor Exemption Certificate or Capital Improvement Certificate from the GC.'
        },
        {
          cat: 'Initial Deep Clean vs. Recurring Maintenance',
          tax: 'Mixed Treatment',
          rule: 'States may classify one-time deep restorative cleans differently from recurring janitorial maintenance contracts.',
          req: 'Ensure master service agreements distinguish ongoing maintenance schedules from specialized restorative restoration.'
        }
      ];
      var stFs = 7.4;
      var stLh = stFs * 1.16;
      var stPad = 2.2;
      var stInset = 3;
      var stCols = {
        cat: Math.floor(contentW * 0.20),
        tax: Math.floor(contentW * 0.14),
        rule: Math.floor(contentW * 0.30),
        req: 0
      };
      stCols.req = contentW - stCols.cat - stCols.tax - stCols.rule;
      var stHeadFs = 6.4;
      var stHeadLh = stHeadFs * 1.12;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(stHeadFs);
      var stH0 = pdf.splitTextToSize('Custodial Billing Category', stCols.cat - stInset * 2).slice(0, 3);
      var stH1 = pdf.splitTextToSize('General Taxability', stCols.tax - stInset * 2).slice(0, 3);
      var stH2 = pdf.splitTextToSize('Audit Trigger / Classification Rule', stCols.rule - stInset * 2).slice(0, 3);
      var stH3 = pdf.splitTextToSize('Invoicing & Compliance Requirement', stCols.req - stInset * 2).slice(0, 3);
      var stHeadH = Math.max(stH0.length, stH1.length, stH2.length, stH3.length, 1) * stHeadLh + 8;
      ensureSpace(stHeadH + 4);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, stHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(stHeadFs);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var stHy = y + 5 + stHeadFs * 0.72;
      writePdfLines(stH0, marginL + stInset, stHy, stHeadLh);
      writePdfLines(stH1, marginL + stCols.cat + stInset, stHy, stHeadLh);
      writePdfLines(stH2, marginL + stCols.cat + stCols.tax + stInset, stHy, stHeadLh);
      writePdfLines(stH3, marginL + stCols.cat + stCols.tax + stCols.rule + stInset, stHy, stHeadLh);
      y += stHeadH;
      function salesTaxCellPlain(s) {
        return String(s == null ? '' : s)
          .replace(/[\u2010-\u2015\u2212]/g, '-')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      stRef.forEach(function (row, idx) {
        if (y + stLh * 2 + stPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(stFs);
        var cLines = pdf.splitTextToSize(salesTaxCellPlain(row.cat), stCols.cat - stInset * 2).slice(0, 4);
        pdf.setFont('helvetica', 'normal');
        var tLines = pdf.splitTextToSize(salesTaxCellPlain(row.tax), stCols.tax - stInset * 2).slice(0, 4);
        var rLines = pdf.splitTextToSize(salesTaxCellPlain(row.rule), stCols.rule - stInset * 2).slice(0, 5);
        var qLines = pdf.splitTextToSize(salesTaxCellPlain(row.req), stCols.req - stInset * 2).slice(0, 5);
        var rh = Math.max(cLines.length, tLines.length, rLines.length, qLines.length, 1) * stLh + stPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + stPad + stFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(stFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(cLines, marginL + stInset, ty, stLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(tLines, marginL + stCols.cat + stInset, ty, stLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(rLines, marginL + stCols.cat + stCols.tax + stInset, ty, stLh);
        writePdfLines(qLines, marginL + stCols.cat + stCols.tax + stCols.rule + stInset, ty, stLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // SDS Finder: chemical hazard classes & OSHA §8 PPE protocol fills lower dead space
    if (isSdsFinder) {
      drawPdfSectionTitle('COMMERCIAL CUSTODIAL CHEMICAL HAZARD CLASSES & OSHA SECTION 8 PPE MANDATES', 10);
      var sdsRef = [
        {
          cat: 'Caustic Floor Strippers',
          chem: 'MEA, NaOH, KOH',
          ghs: 'Corrosive (Skin Cat 1)',
          ppe: 'Butyl/nitrile gauntlets, splash goggles, neoprene apron, anti-slip boots.',
          rule: 'High exothermic risk. Dilute only with cold water; warm water vaporizes caustic amine fumes.'
        },
        {
          cat: 'Chlorine Disinfectants',
          chem: 'Sodium Hypochlorite (NaOCl)',
          ghs: 'Oxidizer / Corrosive',
          ppe: 'Heavy nitrile gloves, wrap-around eye protection.',
          rule: 'Lethal gas risk. NEVER mix with acid descalers (chlorine gas) or ammoniated products (chloramine).'
        },
        {
          cat: 'Acid Restroom Descalers',
          chem: 'Phosphoric, Hydrochloric acid',
          ghs: 'Corrosive to Metals & Skin',
          ppe: 'Chemical splash goggles, acid-resistant rubber gloves.',
          rule: 'Attacks chrome fixtures if allowed to dry. Neutralize with fresh water rinse immediately.'
        },
        {
          cat: 'Quaternary Disinfectants',
          chem: 'Alkyl Dimethyl Benzyl NH4Cl',
          ghs: 'Irritant / Sensitizer',
          ppe: 'Nitrile exam gloves, safety glasses with side shields.',
          rule: 'Quat binding risk. Use microfiber flat mops; cotton string mops absorb and neutralize active quats.'
        },
        {
          cat: 'Heavy-Duty Degreasers',
          chem: 'Glycol ethers, d-Limonene',
          ghs: 'Skin Irritant / Combustible',
          ppe: 'Solvent-resistant nitrile gloves, vapor respirator if enclosed.',
          rule: 'Combustible liquid. Keep away from floor burnishers and open electrical ignition sources.'
        }
      ];
      var sdsFs = 6.8;
      var sdsLh = sdsFs * 1.14;
      var sdsPad = 2.0;
      var sdsInset = 2.5;
      var sdsCols = {
        cat: Math.floor(contentW * 0.16),
        chem: Math.floor(contentW * 0.16),
        ghs: Math.floor(contentW * 0.14),
        ppe: Math.floor(contentW * 0.24),
        rule: 0
      };
      sdsCols.rule = contentW - sdsCols.cat - sdsCols.chem - sdsCols.ghs - sdsCols.ppe;
      var sdsHeadFs = 5.8;
      var sdsHeadLh = sdsHeadFs * 1.12;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(sdsHeadFs);
      var sdsH0 = pdf.splitTextToSize('Chemical Category', sdsCols.cat - sdsInset * 2).slice(0, 3);
      var sdsH1 = pdf.splitTextToSize('Primary Active Chemistry', sdsCols.chem - sdsInset * 2).slice(0, 3);
      var sdsH2 = pdf.splitTextToSize('GHS Hazard Class', sdsCols.ghs - sdsInset * 2).slice(0, 3);
      var sdsH3 = pdf.splitTextToSize('OSHA Mandated PPE', sdsCols.ppe - sdsInset * 2).slice(0, 3);
      var sdsH4 = pdf.splitTextToSize('Critical Handling & Incompatibility Rule', sdsCols.rule - sdsInset * 2).slice(0, 3);
      var sdsHeadH = Math.max(sdsH0.length, sdsH1.length, sdsH2.length, sdsH3.length, sdsH4.length, 1) * sdsHeadLh + 7;
      ensureSpace(sdsHeadH + 4);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, sdsHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(sdsHeadFs);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var sdsHy = y + 4.5 + sdsHeadFs * 0.72;
      writePdfLines(sdsH0, marginL + sdsInset, sdsHy, sdsHeadLh);
      writePdfLines(sdsH1, marginL + sdsCols.cat + sdsInset, sdsHy, sdsHeadLh);
      writePdfLines(sdsH2, marginL + sdsCols.cat + sdsCols.chem + sdsInset, sdsHy, sdsHeadLh);
      writePdfLines(sdsH3, marginL + sdsCols.cat + sdsCols.chem + sdsCols.ghs + sdsInset, sdsHy, sdsHeadLh);
      writePdfLines(sdsH4, marginL + sdsCols.cat + sdsCols.chem + sdsCols.ghs + sdsCols.ppe + sdsInset, sdsHy, sdsHeadLh);
      y += sdsHeadH;
      function sdsCellPlain(s) {
        return String(s == null ? '' : s)
          .replace(/[\u2010-\u2015\u2212]/g, '-')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      sdsRef.forEach(function (row, idx) {
        if (y + sdsLh * 2 + sdsPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(sdsFs);
        var cLines = pdf.splitTextToSize(sdsCellPlain(row.cat), sdsCols.cat - sdsInset * 2).slice(0, 4);
        pdf.setFont('helvetica', 'normal');
        var chLines = pdf.splitTextToSize(sdsCellPlain(row.chem), sdsCols.chem - sdsInset * 2).slice(0, 4);
        var gLines = pdf.splitTextToSize(sdsCellPlain(row.ghs), sdsCols.ghs - sdsInset * 2).slice(0, 4);
        var pLines = pdf.splitTextToSize(sdsCellPlain(row.ppe), sdsCols.ppe - sdsInset * 2).slice(0, 5);
        var rLines = pdf.splitTextToSize(sdsCellPlain(row.rule), sdsCols.rule - sdsInset * 2).slice(0, 5);
        var rh = Math.max(cLines.length, chLines.length, gLines.length, pLines.length, rLines.length, 1) * sdsLh + sdsPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + sdsPad + sdsFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(sdsFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(cLines, marginL + sdsInset, ty, sdsLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(chLines, marginL + sdsCols.cat + sdsInset, ty, sdsLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(gLines, marginL + sdsCols.cat + sdsCols.chem + sdsInset, ty, sdsLh);
        writePdfLines(pLines, marginL + sdsCols.cat + sdsCols.chem + sdsCols.ghs + sdsInset, ty, sdsLh);
        writePdfLines(rLines, marginL + sdsCols.cat + sdsCols.chem + sdsCols.ghs + sdsCols.ppe + sdsInset, ty, sdsLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // VOC Compliance: CARB / OTC / EPA category limits matrix fills lower dead space
    if (isVocCompliance) {
      y += 8;
      var vocTitle = 'COMMERCIAL CUSTODIAL VOC CONCENTRATION LIMITS ACROSS JURISDICTIONS (% BY WEIGHT)';
      var vocTitleFs = 8.0;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(vocTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      var vocTitleLines = pdf.splitTextToSize(vocTitle, contentW);
      ensureSpace(vocTitleLines.length * (vocTitleFs * 1.2) + 8);
      writePdfLines(vocTitleLines, marginL, y + vocTitleFs * 0.75, vocTitleFs * 1.15);
      y += vocTitleLines.length * (vocTitleFs * 1.15) + 4;
      var vocRef = [
        {
          cat: 'Bathroom & Tile Cleaner (Non-Aerosol)',
          carb: '1.0%',
          otc: '1.0%',
          epa: '5.0%',
          act: 'Acid-based descalers must use organic citric/lactic acids rather than volatile solvents.'
        },
        {
          cat: 'General Purpose Cleaner (Non-Aerosol)',
          carb: '0.5%',
          otc: '4.0%',
          epa: '4.0%',
          act: 'CARB enforces an ultra-low 0.5% limit. Specify hydrogen peroxide or surfactant concentrates.'
        },
        {
          cat: 'Glass & Multi-Surface (Non-Aerosol)',
          carb: '1.0%',
          otc: '4.0%',
          epa: '4.0%',
          act: 'Avoid isopropyl alcohol or butyl-based glass cleaners; transition to DI-water blends.'
        },
        {
          cat: 'Floor Polish / Wax Stripper (Non-Aerosol)',
          carb: '3.0% (as diluted)',
          otc: '3.0%',
          epa: '3.0%',
          act: 'Dilution ratios on label are legally binding. Ensure field crews verify proportioning systems.'
        },
        {
          cat: 'Heavy-Duty Degreaser (Non-Aerosol)',
          carb: '0.5%',
          otc: '4.0%',
          epa: '8.0%',
          act: 'd-Limonene counts as a VOC. Replace petroleum solvents with bio-enzymatic degreasers.'
        }
      ];
      var vocFs = 7.8;
      var vocLh = vocFs * 1.18;
      var vocPad = 2.2;
      var vocInset = 3;
      var vocCols = {
        cat: Math.floor(contentW * 0.22),
        carb: Math.floor(contentW * 0.12),
        otc: Math.floor(contentW * 0.12),
        epa: Math.floor(contentW * 0.12),
        act: 0
      };
      vocCols.act = contentW - vocCols.cat - vocCols.carb - vocCols.otc - vocCols.epa;
      var vocHeadH = 16;
      ensureSpace(vocHeadH + vocLh * 3);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, vocHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.8);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var vocHy = y + 10.5;
      pdf.text('CUSTODIAL PRODUCT', marginL + vocInset, vocHy);
      pdf.text('CA (CARB)', marginL + vocCols.cat + vocInset, vocHy);
      pdf.text('OTC MODEL', marginL + vocCols.cat + vocCols.carb + vocInset, vocHy);
      pdf.text('US EPA', marginL + vocCols.cat + vocCols.carb + vocCols.otc + vocInset, vocHy);
      pdf.text('PROCUREMENT / SUBSTITUTION', marginL + vocCols.cat + vocCols.carb + vocCols.otc + vocCols.epa + vocInset, vocHy);
      y += vocHeadH;
      function vocCellPlain(s) {
        return String(s == null ? '' : s)
          .replace(/[\u2010-\u2015\u2212]/g, '-')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      vocRef.forEach(function (row, idx) {
        if (y + vocLh * 2 + vocPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(vocFs);
        var cLines = pdf.splitTextToSize(vocCellPlain(row.cat), vocCols.cat - vocInset * 2).slice(0, 4);
        pdf.setFont('helvetica', 'normal');
        var carbLines = pdf.splitTextToSize(vocCellPlain(row.carb), vocCols.carb - vocInset * 2).slice(0, 3);
        var otcLines = pdf.splitTextToSize(vocCellPlain(row.otc), vocCols.otc - vocInset * 2).slice(0, 3);
        var epaLines = pdf.splitTextToSize(vocCellPlain(row.epa), vocCols.epa - vocInset * 2).slice(0, 3);
        var aLines = pdf.splitTextToSize(vocCellPlain(row.act), vocCols.act - vocInset * 2).slice(0, 5);
        var rh = Math.max(cLines.length, carbLines.length, otcLines.length, epaLines.length, aLines.length, 1) * vocLh + vocPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + vocPad + vocFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(vocFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(cLines, marginL + vocInset, ty, vocLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(190, 18, 60); // rose for CARB tight limits
        writePdfLines(carbLines, marginL + vocCols.cat + vocInset, ty, vocLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(otcLines, marginL + vocCols.cat + vocCols.carb + vocInset, ty, vocLh);
        writePdfLines(epaLines, marginL + vocCols.cat + vocCols.carb + vocCols.otc + vocInset, ty, vocLh);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(aLines, marginL + vocCols.cat + vocCols.carb + vocCols.otc + vocCols.epa + vocInset, ty, vocLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 4;
    }

    // EPA List N: CDC / Spaulding pathogen hierarchy fills lower dead space
    if (isEpaListN) {
      y += 8;
      var spaTitle = 'CDC / SPAULDING PATHOGEN INACTIVATION HIERARCHY & EPA ANTIMICROBIAL LISTS';
      var spaTitleFs = 8.0;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(spaTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      var spaTitleLines = pdf.splitTextToSize(spaTitle, contentW);
      ensureSpace(spaTitleLines.length * (spaTitleFs * 1.2) + 8);
      writePdfLines(spaTitleLines, marginL, y + spaTitleFs * 0.75, spaTitleFs * 1.15);
      y += spaTitleLines.length * (spaTitleFs * 1.15) + 4;
      var spaRef = [
        {
          tier: 'Bacterial Endospores (Hardest)',
          target: 'C. difficile',
          list: 'List K',
          chem: 'Sodium hypochlorite, peracetic acid',
          rule: 'Requires sporicidal chemistry. Quats are completely ineffective. Mechanical friction pre-clean mandatory.'
        },
        {
          tier: 'Mycobacteria',
          target: 'M. tuberculosis',
          list: 'List B',
          chem: 'Accelerated H2O2, phenolics',
          rule: 'Tuberculocidal claim serves as the EPA benchmark for intermediate-level disinfectant classification.'
        },
        {
          tier: 'Non-Enveloped Viruses',
          target: 'Norovirus, Adenovirus',
          list: 'List G',
          chem: 'AHP, stabilized NaOCl',
          rule: 'Lacks lipid membrane. Resistant to standard alcohol rubs; requires oxidizing formulations.'
        },
        {
          tier: 'Fungal Pathogens',
          target: 'Candida auris',
          list: 'List P',
          chem: 'Specialized quat blends, AHP',
          rule: 'Emerging multidrug-resistant yeast colonizing patient room high-touch surfaces; requires 100% surface wetting.'
        },
        {
          tier: 'Vegetative Bacteria',
          target: 'MRSA, VRE',
          list: 'List H',
          chem: 'Quats, H2O2, alcohols',
          rule: 'Hospital-grade broad-spectrum bactericidal claim. Surface must remain visibly glistening for full labeled dwell time.'
        },
        {
          tier: 'Enveloped Viruses (Easiest)',
          target: 'Influenza A, SARS-CoV-2',
          list: 'List N / List M',
          chem: 'Quats, ethanol, citric acid',
          rule: 'Lipid envelope easily destroyed by mild surfactants and low-concentration quats within 30 to 60 seconds.'
        }
      ];
      var spaFs = 7.4;
      var spaLh = spaFs * 1.16;
      var spaPad = 2.0;
      var spaInset = 3;
      var spaCols = {
        tier: Math.floor(contentW * 0.20),
        target: Math.floor(contentW * 0.14),
        list: Math.floor(contentW * 0.10),
        chem: Math.floor(contentW * 0.18),
        rule: 0
      };
      spaCols.rule = contentW - spaCols.tier - spaCols.target - spaCols.list - spaCols.chem;
      var spaHeadH = 15;
      ensureSpace(spaHeadH + spaLh * 3);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, spaHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.6);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var spaHy = y + 10;
      pdf.text('RESISTANCE TIER', marginL + spaInset, spaHy);
      pdf.text('CLINICAL TARGET', marginL + spaCols.tier + spaInset, spaHy);
      pdf.text('EPA LIST', marginL + spaCols.tier + spaCols.target + spaInset, spaHy);
      pdf.text('ACTIVE CHEM', marginL + spaCols.tier + spaCols.target + spaCols.list + spaInset, spaHy);
      pdf.text('INFECTION CONTROL RULE', marginL + spaCols.tier + spaCols.target + spaCols.list + spaCols.chem + spaInset, spaHy);
      y += spaHeadH;
      function spaCellPlain(s) {
        return String(s == null ? '' : s)
          .replace(/[\u2010-\u2015\u2212]/g, '-')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      spaRef.forEach(function (row, idx) {
        if (y + spaLh * 2 + spaPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(spaFs);
        var tLines = pdf.splitTextToSize(spaCellPlain(row.tier), spaCols.tier - spaInset * 2).slice(0, 3);
        pdf.setFont('helvetica', 'normal');
        var gLines = pdf.splitTextToSize(spaCellPlain(row.target), spaCols.target - spaInset * 2).slice(0, 3);
        var lLines = pdf.splitTextToSize(spaCellPlain(row.list), spaCols.list - spaInset * 2).slice(0, 2);
        var cLines = pdf.splitTextToSize(spaCellPlain(row.chem), spaCols.chem - spaInset * 2).slice(0, 3);
        var rLines = pdf.splitTextToSize(spaCellPlain(row.rule), spaCols.rule - spaInset * 2).slice(0, 4);
        var rh = Math.max(tLines.length, gLines.length, lLines.length, cLines.length, rLines.length, 1) * spaLh + spaPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + spaPad + spaFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(spaFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(tLines, marginL + spaInset, ty, spaLh);
        pdf.setFont('helvetica', 'normal');
        writePdfLines(gLines, marginL + spaCols.tier + spaInset, ty, spaLh);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
        writePdfLines(lLines, marginL + spaCols.tier + spaCols.target + spaInset, ty, spaLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(cLines, marginL + spaCols.tier + spaCols.target + spaCols.list + spaInset, ty, spaLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(rLines, marginL + spaCols.tier + spaCols.target + spaCols.list + spaCols.chem + spaInset, ty, spaLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 4;
    }

    // Insurance Comparison: custodial coverage / EMR benchmark matrix fills lower dead space
    if (isInsuranceCompare) {
      y += 8;
      var insTitle = 'COMMERCIAL CUSTODIAL INSURANCE COVERAGE STANDARDS & EMR RISK BENCHMARKS';
      var insTitleFs = 8.0;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(insTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      var insTitleLines = pdf.splitTextToSize(insTitle, contentW);
      ensureSpace(insTitleLines.length * (insTitleFs * 1.2) + 8);
      writePdfLines(insTitleLines, marginL, y + insTitleFs * 0.75, insTitleFs * 1.15);
      y += insTitleLines.length * (insTitleFs * 1.15) + 4;
      var insRef = [
        {
          pol: 'Commercial General Liability (CGL)',
          lim: '$1,000,000 / $2,000,000',
          end: 'Care, Custody & Control (CCC)',
          risk: 'Standard CGL excludes property in your care. Without CCC, burning client carpet or scratching marble floors is 100% out-of-pocket.'
        },
        {
          pol: 'Workers\' Compensation & EMR',
          lim: 'Statutory / $1,000,000 EL',
          end: 'Waiver of Subrogation',
          risk: 'EMR > 1.00 triggers debit surcharges and disqualifies contractors from bidding institutional/Class A property portfolios.'
        },
        {
          pol: 'Janitorial Surety Bond',
          lim: '$50,000 - $100,000',
          end: 'Third-Party Fidelity Rider',
          risk: 'Protects building owners against custodial employee theft of tenant equipment, high-value electronics, or confidential assets.'
        },
        {
          pol: 'Lost Key / Rekeying Coverage',
          lim: '$25,000 - $50,000',
          end: 'Master Key Replacement Endorsement',
          risk: 'Losing a facility master sub-key can require complete rekeying or badge reprogramming of a multi-story commercial tower.'
        },
        {
          pol: 'Commercial Auto / Hired & Non-Owned',
          lim: '$1,000,000 CSL',
          end: 'HNOA Liability',
          risk: 'Covers supervisor and cleaner liability when using personal vehicles to transport custodial crews, vacuums, or chemicals between job sites.'
        }
      ];
      var insFs = 7.4;
      var insLh = insFs * 1.16;
      var insPad = 2.0;
      var insInset = 3;
      var insCols = {
        pol: Math.floor(contentW * 0.22),
        lim: Math.floor(contentW * 0.18),
        end: Math.floor(contentW * 0.20),
        risk: 0
      };
      insCols.risk = contentW - insCols.pol - insCols.lim - insCols.end;
      var insHeadH = 15;
      ensureSpace(insHeadH + insLh * 3);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, insHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.6);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var insHy = y + 10;
      pdf.text('POLICY / COVERAGE', marginL + insInset, insHy);
      pdf.text('CLASS A MINIMUM', marginL + insCols.pol + insInset, insHy);
      pdf.text('ESSENTIAL ENDORSEMENT', marginL + insCols.pol + insCols.lim + insInset, insHy);
      pdf.text('UNDERWRITING RISK & CLAIMS', marginL + insCols.pol + insCols.lim + insCols.end + insInset, insHy);
      y += insHeadH;
      function insCellPlain(s) {
        return String(s == null ? '' : s)
          .replace(/[\u2010-\u2015\u2212]/g, '-')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      insRef.forEach(function (row, idx) {
        if (y + insLh * 2 + insPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(insFs);
        var pLines = pdf.splitTextToSize(insCellPlain(row.pol), insCols.pol - insInset * 2).slice(0, 3);
        pdf.setFont('helvetica', 'normal');
        var lLines = pdf.splitTextToSize(insCellPlain(row.lim), insCols.lim - insInset * 2).slice(0, 3);
        var eLines = pdf.splitTextToSize(insCellPlain(row.end), insCols.end - insInset * 2).slice(0, 3);
        var rLines = pdf.splitTextToSize(insCellPlain(row.risk), insCols.risk - insInset * 2).slice(0, 4);
        var rh = Math.max(pLines.length, lLines.length, eLines.length, rLines.length, 1) * insLh + insPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + insPad + insFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(insFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(pLines, marginL + insInset, ty, insLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(lLines, marginL + insCols.pol + insInset, ty, insLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(eLines, marginL + insCols.pol + insCols.lim + insInset, ty, insLh);
        writePdfLines(rLines, marginL + insCols.pol + insCols.lim + insCols.end + insInset, ty, insLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 4;
    }

    // OSHA 300 / 300A: recordkeeping & BLS NAICS 561720 benchmarks fill lower dead space
    if (isOsha300) {
      y += 8;
      var oshaTitle = 'COMMERCIAL CUSTODIAL OSHA RECORDKEEPING STANDARDS & BLS NAICS 561720 BENCHMARKS';
      var oshaTitleFs = 8.0;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(oshaTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      var oshaTitleLines = pdf.splitTextToSize(oshaTitle, contentW);
      ensureSpace(oshaTitleLines.length * (oshaTitleFs * 1.2) + 8);
      writePdfLines(oshaTitleLines, marginL, y + oshaTitleFs * 0.75, oshaTitleFs * 1.15);
      y += oshaTitleLines.length * (oshaTitleFs * 1.15) + 4;
      var oshaRef = [
        {
          mand: 'OSHA Form 300A Posting',
          std: '29 CFR 1904.32',
          thr: 'Feb 1 - Apr 30 annually',
          req: 'Mandatory physical posting of certified prior-year summary in all branch offices and permanent custodial closets.'
        },
        {
          mand: 'ITA Electronic Reporting',
          std: '29 CFR 1904.41',
          thr: 'March 2 annually',
          req: 'Establishments with 250+ employees (or 20-249 in high-hazard NAICS) must submit 300A summary electronically via OSHA ITA.'
        },
        {
          mand: 'Recordability Criteria',
          std: '29 CFR 1904.7',
          thr: 'Medical treatment beyond first aid',
          req: 'Any custodial work injury resulting in prescription meds, stitches, days away from work, or job restrictions must be logged within 7 days.'
        },
        {
          mand: 'BLS Custodial Benchmark',
          std: 'NAICS 561720',
          thr: '3.2 TRIR / 1.8 DART',
          req: 'National average incident rate for commercial janitorial services. Rates above 3.2 invite OSHA programmed inspections.'
        },
        {
          mand: 'Workers\' Comp Mod Impact',
          std: 'NCCI Actuarial Standard',
          thr: '3-year rolling claims loss run',
          req: 'Elevated DART frequency directly drives EMR above 1.00, triggering insurance surcharges and RFP disqualification.'
        }
      ];
      var oshaFs = 7.4;
      var oshaLh = oshaFs * 1.16;
      var oshaPad = 2.0;
      var oshaInset = 3;
      var oshaCols = {
        mand: Math.floor(contentW * 0.20),
        std: Math.floor(contentW * 0.16),
        thr: Math.floor(contentW * 0.18),
        req: 0
      };
      oshaCols.req = contentW - oshaCols.mand - oshaCols.std - oshaCols.thr;
      var oshaHeadH = 15;
      ensureSpace(oshaHeadH + oshaLh * 3);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, oshaHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.6);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var oshaHy = y + 10;
      pdf.text('REGULATORY MANDATE', marginL + oshaInset, oshaHy);
      pdf.text('STATUTORY STANDARD', marginL + oshaCols.mand + oshaInset, oshaHy);
      pdf.text('THRESHOLD / DEADLINE', marginL + oshaCols.mand + oshaCols.std + oshaInset, oshaHy);
      pdf.text('OPERATIONAL REQUIREMENT', marginL + oshaCols.mand + oshaCols.std + oshaCols.thr + oshaInset, oshaHy);
      y += oshaHeadH;
      function oshaCellPlain(s) {
        return String(s == null ? '' : s)
          .replace(/[\u2010-\u2015\u2212]/g, '-')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      oshaRef.forEach(function (row, idx) {
        if (y + oshaLh * 2 + oshaPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(oshaFs);
        var mLines = pdf.splitTextToSize(oshaCellPlain(row.mand), oshaCols.mand - oshaInset * 2).slice(0, 3);
        pdf.setFont('helvetica', 'normal');
        var sLines = pdf.splitTextToSize(oshaCellPlain(row.std), oshaCols.std - oshaInset * 2).slice(0, 3);
        var tLines = pdf.splitTextToSize(oshaCellPlain(row.thr), oshaCols.thr - oshaInset * 2).slice(0, 3);
        var rLines = pdf.splitTextToSize(oshaCellPlain(row.req), oshaCols.req - oshaInset * 2).slice(0, 4);
        var rh = Math.max(mLines.length, sLines.length, tLines.length, rLines.length, 1) * oshaLh + oshaPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + oshaPad + oshaFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(oshaFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(mLines, marginL + oshaInset, ty, oshaLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(sLines, marginL + oshaCols.mand + oshaInset, ty, oshaLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(tLines, marginL + oshaCols.mand + oshaCols.std + oshaInset, ty, oshaLh);
        writePdfLines(rLines, marginL + oshaCols.mand + oshaCols.std + oshaCols.thr + oshaInset, ty, oshaLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 4;
    }

    // Union Contract Lookup: SEIU & SCA prevailing wage bidding guidelines fill lower dead space
    if (isUnionLookup) {
      y += 8;
      var unTitle = 'COMMERCIAL CUSTODIAL UNION (SEIU) & SCA PREVAILING WAGE BIDDING GUIDELINES';
      var unTitleFs = 8.0;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(unTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      var unTitleLines = pdf.splitTextToSize(unTitle, contentW);
      ensureSpace(unTitleLines.length * (unTitleFs * 1.2) + 8);
      writePdfLines(unTitleLines, marginL, y + unTitleFs * 0.75, unTitleFs * 1.15);
      y += unTitleLines.length * (unTitleFs * 1.15) + 4;
      var unRef = [
        {
          area: 'Mandatory Benefit Funds',
          rule: 'Taft-Hartley Multi-Employer Trust',
          mech: 'Fixed hourly remittance ($7.00 - $12.50/hr)',
          bid: 'Fringes must be remitted directly to the union trust fund monthly; cannot be paid as cash wages unless allowed by SCA.'
        },
        {
          area: 'Shift Differentials',
          rule: 'Night & Weekend Premiums',
          mech: '1.05x to 1.15x base hourly scale',
          bid: 'Graveyard and second-shift custodial operations carry mandatory premium rates that compound overtime multipliers.'
        },
        {
          area: 'Seniority & Step Progression',
          rule: 'Entry vs. Top Wage Scale',
          mech: 'Automatic step increases after 12-36 months',
          bid: 'Never bid an entire contract at entry-level wages. Active buildings carry grandfathered senior staff at top scale.'
        },
        {
          area: 'Service Contract Act (SCA)',
          rule: '29 CFR Part 4 (FAR 52.222-41)',
          mech: 'DOL Wage Determination minimum floor',
          bid: 'Federal and municipal accounts enforce strict prevailing wage rates. Contractors paying below scale face debarment.'
        },
        {
          area: 'Joint Employer Liability',
          rule: 'NLRA / Common Law Standard',
          mech: 'Property owner / manager exposure',
          bid: 'Class A building owners mandate certified union compliance; non-compliant contractors risk immediate default termination.'
        }
      ];
      var unFs = 7.4;
      var unLh = unFs * 1.16;
      var unPad = 2.0;
      var unInset = 3;
      var unCols = {
        area: Math.floor(contentW * 0.18),
        rule: Math.floor(contentW * 0.18),
        mech: Math.floor(contentW * 0.22),
        bid: 0
      };
      unCols.bid = contentW - unCols.area - unCols.rule - unCols.mech;
      var unHeadH = 15;
      ensureSpace(unHeadH + unLh * 3);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, unHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.4);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var unHy = y + 10;
      pdf.text('LABOR COMPLIANCE', marginL + unInset, unHy);
      pdf.text('STATUTORY / CBA RULE', marginL + unCols.area + unInset, unHy);
      pdf.text('FINANCIAL MECHANISM', marginL + unCols.area + unCols.rule + unInset, unHy);
      pdf.text('BIDDING & OPERATING MANDATE', marginL + unCols.area + unCols.rule + unCols.mech + unInset, unHy);
      y += unHeadH;
      function unCellPlain(s) {
        return String(s == null ? '' : s)
          .replace(/[\u2010-\u2015\u2212]/g, '-')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      unRef.forEach(function (row, idx) {
        if (y + unLh * 2 + unPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(unFs);
        var aLines = pdf.splitTextToSize(unCellPlain(row.area), unCols.area - unInset * 2).slice(0, 3);
        pdf.setFont('helvetica', 'normal');
        var rLines = pdf.splitTextToSize(unCellPlain(row.rule), unCols.rule - unInset * 2).slice(0, 3);
        var mLines = pdf.splitTextToSize(unCellPlain(row.mech), unCols.mech - unInset * 2).slice(0, 3);
        var bLines = pdf.splitTextToSize(unCellPlain(row.bid), unCols.bid - unInset * 2).slice(0, 4);
        var rh = Math.max(aLines.length, rLines.length, mLines.length, bLines.length, 1) * unLh + unPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + unPad + unFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(unFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(aLines, marginL + unInset, ty, unLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(rLines, marginL + unCols.area + unInset, ty, unLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(mLines, marginL + unCols.area + unCols.rule + unInset, ty, unLh);
        writePdfLines(bLines, marginL + unCols.area + unCols.rule + unCols.mech + unInset, ty, unLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 4;
    }

    // Tax Deduction Finder: entity tax structuring placard fills lower dead space
    if (isTaxDeduct) {
      y += 8;
      var taxTitle = 'COMMERCIAL CUSTODIAL ENTITY TAX STRUCTURING & STRATEGY COMPARISON';
      var taxTitleFs = 8.0;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(taxTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      var taxTitleLines = pdf.splitTextToSize(taxTitle, contentW);
      ensureSpace(taxTitleLines.length * (taxTitleFs * 1.2) + 8);
      writePdfLines(taxTitleLines, marginL, y + taxTitleFs * 0.75, taxTitleFs * 1.15);
      y += taxTitleLines.length * (taxTitleFs * 1.15) + 4;
      var taxRef = [
        {
          dim: 'Self-Employment (FICA) Drag',
          sole: '15.3% SE tax assessed on 100% of net profit up to the Social Security wage base, plus Medicare.',
          scorp: '15.3% FICA paid only on reasonable W-2 salary. Remaining net profits distribute as dividends (0% FICA).'
        },
        {
          dim: 'Equipment Expensing (Sec. 179)',
          sole: 'Full write-off of autoscrubbers, vans, and extractors up to $2,560,000, limited to active business income.',
          scorp: 'Full write-off under Sec. 179 and Sec. 168(k) bonus depreciation, creating pass-through losses on Schedule K-1.'
        },
        {
          dim: 'Owner Health Insurance',
          sole: 'Deducted on Form 1040 Schedule 1; cannot reduce self-employment income on Schedule C.',
          scorp: 'Paid by S-Corp, added to Box 1 of W-2 (exempt from FICA/FUTA), and deducted on Form 1040 line 17.'
        },
        {
          dim: 'Retirement Shelter Capacity',
          sole: 'SEP-IRA allows up to 20% of net self-employment earnings (capped at $72,000 in 2026).',
          scorp: 'Solo 401(k) allows $23,500 employee deferral PLUS 25% employer profit sharing up to $72,000 total.'
        },
        {
          dim: 'Audit Trigger Risk',
          sole: 'Schedule C filings face significantly higher IRS audit scrutiny on home office, auto, and supply expenses.',
          scorp: 'Form 1120-S audit rates are substantially lower; primary audit focus is defending Reasonable Compensation.'
        }
      ];
      var txFs = 7.2;
      var txLh = txFs * 1.14;
      var txPad = 2.0;
      var txInset = 3;
      var txCols = {
        dim: Math.floor(contentW * 0.20),
        sole: Math.floor(contentW * 0.40),
        scorp: 0
      };
      txCols.scorp = contentW - txCols.dim - txCols.sole;
      var txHeadH = 18;
      ensureSpace(txHeadH + txLh * 3);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, txHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.4);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var txHy = y + 8;
      pdf.text('TAX DIMENSION', marginL + txInset, txHy);
      var soleHead = pdf.splitTextToSize('SOLE PROPRIETOR / SINGLE-MEMBER LLC', txCols.sole - txInset * 2);
      writePdfLines(soleHead.slice(0, 2), marginL + txCols.dim + txInset, txHy, 7.2);
      var scorpHead = pdf.splitTextToSize('S-CORPORATION (RECOMMENDED >$150k NET)', txCols.scorp - txInset * 2);
      writePdfLines(scorpHead.slice(0, 2), marginL + txCols.dim + txCols.sole + txInset, txHy, 7.2);
      y += txHeadH;
      function taxStratPlain(str) {
        return String(str == null ? '' : str)
          .replace(/§/g, 'Sec. ')
          .replace(/[\u2010-\u2015\u2212]/g, '-')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      taxRef.forEach(function (row, idx) {
        if (y + txLh * 2 + txPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(txFs);
        var dLines = pdf.splitTextToSize(taxStratPlain(row.dim), txCols.dim - txInset * 2).slice(0, 3);
        pdf.setFont('helvetica', 'normal');
        var sLines = pdf.splitTextToSize(taxStratPlain(row.sole), txCols.sole - txInset * 2).slice(0, 4);
        var cLines = pdf.splitTextToSize(taxStratPlain(row.scorp), txCols.scorp - txInset * 2).slice(0, 4);
        var rh = Math.max(dLines.length, sLines.length, cLines.length, 1) * txLh + txPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + txPad + txFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(txFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(dLines, marginL + txInset, ty, txLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(sLines, marginL + txCols.dim + txInset, ty, txLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(cLines, marginL + txCols.dim + txCols.sole + txInset, ty, txLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 4;
    }

    // Day Porter vs Night Crew: operational trade-off matrix fills lower dead space
    if (isDayPorterRoi) {
      y += 8;
      var dpTitle = 'DAY PORTER VS NIGHT CREW OPERATIONAL TRADE-OFF & SERVICE SCOPE MATRIX';
      var dpTitleFs = 8.5;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(dpTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      var dpTitleLines = pdf.splitTextToSize(safe(dpTitle), contentW);
      writePdfLines(dpTitleLines, marginL, y, dpTitleFs * 1.15);
      y += Math.max(1, dpTitleLines.length) * dpTitleFs * 1.15 + 3;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 6;
      var dpRef = [
        {
          dim: 'Primary Service Objective',
          day: 'High-visibility policing, immediate spill mitigation, continuous restroom stocking, executive hospitality.',
          night: 'Deep sanitization, high-production vacuuming, trash pull, mechanical auto-scrubbing, periodic project work.'
        },
        {
          dim: 'Production Rates (ISSA 612)',
          day: 'Low (1,500 - 2,500 sqft/hr) due to tenant traffic, elevator waits, and localized spot-cleaning interruptions.',
          night: 'High (4,500 - 12,500 sqft/hr) unobstructed wide-area production with commercial equipment.'
        },
        {
          dim: 'Equipment Limitations',
          day: 'Restricted to quiet vacuums (<65 dBA), flat mops, and discreet service carts. Heavy machinery prohibited.',
          night: 'Full access to 20-26" auto-scrubbers, burnishers, carpet extractors, and high-decibel equipment.'
        },
        {
          dim: 'Facility Security & Access',
          day: 'Requires public-facing soft skills, customer service presentation, and badge/visitor access compliance.',
          night: 'Requires master key access, strict perimeter security management, and automated alarm arming/disarming SOPs.'
        },
        {
          dim: 'Energy & HVAC Impact',
          day: 'Zero incremental building utility cost; operates within scheduled tenant heating/cooling and lighting envelopes.',
          night: 'May require after-hours janitorial lighting schedules and baseline HVAC conditioning per lease terms.'
        }
      ];
      // Larger body type; fixed col widths keep left edges aligned across all rows
      var dpFs = 8.0;
      var dpLh = dpFs * 1.18;
      var dpPad = 2.2;
      var dpCellInset = 3;
      var dpCols = {
        dim: Math.floor(contentW * 0.20),
        day: Math.floor(contentW * 0.40),
        night: 0
      };
      dpCols.night = contentW - dpCols.dim - dpCols.day;
      var dpHeadH = 16;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, dpHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(7.2);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var dpHy = y + 10.5;
      pdf.text('OPERATIONAL DIMENSION', marginL + dpCellInset, dpHy);
      pdf.text('DAY PORTER (OCCUPIED HOURS)', marginL + dpCols.dim + dpCellInset, dpHy);
      pdf.text('NIGHT CREW (UNOCCUPIED HOURS)', marginL + dpCols.dim + dpCols.day + dpCellInset, dpHy);
      y += dpHeadH;
      dpRef.forEach(function (row, idx) {
        if (y + dpLh * 2 + dpPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(dpFs);
        var dimLines = pdf.splitTextToSize(safe(row.dim), dpCols.dim - dpCellInset * 2).slice(0, 3);
        pdf.setFont('helvetica', 'normal');
        var dayLines = pdf.splitTextToSize(safe(row.day), dpCols.day - dpCellInset * 2).slice(0, 5);
        var nightLines = pdf.splitTextToSize(safe(row.night), dpCols.night - dpCellInset * 2).slice(0, 5);
        var rh = Math.max(dimLines.length, dayLines.length, nightLines.length, 1) * dpLh + dpPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + dpPad + dpFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(dpFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(dimLines, marginL + dpCellInset, ty, dpLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(dayLines, marginL + dpCols.dim + dpCellInset, ty, dpLh);
        writePdfLines(nightLines, marginL + dpCols.dim + dpCols.day + dpCellInset, ty, dpLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 4;
    }

    // Account Profitability: BSCAI / industry P&L benchmarks fill lower dead space
    if (isAccountProfit) {
      y += 12;
      var apTitle = 'COMMERCIAL CUSTODIAL OPERATING FINANCIAL BENCHMARKS (BSCAI / INDUSTRY)';
      var apTitleFs = 7.2;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(apTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text(safe(apTitle), marginL, y);
      y += apTitleFs * 0.45 + 4;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 6;
      var apRef = [
        {
          component: 'Direct Labor (COGS)',
          band: '45.0% - 55.0% of Rev',
          note: 'Wages, FICA, FUTA/SUTA, WC, payroll taxes. Ratios >60% signal underbidding or task creep.'
        },
        {
          component: 'Cleaning Supplies & Liners',
          band: '4.0% - 8.0% of Labor',
          note: 'Chemicals, mop heads, liners, consumables. Dilution control keeps usage under ~6% of labor.'
        },
        {
          component: 'Equipment Depreciation',
          band: '1.5% - 3.0% of Rev',
          note: 'Monthly sinking fund for scrubbers, vacuums, burnishers, and repairs.'
        },
        {
          component: 'Gross Margin (GP)',
          band: '35.0% - 48.0%',
          note: 'Contract gross before indirect overhead, insurance, and admin allocations.'
        },
        {
          component: 'Overhead & Admin (SG&A)',
          band: '12.0% - 18.0% of Rev',
          note: 'Supervision, vehicles, warehouse, software, and general liability.'
        },
        {
          component: 'Net Operating Margin',
          band: '10.0% - 25.0%',
          note: 'Standard janitorial 8-15%; medical / high-spec industrial often 18-25%.'
        }
      ];
      var apFs = 7.1;
      var apLh = apFs * 1.12;
      var apPad = 1.6;
      var apCols = {
        component: Math.floor(contentW * 0.24),
        band: Math.floor(contentW * 0.20),
        note: 0
      };
      apCols.note = contentW - apCols.component - apCols.band;
      var apHeadH = 11.5;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, apHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.5);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var apHy = y + 7.8;
      pdf.text('P&L COST COMPONENT', marginL + 3, apHy);
      pdf.text('BENCHMARK RANGE', marginL + apCols.component + 3, apHy);
      pdf.text('OPERATIONAL RISK & MANAGEMENT STANDARD', marginL + apCols.component + apCols.band + 3, apHy);
      y += apHeadH;
      apRef.forEach(function (row, idx) {
        if (y + apLh * 2 + apPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(apFs);
        var cLines = pdf.splitTextToSize(safe(row.component), apCols.component - 6).slice(0, 2);
        pdf.setFont('helvetica', 'normal');
        var bLines = pdf.splitTextToSize(safe(row.band), apCols.band - 6).slice(0, 2);
        var nLines = pdf.splitTextToSize(safe(row.note), apCols.note - 6).slice(0, 3);
        var rh = Math.max(cLines.length, bLines.length, nLines.length, 1) * apLh + apPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + apPad + apFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(apFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(cLines, marginL + 3, ty, apLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(bLines, marginL + apCols.component + 3, ty, apLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(nLines, marginL + apCols.component + apCols.band + 3, ty, apLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // Job Costing: BSCAI expense allocation benchmarks fill lower dead space
    if (isJobCosting) {
      y += 12;
      var jcTitle = 'COMMERCIAL CUSTODIAL JOB COSTING & EXPENSE ALLOCATION BENCHMARKS (BSCAI)';
      var jcTitleFs = 7.5;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(jcTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      var jcTitleLines = pdf.splitTextToSize(safe(jcTitle), contentW);
      writePdfLines(jcTitleLines, marginL, y, jcTitleFs * 1.15);
      y += Math.max(1, jcTitleLines.length) * jcTitleFs * 1.15 + 3;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 6;
      var jcRef = [
        {
          el: 'Direct Labor',
          band: '50.0% - 60.0% of Bid',
          rule: 'Wages plus mandatory payroll taxes (FICA, FUTA, SUTA, WC). Exceeding 65% erodes overhead recovery.'
        },
        {
          el: 'Supplies & Consumables',
          band: '3.0% - 6.0% of Labor',
          rule: 'Chemicals, trash liners, and microfiber. Heavy liner accounts may budget up to 8% of direct labor.'
        },
        {
          el: 'Equipment Allocation',
          band: '1.5% - 3.0% of Bid',
          rule: 'Depreciation and wear reserve for autoscrubbers, vacuums, and burnishers dedicated to the facility.'
        },
        {
          el: 'Operating Overhead (SG&A)',
          band: '15.0% - 22.0% of Labor',
          rule: 'Field supervision, management vehicles, software, GL insurance, and branch administrative support.'
        },
        {
          el: 'Target Net Margin',
          band: '15.0% - 25.0% of Bid',
          rule: 'True margin formula: Cost / (1 - Margin). Never use naive cost markup.'
        }
      ];
      var jcFs = 7.4;
      var jcLh = jcFs * 1.15;
      var jcPad = 2.0;
      var jcInset = 3;
      var jcCols = {
        el: Math.floor(contentW * 0.22),
        band: Math.floor(contentW * 0.22),
        rule: 0
      };
      jcCols.rule = contentW - jcCols.el - jcCols.band;
      var jcHeadH = 15;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, jcHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.8);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var jcHy = y + 10;
      pdf.text('BID COST ELEMENT', marginL + jcInset, jcHy);
      pdf.text('BENCHMARK RATIO', marginL + jcCols.el + jcInset, jcHy);
      pdf.text('BIDDING GUARDRAIL & RISK RULE', marginL + jcCols.el + jcCols.band + jcInset, jcHy);
      y += jcHeadH;
      jcRef.forEach(function (row, idx) {
        if (y + jcLh * 2 + jcPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(jcFs);
        var elLines = pdf.splitTextToSize(safe(row.el), jcCols.el - jcInset * 2).slice(0, 3);
        pdf.setFont('helvetica', 'normal');
        var bandLines = pdf.splitTextToSize(safe(row.band), jcCols.band - jcInset * 2).slice(0, 3);
        var ruleLines = pdf.splitTextToSize(safe(row.rule), jcCols.rule - jcInset * 2).slice(0, 4);
        var rh = Math.max(elLines.length, bandLines.length, ruleLines.length, 1) * jcLh + jcPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + jcPad + jcFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(jcFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(elLines, marginL + jcInset, ty, jcLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(bandLines, marginL + jcCols.el + jcInset, ty, jcLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(ruleLines, marginL + jcCols.el + jcCols.band + jcInset, ty, jcLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // Equipment TCO: ISSA lifecycle & OpEx benchmarks fill lower dead space
    if (isTcoCalc) {
      y += 12;
      var tcoTitle = 'COMMERCIAL CUSTODIAL EQUIPMENT 5-YEAR LIFECYCLE & EXPENSE STANDARDS';
      var tcoTitleFs = 7.0;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(tcoTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text(safe(tcoTitle), marginL, y);
      y += tcoTitleFs * 0.45 + 4;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 6;
      var tcoRef = [
        {
          cat: 'Walk-Behind Scrubber (20-26")',
          life: '3,500 - 5,000 hrs',
          maint: '8.0% - 12.0% of Capex',
          parts: 'Squeegee blades (quarterly), pad drivers, vacuum motor brushes, AGM pack at 2.5-3 yrs.'
        },
        {
          cat: 'Ride-On Scrubber (28-36")',
          life: '5,000 - 7,500 hrs',
          maint: '10.0% - 14.0% of Capex',
          parts: 'Drive tires, recovery seals, side squeegees, deep-cycle battery pack at Year 3.'
        },
        {
          cat: 'High-Speed Burnisher (20")',
          life: '2,500 - 3,500 hrs',
          maint: '6.0% - 9.0% of Capex',
          parts: 'Drive belts, flex pad assemblies, motor carbon brushes, dust skirts.'
        },
        {
          cat: 'Commercial Upright Vacuum',
          life: '1,200 - 2,000 hrs',
          maint: '15.0% - 20.0% of Capex',
          parts: 'Roller brush strips, drive belts (monthly), HEPA filters, cords, fan impellers.'
        },
        {
          cat: 'Commercial Backpack Vacuum',
          life: '2,000 - 3,000 hrs',
          maint: '8.0% - 12.0% of Capex',
          parts: 'Harness webbing, hose cuffs, floor wand orifices, HEPA exhaust filters.'
        }
      ];
      var tcoFs = 6.8;
      var tcoLh = tcoFs * 1.12;
      var tcoPad = 1.5;
      var tcoCols = {
        cat: Math.floor(contentW * 0.26),
        life: Math.floor(contentW * 0.16),
        maint: Math.floor(contentW * 0.18),
        parts: 0
      };
      tcoCols.parts = contentW - tcoCols.cat - tcoCols.life - tcoCols.maint;
      var tcoHeadH = 11.2;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, tcoHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.2);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var tcoHy = y + 7.6;
      pdf.text('EQUIPMENT CATEGORY', marginL + 3, tcoHy);
      pdf.text('RATED LIFESPAN', marginL + tcoCols.cat + 3, tcoHy);
      pdf.text('ANNUAL MAINT.', marginL + tcoCols.cat + tcoCols.life + 3, tcoHy);
      pdf.text('MAJOR WEAR PARTS & CONSUMABLES', marginL + tcoCols.cat + tcoCols.life + tcoCols.maint + 3, tcoHy);
      y += tcoHeadH;
      tcoRef.forEach(function (row, idx) {
        if (y + tcoLh * 2 + tcoPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(tcoFs);
        var cLines = pdf.splitTextToSize(safe(row.cat), tcoCols.cat - 6).slice(0, 2);
        pdf.setFont('helvetica', 'normal');
        var lLines = pdf.splitTextToSize(safe(row.life), tcoCols.life - 6).slice(0, 2);
        var mLines = pdf.splitTextToSize(safe(row.maint), tcoCols.maint - 6).slice(0, 2);
        var pLines = pdf.splitTextToSize(safe(row.parts), tcoCols.parts - 6).slice(0, 3);
        var rh = Math.max(cLines.length, lLines.length, mLines.length, pLines.length, 1) * tcoLh + tcoPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + tcoPad + tcoFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(tcoFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(cLines, marginL + 3, ty, tcoLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(lLines, marginL + tcoCols.cat + 3, ty, tcoLh);
        writePdfLines(mLines, marginL + tcoCols.cat + tcoCols.life + 3, ty, tcoLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(pLines, marginL + tcoCols.cat + tcoCols.life + tcoCols.maint + 3, ty, tcoLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // Equipment ROI: ISSA mechanization & capital payback benchmarks fill lower dead space
    if (isEquipmentRoi) {
      y += 12;
      var roiTitle = 'ISSA COMMERCIAL CLEANING MECHANIZATION & CAPITAL PAYBACK BENCHMARKS';
      var roiTitleFs = 7.0;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(roiTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text(safe(roiTitle), marginL, y);
      y += roiTitleFs * 0.45 + 4;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 6;
      var roiRef = [
        {
          base: 'Wet Mop to 20" Scrubber',
          speed: '4,000 to 12,500 sqft/hr',
          area: '10,000+ sqft / shift',
          rule: '3.0 - 5.0 Months. Eliminates chemical mop buckets, reduces slip/fall liabilities, and recovers 65% of floor labor.'
        },
        {
          base: '20" to 26" Walk-Behind',
          speed: '12,500 to 20,000 sqft/hr',
          area: '25,000+ sqft / shift',
          rule: '4.0 - 6.5 Months. 30% wider cleaning path reduces double-passing in medium corridors and open school areas.'
        },
        {
          base: 'Walk-Behind to 32" Ride-On',
          speed: '20,000 to 30,000+ sqft/hr',
          area: '45,000+ sqft / shift',
          rule: '5.0 - 8.0 Months. Eliminates operator fatigue in large logistics, manufacturing plants, and airport concourses.'
        },
        {
          base: 'Upright to Backpack Vacuum',
          speed: '2,800 to 8,500 sqft/hr',
          area: '5,000+ sqft carpet',
          rule: '1.5 - 2.5 Months. Over 200% production increase in commercial office workstations and multi-floor complexes.'
        }
      ];
      var roiFs = 6.8;
      var roiLh = roiFs * 1.12;
      var roiPad = 1.5;
      var roiCols = {
        base: Math.floor(contentW * 0.22),
        speed: Math.floor(contentW * 0.18),
        area: Math.floor(contentW * 0.16),
        rule: 0
      };
      roiCols.rule = contentW - roiCols.base - roiCols.speed - roiCols.area;
      var roiHeadH = 11.2;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, roiHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.0);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var roiHy = y + 7.6;
      pdf.text('TRANSITION BASELINE', marginL + 3, roiHy);
      pdf.text('SPEED GAIN (ISSA 612)', marginL + roiCols.base + 3, roiHy);
      pdf.text('AREA THRESHOLD', marginL + roiCols.base + roiCols.speed + 3, roiHy);
      pdf.text('PAYBACK HORIZON & CAPITAL RULE', marginL + roiCols.base + roiCols.speed + roiCols.area + 3, roiHy);
      y += roiHeadH;
      roiRef.forEach(function (row, idx) {
        if (y + roiLh * 2 + roiPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(roiFs);
        var bLines = pdf.splitTextToSize(safe(row.base), roiCols.base - 6).slice(0, 2);
        pdf.setFont('helvetica', 'normal');
        var sLines = pdf.splitTextToSize(safe(row.speed), roiCols.speed - 6).slice(0, 2);
        var aLines = pdf.splitTextToSize(safe(row.area), roiCols.area - 6).slice(0, 2);
        var rLines = pdf.splitTextToSize(safe(row.rule), roiCols.rule - 6).slice(0, 4);
        var rh = Math.max(bLines.length, sLines.length, aLines.length, rLines.length, 1) * roiLh + roiPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + roiPad + roiFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(roiFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(bLines, marginL + 3, ty, roiLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(sLines, marginL + roiCols.base + 3, ty, roiLh);
        writePdfLines(aLines, marginL + roiCols.base + roiCols.speed + 3, ty, roiLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(rLines, marginL + roiCols.base + roiCols.speed + roiCols.area + 3, ty, roiLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // Churn Cost: BSCAI / BOMA retention & lifecycle benchmarks fill lower dead space
    if (isChurnCost) {
      y += 12;
      var churnTitle = 'COMMERCIAL CUSTODIAL ACCOUNT RETENTION & LIFECYCLE BENCHMARKS (BSCAI / BOMA)';
      var churnTitleFs = 7.0;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(churnTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      var churnTitleLines = pdf.splitTextToSize(safe(churnTitle), contentW);
      writePdfLines(churnTitleLines, marginL, y, churnTitleFs * 1.15);
      y += Math.max(1, churnTitleLines.length) * churnTitleFs * 1.15 + 3;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 6;
      var churnRef = [
        {
          metric: 'Annual Account Churn Rate',
          avg: '20.0% - 30.0% / yr',
          top: '< 12.0% / yr',
          rule: 'High churn forces sales teams to run merely to replace lost volume. Churn under 12% drives enterprise valuation.'
        },
        {
          metric: 'Average Account Tenure',
          avg: '3.2 Years',
          top: '> 5.5 Years',
          rule: 'Accounts become highly profitable after Year 1 once crew routes stabilize and startup equipment is amortized.'
        },
        {
          metric: 'Primary Churn Cause: Supervision',
          avg: '55.0% of Cancellations',
          top: '< 25.0%',
          rule: 'Clients cancel not over price, but lack of inspection follow-through and unannounced custodial turnover.'
        },
        {
          metric: 'Primary Churn Cause: Restrooms',
          avg: '30.0% of Cancellations',
          top: '< 10.0%',
          rule: 'Consistently dirty fixtures and empty soap/towel dispensers trigger most executive-level tenant complaints.'
        },
        {
          metric: 'Retention Investment ROI',
          avg: '1 : 3 Payback',
          top: '1 : 6 Payback',
          rule: 'Spending $500 - $750 on proactive floor deep cleans or carpet extraction preserves contracts worth $20k+/yr.'
        }
      ];
      // Keep "$500 - $750" as spaced ASCII — safe() money-corridor protect would rewrite to en-dash
      function churnRulePlain(s) {
        return String(s == null ? '' : s)
          .replace(/[\u2010-\u2015\u2212]/g, ' - ')
          .replace(/\s+-\s+/g, ' - ')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      var chFs = 6.8;
      var chLh = chFs * 1.12;
      var chPad = 1.8;
      var chInset = 3;
      var chCols = {
        metric: Math.floor(contentW * 0.22),
        avg: Math.floor(contentW * 0.16),
        top: Math.floor(contentW * 0.14),
        rule: 0
      };
      chCols.rule = contentW - chCols.metric - chCols.avg - chCols.top;
      var chHeadH = 12;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, chHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(5.8);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var chHy = y + 8;
      pdf.text('RETENTION METRIC', marginL + chInset, chHy);
      pdf.text('INDUSTRY AVG', marginL + chCols.metric + chInset, chHy);
      pdf.text('TOP QUARTILE', marginL + chCols.metric + chCols.avg + chInset, chHy);
      pdf.text('OPERATIONAL SIGNIFICANCE & MANAGEMENT RULE', marginL + chCols.metric + chCols.avg + chCols.top + chInset, chHy);
      y += chHeadH;
      churnRef.forEach(function (row, idx) {
        if (y + chLh * 2 + chPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(chFs);
        var mLines = pdf.splitTextToSize(safe(row.metric), chCols.metric - chInset * 2).slice(0, 3);
        pdf.setFont('helvetica', 'normal');
        var aLines = pdf.splitTextToSize(safe(row.avg), chCols.avg - chInset * 2).slice(0, 3);
        var tLines = pdf.splitTextToSize(safe(row.top), chCols.top - chInset * 2).slice(0, 3);
        var rLines = pdf.splitTextToSize(churnRulePlain(row.rule), chCols.rule - chInset * 2).slice(0, 4);
        var rh = Math.max(mLines.length, aLines.length, tLines.length, rLines.length, 1) * chLh + chPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + chPad + chFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(chFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(mLines, marginL + chInset, ty, chLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(aLines, marginL + chCols.metric + chInset, ty, chLh);
        pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
        writePdfLines(tLines, marginL + chCols.metric + chCols.avg + chInset, ty, chLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(rLines, marginL + chCols.metric + chCols.avg + chCols.top + chInset, ty, chLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // EBITDA Estimator: BSCAI M&A valuation multiples fill lower dead space
    if (isEbitdaEst) {
      y += 12;
      var ebTitle = 'COMMERCIAL CUSTODIAL M&A VALUATION & TRANSACTION MULTIPLES (BSCAI / INDUSTRY)';
      var ebTitleFs = 7.0;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(ebTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      var ebTitleLines = pdf.splitTextToSize(safe(ebTitle), contentW);
      writePdfLines(ebTitleLines, marginL, y, ebTitleFs * 1.15);
      y += Math.max(1, ebTitleLines.length) * ebTitleFs * 1.15 + 3;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 6;
      var ebRef = [
        {
          tier: '< $1,000,000',
          metric: 'SDE (Seller Discretionary)',
          mult: '2.0x - 2.8x SDE',
          rule: 'Owner-operator heavily involved in daily routes/supervision. Low buyer transferability; buyer must replace owner labor.'
        },
        {
          tier: '$1,000,000 - $3,000,000',
          metric: 'Adjusted EBITDA',
          mult: '3.0x - 4.0x EBITDA',
          rule: 'Middle tier: dedicated field supervisors, written SOPs, stable commercial client base with <15% single customer concentration.'
        },
        {
          tier: '$3,000,000 - $10,000,000',
          metric: 'Adjusted EBITDA',
          mult: '4.25x - 5.5x EBITDA',
          rule: 'Autonomous management team, robust recurring multi-year contracts, dedicated sales reps, and gross margins consistently >38%.'
        },
        {
          tier: '> $10,000,000',
          metric: 'Adjusted EBITDA',
          mult: '5.5x - 7.5x+ EBITDA',
          rule: 'Platform acquisition target for private equity. Regional footprint, institutional accounts (education, healthcare), ERP operations.'
        }
      ];
      var ebFs = 6.8;
      var ebLh = ebFs * 1.12;
      var ebPad = 1.5;
      var ebCols = {
        tier: Math.floor(contentW * 0.18),
        metric: Math.floor(contentW * 0.18),
        mult: Math.floor(contentW * 0.16),
        rule: 0
      };
      ebCols.rule = contentW - ebCols.tier - ebCols.metric - ebCols.mult;
      var ebHeadH = 11.2;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, ebHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(5.8);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var ebHy = y + 7.6;
      pdf.text('ANNUAL REVENUE TIER', marginL + 3, ebHy);
      pdf.text('VALUATION METRIC', marginL + ebCols.tier + 3, ebHy);
      pdf.text('MULTIPLE RANGE', marginL + ebCols.tier + ebCols.metric + 3, ebHy);
      pdf.text('EV DRIVERS & BUYER UNDERWRITING', marginL + ebCols.tier + ebCols.metric + ebCols.mult + 3, ebHy);
      y += ebHeadH;
      ebRef.forEach(function (row, idx) {
        if (y + ebLh * 2 + ebPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(ebFs);
        var tLines = pdf.splitTextToSize(safe(row.tier), ebCols.tier - 6).slice(0, 2);
        pdf.setFont('helvetica', 'normal');
        var mLines = pdf.splitTextToSize(safe(row.metric), ebCols.metric - 6).slice(0, 2);
        var xLines = pdf.splitTextToSize(safe(row.mult), ebCols.mult - 6).slice(0, 2);
        var rLines = pdf.splitTextToSize(safe(row.rule), ebCols.rule - 6).slice(0, 4);
        var rh = Math.max(tLines.length, mLines.length, xLines.length, rLines.length, 1) * ebLh + ebPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + ebPad + ebFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(ebFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(tLines, marginL + 3, ty, ebLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(mLines, marginL + ebCols.tier + 3, ty, ebLh);
        writePdfLines(xLines, marginL + ebCols.tier + ebCols.metric + 3, ty, ebLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(rLines, marginL + ebCols.tier + ebCols.metric + ebCols.mult + 3, ty, ebLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // Robot ROI: AMR site feasibility standards fill lower dead space
    if (isRobotRoi) {
      y += 12;
      var robotTitle = 'COMMERCIAL CUSTODIAL AUTONOMOUS MOBILE ROBOT (AMR) SITE FEASIBILITY STANDARDS';
      var robotTitleFs = 7.0;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(robotTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      var robotTitleLines = pdf.splitTextToSize(safe(robotTitle), contentW);
      writePdfLines(robotTitleLines, marginL, y, robotTitleFs * 1.15);
      y += Math.max(1, robotTitleLines.length) * robotTitleFs * 1.15 + 3;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 6;
      var robotRef = [
        {
          dim: 'Floor Layout & Width',
          green: 'Aisles > 6.0 ft wide',
          yellow: 'Aisles 4.5 to 6.0 ft',
          red: 'Narrow pinch-points (<4.0 ft), tight maze cubicles, dead-end storage lanes requiring manual turnaround.'
        },
        {
          dim: 'Thresholds & Ramps',
          green: 'Flush transitions',
          yellow: 'Ramps < 5 deg grade',
          red: 'Expansion joint lips > 0.5 in, severe slopes triggering emergency braking, step transitions between rooms.'
        },
        {
          dim: 'Lighting & Optical Field',
          green: 'Uniform ambient lighting',
          yellow: 'Dim night lighting',
          red: 'Pitch-black night runs blinding optical cameras, high-gloss solar glare washing out 2D/3D LiDAR sensors.'
        },
        {
          dim: 'Obstacle Dynamics',
          green: 'Fixed infrastructure',
          yellow: 'Predictable pallets',
          red: 'Constantly shifting staging boxes, random floor clutter, active forklift traffic crossing designated cleaning paths.'
        },
        {
          dim: 'Minimum Shift Area',
          green: '> 25,000 sqft unobstructed',
          yellow: '15,000 to 25,000 sqft',
          red: '< 12,000 cleanable sqft per shift. Robot amortizes too slowly to offset annual software licensing costs.'
        }
      ];
      var rbFs = 6.6;
      var rbLh = rbFs * 1.12;
      var rbPad = 1.6;
      var rbInset = 3;
      var rbCols = {
        dim: Math.floor(contentW * 0.18),
        green: Math.floor(contentW * 0.18),
        yellow: Math.floor(contentW * 0.18),
        red: 0
      };
      rbCols.red = contentW - rbCols.dim - rbCols.green - rbCols.yellow;
      var rbHeadH = 12;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, rbHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(5.6);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var rbHy = y + 8;
      pdf.text('FEASIBILITY DIMENSION', marginL + rbInset, rbHy);
      pdf.text('GREEN LIGHT', marginL + rbCols.dim + rbInset, rbHy);
      pdf.text('YELLOW LIGHT', marginL + rbCols.dim + rbCols.green + rbInset, rbHy);
      pdf.text('RED LIGHT (DISQUALIFYING)', marginL + rbCols.dim + rbCols.green + rbCols.yellow + rbInset, rbHy);
      y += rbHeadH;
      robotRef.forEach(function (row, idx) {
        if (y + rbLh * 2 + rbPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(rbFs);
        var dLines = pdf.splitTextToSize(safe(row.dim), rbCols.dim - rbInset * 2).slice(0, 3);
        pdf.setFont('helvetica', 'normal');
        var gLines = pdf.splitTextToSize(safe(row.green), rbCols.green - rbInset * 2).slice(0, 3);
        var yLines = pdf.splitTextToSize(safe(row.yellow), rbCols.yellow - rbInset * 2).slice(0, 3);
        var rLines = pdf.splitTextToSize(safe(row.red), rbCols.red - rbInset * 2).slice(0, 4);
        var rh = Math.max(dLines.length, gLines.length, yLines.length, rLines.length, 1) * rbLh + rbPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + rbPad + rbFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(rbFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(dLines, marginL + rbInset, ty, rbLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
        writePdfLines(gLines, marginL + rbCols.dim + rbInset, ty, rbLh);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(yLines, marginL + rbCols.dim + rbCols.green + rbInset, ty, rbLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(rLines, marginL + rbCols.dim + rbCols.green + rbCols.yellow + rbInset, ty, rbLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // Equipment Financing: capital structure trade-off matrix fills lower dead space
    if (isEquipFinanc) {
      y += 8;
      var finTitle = 'COMMERCIAL EQUIPMENT FINANCING & CAPITAL STRUCTURE TRADE-OFF MATRIX';
      var finTitleFs = 8.5;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(finTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      var finTitleLines = pdf.splitTextToSize(safe(finTitle), contentW);
      writePdfLines(finTitleLines, marginL, y, finTitleFs * 1.15);
      y += Math.max(1, finTitleLines.length) * finTitleFs * 1.15 + 3;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 6;
      var finRef = [
        {
          struct: 'Commercial Bank Loan / Equipment Note',
          bal: 'Asset & liability booked on balance sheet; affects debt-to-equity ratios.',
          tax: 'Depreciate machine via MACRS; deduct annual loan interest expense.',
          own: 'Contractor owns 100% of equipment equity upon final payment; captures 10%-15% Year-5 salvage/trade-in value.'
        },
        {
          struct: '$1.00 Buyout Capital Lease',
          bal: 'Treated similarly to a financed loan; capital asset on balance sheet.',
          tax: 'Eligible for IRS Section 179 full purchase price write-off in Year 1.',
          own: 'Title automatically transfers to contractor for $1.00 at term conclusion; retains full machine residual.'
        },
        {
          struct: 'Fair Market Value (FMV) Operating Lease',
          bal: 'Off-balance-sheet financing; preserves bank credit lines and working capital.',
          tax: '100% of monthly lease payment is fully tax-deductible as an operating expense (OpEx).',
          own: 'Contractor does NOT own equipment at term end. Must return machine, renew lease, or buy out at current fair market value.'
        }
      ];
      // Larger body type (~Day Porter); fixed col widths keep left edges aligned across rows
      var fnFs = 7.8;
      var fnLh = fnFs * 1.18;
      var fnPad = 2.2;
      var fnInset = 3;
      var fnCols = {
        struct: Math.floor(contentW * 0.20),
        bal: Math.floor(contentW * 0.24),
        tax: Math.floor(contentW * 0.24),
        own: 0
      };
      fnCols.own = contentW - fnCols.struct - fnCols.bal - fnCols.tax;
      var fnHeadH = 16;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, fnHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(7.0);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var fnHy = y + 10.5;
      pdf.text('FINANCING STRUCTURE', marginL + fnInset, fnHy);
      pdf.text('BALANCE SHEET IMPACT', marginL + fnCols.struct + fnInset, fnHy);
      pdf.text('TAX & DEPRECIATION RULE', marginL + fnCols.struct + fnCols.bal + fnInset, fnHy);
      pdf.text('OWNERSHIP, EQUITY & END-OF-TERM', marginL + fnCols.struct + fnCols.bal + fnCols.tax + fnInset, fnHy);
      y += fnHeadH;
      finRef.forEach(function (row, idx) {
        if (y + fnLh * 2 + fnPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(fnFs);
        var sLines = pdf.splitTextToSize(safe(row.struct), fnCols.struct - fnInset * 2).slice(0, 5);
        pdf.setFont('helvetica', 'normal');
        var bLines = pdf.splitTextToSize(safe(row.bal), fnCols.bal - fnInset * 2).slice(0, 6);
        var tLines = pdf.splitTextToSize(safe(row.tax), fnCols.tax - fnInset * 2).slice(0, 6);
        var oLines = pdf.splitTextToSize(safe(row.own), fnCols.own - fnInset * 2).slice(0, 6);
        var rh = Math.max(sLines.length, bLines.length, tLines.length, oLines.length, 1) * fnLh + fnPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + fnPad + fnFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(fnFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(sLines, marginL + fnInset, ty, fnLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(bLines, marginL + fnCols.struct + fnInset, ty, fnLh);
        writePdfLines(tLines, marginL + fnCols.struct + fnCols.bal + fnInset, ty, fnLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(oLines, marginL + fnCols.struct + fnCols.bal + fnCols.tax + fnInset, ty, fnLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // PFAS State Lookup: custodial PFAS risk / lead-state matrix fills lower dead space
    if (isPfasLookup) {
      drawPdfSectionTitle('COMMERCIAL CUSTODIAL PFAS RISK PROFILES & LEAD STATE ENACTMENTS', 10);
      var pfasRef = [
        {
          cat: 'Floor Finishes & Sealers',
          fn: 'Fluorosurfactants used as wetting and leveling agents to prevent ridges.',
          reg: 'CO (2026 / 2028), CA (AB 1817), MN (Amara\'s Law)',
          act: 'Specify Green Seal GS-40 certified acrylic polymers using hydrocarbon surfactants.'
        },
        {
          cat: 'Carpet Protectors & Spotters',
          fn: 'Perfluoroalkyl chains providing oleophobic and hydrophobic stain resistance.',
          reg: 'Enacted in 12+ states (CO, NY, WA, ME)',
          act: 'Transition to silicon-based, bio-based, or non-fluorinated soil repellents.'
        },
        {
          cat: 'Metal Polishes & Cleaners',
          fn: 'Surface-tension reduction for uniform shine and water beading.',
          reg: 'Phase 1 bans in MN, ME, and CO',
          act: 'Replace with mechanical microfiber polishing and mineral-oil-based formulations.'
        },
        {
          cat: 'Heavy-Duty Degreasers',
          fn: 'Fluorinated surfactants allowing penetration of industrial carbon greases.',
          reg: 'State general cleaning restrictions',
          act: 'Formulations utilizing citrus terpenes, d-limonene, or micro-emulsion surfactants.'
        }
      ];
      // Readable body (~Day Porter); fixed col widths keep left edges aligned
      var pfFs = 8.0;
      var pfLh = pfFs * 1.18;
      var pfPad = 2.2;
      var pfInset = 3;
      var pfCols = {
        cat: Math.floor(contentW * 0.20),
        fn: Math.floor(contentW * 0.26),
        reg: Math.floor(contentW * 0.24),
        act: 0
      };
      pfCols.act = contentW - pfCols.cat - pfCols.fn - pfCols.reg;
      var pfHeadH = 16;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, pfHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(7.2);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var pfHy = y + 10.5;
      pdf.text('CUSTODIAL CHEMICAL', marginL + pfInset, pfHy);
      pdf.text('PFAS FUNCTIONALITY', marginL + pfCols.cat + pfInset, pfHy);
      pdf.text('PRIMARY REGULATORY FOCUS', marginL + pfCols.cat + pfCols.fn + pfInset, pfHy);
      pdf.text('SAFER ALT / PROCUREMENT', marginL + pfCols.cat + pfCols.fn + pfCols.reg + pfInset, pfHy);
      y += pfHeadH;
      // Keep year ranges + statute parens — never run cleanPdfPlain "(3/5)→3 of 5" on this column
      function pfasCellPlain(s) {
        return String(s == null ? '' : s)
          .replace(/[\u2010-\u2015\u2212]/g, '-')
          .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');
      }
      pfasRef.forEach(function (row, idx) {
        if (y + pfLh * 2 + pfPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(pfFs);
        var cLines = pdf.splitTextToSize(pfasCellPlain(row.cat), pfCols.cat - pfInset * 2).slice(0, 4);
        pdf.setFont('helvetica', 'normal');
        var fLines = pdf.splitTextToSize(pfasCellPlain(row.fn), pfCols.fn - pfInset * 2).slice(0, 5);
        var rLines = pdf.splitTextToSize(pfasCellPlain(row.reg), pfCols.reg - pfInset * 2).slice(0, 5);
        var aLines = pdf.splitTextToSize(pfasCellPlain(row.act), pfCols.act - pfInset * 2).slice(0, 5);
        var rh = Math.max(cLines.length, fLines.length, rLines.length, aLines.length, 1) * pfLh + pfPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + pfPad + pfFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(pfFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(cLines, marginL + pfInset, ty, pfLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(fLines, marginL + pfCols.cat + pfInset, ty, pfLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(rLines, marginL + pfCols.cat + pfCols.fn + pfInset, ty, pfLh);
        writePdfLines(aLines, marginL + pfCols.cat + pfCols.fn + pfCols.reg + pfInset, ty, pfLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 4;
    }

    // Franchise Comparison: franchise vs independent trade-off matrix fills lower dead space
    if (isFranchiseCompare) {
      drawPdfSectionTitle('COMMERCIAL CUSTODIAL FRANCHISE VS INDEPENDENT OPERATOR TRADE-OFF MATRIX', 10);
      // ASCII-only money ranges ("to" / spaced hyphen) — never en-dash corridors that render as "?"
      var franRef = [
        {
          dim: 'Upfront Capital & Fees',
          fran: '$3,000 to $15,000 initial franchise fee plus mandatory starter equipment packages with high vendor markups.',
          ind: '$0 licensing fees. 100% of startup capital is deployed directly into commercial equipment and working capital.'
        },
        {
          dim: 'Ongoing Royalties & Drag',
          fran: 'Permanent 6% to 12% royalty + 1% to 3% national advertising fee off top-line gross revenue, regardless of profitability.',
          ind: '0% royalty. Retain 100% of gross contract billings to fund field supervisor wages or net profit.'
        },
        {
          dim: 'Client Acquisition & Churn',
          fran: 'Franchisor provides initial customer accounts, but charges replacement/finder fees and non-refundable assignment penalties if an account cancels.',
          ind: 'Owner generates contracts organically or via direct outreach. Client relationship is owned 100% with no replacement penalties.'
        },
        {
          dim: 'Billing, Factoring & Cash Flow',
          fran: 'Mandatory centralized billing through franchisor. Regional master franchisors frequently charge 3% to 5% factoring/admin fees to disperse receivables.',
          ind: 'Direct contractor-to-client invoicing (QuickBooks / ERP). Receivables deposit directly to operating checking accounts.'
        },
        {
          dim: 'Enterprise Value & Exit',
          fran: 'Severely restricted transferability. Franchisor must approve buyer, collects transfer fees, and can repossess territory.',
          ind: '100% unencumbered enterprise equity. Business can be taken to market and sold at 3.0x to 4.5x EBITDA multiples.'
        }
      ];
      // Larger body type (~Day Porter ~7.8pt); fixed col widths keep left edges aligned across rows
      var frFs = 7.8;
      var frLh = frFs * 1.18;
      var frPad = 2.2;
      var frInset = 3;
      var frCols = {
        dim: Math.floor(contentW * 0.20),
        fran: Math.floor(contentW * 0.40),
        ind: 0
      };
      frCols.ind = contentW - frCols.dim - frCols.fran;
      // Three distinct header cells — wrap within col width (never concatenate DIMENSION+FRANCHISE)
      var frHeadFs = 6.6;
      var frHeadLh = frHeadFs * 1.15;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(frHeadFs);
      var frHead0 = pdf.splitTextToSize('Operational Dimension', frCols.dim - frInset * 2).slice(0, 3);
      var frHead1 = pdf.splitTextToSize('Franchise Model (Janitorial System)', frCols.fran - frInset * 2).slice(0, 3);
      var frHead2 = pdf.splitTextToSize('Independent Commercial Contractor', frCols.ind - frInset * 2).slice(0, 3);
      var frHeadH = Math.max(frHead0.length, frHead1.length, frHead2.length, 1) * frHeadLh + 8;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, frHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(frHeadFs);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var frHy = y + 5 + frHeadFs * 0.72;
      writePdfLines(frHead0, marginL + frInset, frHy, frHeadLh);
      writePdfLines(frHead1, marginL + frCols.dim + frInset, frHy, frHeadLh);
      writePdfLines(frHead2, marginL + frCols.dim + frCols.fran + frInset, frHy, frHeadLh);
      y += frHeadH;
      franRef.forEach(function (row, idx) {
        if (y + frLh * 2 + frPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(frFs);
        var dLines = pdf.splitTextToSize(safe(row.dim), frCols.dim - frInset * 2).slice(0, 4);
        pdf.setFont('helvetica', 'normal');
        var fLines = pdf.splitTextToSize(safe(row.fran), frCols.fran - frInset * 2).slice(0, 6);
        var iLines = pdf.splitTextToSize(safe(row.ind), frCols.ind - frInset * 2).slice(0, 6);
        var rh = Math.max(dLines.length, fLines.length, iLines.length, 1) * frLh + frPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + frPad + frFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(frFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(dLines, marginL + frInset, ty, frLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(fLines, marginL + frCols.dim + frInset, ty, frLh);
        pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
        writePdfLines(iLines, marginL + frCols.dim + frCols.fran + frInset, ty, frLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // Pad Selector: compact pad color / abrasiveness closet reference (fills lower page, stays 1-page)
    if (isPadSelector) {
      drawPdfSectionTitle('PAD COLOR & ABRASIVENESS REFERENCE', 6);
      var padRef = [
        { color: 'White / Tan', use: 'Polish, final buff, rated burnish', agg: '1 of 5' },
        { color: 'Red', use: 'Daily clean / light spray scrub', agg: '2 of 5' },
        { color: 'Blue', use: 'Top-scrubbing / heavy soil', agg: '3 of 5' },
        { color: 'Green', use: 'Heavy scrub / interim cut', agg: '4 of 5' },
        { color: 'Brown / Black', use: 'Strip / deep acrylic cut', agg: '5 of 5' },
        { color: 'Maroon SPP', use: 'Chemical-free wet surface prep', agg: '4 of 5' },
        { color: 'Melamine', use: 'Fine soil (never on calcite stone)', agg: 'Soft foam' },
        { color: 'Diamond / Brush', use: 'Stone DIP hone; grit / carpet interim', agg: 'Specialty' }
      ];
      // +6% vs prior 6.6 / 1.1 — still fits page 1 with spare room
      var prFs = 7;
      var prLh = prFs * 1.166;
      var prPad = 1.6;
      var prCols = {
        color: Math.floor(contentW * 0.22),
        use: Math.floor(contentW * 0.56),
        agg: 0
      };
      prCols.agg = contentW - prCols.color - prCols.use;
      var prHeadH = 10.6;
      ensureSpace(prHeadH + padRef.length * (prLh + prPad * 2) + 6);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, prHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.4);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var prHy = y + 7.4;
      pdf.text('COLOR / TYPE', marginL + 4, prHy);
      pdf.text('TYPICAL USE', marginL + prCols.color + 4, prHy);
      pdf.text('ABRASIVENESS', marginL + prCols.color + prCols.use + 4, prHy);
      y += prHeadH;
      padRef.forEach(function (row, idx) {
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(prFs);
        var cLines = pdf.splitTextToSize(safe(row.color), prCols.color - 8).slice(0, 1);
        pdf.setFont('helvetica', 'normal');
        var uLines = pdf.splitTextToSize(safe(row.use), prCols.use - 8).slice(0, 1);
        var aLines = pdf.splitTextToSize(safe(row.agg), prCols.agg - 8).slice(0, 1);
        var rh = Math.max(cLines.length, uLines.length, aLines.length, 1) * prLh + prPad * 2;
        ensureSpace(rh + 1);
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + prPad + prFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(prFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(cLines, marginL + 4, ty, prLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(uLines, marginL + prCols.color + 4, ty, prLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(aLines, marginL + prCols.color + prCols.use + 4, ty, prLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 3;
    }

    // PPE Selector: OSHA glove & eye reference fills lower dead space (closet poster)
    if (isPpeSelector) {
      // Wrap-aware title — long single-line titles overlap the column header row
      y += 5;
      var oshaTitle = 'OSHA CHEMICAL GLOVE & EYE PROTECTION REFERENCE (29 CFR 1910.132 / 133 / 138)';
      var oshaTitleFs = 7.2;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(oshaTitleFs);
      var oshaTitleLines = pdf.splitTextToSize(safe(oshaTitle), contentW);
      var oshaTitleLh = oshaTitleFs * 1.15;
      ensureSpace(oshaTitleLines.length * oshaTitleLh + 20);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      writePdfLines(oshaTitleLines, marginL, y, oshaTitleLh);
      y += Math.max(1, oshaTitleLines.length) * oshaTitleLh + 2;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 6;
      var ppeRef = [
        {
          cat: 'Disposable Nitrile',
          spec: '4-6 mil thickness',
          chem: 'Quats, neutral cleaners, RTU glass cleaner',
          lim: 'Splash only; not for immersion, acid descalers, or solvent strippers.'
        },
        {
          cat: 'Heavy Nitrile / Neoprene',
          spec: '11-15 mil thickness',
          chem: 'Alkaline strippers, acid descalers, heavy degreasers',
          lim: 'Mandatory for concentrate pouring; inspect for pinholes before use.'
        },
        {
          cat: 'Butyl Rubber',
          spec: '15-20 mil thickness',
          chem: 'Peracetic acid (PAA), ketones, aggressive solvents',
          lim: 'Highest chemical permeation resistance; poor mechanical dexterity.'
        },
        {
          cat: 'Safety Glasses',
          spec: 'ANSI Z87.1 (Side Shields)',
          chem: 'RTU mopping, auto-scrubber, low splash',
          lim: 'Zero liquid seal; prohibited during concentrate mixing.'
        },
        {
          cat: 'Chemical Splash Goggles',
          spec: 'ANSI Z87.1 D3 (Indirect Vent)',
          chem: 'Concentrates, acid washes, stripper splashes',
          lim: 'Full orbital liquid seal; pair with face shield if >1 gal poured.'
        }
      ];
      // +16% vs prior 6.2 body / 5.8 header
      var ppeFs = 7.2;
      var ppeHeadFs = 6.7;
      var ppeLh = ppeFs * 1.08;
      var ppePad = 1.2;
      var ppeCols = {
        cat: Math.floor(contentW * 0.20),
        spec: Math.floor(contentW * 0.18),
        chem: Math.floor(contentW * 0.28),
        lim: 0
      };
      ppeCols.lim = contentW - ppeCols.cat - ppeCols.spec - ppeCols.chem;
      var ppeHeadH = 11;
      var ppeNeed = ppeHeadH + ppeRef.length * (ppeLh * 2 + ppePad * 2) + 2;
      if (y + ppeNeed > bottom) {
        ppePad = 0.9;
        ppeLh = ppeFs * 1.05;
      }
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, ppeHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(ppeHeadFs);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var ppeHy = y + 7.4;
      pdf.text('PPE CATEGORY', marginL + 3, ppeHy);
      pdf.text('SPEC RATING', marginL + ppeCols.cat + 3, ppeHy);
      pdf.text('TARGET CHEM CLASSES', marginL + ppeCols.cat + ppeCols.spec + 3, ppeHy);
      pdf.text('OPERATIONAL LIMITATIONS', marginL + ppeCols.cat + ppeCols.spec + ppeCols.chem + 3, ppeHy);
      y += ppeHeadH;
      ppeRef.forEach(function (row, idx) {
        if (y + ppeLh * 2 + ppePad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(ppeFs);
        var catLines = pdf.splitTextToSize(safe(row.cat), ppeCols.cat - 6).slice(0, 2);
        pdf.setFont('helvetica', 'normal');
        var specLines = pdf.splitTextToSize(safe(row.spec), ppeCols.spec - 6).slice(0, 2);
        var chemLines = pdf.splitTextToSize(safe(row.chem), ppeCols.chem - 6).slice(0, 2);
        var limLines = pdf.splitTextToSize(safe(row.lim), ppeCols.lim - 6).slice(0, 2);
        var rh = Math.max(catLines.length, specLines.length, chemLines.length, limLines.length, 1) * ppeLh + ppePad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + ppePad + ppeFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(ppeFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(catLines, marginL + 3, ty, ppeLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(specLines, marginL + ppeCols.cat + 3, ty, ppeLh);
        writePdfLines(chemLines, marginL + ppeCols.cat + ppeCols.spec + 3, ty, ppeLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(limLines, marginL + ppeCols.cat + ppeCols.spec + ppeCols.chem + 3, ty, ppeLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 2;
    }

    // Restroom Time: ISSA 612 fixture benchmarks fill lower dead space
    if (isRestroomTime) {
      y += 14; // clear air under YOUR INPUTS (was cramped at +5)
      var rrTitle = 'ISSA 612 COMMERCIAL RESTROOM LABOR BENCHMARKS';
      var rrTitleFs = 7.5;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(rrTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text(safe(rrTitle), marginL, y);
      y += rrTitleFs * 0.45 + 4;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 7;
      var rrRef = [
        {
          fix: 'Toilet (Water Closet)',
          time: '3.00 min / fixture',
          scope: 'Inside bowl swab, sanitize seat/hinges/rim, wipe exterior porcelain & flushometer',
          prod: '20 fixtures / hr'
        },
        {
          fix: 'Urinal',
          time: '1.50 min / fixture',
          scope: 'Clean drain screen, disinfect interior sides/rim, polish chrome valve, check screen',
          prod: '40 fixtures / hr'
        },
        {
          fix: 'Wash Basin / Sink',
          time: '2.00 min / basin',
          scope: 'Scour basin, wipe faucet fixture, disinfect backsplash, polish brightwork',
          prod: '30 fixtures / hr'
        },
        {
          fix: 'Mirror & Dispensers',
          time: '1.50 min / set',
          scope: 'Streak-free glass wipe, replenish soap & paper cartridges, wipe dispenser shell',
          prod: '40 stations / hr'
        },
        {
          fix: 'Trash Collection',
          time: '2.50 min / station',
          scope: 'Empty sanitary & central bins, wipe exterior container, install fresh liner',
          prod: '24 bins / hr'
        },
        {
          fix: 'Mopping (Tile Floor)',
          time: '1.50 min / 100 sq ft',
          scope: 'Dust mop debris, damp mop with neutral/quat disinfectant, allow air dry',
          prod: '4,000 sq ft / hr'
        }
      ];
      // +20% vs prior 6.6 / 5.9 body & header
      var rrFs = 7.9;
      var rrLh = rrFs * 1.1;
      var rrPad = 1.5;
      var rrCols = {
        fix: Math.floor(contentW * 0.20),
        time: Math.floor(contentW * 0.16),
        scope: Math.floor(contentW * 0.44),
        prod: 0
      };
      rrCols.prod = contentW - rrCols.fix - rrCols.time - rrCols.scope;
      var rrHeadH = 12.2;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, rrHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(7.1);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var rrHy = y + 8.2;
      pdf.text('FIXTURE / TASK', marginL + 3, rrHy);
      pdf.text('ISSA STD TIME', marginL + rrCols.fix + 3, rrHy);
      pdf.text('SCOPE OF WORK INCLUDED', marginL + rrCols.fix + rrCols.time + 3, rrHy);
      pdf.text('PRODUCTION', marginL + rrCols.fix + rrCols.time + rrCols.scope + 3, rrHy);
      y += rrHeadH;
      rrRef.forEach(function (row, idx) {
        if (y + rrLh * 2 + rrPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(rrFs);
        var fLines = pdf.splitTextToSize(safe(row.fix), rrCols.fix - 6).slice(0, 2);
        pdf.setFont('helvetica', 'normal');
        var tLines = pdf.splitTextToSize(safe(row.time), rrCols.time - 6).slice(0, 2);
        var sLines = pdf.splitTextToSize(safe(row.scope), rrCols.scope - 6).slice(0, 2);
        var pLines = pdf.splitTextToSize(safe(row.prod), rrCols.prod - 6).slice(0, 2);
        var rh = Math.max(fLines.length, tLines.length, sLines.length, pLines.length, 1) * rrLh + rrPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + rrPad + rrFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(rrFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(fLines, marginL + 3, ty, rrLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(tLines, marginL + rrCols.fix + 3, ty, rrLh);
        writePdfLines(sLines, marginL + rrCols.fix + rrCols.time + 3, ty, rrLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(pLines, marginL + rrCols.fix + rrCols.time + rrCols.scope + 3, ty, rrLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6; // breathing room before Methodology
    }

    // Production Rate Lookup: ISSA 612 core commercial benchmarks fill lower dead space
    if (isIssa447Lookup) {
      y += 14;
      var issaTitle = 'ISSA 612 CORE COMMERCIAL PRODUCTION BENCHMARKS (APPA LEVEL 2)';
      var issaTitleFs = 7.5;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(issaTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text(safe(issaTitle), marginL, y);
      y += issaTitleFs * 0.45 + 4;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 7;
      var issaRef = [
        { task: 'Dust mop 24-inch', rate: '10,000 sqft/hr', band: '9,000-12,000', note: 'Hard floor, open pass' },
        { task: 'Dust mop 36-inch', rate: '18,000 sqft/hr', band: '16,000-20,000', note: 'Large open hard floor' },
        { task: 'Upright vacuum', rate: '3,000 sqft/hr', band: '2,800-3,200', note: 'Open carpet corridors' },
        { task: 'Backpack vacuum', rate: '7,500 sqft/hr', band: '7,000-8,500', note: 'Detail / furniture lanes' },
        { task: 'Autoscrubber 20-inch', rate: '13,000 sqft/hr', band: '12,000-15,000', note: 'Corridors / light furniture' },
        { task: 'Autoscrubber 26-inch', rate: '20,000 sqft/hr', band: '18,000-22,000', note: 'Large open hard floor' },
        { task: 'High-speed burnish', rate: '9,000 sqft/hr', band: '8,000-11,000', note: 'Finished hard floor' }
      ];
      var issaFs = 7.6;
      var issaLh = issaFs * 1.1;
      var issaPad = 1.5;
      var issaCols = {
        task: Math.floor(contentW * 0.24),
        rate: Math.floor(contentW * 0.20),
        band: Math.floor(contentW * 0.22),
        note: 0
      };
      issaCols.note = contentW - issaCols.task - issaCols.rate - issaCols.band;
      var issaHeadH = 12.2;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, issaHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.9);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var issaHy = y + 8.2;
      pdf.text('TASK', marginL + 3, issaHy);
      pdf.text('APPA L2 GUIDE', marginL + issaCols.task + 3, issaHy);
      pdf.text('ISSA 612 BAND', marginL + issaCols.task + issaCols.rate + 3, issaHy);
      pdf.text('TYPICAL USE', marginL + issaCols.task + issaCols.rate + issaCols.band + 3, issaHy);
      y += issaHeadH;
      issaRef.forEach(function (row, idx) {
        if (y + issaLh * 2 + issaPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(issaFs);
        var taskLines = pdf.splitTextToSize(safe(row.task), issaCols.task - 6).slice(0, 2);
        pdf.setFont('helvetica', 'normal');
        var rateLines = pdf.splitTextToSize(safe(row.rate), issaCols.rate - 6).slice(0, 2);
        var bandLines = pdf.splitTextToSize(safe(row.band), issaCols.band - 6).slice(0, 2);
        var noteLines = pdf.splitTextToSize(safe(row.note), issaCols.note - 6).slice(0, 2);
        var rh = Math.max(taskLines.length, rateLines.length, bandLines.length, noteLines.length, 1) * issaLh + issaPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + issaPad + issaFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(issaFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(taskLines, marginL + 3, ty, issaLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(rateLines, marginL + issaCols.task + 3, ty, issaLh);
        writePdfLines(bandLines, marginL + issaCols.task + issaCols.rate + 3, ty, issaLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(noteLines, marginL + issaCols.task + issaCols.rate + issaCols.band + 3, ty, issaLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // APPA Inspection: 5 Levels of Cleanliness reference fills lower dead space
    if (isAppaInspection) {
      y += 14;
      var appaTitle = 'APPA 5 LEVELS OF CLEANLINESS REFERENCE STANDARDS';
      var appaTitleFs = 7.5;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(appaTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text(safe(appaTitle), marginL, y);
      y += appaTitleFs * 0.45 + 4;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 7;
      var appaRef = [
        {
          lvl: 'Level 1',
          name: 'Orderly Spotlessness',
          criteria: 'Floors bright and clean; vertical surfaces spot-free; trash empty; zero dust accumulation.',
          impact: 'Showcase / 100% FTE'
        },
        {
          lvl: 'Level 2',
          name: 'Ordinary Tidiness',
          criteria: 'Floors and base moldings clean; light soil in corners; brightwork clean; waste cans clean.',
          impact: 'Class A Standard'
        },
        {
          lvl: 'Level 3',
          name: 'Casual Inattention',
          criteria: 'Static dust on surfaces; scuffs and soil lanes visible; dull floor finish; trash full.',
          impact: 'Budget / Deficient'
        },
        {
          lvl: 'Level 4',
          name: 'Moderate Dinginess',
          criteria: 'Heavy soil in corners; dirty baseboards; trash overflowing; restroom odor noticeable.',
          impact: 'Severe Neglect'
        },
        {
          lvl: 'Level 5',
          name: 'Unkempt Neglect',
          criteria: 'Pervasive dirt and debris; finish worn to substrate; health and safety hazards present.',
          impact: 'Unacceptable'
        }
      ];
      var appaFs = 7.4;
      var appaLh = appaFs * 1.1;
      var appaPad = 1.5;
      var appaCols = {
        lvl: Math.floor(contentW * 0.12),
        name: Math.floor(contentW * 0.20),
        criteria: Math.floor(contentW * 0.48),
        impact: 0
      };
      appaCols.impact = contentW - appaCols.lvl - appaCols.name - appaCols.criteria;
      var appaHeadH = 12.2;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, appaHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.8);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var appaHy = y + 8.2;
      pdf.text('LEVEL', marginL + 3, appaHy);
      pdf.text('CLASSIFICATION', marginL + appaCols.lvl + 3, appaHy);
      pdf.text('VISUAL ASSESSMENT & AUDIT CRITERIA', marginL + appaCols.lvl + appaCols.name + 3, appaHy);
      pdf.text('CUSTODIAL IMPACT', marginL + appaCols.lvl + appaCols.name + appaCols.criteria + 3, appaHy);
      y += appaHeadH;
      appaRef.forEach(function (row, idx) {
        if (y + appaLh * 2 + appaPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(appaFs);
        var lvlLines = pdf.splitTextToSize(safe(row.lvl), appaCols.lvl - 6).slice(0, 2);
        pdf.setFont('helvetica', 'normal');
        var nameLines = pdf.splitTextToSize(safe(row.name), appaCols.name - 6).slice(0, 2);
        var critLines = pdf.splitTextToSize(safe(row.criteria), appaCols.criteria - 6).slice(0, 3);
        var impLines = pdf.splitTextToSize(safe(row.impact), appaCols.impact - 6).slice(0, 2);
        var rh = Math.max(lvlLines.length, nameLines.length, critLines.length, impLines.length, 1) * appaLh + appaPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + appaPad + appaFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(appaFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(lvlLines, marginL + 3, ty, appaLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(nameLines, marginL + appaCols.lvl + 3, ty, appaLh);
        writePdfLines(critLines, marginL + appaCols.lvl + appaCols.name + 3, ty, appaLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(impLines, marginL + appaCols.lvl + appaCols.name + appaCols.criteria + 3, ty, appaLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // Client Onboarding: commercial account mobilization phase-gate placard fills lower dead space
    if (isClientOnboarding) {
      y += 14;
      var obTitle = 'COMMERCIAL ACCOUNT MOBILIZATION PHASE-GATE STANDARDS';
      var obTitleFs = 7.5;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(obTitleFs);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text(safe(obTitle), marginL, y);
      y += obTitleFs * 0.45 + 4;
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 7;
      var obRef = [
        {
          when: 'T - 14 Days',
          gate: 'Compliance & Scope',
          scope: 'Execute master service agreement; issue COI naming property manager as additional insured; verify background checks.'
        },
        {
          when: 'T - 7 Days',
          gate: 'Logistics & Security',
          scope: 'Conduct physical site key/badge audit; test security alarm codes; map janitorial closet electrical/water hookups; finalize trash/dumpster logistics.'
        },
        {
          when: 'T - 3 Days',
          gate: 'Chemicals & Equipment',
          scope: 'Deliver chemical dilution dispensers; install SDS binder in custodial closet; stage floor machines and microfiber systems; label secondary spray bottles.'
        },
        {
          when: 'Day 1 Go-Live',
          gate: 'Operational Handoff',
          scope: 'Supervisor-led first shift orientation; walk physical room routes with custodial team; verify alarm arming and exterior door lockup protocols.'
        },
        {
          when: 'Day 7',
          gate: 'Quality Baseline Audit',
          scope: 'Conduct joint APPA Level 2 inspection with facility director; adjust route timing and fixture allocations; close out punch-list items.'
        },
        {
          when: 'Day 30',
          gate: 'Executive Account Review',
          scope: 'Present 30-day KPI scorecard; review supply burn rates; formalize quarterly periodic floor/carpet care schedule.'
        }
      ];
      var obFs = 7.2;
      var obLh = obFs * 1.1;
      var obPad = 1.5;
      var obCols = {
        when: Math.floor(contentW * 0.16),
        gate: Math.floor(contentW * 0.22),
        scope: 0
      };
      obCols.scope = contentW - obCols.when - obCols.gate;
      var obHeadH = 12.2;
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, obHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.8);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var obHy = y + 8.2;
      pdf.text('TIMELINE', marginL + 3, obHy);
      pdf.text('MILESTONE GATE', marginL + obCols.when + 3, obHy);
      pdf.text('OPERATIONAL SCOPE & MANDATORY DELIVERABLES', marginL + obCols.when + obCols.gate + 3, obHy);
      y += obHeadH;
      obRef.forEach(function (row, idx) {
        if (y + obLh * 2 + obPad * 2 > bottom) return;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(obFs);
        var whenLines = pdf.splitTextToSize(safe(row.when), obCols.when - 6).slice(0, 2);
        pdf.setFont('helvetica', 'normal');
        var gateLines = pdf.splitTextToSize(safe(row.gate), obCols.gate - 6).slice(0, 2);
        var scopeLines = pdf.splitTextToSize(safe(row.scope), obCols.scope - 6).slice(0, 3);
        var rh = Math.max(whenLines.length, gateLines.length, scopeLines.length, 1) * obLh + obPad * 2;
        if (y + rh > bottom) return;
        if (idx % 2 === 0) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, y, contentW, rh, 'F');
        }
        var ty = y + obPad + obFs * 0.72;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(obFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(whenLines, marginL + 3, ty, obLh);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        writePdfLines(gateLines, marginL + obCols.when + 3, ty, obLh);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(scopeLines, marginL + obCols.when + obCols.gate + 3, ty, obLh);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.3);
        pdf.line(marginL, y + rh - 0.5, pageW - marginR, y + rh - 0.5);
        y += rh;
      });
      y += 6;
    }

    // Chemical Compatibility: fill page with HazCom emergency + PPE + OSHA brief (1-page QRS)
    if (isChemCompat && model.hazcomBrief) {
      var hb = model.hazcomBrief;
      var hbFs = 7.5;
      var hbLh = hbFs * 1.2;
      var hbPad = 6;

      drawPdfSectionTitle('EMERGENCY RESPONSE', 8);
      var emBody = String(hb.emergency || '').replace(/\s+/g, ' ').trim();
      if (emBody) {
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(hbFs);
        var emLines = pdf.splitTextToSize(safe(emBody), contentW - hbPad * 2);
        var emH = hbPad * 2 + Math.max(1, emLines.length) * hbLh;
        ensureSpace(emH + 2);
        pdf.setFillColor(255, 241, 242);
        pdf.setDrawColor(253, 164, 175);
        pdf.setLineWidth(1);
        pdf.roundedRect(marginL, y, contentW, emH, 3, 3, 'FD');
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(emLines, marginL + hbPad, y + hbPad + hbFs * 0.75, hbLh);
        y += emH + 4;
      }

      // PPE matrix — Eyes/Hands/Skin/Feet only; draw as one unbreakable block
      var ppeRows = (hb.ppe || []).filter(function (row) {
        return /^(eyes|hands|skin|feet)/i.test(String(row.part || ''));
      }).slice(0, 4);
      if (ppeRows.length) {
        drawPdfSectionTitle('REQUIRED PPE MATRIX', 8);
        var ppeFs = 7.5;
        var ppeLh = ppeFs * 1.2;
        var ppePad = 5;
        var ppeValW = Math.min(140, Math.max(96, contentW * 0.42));
        var ppeLabW = contentW - ppeValW;
        var ppeHeadH = 12;
        var preparedPpe = ppeRows.map(function (row) {
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(ppeFs);
          var labs = pdf.splitTextToSize(safe(row.part || ''), ppeLabW - 12).slice(0, 2);
          pdf.setFont('helvetica', 'bold');
          var vals = pdf.splitTextToSize(safe(row.gear || ''), ppeValW - 12).slice(0, 2);
          var rh = Math.max(labs.length, vals.length, 1) * ppeLh + ppePad;
          return { labs: labs, vals: vals, rh: rh };
        });
        var ppeBodyH = 0;
        preparedPpe.forEach(function (p) { ppeBodyH += p.rh; });
        var ppeBlockH = ppeHeadH + ppeBodyH + 2;
        // Keep header + all rows together (never orphan 3 rows on page 2)
        ensureSpace(ppeBlockH);
        pdf.setFillColor(248, 250, 252);
        pdf.rect(marginL, y, contentW, ppeHeadH, 'F');
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(7);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        pdf.text('PART', marginL + 6, y + 9);
        pdf.text('GEAR', pageW - marginR - 6, y + 9, { align: 'right' });
        y += ppeHeadH;
        preparedPpe.forEach(function (prep, idx) {
          if (idx % 2 === 0) {
            pdf.setFillColor(252, 252, 253);
            pdf.rect(marginL, y, contentW, prep.rh, 'F');
          }
          var textY = y + ppePad * 0.45 + ppeFs * 0.78;
          pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
          pdf.setLineWidth(0.3);
          pdf.line(marginL + ppeLabW, y + 1, marginL + ppeLabW, y + prep.rh - 1);
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(ppeFs);
          pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
          writePdfLines(prep.labs, marginL + 6, textY, ppeLh);
          pdf.setFont('helvetica', 'bold');
          pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
          var vy = textY;
          for (var pi = 0; pi < prep.vals.length; pi++) {
            pdf.text(String(prep.vals[pi] || ''), pageW - marginR - 6, vy, { align: 'right' });
            vy += ppeLh;
          }
          pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
          pdf.setLineWidth(0.4);
          pdf.line(marginL, y + prep.rh, pageW - marginR, y + prep.rh);
          y += prep.rh;
        });
        y += 4;
      }

      drawPdfSectionTitle('OSHA HAZCOM REFERENCE', 8);
      var oshaBody = String(hb.osha || '').replace(/\s+/g, ' ').trim();
      if (oshaBody) {
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(hbFs);
        var oshaLines = pdf.splitTextToSize(safe(oshaBody), contentW - hbPad * 2);
        var oshaH = hbPad * 2 + Math.max(1, oshaLines.length) * hbLh;
        ensureSpace(oshaH + 2);
        pdf.setFillColor(248, 250, 252);
        pdf.setDrawColor(203, 213, 225);
        pdf.setLineWidth(0.8);
        pdf.roundedRect(marginL, y, contentW, oshaH, 3, 3, 'FD');
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(oshaLines, marginL + hbPad, y + hbPad + hbFs * 0.75, hbLh);
        y += oshaH + 4;
      }
    }

    // Bid Stress-Test: scenario matrix + Fix-it remediation (must not drop off the PDF)
    if (model.scenarioRows && model.scenarioRows.length) {
      drawPdfSectionTitle('SCENARIO STRESS MATRIX', densePack ? 10 : 14);
      var scCol = {
        name: contentW * 0.36,
        profit: contentW * 0.22,
        margin: contentW * 0.18,
        impact: contentW * 0.24
      };
      var scFs = densePack ? 7.5 : 8;
      var scLh = lineH(scFs);
      var scPad = densePack ? 4 : 6;
      var scHeadH = densePack ? 13 : 16;
      ensureSpace(scHeadH + 4);
      pdf.setFillColor(248, 250, 252);
      pdf.rect(marginL, y, contentW, scHeadH, 'F');
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.5);
      pdf.line(marginL, y + scHeadH, pageW - marginR, y + scHeadH);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(7);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      pdf.text('SCENARIO', marginL + 5, y + (densePack ? 9 : 11));
      pdf.text('MONTHLY PROFIT', marginL + scCol.name + 5, y + (densePack ? 9 : 11));
      pdf.text('MARGIN %', marginL + scCol.name + scCol.profit + 5, y + (densePack ? 9 : 11));
      pdf.text('MARGIN IMPACT', marginL + scCol.name + scCol.profit + scCol.margin + 5, y + (densePack ? 9 : 11));
      y += scHeadH;
      model.scenarioRows.forEach(function (row, idx) {
        var nLines = pdf.splitTextToSize(safe(row.scenario || ''), scCol.name - 10).slice(0, 2);
        var rh = Math.max(nLines.length, 1) * scLh + scPad;
        ensureSpace(rh + 2);
        var rowTop = y;
        if (row.below) {
          pdf.setFillColor(254, 242, 242);
          pdf.rect(marginL, rowTop - 1, contentW, rh, 'F');
        } else if (idx % 2 === 1) {
          pdf.setFillColor(252, 252, 253);
          pdf.rect(marginL, rowTop - 1, contentW, rh, 'F');
        }
        var textY = rowTop + scPad * 0.45 + scFs * 0.72;
        pdf.setFont('helvetica', idx === 0 ? 'bold' : 'normal');
        pdf.setFontSize(scFs);
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        writePdfLines(nLines, marginL + 5, textY, scLh);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(row.below ? 185 : TEXT[0], row.below ? 28 : TEXT[1], row.below ? 28 : TEXT[2]);
        pdf.text(safeMoney(row.profit || ''), marginL + scCol.name + 5, textY);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        pdf.text(safe(row.margin || ''), marginL + scCol.name + scCol.profit + 5, textY);
        pdf.setTextColor(row.below ? 185 : MUTED[0], row.below ? 28 : MUTED[1], row.below ? 28 : MUTED[2]);
        pdf.text(safe(row.impact || ''), marginL + scCol.name + scCol.profit + scCol.margin + 5, textY);
        pdf.setDrawColor(LINE_SOFT[0], LINE_SOFT[1], LINE_SOFT[2]);
        pdf.setLineWidth(0.4);
        pdf.line(marginL, rowTop + rh - 1, pageW - marginR, rowTop + rh - 1);
        y = rowTop + rh;
      });
    }

    if (model.remediation) {
      y += densePack ? 8 : 10;
      var fixFs = densePack ? 8 : 9;
      var fixLh = lineH(fixFs);
      var fixPad = densePack ? 8 : 10;
      var fixBody = 'Fix it: ' + String(model.remediation || '').replace(/\s+/g, ' ').trim();
      // Parenthesized money is treated as accounting credits elsewhere — keep positive $ prose
      fixBody = fixBody.replace(/\(\s*(\$[\d,]+(?:\.\d+)?(?:\s*\/\s*(?:mo|yr|hr))?)\s*\)/gi, 'of $1');
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(fixFs);
      var fixClean = safeMoney(fixBody);
      var fixInnerW = contentW - fixPad * 2;
      var fixLines = pdf.splitTextToSize(fixClean, fixInnerW);
      var fixH = fixPad * 2 + Math.max(1, fixLines.length) * fixLh + 2;
      ensureSpace(fixH + 4);
      pdf.setFillColor(240, 253, 250);
      pdf.setDrawColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.setLineWidth(1.1);
      pdf.roundedRect(marginL, y, contentW, fixH, 3, 3, 'FD');
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(fixFs);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      writePdfLines(fixLines, marginL + fixPad, y + fixPad + fixFs * 0.75, fixLh);
      y += fixH + (densePack ? 4 : 6);
    }

    // Chem Compatibility / Floor Program / Pad / PPE: methodology after tables, above page chrome
    if (model.method && model.methodInFooter) {
      var footMethod = String(model.method || '').replace(/\s+/g, ' ').replace(/\.+$/, '').trim();
      if (footMethod) {
        // PPE / Restroom: never spill methodology onto page 2 — Section 5 footer covers standards
        // PPE / Restroom: never spill methodology onto page 2 or into the §5 footer band
        if (isPpeSelector || isRestroomTime || isIssa447Lookup || isAppaInspection || isClientOnboarding || isDayPorterRoi || isAccountProfit || isTcoCalc || isEquipmentRoi || isJobCosting || isChurnCost || isEbitdaEst || isRobotRoi || isEquipFinanc || isPfasLookup || isFranchiseCompare || isVocCompliance || isSalesTax || isEpaListN || isSdsFinder || isInsuranceCompare || isTaxDeduct) {
          var methodNeed = (isRestroomTime || isIssa447Lookup || isAppaInspection || isClientOnboarding || isDayPorterRoi || isAccountProfit || isTcoCalc || isEquipmentRoi || isJobCosting || isChurnCost || isEbitdaEst || isRobotRoi || isEquipFinanc || isPfasLookup || isFranchiseCompare || isVocCompliance || isSalesTax || isEpaListN || isSdsFinder || isInsuranceCompare || isTaxDeduct) ? 22 : 14;
          if (y + methodNeed <= bottom) {
            y += (isRestroomTime || isIssa447Lookup || isAppaInspection || isClientOnboarding || isDayPorterRoi || isAccountProfit || isTcoCalc || isEquipmentRoi || isJobCosting || isChurnCost || isEbitdaEst || isRobotRoi || isEquipFinanc || isPfasLookup || isFranchiseCompare || isVocCompliance || isSalesTax || isEpaListN || isSdsFinder || isInsuranceCompare || isTaxDeduct) ? 10 : 3;
            writeWrapped(
              'Methodology: ' + footMethod + '.',
              marginL,
              (isRestroomTime || isIssa447Lookup || isAppaInspection || isClientOnboarding || isDayPorterRoi || isAccountProfit || isTcoCalc || isEquipmentRoi || isJobCosting || isChurnCost || isEbitdaEst || isRobotRoi || isEquipFinanc || isPfasLookup || isFranchiseCompare || isVocCompliance || isSalesTax || isEpaListN || isSdsFinder || isInsuranceCompare || isTaxDeduct) ? 7 : 6.5,
              'normal',
              MUTED,
              contentW
            );
          }
          // If no room above footer, skip body methodology — §5 footer carries cite
        } else {
          y += isChemCompat ? 6 : (isFloorProgram ? 4 : (isPadSelector ? 6 : (densePack ? 10 : 12)));
          ensureSpace(isFloorProgram ? 14 : (isPadSelector ? 14 : 18));
          writeWrapped(
            'Methodology: ' + footMethod + '.',
            marginL,
            isFloorProgram || isChemCompat ? 7 : (isPadSelector ? 7.4 : (densePack ? 7 : 8)),
            'normal',
            MUTED,
            contentW
          );
        }
      }
    }

    } // end !formalOnly / !agreementOnly dashboard path

    // Footer on each page
    var totalPages = pdf.internal.getNumberOfPages();
    var footerLineY = pageH - (densePack ? 22 : 30);
    var termsUrl = 'https://www.oporasupply.com/pages/terms-of-service';
    for (var p = 1; p <= totalPages; p++) {
      pdf.setPage(p);
      pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
      pdf.setLineWidth(0.5);
      if (agreementOnly) {
        // Two-line legal insulation + page count (IC agreement only)
        var agFooterTop = pageH - 48;
        pdf.line(marginL, agFooterTop, pageW - marginR, agFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var agLine1Left =
          'Draft instrument for negotiation & legal counsel review · Not legal advice · Worker classification rules vary by state';
        var agPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var pageWNeeded = pdf.getTextWidth(agPage);
        var leftMax = Math.max(120, contentW - pageWNeeded - 10);
        var leftWrapped = pdf.splitTextToSize(agLine1Left, leftMax);
        pdf.text(leftWrapped[0] || agLine1Left, marginL, agFooterTop + 10);
        pdf.setFont('helvetica', 'normal');
        pdf.text(agPage, pageW - marginR, agFooterTop + 10, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var agLine2 =
          'Generated via Opora Supply · Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(agLine2, contentW), marginL, agFooterTop + 20);
      } else if (String(model.slug || '') === 'bill-rate-calculator') {
        var brFooterTop = pageH - 48;
        pdf.line(marginL, brFooterTop, pageW - marginR, brFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var brLine1 =
          'Operational billing model for labor estimation · Not legal or payroll advice · Verify regional minimum wages and statutory burden rates';
        var brPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var brPageW = pdf.getTextWidth(brPage);
        var brLeftMax = Math.max(120, contentW - brPageW - 10);
        var brWrapped = pdf.splitTextToSize(brLine1, brLeftMax);
        pdf.text(brWrapped[0] || brLine1, marginL, brFooterTop + 10);
        pdf.setFont('helvetica', 'normal');
        pdf.text(brPage, pageW - marginR, brFooterTop + 10, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var brLine2 =
          'Generated via Opora Supply · Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(brLine2, contentW), marginL, brFooterTop + 20);
      } else if (String(model.slug || '') === '1099-vs-w2-calculator') {
        var icFooterTop = pageH - 48;
        pdf.line(marginL, icFooterTop, pageW - marginR, icFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var icLine1 =
          'Illustrative payroll burden & worker classification model · Not legal or tax advice · Worker classification rules vary by state';
        var icPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var icPageW = pdf.getTextWidth(icPage);
        var icLeftMax = Math.max(120, contentW - icPageW - 10);
        var icWrapped = pdf.splitTextToSize(icLine1, icLeftMax);
        pdf.text(icWrapped[0] || icLine1, marginL, icFooterTop + 10);
        pdf.setFont('helvetica', 'normal');
        pdf.text(icPage, pageW - marginR, icFooterTop + 10, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var icLine2 =
          'Generated via Opora Supply · Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(icLine2, contentW), marginL, icFooterTop + 20);
      } else if (String(model.slug || '') === 'production-rate-calculator') {
        var prFooterTop = pageH - 48;
        pdf.line(marginL, prFooterTop, pageW - marginR, prFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var prLine1 =
          'APPA custodial workloading & labor allocation model · Production estimates for operational planning · Field conditions dictate actual yields';
        var prPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var prPageW = pdf.getTextWidth(prPage);
        var prLeftMax = Math.max(120, contentW - prPageW - 10);
        var prWrapped = pdf.splitTextToSize(prLine1, prLeftMax);
        pdf.text(prWrapped[0] || prLine1, marginL, prFooterTop + 10);
        pdf.setFont('helvetica', 'normal');
        pdf.text(prPage, pageW - marginR, prFooterTop + 10, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var prLine2 =
          'Generated via Opora Supply · Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(prLine2, contentW), marginL, prFooterTop + 20);
      } else if (String(model.slug || '') === 'chemical-compatibility') {
        var ccFooterTop = pageH - 48;
        pdf.line(marginL, ccFooterTop, pageW - marginR, ccFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var ccLine1 =
          'HazCom operational safety reference · Not a substitute for manufacturer Safety Data Sheets (SDS) · Comply with OSHA 29 CFR 1910.1200';
        var ccPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var ccPageW = pdf.getTextWidth(ccPage);
        var ccLeftMax = Math.max(120, contentW - ccPageW - 10);
        var ccWrapped = pdf.splitTextToSize(ccLine1, ccLeftMax);
        pdf.text(ccWrapped[0] || ccLine1, marginL, ccFooterTop + 10);
        pdf.setFont('helvetica', 'normal');
        pdf.text(ccPage, pageW - marginR, ccFooterTop + 10, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var ccLine2 =
          'Generated via Opora Supply · Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(ccLine2, contentW), marginL, ccFooterTop + 20);
      } else if (String(model.slug || '') === 'dilution-calculator') {
        var dilFooterTop = pageH - 48;
        pdf.line(marginL, dilFooterTop, pageW - marginR, dilFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var dilLine1 =
          'Volumetric dilution reference for commercial operations · Always verify manufacturer EPA master label for kill claims & dwell times';
        var dilPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var dilPageW = pdf.getTextWidth(dilPage);
        var dilLeftMax = Math.max(120, contentW - dilPageW - 10);
        var dilWrapped = pdf.splitTextToSize(dilLine1, dilLeftMax);
        pdf.text(dilWrapped[0] || dilLine1, marginL, dilFooterTop + 10);
        pdf.setFont('helvetica', 'normal');
        pdf.text(dilPage, pageW - marginR, dilFooterTop + 10, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var dilLine2 =
          'Generated via Opora Supply · Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(dilLine2, contentW), marginL, dilFooterTop + 20);
      } else if (String(model.slug || '') === 'floor-program-builder') {
        var fpFooterTop = pageH - 48;
        pdf.line(marginL, fpFooterTop, pageW - marginR, fpFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var fpLine1 =
          'Floor care specification & maintenance guide · Verify substrate manufacturer warranty & ASTM slip-resistance standards';
        var fpPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var fpPageW = pdf.getTextWidth(fpPage);
        var fpLeftMax = Math.max(120, contentW - fpPageW - 10);
        var fpWrapped = pdf.splitTextToSize(fpLine1, fpLeftMax);
        pdf.text(fpWrapped[0] || fpLine1, marginL, fpFooterTop + 10);
        pdf.setFont('helvetica', 'normal');
        pdf.text(fpPage, pageW - marginR, fpFooterTop + 10, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var fpLine2 =
          'Generated via Opora Supply · Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(fpLine2, contentW), marginL, fpFooterTop + 20);
      } else if (isPadSelector) {
        var psFooterTop = pageH - 48;
        pdf.line(marginL, psFooterTop, pageW - marginR, psFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var psLine1 =
          'Floor pad selection reference · Confirm machine speed, finish chemistry & substrate manufacturer guidance before use';
        var psPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var psPageW = pdf.getTextWidth(psPage);
        var psLeftMax = Math.max(120, contentW - psPageW - 10);
        var psWrapped = pdf.splitTextToSize(psLine1, psLeftMax);
        pdf.text(psWrapped[0] || psLine1, marginL, psFooterTop + 10);
        pdf.setFont('helvetica', 'normal');
        pdf.text(psPage, pageW - marginR, psFooterTop + 10, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var psLine2 =
          'Generated via Opora Supply · Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(psLine2, contentW), marginL, psFooterTop + 20);
      } else if (isPpeSelector) {
        var ppeFooterTop = pageH - 48;
        pdf.line(marginL, ppeFooterTop, pageW - marginR, ppeFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var ppeLine1 =
          'PPE compliance & chemical hazard assessment · Verify specific SDS Section 8 & OSHA 1910.132 / 1910.134 standards';
        var ppePage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var ppePageW = pdf.getTextWidth(ppePage);
        var ppeLeftMax = Math.max(120, contentW - ppePageW - 10);
        var ppeWrapped = pdf.splitTextToSize(ppeLine1, ppeLeftMax);
        pdf.text(ppeWrapped[0] || ppeLine1, marginL, ppeFooterTop + 10);
        pdf.setFont('helvetica', 'normal');
        pdf.text(ppePage, pageW - marginR, ppeFooterTop + 10, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var ppeLine2 =
          'Generated via Opora Supply · Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(ppeLine2, contentW), marginL, ppeFooterTop + 20);
      } else if (isRestroomTime || String(model.slug || '') === 'restroom-time-calculator') {
        // Hard §5 footer — clear footer band first so benchmark/methodology never erase it
        var rrFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, rrFooterTop - 4, pageW, pageH - (rrFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, rrFooterTop, pageW - marginR, rrFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var rrLine1 =
          'Restroom cleaning labor specification & fixture time standard - Based on ISSA 612 / APPA commercial production rates';
        var rrPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var rrPageW = pdf.getTextWidth(rrPage);
        var rrLeftMax = Math.max(120, contentW - rrPageW - 10);
        var rrWrapped = pdf.splitTextToSize(rrLine1, rrLeftMax);
        pdf.text(rrWrapped[0] || rrLine1, marginL, rrFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(rrPage, pageW - marginR, rrFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var rrLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(rrLine2, contentW), marginL, rrFooterTop + 22);
      } else if (isIssa447Lookup || String(model.slug || '') === 'issa-447-lookup') {
        // Hard §5 footer — clear footer band first so matrix/methodology never erase it
        var issaFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, issaFooterTop - 4, pageW, pageH - (issaFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, issaFooterTop, pageW - marginR, issaFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var issaLine1 =
          'Production rate lookup & task workloading guide - Based on APPA Level 2 / ISSA 612 commercial production rates';
        var issaPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var issaPageW = pdf.getTextWidth(issaPage);
        var issaLeftMax = Math.max(120, contentW - issaPageW - 10);
        var issaWrapped = pdf.splitTextToSize(issaLine1, issaLeftMax);
        pdf.text(issaWrapped[0] || issaLine1, marginL, issaFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(issaPage, pageW - marginR, issaFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var issaLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(issaLine2, contentW), marginL, issaFooterTop + 22);
      } else if (isAppaInspection || String(model.slug || '') === 'appa-inspection-report') {
        // Hard §5 footer — clear footer band first so placard/methodology never erase it
        var appaFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, appaFooterTop - 4, pageW, pageH - (appaFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, appaFooterTop, pageW - marginR, appaFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var appaLine1 =
          'APPA cleanliness inspection report & quality audit standard - Based on APPA Custodial Operational Development Standards';
        var appaPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var appaPageW = pdf.getTextWidth(appaPage);
        var appaLeftMax = Math.max(120, contentW - appaPageW - 10);
        var appaWrapped = pdf.splitTextToSize(appaLine1, appaLeftMax);
        pdf.text(appaWrapped[0] || appaLine1, marginL, appaFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(appaPage, pageW - marginR, appaFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var appaLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(appaLine2, contentW), marginL, appaFooterTop + 22);
      } else if (isClientOnboarding || String(model.slug || '') === 'client-onboarding-checklist') {
        // Hard §5 footer — clear footer band first so placard/methodology never erase it
        var obFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, obFooterTop - 4, pageW, pageH - (obFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, obFooterTop, pageW - marginR, obFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var obLine1 =
          'Commercial custodial account onboarding & startup protocol - Standardized contract mobilization framework';
        var obPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var obPageW = pdf.getTextWidth(obPage);
        var obLeftMax = Math.max(120, contentW - obPageW - 10);
        var obWrapped = pdf.splitTextToSize(obLine1, obLeftMax);
        pdf.text(obWrapped[0] || obLine1, marginL, obFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(obPage, pageW - marginR, obFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var obLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(obLine2, contentW), marginL, obFooterTop + 22);
      } else if (isDayPorterRoi || String(model.slug || '') === 'day-porter-roi') {
        var dpFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, dpFooterTop - 4, pageW, pageH - (dpFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, dpFooterTop, pageW - marginR, dpFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var dpLine1 =
          'Day porter vs night crew staffing & labor model analysis - Benchmarked to BOMA / ISSA commercial custodial workloading standards';
        var dpPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var dpPageW = pdf.getTextWidth(dpPage);
        var dpLeftMax = Math.max(120, contentW - dpPageW - 10);
        var dpWrapped = pdf.splitTextToSize(dpLine1, dpLeftMax);
        pdf.text(dpWrapped[0] || dpLine1, marginL, dpFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(dpPage, pageW - marginR, dpFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var dpLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(dpLine2, contentW), marginL, dpFooterTop + 22);
      } else if (isAccountProfit || String(model.slug || '') === 'account-profitability-auditor') {
        // Hard §5 footer — clear footer band first so P&L placard/methodology never erase it
        var acctFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, acctFooterTop - 4, pageW, pageH - (acctFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, acctFooterTop, pageW - marginR, acctFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var acctLine1 =
          'Commercial account profitability audit & labor P&L analysis - Benchmarked to BSCAI / ISSA financial operating ratios';
        var acctPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var acctPageW = pdf.getTextWidth(acctPage);
        var acctLeftMax = Math.max(120, contentW - acctPageW - 10);
        var acctWrapped = pdf.splitTextToSize(acctLine1, acctLeftMax);
        pdf.text(acctWrapped[0] || acctLine1, marginL, acctFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(acctPage, pageW - marginR, acctFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var acctLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(acctLine2, contentW), marginL, acctFooterTop + 22);
      } else if (isJobCosting || String(model.slug || '') === 'job-costing-calculator') {
        var jcFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, jcFooterTop - 4, pageW, pageH - (jcFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, jcFooterTop, pageW - marginR, jcFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var jcLine1 =
          'Commercial job costing & contract price-floor specification - Benchmarked to BSCAI & ISSA commercial bidding standards';
        var jcPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var jcPageW = pdf.getTextWidth(jcPage);
        var jcLeftMax = Math.max(120, contentW - jcPageW - 10);
        var jcWrapped = pdf.splitTextToSize(jcLine1, jcLeftMax);
        pdf.text(jcWrapped[0] || jcLine1, marginL, jcFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(jcPage, pageW - marginR, jcFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var jcLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(jcLine2, contentW), marginL, jcFooterTop + 22);
      } else if (isTcoCalc || String(model.slug || '') === 'tco-calculator') {
        // Hard §5 footer — clear footer band first so lifecycle placard/methodology never erase it
        var tcoFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, tcoFooterTop - 4, pageW, pageH - (tcoFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, tcoFooterTop, pageW - marginR, tcoFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var tcoLine1 =
          'Commercial custodial equipment lifecycle TCO & capital asset standard - Benchmarked to ISSA & BSCAI equipment operating ratios';
        var tcoPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var tcoPageW = pdf.getTextWidth(tcoPage);
        var tcoLeftMax = Math.max(120, contentW - tcoPageW - 10);
        var tcoWrapped = pdf.splitTextToSize(tcoLine1, tcoLeftMax);
        pdf.text(tcoWrapped[0] || tcoLine1, marginL, tcoFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(tcoPage, pageW - marginR, tcoFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var tcoLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(tcoLine2, contentW), marginL, tcoFooterTop + 22);
      } else if (isEquipmentRoi || String(model.slug || '') === 'equipment-roi-calculator') {
        // Hard §5 footer — clear footer band first so payback placard/methodology never erase it
        var roiFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, roiFooterTop - 4, pageW, pageH - (roiFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, roiFooterTop, pageW - marginR, roiFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var roiLine1 =
          'Commercial custodial equipment ROI & capital allocation model - Benchmarked to ISSA 612 & BSCAI productivity standards';
        var roiPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var roiPageW = pdf.getTextWidth(roiPage);
        var roiLeftMax = Math.max(120, contentW - roiPageW - 10);
        var roiWrapped = pdf.splitTextToSize(roiLine1, roiLeftMax);
        pdf.text(roiWrapped[0] || roiLine1, marginL, roiFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(roiPage, pageW - marginR, roiFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var roiLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(roiLine2, contentW), marginL, roiFooterTop + 22);
      } else if (isChurnCost || String(model.slug || '') === 'churn-cost-calculator') {
        // Hard §5 footer — clear footer band first so retention placard/methodology never erase it
        var churnFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, churnFooterTop - 4, pageW, pageH - (churnFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, churnFooterTop, pageW - marginR, churnFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var churnLine1 =
          'Commercial custodial churn cost & account retention analysis - Benchmarked to BSCAI & BOMA contract lifecycle standards';
        var churnPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var churnPageW = pdf.getTextWidth(churnPage);
        var churnLeftMax = Math.max(120, contentW - churnPageW - 10);
        var churnWrapped = pdf.splitTextToSize(churnLine1, churnLeftMax);
        pdf.text(churnWrapped[0] || churnLine1, marginL, churnFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(churnPage, pageW - marginR, churnFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var churnLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(churnLine2, contentW), marginL, churnFooterTop + 22);
      } else if (isEbitdaEst || String(model.slug || '') === 'ebitda-estimator') {
        // Hard §5 footer — clear footer band first so M&A placard/methodology never erase it
        var ebFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, ebFooterTop - 4, pageW, pageH - (ebFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, ebFooterTop, pageW - marginR, ebFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var ebLine1 =
          'Commercial custodial enterprise valuation & EBITDA analysis - Benchmarked to commercial cleaning M&A transaction multiples';
        var ebPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var ebPageW = pdf.getTextWidth(ebPage);
        var ebLeftMax = Math.max(120, contentW - ebPageW - 10);
        var ebWrapped = pdf.splitTextToSize(ebLine1, ebLeftMax);
        pdf.text(ebWrapped[0] || ebLine1, marginL, ebFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(ebPage, pageW - marginR, ebFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var ebLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(ebLine2, contentW), marginL, ebFooterTop + 22);
      } else if (isRobotRoi || String(model.slug || '') === 'robot-roi-matcher') {
        // Hard §5 footer — clear footer band first so AMR placard/methodology never erase it
        var robotFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, robotFooterTop - 4, pageW, pageH - (robotFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, robotFooterTop, pageW - marginR, robotFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var robotLine1 =
          'Commercial custodial robotics ROI & automated scrubbing specification - Benchmarked to ISSA 612 & RIA robotics standards';
        var robotPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var robotPageW = pdf.getTextWidth(robotPage);
        var robotLeftMax = Math.max(120, contentW - robotPageW - 10);
        var robotWrapped = pdf.splitTextToSize(robotLine1, robotLeftMax);
        pdf.text(robotWrapped[0] || robotLine1, marginL, robotFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(robotPage, pageW - marginR, robotFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var robotLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(robotLine2, contentW), marginL, robotFooterTop + 22);
      } else if (isEquipFinanc || String(model.slug || '') === 'equipment-financing-comparator') {
        // Hard §5 footer — clear footer band first so financing placard/methodology never erase it
        var finFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, finFooterTop - 4, pageW, pageH - (finFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, finFooterTop, pageW - marginR, finFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var finLine1 =
          'Commercial custodial equipment financing & capital acquisition comparison - Standardized cash flow & debt service analysis';
        var finPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var finPageW = pdf.getTextWidth(finPage);
        var finLeftMax = Math.max(120, contentW - finPageW - 10);
        var finWrapped = pdf.splitTextToSize(finLine1, finLeftMax);
        pdf.text(finWrapped[0] || finLine1, marginL, finFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(finPage, pageW - marginR, finFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var finLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(finLine2, contentW), marginL, finFooterTop + 22);
      } else if (isPfasLookup || String(model.slug || '') === 'pfas-state-lookup') {
        // Hard §5 footer — clear footer band first so PFAS placard/methodology never erase it
        var pfasFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, pfasFooterTop - 4, pageW, pageH - (pfasFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, pfasFooterTop, pageW - marginR, pfasFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var pfasLine1 =
          'Commercial custodial chemical compliance & PFAS regulatory lookup - Benchmarked to state statutory registries & EPA guidelines';
        var pfasPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var pfasPageW = pdf.getTextWidth(pfasPage);
        var pfasLeftMax = Math.max(120, contentW - pfasPageW - 10);
        var pfasWrapped = pdf.splitTextToSize(pfasLine1, pfasLeftMax);
        pdf.text(pfasWrapped[0] || pfasLine1, marginL, pfasFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(pfasPage, pageW - marginR, pfasFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var pfasLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(pfasLine2, contentW), marginL, pfasFooterTop + 22);
      } else if (isFranchiseCompare || String(model.slug || '') === 'franchise-comparison-matrix') {
        // Hard §5 footer — clear footer band first so franchise placard/methodology never erase it
        var franFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, franFooterTop - 4, pageW, pageH - (franFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, franFooterTop, pageW - marginR, franFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var franLine1 =
          'Commercial custodial franchise evaluation & royalty analysis - Comparative analysis benchmarked to published FDD disclosures';
        var franPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var franPageW = pdf.getTextWidth(franPage);
        var franLeftMax = Math.max(120, contentW - franPageW - 10);
        var franWrapped = pdf.splitTextToSize(franLine1, franLeftMax);
        pdf.text(franWrapped[0] || franLine1, marginL, franFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(franPage, pageW - marginR, franFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var franLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(franLine2, contentW), marginL, franFooterTop + 22);
      } else if (isVocCompliance || String(model.slug || '') === 'voc-compliance') {
        // Hard §5 footer — clear footer band first so VOC placard/methodology never erase it
        var vocFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, vocFooterTop - 4, pageW, pageH - (vocFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, vocFooterTop, pageW - marginR, vocFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var vocLine1 =
          'Commercial custodial chemical compliance & VOC regulatory lookup - Benchmarked to CARB, OTC, and US EPA Consumer Product Rules';
        var vocPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var vocPageW = pdf.getTextWidth(vocPage);
        var vocLeftMax = Math.max(120, contentW - vocPageW - 10);
        var vocWrapped = pdf.splitTextToSize(vocLine1, vocLeftMax);
        pdf.text(vocWrapped[0] || vocLine1, marginL, vocFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(vocPage, pageW - marginR, vocFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var vocLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(vocLine2, contentW), marginL, vocFooterTop + 22);
      } else if (isSalesTax || String(model.slug || '') === 'sales-tax-calculator') {
        // Hard §5 footer — clear footer band first so taxability placard/methodology never erase it
        var stFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, stFooterTop - 4, pageW, pageH - (stFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, stFooterTop, pageW - marginR, stFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var stLine1 =
          'Commercial custodial sales tax calculation & nexus determination - Governed by state revenue codes & statutory service definitions';
        var stPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var stPageW = pdf.getTextWidth(stPage);
        var stLeftMax = Math.max(120, contentW - stPageW - 10);
        var stWrapped = pdf.splitTextToSize(stLine1, stLeftMax);
        pdf.text(stWrapped[0] || stLine1, marginL, stFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(stPage, pageW - marginR, stFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var stLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(stLine2, contentW), marginL, stFooterTop + 22);
      } else if (isEpaListN || String(model.slug || '') === 'epa-list-n-matcher') {
        // Hard §5 footer — clear footer band first so Spaulding placard/methodology never erase it
        var epaFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, epaFooterTop - 4, pageW, pageH - (epaFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, epaFooterTop, pageW - marginR, epaFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var epaLine1 =
          'Commercial custodial disinfectant matching & EPA registration verification - Cross-referenced to EPA List N/K/H antimicrobial ledgers';
        var epaPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var epaPageW = pdf.getTextWidth(epaPage);
        var epaLeftMax = Math.max(120, contentW - epaPageW - 10);
        var epaWrapped = pdf.splitTextToSize(epaLine1, epaLeftMax);
        pdf.text(epaWrapped[0] || epaLine1, marginL, epaFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(epaPage, pageW - marginR, epaFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var epaLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(epaLine2, contentW), marginL, epaFooterTop + 22);
      } else if (isSdsFinder || String(model.slug || '') === 'sds-finder') {
        // Hard §5 footer — clear footer band first so HazCom placard/methodology never erase it
        var sdsFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, sdsFooterTop - 4, pageW, pageH - (sdsFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, sdsFooterTop, pageW - marginR, sdsFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var sdsLine1 =
          'Commercial custodial safety data sheet (SDS) lookup & hazard classification - Governed by OSHA HazCom 29 CFR 1910.1200 & GHS standards';
        var sdsPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var sdsPageW = pdf.getTextWidth(sdsPage);
        var sdsLeftMax = Math.max(120, contentW - sdsPageW - 10);
        var sdsWrapped = pdf.splitTextToSize(sdsLine1, sdsLeftMax);
        pdf.text(sdsWrapped[0] || sdsLine1, marginL, sdsFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(sdsPage, pageW - marginR, sdsFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var sdsLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(sdsLine2, contentW), marginL, sdsFooterTop + 22);
      } else if (isInsuranceCompare || String(model.slug || '') === 'insurance-comparison') {
        // Hard §5 footer — clear footer band first so insurance placard/methodology never erase it
        var insFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, insFooterTop - 4, pageW, pageH - (insFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, insFooterTop, pageW - marginR, insFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var insLine1 =
          'Commercial custodial insurance comparison & underwriting evaluation - Standardized GL and Workers\' Compensation EMR modeling';
        var insPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var insPageW = pdf.getTextWidth(insPage);
        var insLeftMax = Math.max(120, contentW - insPageW - 10);
        var insWrapped = pdf.splitTextToSize(insLine1, insLeftMax);
        pdf.text(insWrapped[0] || insLine1, marginL, insFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(insPage, pageW - marginR, insFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var insLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(insLine2, contentW), marginL, insFooterTop + 22);
      } else if (isOsha300 || String(model.slug || '') === 'osha-300-300a-log') {
        // Hard §5 footer — clear footer band first so OSHA placard/methodology never erase it
        var oshaFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, oshaFooterTop - 4, pageW, pageH - (oshaFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, oshaFooterTop, pageW - marginR, oshaFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var oshaLine1 =
          'Commercial custodial safety compliance & OSHA 300A recordkeeping analysis - Standardized BLS NAICS 561720 injury & illness rate modeling';
        var oshaPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var oshaPageW = pdf.getTextWidth(oshaPage);
        var oshaLeftMax = Math.max(120, contentW - oshaPageW - 10);
        var oshaWrapped = pdf.splitTextToSize(oshaLine1, oshaLeftMax);
        pdf.text(oshaWrapped[0] || oshaLine1, marginL, oshaFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(oshaPage, pageW - marginR, oshaFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var oshaLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(oshaLine2, contentW), marginL, oshaFooterTop + 22);
      } else if (isTaxDeduct || String(model.slug || '') === 'tax-deduction-finder') {
        // Hard §5 footer — clear footer band first so tax placard/methodology never erase it
        var taxFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, taxFooterTop - 4, pageW, pageH - (taxFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, taxFooterTop, pageW - marginR, taxFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var taxLine1 =
          'Commercial custodial tax deduction & entity structuring analysis - Benchmarked to IRS Internal Revenue Code provisions & 2026 thresholds';
        var taxPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var taxPageW = pdf.getTextWidth(taxPage);
        var taxLeftMax = Math.max(120, contentW - taxPageW - 10);
        var taxWrapped = pdf.splitTextToSize(taxLine1, taxLeftMax);
        pdf.text(taxWrapped[0] || taxLine1, marginL, taxFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(taxPage, pageW - marginR, taxFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var taxLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(taxLine2, contentW), marginL, taxFooterTop + 22);
      } else if (isUnionLookup || String(model.slug || '') === 'union-contract-lookup') {
        // Hard §5 footer — clear footer band first so SEIU/SCA placard/methodology never erase it
        var unFooterTop = pageH - 52;
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, unFooterTop - 4, pageW, pageH - (unFooterTop - 4), 'F');
        pdf.setDrawColor(LINE[0], LINE[1], LINE[2]);
        pdf.setLineWidth(0.5);
        pdf.line(marginL, unFooterTop, pageW - marginR, unFooterTop);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.5);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        var unLine1 =
          'Commercial custodial union scale & prevailing wage rate lookup - Benchmarked to published SEIU CBAs and DOL Service Contract Act determinations';
        var unPage = 'Page ' + String(p) + ' of ' + String(totalPages);
        var unPageW = pdf.getTextWidth(unPage);
        var unLeftMax = Math.max(120, contentW - unPageW - 10);
        var unWrapped = pdf.splitTextToSize(unLine1, unLeftMax);
        pdf.text(unWrapped[0] || unLine1, marginL, unFooterTop + 11);
        pdf.setFont('helvetica', 'normal');
        pdf.text(unPage, pageW - marginR, unFooterTop + 11, { align: 'right' });
        pdf.setFontSize(6);
        pdf.setTextColor(160, 160, 170);
        var unLine2 =
          'Generated via Opora Supply - Subject to Platform Terms of Service (Section 5 AI Output & Verification) at ' +
          termsUrl;
        pdf.text(pdf.splitTextToSize(unLine2, contentW), marginL, unFooterTop + 22);
      } else {
        pdf.line(marginL, footerLineY, pageW - marginR, footerLineY);
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(7);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        if (formalOnly) {
          pdf.text('Rate adjustment notice | Confirm contract notice terms before sending', marginL, pageH - (densePack ? 12 : 18));
        } else {
          pdf.text('Generated via Opora Supply Tools - Commercial Bid Engine', marginL, pageH - (densePack ? 12 : 18));
        }
        pdf.text(safe(model.cleanUrl), marginL, pageH - (densePack ? 5 : 9));
        pdf.text(String(p) + ' of ' + String(totalPages), pageW - marginR, pageH - (densePack ? 12 : 18), { align: 'right' });
      }
    }

    var dateSlug = (S() && S().fileStamp)
      ? S().fileStamp()
      : (typeof global.OporaFileStamp === 'function'
        ? global.OporaFileStamp()
        : new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-'));
    function fileSafe(s) {
      return String(s || '')
        .trim()
        .replace(/['"]/g, '')
        .replace(/[^a-zA-Z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .slice(0, 48) || '';
    }
    var fileSlug = String(model.slug || 'calculator').replace(/[^a-z0-9\-]+/gi, '-');
    var filename;
    if (String(model.slug || '') === 'bid-generator' && (model.pdfMode === 'client' || model.pdfMode === 'internal')) {
      var acct = fileSafe(model.facilityName) || 'Bid';
      var kind = model.pdfMode === 'client'
        ? 'Client_Proposal_Summary'
        : 'Internal_Estimating_Worksheet';
      filename = acct + '_' + kind + '_' + dateSlug + '.pdf';
    } else if (formalOnly) {
      var clientSafe = fileSafe((model.formalLetter && model.formalLetter.client) || 'Client');
      filename = clientSafe + '_Rate_Adjustment_Notice_' + dateSlug + '.pdf';
    } else if (agreementOnly) {
      var subSafe = fileSafe(
        (model.formalAgreement && model.formalAgreement.partiesLine) ||
        model.facility ||
        'Subcontractor'
      );
      filename = subSafe.slice(0, 40) + '_IC_Agreement_' + dateSlug + '.pdf';
    } else {
      filename = fileSlug + '-report-' + dateSlug + '.pdf';
    }
    var base64 = null;
    if (opts.returnBase64) {
      try {
        var uri = pdf.output('datauristring');
        var marker = 'base64,';
        var at = uri.indexOf(marker);
        base64 = at >= 0 ? uri.slice(at + marker.length) : '';
      } catch (eB64) {
        base64 = null;
      }
    }
    if (opts.save !== false) pdf.save(filename);
    return { filename: filename, base64: base64, ok: true };
  }

  function toastPdf(msg, kind) {
    if (global.OporaTools && typeof global.OporaTools.showToast === 'function') {
      global.OporaTools.showToast(msg, kind || 'info');
    }
  }

  function calcWorkerBase() {
    return ((global.OporaEdge && global.OporaEdge.WORKER_URL) ||
      global.OPORA_WORKER_URL ||
      'https://api.oporasupply.com').replace(/\/$/, '');
  }

  function escapeEmailHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function postCalcSendEmail(body) {
    var json = JSON.stringify(body);
    var edge = global.OporaEdge;
    if (edge && typeof edge.fetchApi === 'function') {
      return edge.fetchApi('/api/send-email', { method: 'POST', body: json }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || (j && j.success === false)) {
            var err = new Error((j && j.error) || 'Email could not be sent');
            err.status = r.status;
            throw err;
          }
          return j;
        });
      });
    }
    var bases = [calcWorkerBase()];
    if (global.OPORA_WORKER_URL_FALLBACK) {
      bases.push(String(global.OPORA_WORKER_URL_FALLBACK).replace(/\/$/, ''));
    }
    function tryBase(i) {
      if (i >= bases.length) return Promise.reject(new Error('Email could not be sent'));
      return fetch(bases[i] + '/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: json
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || (j && j.success === false)) {
            var err = new Error((j && j.error) || 'Email could not be sent');
            err.status = r.status;
            throw err;
          }
          return j;
        });
      }).catch(function () { return tryBase(i + 1); });
    }
    return tryBase(0);
  }

  /** Email the executive PDF (attachment). No browser download from this path. */
  function emailCalcCopy(opts) {
    var email = String(opts.to || '').trim().toLowerCase();
    if (!email || email.indexOf('@') === -1) {
      return Promise.reject(new Error('Enter a valid email'));
    }
    var last = opts.result || {};
    // Re-bind from live form so emailed PDF matches current inputs.
    if (typeof opts.calculate === 'function' && opts.fields && opts.formRoot) {
      try {
        var liveInputs = collectInputs(opts.formRoot, opts.fields);
        var fresh = opts.calculate(liveInputs);
        if (fresh && fresh.valid) last = fresh;
      } catch (eFresh) { /* keep opts.result */ }
    }
    var title = opts.title || 'Opora Calculator';
    var srcUrl = String(opts.srcUrl || (global.location && global.location.href) || 'https://oporasupply.com');
    var cleanUrl = srcUrl.replace(/[?&]preview_theme_id=\d+/g, '').replace(/\?$/, '');
    var primary = last.primary ||
      (last.metrics && last.metrics[0] && last.metrics[0].value) ||
      '';
    var subject = 'Your ' + title + ' report — Opora Supply';
    var text =
      'Your ' + title + ' report is attached as a PDF.\n\n' +
      (primary ? 'Headline: ' + primary + '\n\n' : '') +
      'Reopen this calculator:\n' + cleanUrl + '\n\n' +
      '- Opora Supply · Illustrative planning tool; verify before bidding.';
    var html =
      '<div style="font-family:Inter,Segoe UI,sans-serif;font-size:15px;line-height:1.25;color:#0F1217">' +
      '<p style="margin:0 0 12px">Your <strong>' + escapeEmailHtml(title) + '</strong> report is attached.</p>' +
      (primary
        ? '<p style="margin:0 0 16px;font-size:20px;font-weight:800;color:#01696F">' +
          escapeEmailHtml(primary) + '</p>'
        : '') +
      '<p style="margin:0 0 18px">Open the PDF for the full executive summary, breakdown, and inputs.</p>' +
      '<p style="margin:0 0 8px"><a href="' + escapeEmailHtml(cleanUrl) +
      '" style="color:#01696F;font-weight:700;text-decoration:none">Reopen this calculator →</a></p>' +
      '<p style="margin:18px 0 0;color:#6f6d66;font-size:12px">Generated with Opora Supply · Illustrative planning tool; verify before bidding.</p>' +
      '</div>';

    function rememberLead() {
      if (global.OporaLeadEmail && typeof global.OporaLeadEmail.remember === 'function') {
        try { global.OporaLeadEmail.remember(email); } catch (eRem) { /* noop */ }
      }
      try {
        if (global.klaviyo && typeof global.klaviyo.push === 'function') {
          global.klaviyo.push(['identify', { $email: email, tool: opts.slug || 'calculator' }]);
          global.klaviyo.push(['track', 'Calc Email Capture', {
            tool: opts.slug || 'calculator',
            method: 'calc_email_pdf',
            url: cleanUrl
          }]);
        }
      } catch (eK) { /* noop */ }
      try {
        if (typeof global.gtag === 'function') {
          global.gtag('event', 'calc_email_copy', { tool: opts.slug || 'calculator', attached_pdf: true });
        }
      } catch (eG) { /* noop */ }
    }

    function buildMailtoHref() {
      return 'mailto:' + encodeURIComponent(email) +
        '?subject=' + encodeURIComponent(subject) +
        '&body=' + encodeURIComponent(text.slice(0, 1800));
    }

    var model = collectCalcPdfModel({
      title: title,
      slug: opts.slug,
      fields: opts.fields,
      formRoot: opts.formRoot,
      result: last,
      srcUrl: srcUrl,
      // Email attach: internal worksheet for Bid Generator (never client sheet by accident)
      pdfMode: opts.slug === 'bid-generator' ? 'internal' : ''
    });

    return ensureJsPdf().then(function (jsPDF) {
      var pdfOut = writeCalcJsPdf(jsPDF, model, { save: false, returnBase64: true });
      if (!pdfOut || !pdfOut.base64) {
        throw new Error('Could not build PDF attachment');
      }
      return postCalcSendEmail({
        to: email,
        subject: subject,
        text: text,
        html: html,
        source_tool: opts.slug || 'calculator',
        attachments: [{
          filename: pdfOut.filename,
          content: pdfOut.base64,
          type: 'application/pdf',
          disposition: 'attachment'
        }]
      });
    }).then(function (j) {
      rememberLead();
      return j;
    }).catch(function (err) {
      // Never auto-launch mailto / Outlook — offer an explicit secondary action instead.
      rememberLead();
      return {
        success: false,
        delivery: 'failed',
        mailto: buildMailtoHref(),
        error: (err && err.message) || 'Email could not be sent'
      };
    });
  }

  function openBidPdfExportModal(opts) {
    opts = opts || {};
    return new Promise(function (resolve) {
      var existing = document.getElementById('opora-bid-pdf-mode-modal');
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

      var formRoot = opts.formRoot;
      var nameEl = formRoot && formRoot.querySelector('[data-calc-field="facility_name"]');
      var currentName = nameEl ? String(nameEl.value || '').trim() : '';

      var wrap = document.createElement('div');
      wrap.id = 'opora-bid-pdf-mode-modal';
      wrap.className = 'calc-d4-email-modal calc-d4-pdf-mode-modal';
      wrap.innerHTML =
        '<button type="button" class="calc-d4-email-modal__backdrop" data-pdf-mode-close aria-label="Close"></button>' +
        '<div class="calc-d4-email-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="calc-pdf-mode-title">' +
          '<form class="calc-d4-capture-form calc-d4-capture-form--modal" data-pdf-mode-form>' +
            '<p class="calc-d4-capture-email-label" id="calc-pdf-mode-title">Download Bid PDF</p>' +
            '<p class="calc-d4-pdf-mode-lead">Choose the audience for this export. Client sheets hide margin, burden, and cost-to-serve.</p>' +
            '<label class="calc-d4-pdf-mode-option">' +
              '<input type="radio" name="pdf_mode" value="client" checked>' +
              '<span><strong>Client Proposal Summary</strong>' +
              '<em>Annual/monthly investment, scope, APPA frequency — proprietary costs hidden</em></span>' +
            '</label>' +
            '<label class="calc-d4-pdf-mode-option">' +
              '<input type="radio" name="pdf_mode" value="internal">' +
              '<span><strong>Internal Estimating Worksheet</strong>' +
              '<em>Full cost stack, margin protection, crew sizing — contractor eyes only</em></span>' +
            '</label>' +
            '<label class="calc-d4-capture-email-label" for="calc-pdf-facility-name">Account / building name</label>' +
            '<input id="calc-pdf-facility-name" class="d4-f-input" type="text" name="facility_name" ' +
              'placeholder="e.g. Pacific Center Building B" value="' + esc(currentName) + '" autocomplete="organization" required>' +
            '<p class="calc-d4-pdf-mode-hint" data-pdf-name-hint hidden>Enter the account or building name before exporting.</p>' +
            '<div class="calc-d4-email-modal__actions">' +
              '<button type="button" class="calc-d4-capture-email-cancel" data-pdf-mode-close>Cancel</button>' +
              '<button type="submit" class="calc-d4-capture-email-send">Download PDF</button>' +
            '</div>' +
          '</form>' +
        '</div>';

      document.body.appendChild(wrap);
      document.documentElement.classList.add('calc-d4-email-modal-open');

      function close(result) {
        document.documentElement.classList.remove('calc-d4-email-modal-open');
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        resolve(result || null);
      }

      wrap.querySelectorAll('[data-pdf-mode-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { close(null); });
      });
      var form = wrap.querySelector('[data-pdf-mode-form]');
      var hint = wrap.querySelector('[data-pdf-name-hint]');
      var nameInput = wrap.querySelector('#calc-pdf-facility-name');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var name = nameInput ? String(nameInput.value || '').trim() : '';
          if (!name) {
            if (hint) hint.hidden = false;
            if (nameInput) nameInput.focus();
            return;
          }
          var modeInput = form.querySelector('input[name="pdf_mode"]:checked');
          close({
            mode: modeInput ? modeInput.value : 'client',
            facilityName: name
          });
        });
      }
      if (nameInput) setTimeout(function () { nameInput.focus(); }, 30);
    });
  }

  function exportCalcPdf(opts) {
    var panel = opts.panel;
    if (!panel || !panel.classList.contains('d4-visible') || !panel.dataset.lastResult) {
      toastPdf('Calculate a result first, then download PDF.', 'info');
      return Promise.resolve(false);
    }

    var last = {};
    try { last = JSON.parse(panel.dataset.lastResult || '{}') || {}; } catch (eParse) { last = {}; }

    // Re-bind from live form so letter + audit table match inputs (never stale placeholder).
    if (typeof opts.calculate === 'function' && opts.fields && opts.formRoot) {
      try {
        var liveInputs = collectInputs(opts.formRoot, opts.fields);
        var fresh = opts.calculate(liveInputs);
        if (fresh && fresh.valid) last = fresh;
      } catch (eFresh) { /* keep lastResult */ }
    }

    var model = collectCalcPdfModel({
      title: opts.title || 'Opora Calculator',
      slug: opts.slug,
      fields: opts.fields,
      formRoot: opts.formRoot,
      result: last,
      srcUrl: global.location.href,
      pdfMode: opts.pdfMode || ''
    });

    toastPdf('Downloading PDF…', 'success');
    return ensureJsPdf().then(function (jsPDF) {
      writeCalcJsPdf(jsPDF, model);
      try {
        if (typeof global.gtag === 'function') {
          global.gtag('event', 'calc_pdf_download', {
            tool: opts.slug || 'calculator',
            engine: 'jspdf',
            pdf_mode: opts.pdfMode || 'default'
          });
        }
      } catch (eG) { /* noop */ }
      return true;
    }).catch(function (err) {
      toastPdf((err && err.message) || 'PDF download failed. Please try again.', 'error');
      return false;
    });
  }

  function defaultHandoffs(slug) {
    var HUB_PRIORITY = {
      'win-bid': ['bill-rate-calculator', '1099-vs-w2-calculator', 'bid-generator', 'bid-stress-test', 'cleaning-bid-benchmarks', 'per-clean-vs-hourly'],
      'run-ops': ['production-rate-calculator', 'dilution-calculator', 'chemical-compatibility', 'restroom-time-calculator', 'floor-program-builder'],
      manage: ['account-profitability-auditor', 'day-porter-roi', 'appa-inspection-report', 'client-onboarding-checklist'],
      profit: ['job-costing-calculator', 'equipment-roi-calculator', 'tco-calculator', 'churn-cost-calculator', 'robot-roi-matcher'],
      compliance: ['voc-compliance', 'epa-list-n-matcher', 'sales-tax-calculator', 'pfas-state-lookup', 'sds-finder']
    };
    var SLUG_HUB = {
      'bid-generator': 'win-bid', 'bid-stress-test': 'win-bid', 'cleaning-bid-benchmarks': 'win-bid',
      'per-clean-vs-hourly': 'win-bid', 'bill-rate-calculator': 'win-bid', 'federal-rfp-filter': 'win-bid',
      'price-increase-letter': 'win-bid', 'sales-script-picker': 'win-bid', 'independent-contractor-agreement': 'win-bid',
      '1099-vs-w2-calculator': 'win-bid',
      'production-rate-calculator': 'run-ops', 'chemical-compatibility': 'run-ops', 'dilution-calculator': 'run-ops',
      'floor-program-builder': 'run-ops', 'pad-selector': 'run-ops', 'ppe-selector': 'run-ops',
      'restroom-time-calculator': 'run-ops', 'issa-447-lookup': 'run-ops',
      'appa-inspection-report': 'manage', 'client-onboarding-checklist': 'manage',
      'account-profitability-auditor': 'manage', 'day-porter-roi': 'manage',
      'tco-calculator': 'profit', 'equipment-roi-calculator': 'profit', 'job-costing-calculator': 'profit',
      'churn-cost-calculator': 'profit', 'ebitda-estimator': 'profit', 'robot-roi-matcher': 'profit',
      'equipment-financing-comparator': 'profit', 'franchise-comparison-matrix': 'profit',
      'pfas-state-lookup': 'compliance', 'voc-compliance': 'compliance', 'sales-tax-calculator': 'compliance',
      'epa-list-n-matcher': 'compliance', 'sds-finder': 'compliance', 'insurance-comparison': 'compliance',
      'osha-300-300a-log': 'compliance', 'tax-deduction-finder': 'compliance', 'union-contract-lookup': 'compliance'
    };
    var TITLES = {
      'bill-rate-calculator': 'Bill Rate Calculator',
      '1099-vs-w2-calculator': '1099 vs W-2 Calculator',
      'bid-generator': 'Bid Generator',
      'bid-stress-test': 'Bid Stress-Test',
      'cleaning-bid-benchmarks': 'Cleaning Bid Benchmarks',
      'per-clean-vs-hourly': 'Per-Clean vs Hourly',
      'job-costing-calculator': 'Job Costing Calculator',
      'production-rate-calculator': 'Production Rate Calculator',
      'dilution-calculator': 'Dilution Calculator',
      'chemical-compatibility': 'Chemical Compatibility',
      'restroom-time-calculator': 'Restroom Time Calculator',
      'floor-program-builder': 'Floor Care Program Builder',
      'pad-selector': 'Floor Pad Selector',
      'account-profitability-auditor': 'Account Profitability Auditor',
      'day-porter-roi': 'Day Porter vs Night Crew ROI',
      'appa-inspection-report': 'APPA Inspection Report',
      'client-onboarding-checklist': 'Client Onboarding Checklist',
      'equipment-roi-calculator': 'Equipment ROI Calculator',
      'tco-calculator': '5-Year TCO Calculator',
      'churn-cost-calculator': 'Churn Cost Calculator',
      'robot-roi-matcher': 'Robot ROI Matcher',
      'voc-compliance': 'VOC Compliance Lookup',
      'epa-list-n-matcher': 'EPA List N Matcher',
      'sales-tax-calculator': 'Sales Tax Calculator',
      'pfas-state-lookup': 'PFAS State Lookup',
      'sds-finder': 'SDS Finder'
    };
    var hub = SLUG_HUB[slug];
    var priority = HUB_PRIORITY[hub] || [];
    return priority.filter(function (s) { return s !== slug; }).slice(0, 3).map(function (s) {
      return {
        label: TITLES[s] || s,
        url: '/pages/' + s,
        description: ''
      };
    });
  }

  function resolveHandoffs(def, meta, slug) {
    var wc = getWcMeta(slug);
    var primaryUrl = wc && wc.primary && wc.primary.url ? wc.primary.url : '';
    var raw = def.handoffs || meta.handoffs || [];
    var filtered = raw.filter(function (h) {
      if (!h || !h.url) return false;
      var label = String(h.label || '').toLowerCase();
      if (primaryUrl && h.url === primaryUrl) return false;
      return h.url !== '/pages/tools' &&
        h.url.indexOf('/pages/tools?') !== 0 &&
        label.indexOf('all opora tools') === -1 &&
        label !== 'ask opora';
    });
    if (filtered.length) return filtered.slice(0, 3);
    return defaultHandoffs(slug).filter(function (h) {
      return !primaryUrl || h.url !== primaryUrl;
    });
  }

  var SLUG_ALIASES = {
    'dilution': 'dilution-calculator',
    'ppe': 'ppe-selector',
    'pad': 'pad-selector',
    'bill-rate': 'bill-rate-calculator',
    'churn-cost': 'churn-cost-calculator'
  };

  function resolveSlug(raw) {
    return SLUG_ALIASES[raw] || raw;
  }

  function mount(container) {
    if (container.classList.contains('opora-calc-mounted')) return;

    var slug = resolveSlug(container.getAttribute('data-slug') || container.getAttribute('data-tool'));
    var def = registry[slug];
    if (!def) {
      container.innerHTML = '<p class="d4-error-panel d4-visible">Calculator not found: ' + esc(slug) + '</p>';
      return;
    }

    var metaEl = document.querySelector('meta[name="opora:tool-slug"]');
    if (metaEl) metaEl.setAttribute('content', slug);

    var prefill = parsePrefill();
    var meta = def.d4 || {};
    var wc = getWcMeta(slug);
    var lead = (wc && (wc.outcome || wc.agree)) || HAND_LEADS[slug] || '';
    var toolTitle = def.title;
    var handoffs = resolveHandoffs(def, meta, slug);
    var basicFields = def.fields.filter(function (f) { return !f.advanced; });
    var advFields = def.fields.filter(function (f) { return f.advanced; });
    var isGenerator = def.kind === 'generator';
    var actionLabel = def.actionLabel || (isGenerator ? 'Generate' : 'Calculate');

    // Progressive enhance: keep Liquid SSR only when hand-shell markup is present.
    // Old classic D4 SSR (trust strip + rail) is rebuilt so draft matches hand prototypes.
    var ssrShell = container.querySelector('[data-calc-ssr-ready="' + slug + '"]');
    var ssrAttr = container.getAttribute('data-ssr-ready');
    var hasHandShell = !!(container.querySelector('.d4-hand-shell') ||
      (ssrShell && ssrShell.classList.contains('d4-wrap--hand')));
    var useSsr = hasHandShell && (
      !!(ssrShell && container.querySelector('[data-calc-form]')) ||
      (ssrAttr === slug && container.querySelector('[data-calc-form]'))
    );

    if (!useSsr) {
      var formHtml = buildFormRows(basicFields, prefill, meta.basicSection || 'Inputs', slug);
      if (def.ratioChips && def.ratioChips.length) {
        var ratioChipsHtml = (def.ratioChips || []).map(function (r) {
          return '<button type="button" class="calc-d4-ratio-chip" data-ratio-chip="' + r +
            '" data-ratio-target="' + esc(def.ratioChipTarget || 'ratio_str') + '">1:' + r + '</button>';
        }).join('');
        formHtml += '<div class="d4-form-row calc-d4-ratio-chips-section">' +
          '<div class="calc-d4-ratio-chips" role="group" aria-label="Suggested ratios">' +
          ratioChipsHtml + '</div></div>';
      }
      if (def.containerPresets && def.containerPresets.length) {
        var containerChipsHtml = (def.containerPresets || []).map(function (p) {
          return '<button type="button" class="calc-d4-ratio-chip calc-d4-container-chip" data-container-size="' +
            esc(p.size) + '" data-container-unit="' + esc(p.unit) + '">' + esc(p.label) + '</button>';
        }).join('');
        formHtml += '<div class="d4-form-row calc-d4-ratio-chips-section calc-d4-container-presets-section">' +
          '<div class="calc-d4-ratio-chips" role="group" aria-label="Common containers">' +
          containerChipsHtml + '</div></div>';
      }
      if (advFields.length) {
        formHtml +=
          '<div class="calc-d4-advanced-bar">' +
            '<button type="button" class="calc-d4-advanced-toggle" data-adv-toggle aria-expanded="false">' +
              '<span class="calc-d4-advanced-chevron" aria-hidden="true">▾</span>' +
              '<span>Advanced options</span>' +
              '<span class="calc-d4-advanced-count">' + advFields.length + ' fields</span>' +
            '</button>' +
          '</div>' +
          '<div class="calc-d4-advanced calc-d4-advanced--hidden" data-adv-panel>' +
            '<div class="d4-form-row calc-d4-advanced-fields">' +
              buildAdvFieldsHtml(slug, advFields, prefill) +
            '</div>' +
          '</div>';
      }

      container.innerHTML =
        '<div class="d4-wrap d4-wrap--hand" data-theme="light">' +
          '<div class="d4-hand-shell">' +
            '<header class="d4-hand-intro">' +
              '<h1 class="d4-tool-headline">' + esc(toolTitle) + '</h1>' +
              (lead ? '<p class="d4-hand-lead">' + esc(lead) + '</p>' : '') +
            '</header>' +
            '<div class="d4-hand-work">' +
              '<section class="d4-hand-panel">' +
                '<div class="d4-form-card" data-calc-form>' +
                  '<div class="d4-card-h">Inputs</div>' +
                  formHtml +
                  '<div class="d4-cta-row">' +
                    '<button class="d4-btn-run" type="button" data-calc-run>' +
                      '<span>' + esc(actionLabel) + '</span>' +
                    '</button>' +
                    '<button type="button" class="calc-d4-reset-link" data-calc-reset>Reset defaults</button>' +
                  '</div>' +
                '</div>' +
                '<div class="d4-error-panel" data-calc-error></div>' +
              '</section>' +
              '<aside class="d4-hand-out">' +
                '<section class="d4-result-panel d4-visible calc-d4-result--example" data-calc-result aria-live="polite">' +
                  '<div class="d4-card-h">Your result</div>' +
                  '<div class="d4-result-header">' +
                    '<span class="d4-result-tag" data-result-tag>Sample preview</span>' +
                    '<span class="d4-result-sub" data-result-sub>Example from defaults — tap Calculate for yours</span>' +
                  '</div>' +
                  '<div class="calc-d4-result-body" data-calc-body></div>' +
                  captureRowHtml(slug) +
                '</section>' +
              '</aside>' +
            '</div>' +
            afterBandHtml(handoffs) +
          '</div>' +
        '</div>';
    } else if (Object.keys(prefill).length) {
      // Apply ?prefill= onto the existing SSR fields.
      def.fields.forEach(function (f) {
        if (prefill[f.id] === undefined) return;
        var el = container.querySelector('[data-calc-field="' + f.id + '"]');
        if (!el) return;
        if (f.type === 'checkbox') el.checked = !!prefill[f.id];
        else el.value = prefill[f.id];
      });
    }

    container.classList.add('opora-calc-mounted');

    var root = container;
    normalizeHandShell(root);
    applyWcIntro(root, slug, def);
    ensureCardHeaders(root);
    ensureAfterBand(root, handoffs);
    var formCard = root.querySelector('[data-calc-form]');
    var chipRow = root.querySelector('[data-calc-chips]');
    var errPanel = root.querySelector('[data-calc-error]');
    var panel = root.querySelector('[data-calc-result]');
    var body = root.querySelector('[data-calc-body]');

    // Price Increase Letter: rebuild form from live defs (SSR lags reason options + Advanced)
    if (slug === 'price-increase-letter' && formCard) {
      var pilCta = formCard.querySelector('.d4-cta-row');
      var pilCtaHtml = pilCta ? pilCta.outerHTML : '';
      var pilHead = formCard.querySelector('.d4-card-h');
      var pilHeadHtml = pilHead ? pilHead.outerHTML : '<div class="d4-card-h">Inputs</div>';
      var pilForm = buildFormRows(basicFields, prefill, meta.basicSection || 'Inputs', slug);
      if (advFields.length) {
        pilForm +=
          '<div class="calc-d4-advanced-bar">' +
            '<button type="button" class="calc-d4-advanced-toggle" data-adv-toggle aria-expanded="false">' +
              '<span class="calc-d4-advanced-chevron" aria-hidden="true">▾</span>' +
              '<span>Advanced options</span>' +
              '<span class="calc-d4-advanced-count">' + advFields.length + ' fields</span>' +
            '</button>' +
          '</div>' +
          '<div class="calc-d4-advanced calc-d4-advanced--hidden" data-adv-panel>' +
            '<div class="d4-form-row calc-d4-advanced-fields">' +
              buildAdvFieldsHtml(slug, advFields, prefill) +
            '</div>' +
          '</div>';
      }
      formCard.innerHTML = pilHeadHtml + pilForm + pilCtaHtml;
    }

    // Sales Script Picker: rebuild so Target contact role + price-band hint appear (SSR lags)
    if (slug === 'sales-script-picker' && formCard) {
      var sspCta = formCard.querySelector('.d4-cta-row');
      var sspCtaHtml = sspCta ? sspCta.outerHTML : '';
      var sspHead = formCard.querySelector('.d4-card-h');
      var sspHeadHtml = sspHead ? sspHead.outerHTML : '<div class="d4-card-h">Inputs</div>';
      var sspForm = buildFormRows(basicFields, prefill, meta.basicSection || 'Inputs', slug);
      if (advFields.length) {
        sspForm +=
          '<div class="calc-d4-advanced-bar">' +
            '<button type="button" class="calc-d4-advanced-toggle" data-adv-toggle aria-expanded="false">' +
              '<span class="calc-d4-advanced-chevron" aria-hidden="true">▾</span>' +
              '<span>Advanced options</span>' +
              '<span class="calc-d4-advanced-count">' + advFields.length + ' fields</span>' +
            '</button>' +
          '</div>' +
          '<div class="calc-d4-advanced calc-d4-advanced--hidden" data-adv-panel>' +
            '<div class="d4-form-row calc-d4-advanced-fields">' +
              buildAdvFieldsHtml(slug, advFields, prefill) +
            '</div>' +
          '</div>';
      }
      formCard.innerHTML = sspHeadHtml + sspForm + sspCtaHtml;
    }

    // Independent Contractor Agreement: rebuild expanded field architecture over SSR
    if (slug === 'independent-contractor-agreement' && formCard) {
      var icaCta = formCard.querySelector('.d4-cta-row');
      var icaCtaHtml = icaCta ? icaCta.outerHTML : '';
      var icaHead = formCard.querySelector('.d4-card-h');
      var icaHeadHtml = icaHead ? icaHead.outerHTML : '<div class="d4-card-h">Inputs</div>';
      var icaForm = buildFormRows(basicFields, prefill, meta.basicSection || 'Inputs', slug);
      if (advFields.length) {
        icaForm +=
          '<div class="calc-d4-advanced-bar">' +
            '<button type="button" class="calc-d4-advanced-toggle" data-adv-toggle aria-expanded="false">' +
              '<span class="calc-d4-advanced-chevron" aria-hidden="true">▾</span>' +
              '<span>Advanced options</span>' +
              '<span class="calc-d4-advanced-count">' + advFields.length + ' fields</span>' +
            '</button>' +
          '</div>' +
          '<div class="calc-d4-advanced calc-d4-advanced--hidden" data-adv-panel>' +
            '<div class="d4-form-row calc-d4-advanced-fields">' +
              buildAdvFieldsHtml(slug, advFields, prefill) +
            '</div>' +
          '</div>';
      }
      formCard.innerHTML = icaHeadHtml + icaForm + icaCtaHtml;
    }

    // Chemical Compatibility: Advanced concentration / surface / air over 2-field SSR
    if (slug === 'chemical-compatibility' && formCard) {
      var ccCta = formCard.querySelector('.d4-cta-row');
      var ccCtaHtml = ccCta ? ccCta.outerHTML : '';
      var ccHead = formCard.querySelector('.d4-card-h');
      var ccHeadHtml = ccHead ? ccHead.outerHTML : '<div class="d4-card-h">Inputs</div>';
      var ccForm = buildFormRows(basicFields, prefill, meta.basicSection || 'Chemistry pair', slug);
      if (advFields.length) {
        ccForm +=
          '<div class="calc-d4-advanced-bar">' +
            '<button type="button" class="calc-d4-advanced-toggle" data-adv-toggle aria-expanded="false">' +
              '<span class="calc-d4-advanced-chevron" aria-hidden="true">▾</span>' +
              '<span>Advanced options</span>' +
              '<span class="calc-d4-advanced-count">' + advFields.length + ' fields</span>' +
            '</button>' +
          '</div>' +
          '<div class="calc-d4-advanced calc-d4-advanced--hidden" data-adv-panel>' +
            '<div class="d4-form-row calc-d4-advanced-fields">' +
              buildAdvFieldsHtml(slug, advFields, prefill) +
            '</div>' +
          '</div>';
      }
      formCard.innerHTML = ccHeadHtml + ccForm + ccCtaHtml;
    }

    // Equipment TCO: rebuild so finance interest / term / lease appear over SSR lag
    if (slug === 'tco-calculator' && formCard) {
      var tcoCta = formCard.querySelector('.d4-cta-row');
      var tcoCtaHtml = tcoCta ? tcoCta.outerHTML : '';
      var tcoHead = formCard.querySelector('.d4-card-h');
      var tcoHeadHtml = tcoHead ? tcoHead.outerHTML : '<div class="d4-card-h">Inputs</div>';
      var tcoForm = buildFormRows(basicFields, prefill, meta.basicSection || 'Inputs', slug);
      if (advFields.length) {
        tcoForm +=
          '<div class="calc-d4-advanced-bar">' +
            '<button type="button" class="calc-d4-advanced-toggle" data-adv-toggle aria-expanded="false">' +
              '<span class="calc-d4-advanced-chevron" aria-hidden="true">▾</span>' +
              '<span>Advanced options</span>' +
              '<span class="calc-d4-advanced-count">' + advFields.length + ' fields</span>' +
            '</button>' +
          '</div>' +
          '<div class="calc-d4-advanced calc-d4-advanced--hidden" data-adv-panel>' +
            '<div class="d4-form-row calc-d4-advanced-fields">' +
              buildAdvFieldsHtml(slug, advFields, prefill) +
            '</div>' +
          '</div>';
      }
      formCard.innerHTML = tcoHeadHtml + tcoForm + tcoCtaHtml;
    }

    // Insurance Comparison: rebuild so EMR text field shows "1.00" over SSR number lag
    if (slug === 'insurance-comparison' && formCard) {
      var insCta = formCard.querySelector('.d4-cta-row');
      var insCtaHtml = insCta ? insCta.outerHTML : '';
      var insHead = formCard.querySelector('.d4-card-h');
      var insHeadHtml = insHead ? insHead.outerHTML : '<div class="d4-card-h">Inputs</div>';
      if (prefill.wc_mod === undefined || prefill.wc_mod === null || prefill.wc_mod === '') {
        prefill.wc_mod = '1.00';
      } else {
        var insModN = Number(prefill.wc_mod);
        if (isFinite(insModN)) prefill.wc_mod = insModN.toFixed(2);
      }
      var insForm = buildFormRows(basicFields, prefill, meta.basicSection || 'Inputs', slug);
      if (advFields.length) {
        insForm +=
          '<div class="calc-d4-advanced-bar">' +
            '<button type="button" class="calc-d4-advanced-toggle" data-adv-toggle aria-expanded="false">' +
              '<span class="calc-d4-advanced-chevron" aria-hidden="true">▾</span>' +
              '<span>Advanced options</span>' +
              '<span class="calc-d4-advanced-count">' + advFields.length + ' fields</span>' +
            '</button>' +
          '</div>' +
          '<div class="calc-d4-advanced calc-d4-advanced--hidden" data-adv-panel>' +
            '<div class="d4-form-row calc-d4-advanced-fields">' +
              buildAdvFieldsHtml(slug, advFields, prefill) +
            '</div>' +
          '</div>';
      }
      formCard.innerHTML = insHeadHtml + insForm + insCtaHtml;
    }

    // Floor Program Builder: Advanced equipment/zone/cadence + substrate finish sync
    if (slug === 'floor-program-builder' && formCard) {
      var fpCta = formCard.querySelector('.d4-cta-row');
      var fpCtaHtml = fpCta ? fpCta.outerHTML : '';
      var fpHead = formCard.querySelector('.d4-card-h');
      var fpHeadHtml = fpHead ? fpHead.outerHTML : '<div class="d4-card-h">Inputs</div>';
      var fpForm = buildFormRows(basicFields, prefill, meta.basicSection || 'Floor & traffic', slug);
      if (advFields.length) {
        fpForm +=
          '<div class="calc-d4-advanced-bar">' +
            '<button type="button" class="calc-d4-advanced-toggle" data-adv-toggle aria-expanded="false">' +
              '<span class="calc-d4-advanced-chevron" aria-hidden="true">▾</span>' +
              '<span>Advanced options</span>' +
              '<span class="calc-d4-advanced-count">' + advFields.length + ' fields</span>' +
            '</button>' +
          '</div>' +
          '<div class="calc-d4-advanced calc-d4-advanced--hidden" data-adv-panel>' +
            '<div class="d4-form-row calc-d4-advanced-fields">' +
              buildAdvFieldsHtml(slug, advFields, prefill) +
            '</div>' +
          '</div>';
      }
      formCard.innerHTML = fpHeadHtml + fpForm + fpCtaHtml;
    }

    // Pad Selector: rebuild so Advanced lubrication / head-pressure appear over SSR lag
    if (slug === 'pad-selector' && formCard && advFields.length) {
      var padCta = formCard.querySelector('.d4-cta-row');
      var padCtaHtml = padCta ? padCta.outerHTML : '';
      var padHead = formCard.querySelector('.d4-card-h');
      var padHeadHtml = padHead ? padHead.outerHTML : '<div class="d4-card-h">Inputs</div>';
      var padForm = buildFormRows(basicFields, prefill, meta.basicSection || 'Floor, task & machine', slug);
      padForm +=
        '<div class="calc-d4-advanced-bar">' +
          '<button type="button" class="calc-d4-advanced-toggle" data-adv-toggle aria-expanded="false">' +
            '<span class="calc-d4-advanced-chevron" aria-hidden="true">▾</span>' +
            '<span>Advanced options</span>' +
            '<span class="calc-d4-advanced-count">' + advFields.length + ' fields</span>' +
          '</button>' +
        '</div>' +
        '<div class="calc-d4-advanced calc-d4-advanced--hidden" data-adv-panel>' +
          '<div class="d4-form-row calc-d4-advanced-fields">' +
            buildAdvFieldsHtml(slug, advFields, prefill) +
          '</div>' +
        '</div>';
      formCard.innerHTML = padHeadHtml + padForm + padCtaHtml;
    }

    var advToggle = root.querySelector('[data-adv-toggle]');
    var advPanel = root.querySelector('[data-adv-panel]');
    if (advToggle && advPanel) {
      advToggle.addEventListener('click', function () {
        var open = advPanel.classList.toggle('calc-d4-advanced--hidden');
        advToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        advToggle.classList.toggle('calc-d4-advanced-toggle--open', !open);
      });
    }

    ensureCaptureUi(root, formCard, panel, slug);
    stripCalcActionBars(root);
    bindStickyResult(root);
    root.querySelectorAll('[data-calc-live-badge]').forEach(function (el) { el.remove(); });

    // Production Rate: always rebuild Advanced from field defs (SSR can lag labels/layout)
    if (slug === 'production-rate-calculator' && advPanel) {
      var advHost = advPanel.querySelector('.calc-d4-advanced-fields') || advPanel;
      advHost.innerHTML = buildAdvFieldsHtml(slug, advFields, prefill);
      var laborEl = formCard.querySelector('[data-calc-field="labor_burden"]');
      if (laborEl) {
        if (laborEl.value === '0') laborEl.value = '';
        if (!laborEl.getAttribute('placeholder')) {
          laborEl.setAttribute('placeholder', 'Optional — set in Bill Rate');
        }
      }
      wireProductionModePanels(formCard);
    }

    if (slug === 'bid-generator' && advPanel) {
      var bidAdvHost = advPanel.querySelector('.calc-d4-advanced-fields') || advPanel;
      if (!bidAdvHost.querySelector('[data-surface-mix-card]') ||
          !bidAdvHost.querySelector('[data-burden-decompose]')) {
        bidAdvHost.innerHTML = buildAdvFieldsHtml(slug, advFields, prefill);
      }
      wireBidFacilitySurfaceMix(formCard);
      wireBidFixturesBlankTip(formCard);
    }

    wireFieldInfoTips(formCard);
    wireFieldVisibility(formCard, def.fields);
    if (slug === 'floor-program-builder') {
      wireFloorFinishOptions(formCard);
    }
    if (slug === 'pad-selector') {
      wirePadFinishOptions(formCard);
    }

    if (def.mixPctFields && def.mixPctFields.length) {
      wireMixPctTotal(formCard, def.mixPctFields);
    }
    var confirmed = false;
    var sampleFields = wireSampleFieldDefaults(root);

    if (slug === 'bid-generator') {
      wireBidWageFloor(formCard, { sampleFields: sampleFields });
      wireBidConsumableWarn(formCard);
      wireBidBurdenDecompose(formCard, {
        sampleFields: sampleFields,
        onApply: function () {
          if (confirmed) run({ record: false });
        }
      });
    }
    if (slug === 'bill-rate-calculator') {
      wireBillRateNyDownstateNote(formCard);
    }

    // Union Contract Lookup: locality options depend on selected state + mode
    function wageFloorDataset(mode) {
      var m = String(mode || 'cba').toLowerCase();
      if (m === 'sca') return def.scaData || [];
      if (m === 'market') return def.marketData || [];
      return def.unionData || [];
    }

    function syncUnionModeDefault() {
      var stateEl = formCard.querySelector('[data-calc-field="state"]');
      var modeEl = formCard.querySelector('[data-calc-field="mode"]');
      if (!stateEl || !modeEl) return;
      var st = stateEl.value;
      var hasCba = (def.unionData || []).some(function (u) { return u.state === st; });
      var hasSca = (def.scaData || []).some(function (u) { return u.state === st; });
      var hasMkt = (def.marketData || []).some(function (u) { return u.state === st; });
      var next = hasCba ? 'cba' : hasSca ? 'sca' : hasMkt ? 'market' : modeEl.value;
      if (next && modeEl.value !== next) modeEl.value = next;
    }

    function syncUnionLocalityOptions(preferred) {
      var stateEl = formCard.querySelector('[data-calc-field="state"]');
      var locEl = formCard.querySelector('[data-calc-field="locality"]');
      var modeEl = formCard.querySelector('[data-calc-field="mode"]');
      if (!stateEl || !locEl || locEl.tagName !== 'SELECT') return;
      var mode = modeEl ? modeEl.value : 'cba';
      var locs = wageFloorDataset(mode).filter(function (u) { return u.state === stateEl.value; });
      var want = preferred != null ? preferred : locEl.value;
      if (!locs.length) {
        locEl.innerHTML = '<option value="">No localities in dataset</option>';
        locEl.value = '';
        updateUnionLookupEnabled();
        return;
      }
      locEl.innerHTML = locs.map(function (u) {
        return '<option value="' + esc(u.locality) + '">' + esc(u.locality) + '</option>';
      }).join('');
      var match = locs.some(function (u) { return u.locality === want; });
      locEl.value = match ? want : locs[0].locality;
      updateUnionLookupEnabled();
    }

    function updateUnionLookupEnabled() {
      if (slug !== 'union-contract-lookup') return;
      var runBtnLocal = root.querySelector('[data-calc-run]');
      var locEl = formCard.querySelector('[data-calc-field="locality"]');
      var ok = !!(locEl && String(locEl.value || '').trim());
      if (runBtnLocal) {
        runBtnLocal.disabled = !ok;
        runBtnLocal.setAttribute('aria-disabled', ok ? 'false' : 'true');
      }
    }

    function run(opts) {
      // Keep locality options aligned with state before reading inputs (avoids change-event races).
      if (slug === 'union-contract-lookup') {
        var locElPre = formCard.querySelector('[data-calc-field="locality"]');
        syncUnionLocalityOptions(locElPre ? locElPre.value : null);
        updateUnionLookupEnabled();
        var locNow = formCard.querySelector('[data-calc-field="locality"]');
        if (locNow && !String(locNow.value || '').trim()) {
          clearInvalidCalcResult(panel, root);
          errPanel.textContent = 'Select a locality with sample data before looking up.';
          errPanel.classList.add('d4-visible');
          return;
        }
      }
      var inputs = collectInputs(formCard, def.fields);
      var result = def.calculate(inputs);
      renderResults(body, errPanel, panel, result, def, slug);
      if (result && result.valid) {
        applySyncFields(formCard, result.syncFields);
        if (slug === 'union-contract-lookup' && result.syncFields && result.syncFields.mode) {
          syncUnionLocalityOptions(null);
        }
      }
      updateChips(chipRow, def.fields, formCard);
      bindBidRangeBar(body, formCard, function (info) {
        run({ record: !!(info && info.record) || confirmed, scroll: false });
      });
      if (body) {
        body.querySelectorAll('[data-apply-field][data-apply-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var fid = btn.getAttribute('data-apply-field');
            var val = btn.getAttribute('data-apply-value');
            var el = formCard && formCard.querySelector('[data-calc-field="' + fid + '"]');
            if (!el) return;
            el.value = val;
            // Ensure advanced panel is open so the corrected rate is visible
            if (advPanel && advPanel.classList.contains('calc-d4-advanced--hidden') && advToggle) {
              advPanel.classList.remove('calc-d4-advanced--hidden');
              advToggle.setAttribute('aria-expanded', 'true');
              advToggle.classList.add('calc-d4-advanced-toggle--open');
            }
            run({ record: confirmed, scroll: false });
          });
        });
        // Price Increase Letter: notice-period quick-set → rewrite effective_date
        body.querySelectorAll('[data-notice-days]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var days = parseInt(btn.getAttribute('data-notice-days') || '0', 10);
            var el = formCard && formCard.querySelector('[data-calc-field="effective_date"]');
            if (!el || !days) return;
            var d = new Date();
            d.setDate(d.getDate() + days);
            var mm = String(d.getMonth() + 1);
            var dd = String(d.getDate());
            if (mm.length < 2) mm = '0' + mm;
            if (dd.length < 2) dd = '0' + dd;
            el.value = mm + '/' + dd + '/' + d.getFullYear();
            run({ record: confirmed, scroll: false });
          });
        });
      }
      if (result.valid) {
        if (opts && opts.record) {
          confirmed = true;
          sampleFields.clearAll();
          setResultExampleMode(panel, false, root);
          logCalcRun(root, slug, true);
          // Calcs use result-panel email/Save capture (after aha) — never mount Save/Export/More bars.
          stripCalcActionBars(root);
        } else if (!confirmed) {
          setResultExampleMode(panel, true, root);
        } else {
          setResultExampleMode(panel, false, root);
        }
        // Script picker: keep PDF / Save / Email available once beats are on screen
        if (result.layout === 'script') {
          var scriptCap = root.querySelector('[data-calc-capture]');
          if (scriptCap) scriptCap.hidden = false;
        }
        if (opts && opts.scroll && panel) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      } else {
        if (!(result && result.resultHint)) clearInvalidCalcResult(panel, root);
      }
    }

    // Hard sample gate: defaults sample stays until Calculate; then live-sync "yours" without re-logging.
    function liveRecalc(e) {
      if (!confirmed) return;
      if (!e.target || !e.target.matches || !e.target.matches('[data-calc-field]')) return;
      clearTimeout(container._otTimer);
      container._otTimer = setTimeout(function () {
        run({ record: false });
      }, 80);
    }
    root.addEventListener('input', liveRecalc, true);
    root.addEventListener('change', liveRecalc, true);

    var runBtn = root.querySelector('[data-calc-run]');
    if (runBtn) {
      runBtn.addEventListener('click', function () {
        run({ record: true, scroll: true });
      });
    }
    var resetBtn = root.querySelector('[data-calc-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        def.fields.forEach(function (f) {
          var el = formCard.querySelector('[data-calc-field="' + f.id + '"]');
          if (!el) return;
          if (f.type === 'checkbox') el.checked = !!f.default;
          else el.value = f.default !== undefined ? f.default : '';
        });
        var locField = def.fields.find(function (f) { return f.id === 'locality'; });
        if (slug === 'union-contract-lookup') syncUnionModeDefault();
        syncUnionLocalityOptions(locField && locField.default != null ? locField.default : null);
        if (slug === 'union-contract-lookup') updateUnionLookupEnabled();
        if (slug === 'floor-program-builder') {
          var finishReset = formCard.querySelector('[data-calc-field="finish_status"]');
          if (finishReset) finishReset.removeAttribute('data-floor-family');
          var ftReset = formCard.querySelector('[data-calc-field="floor_type"]');
          if (ftReset) {
            try { ftReset.dispatchEvent(new Event('change', { bubbles: true })); }
            catch (eFp) { /* ignore */ }
          }
        }
        formCard.querySelectorAll('.calc-d4-ratio-chip--active').forEach(function (c) {
          c.classList.remove('calc-d4-ratio-chip--active');
        });
        confirmed = false;
        sampleFields.markAll();
        run({ record: false });
      });
    }

    formCard.querySelectorAll('[data-container-size]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var sizeEl = formCard.querySelector('[data-calc-field="container_size"]');
        var unitEl = formCard.querySelector('[data-calc-field="container_unit"]');
        if (sizeEl) {
          sizeEl.value = chip.getAttribute('data-container-size');
          sampleFields.clearOne(sizeEl);
        }
        if (unitEl) {
          unitEl.value = chip.getAttribute('data-container-unit');
          sampleFields.clearOne(unitEl);
        }
        formCard.querySelectorAll('.calc-d4-container-chip').forEach(function (c) {
          c.classList.toggle('calc-d4-ratio-chip--active', c === chip);
        });
        if (confirmed) run({ record: false });
      });
    });

    formCard.querySelectorAll('[data-ratio-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var target = chip.getAttribute('data-ratio-target') || 'ratio_str';
        var ratio = chip.getAttribute('data-ratio-chip');
        var modeEl = formCard.querySelector('[data-calc-field="dilution_mode"]');
        var ratioEl = formCard.querySelector('[data-calc-field="' + target + '"]');
        if (modeEl) {
          modeEl.value = 'ratio';
          sampleFields.clearOne(modeEl);
        }
        if (ratioEl) {
          ratioEl.value = '1:' + ratio;
          sampleFields.clearOne(ratioEl);
        }
        formCard.querySelectorAll('[data-ratio-chip]').forEach(function (c) {
          c.classList.toggle('calc-d4-ratio-chip--active', c === chip);
        });
        formCard.querySelectorAll('[data-dilution-mode-chip]').forEach(function (c) {
          c.classList.toggle('calc-d4-ratio-chip--active', c.getAttribute('data-dilution-mode-chip') === 'ratio');
        });
        if (confirmed) run({ record: false });
      });
    });

    if (slug === 'dilution-calculator') {
      ensureDilutionModeChips(formCard, sampleFields, function (opts) {
        if (!confirmed) return;
        run(opts || { record: false });
      });
      // Re-sync visibility after mode chips mount
      wireFieldVisibility(formCard, def.fields);
    }

    // Robot ROI: sync catalog list price when model changes
    var robotModelEl = formCard.querySelector('[data-calc-field="robot_model"]');
    var robotCostEl = formCard.querySelector('[data-calc-field="robot_cost"]');
    if (robotModelEl && robotCostEl && def.robots && def.robots.length) {
      robotModelEl.addEventListener('change', function () {
        var m = def.robots.find(function (r) { return r.name === robotModelEl.value; });
        if (m) {
          robotCostEl.value = m.price;
          sampleFields.clearOne(robotCostEl);
        }
      });
    }

    var unionStateEl = formCard.querySelector('[data-calc-field="state"]');
    if (slug === 'union-contract-lookup' && unionStateEl) {
      syncUnionModeDefault();
      syncUnionLocalityOptions(
        (function () {
          var locField = def.fields.find(function (f) { return f.id === 'locality'; });
          return locField && locField.default != null ? locField.default : null;
        })()
      );
      updateUnionLookupEnabled();
      unionStateEl.addEventListener('change', function () {
        syncUnionModeDefault();
        syncUnionLocalityOptions(null);
        var locEl = formCard.querySelector('[data-calc-field="locality"]');
        if (locEl) sampleFields.clearOne(locEl);
      });
      var unionModeEl = formCard.querySelector('[data-calc-field="mode"]');
      if (unionModeEl) {
        unionModeEl.addEventListener('change', function () {
          syncUnionLocalityOptions(null);
          var locEl = formCard.querySelector('[data-calc-field="locality"]');
          if (locEl) sampleFields.clearOne(locEl);
        });
      }
    }

    var pdfBtn = root.querySelector('[data-calc-pdf]');
    var pendingPdfAfterEmail = false;

    function runPdfDownload() {
      function go(mode) {
        return exportCalcPdf({
          panel: panel,
          body: body,
          fields: def.fields,
          formRoot: formCard,
          title: def.title,
          slug: slug,
          calculate: def.calculate,
          pdfMode: mode || ''
        });
      }
      if (slug !== 'bid-generator') return go('');
      return openBidPdfExportModal({ formRoot: formCard }).then(function (choice) {
        if (!choice) return false;
        var facEl = formCard.querySelector('[data-calc-field="facility_name"]');
        if (facEl && choice.facilityName) facEl.value = choice.facilityName;
        return go(choice.mode);
      });
    }

    var emailForm = root.querySelector('[data-email-form]');
    var emailToggle = root.querySelector('[data-calc-email-toggle]');
    var emailPanel = root.querySelector('[data-calc-email-panel]');
    var emailCloseBtns = root.querySelectorAll('[data-calc-email-close]');

    function hideEmailMailtoFallback() {
      if (!emailPanel) return;
      var fb = emailPanel.querySelector('[data-calc-email-fallback]');
      if (fb) fb.hidden = true;
    }

    function showEmailMailtoFallback(mailtoHref) {
      if (!emailPanel || !mailtoHref) return;
      var form = emailPanel.querySelector('[data-email-form]');
      var fb = emailPanel.querySelector('[data-calc-email-fallback]');
      if (!fb && form) {
        fb = document.createElement('p');
        fb.className = 'calc-d4-email-modal__fallback';
        fb.setAttribute('data-calc-email-fallback', '');
        form.appendChild(fb);
      }
      if (!fb) return;
      fb.hidden = false;
      fb.innerHTML =
        'Couldn\u2019t send from Opora. ' +
        '<a href="' + String(mailtoHref).replace(/"/g, '') + '" data-calc-email-mailto>Open in email app</a>';
    }

    function setEmailPanelOpen(open) {
      if (!emailPanel) return;
      emailPanel.hidden = !open;
      if (emailToggle) emailToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      try {
        document.documentElement.classList.toggle('calc-d4-email-modal-open', !!open);
      } catch (eDoc) { /* noop */ }
      if (open) {
        hideEmailMailtoFallback();
        if (emailForm) emailForm.hidden = false;
        var input = emailPanel.querySelector('input[type="email"]');
        if (input) {
          var lead = getCachedLeadEmail();
          if (lead && !input.value) input.value = lead;
          try { input.focus(); } catch (eFocus) { /* noop */ }
        }
      } else {
        hideEmailMailtoFallback();
      }
    }

    function onEmailModalKey(e) {
      if (!emailPanel || emailPanel.hidden) return;
      if (e.key === 'Escape') {
        pendingPdfAfterEmail = false;
        setEmailPanelOpen(false);
      }
    }
    document.addEventListener('keydown', onEmailModalKey);

    if (pdfBtn) {
      pdfBtn.addEventListener('click', function () {
        // Edge parity: signed-in OR remembered lead email → download immediately.
        // Otherwise soft-gate on the Email Copy modal, then download.
        if (isSignedIn() || getCachedLeadEmail()) {
          pendingPdfAfterEmail = false;
          runPdfDownload();
          return;
        }
        if (emailPanel) {
          pendingPdfAfterEmail = true;
          setEmailPanelOpen(true);
          toastPdf('Enter your email to download the PDF.', 'info');
          return;
        }
        runPdfDownload();
      });
    }

    if (emailToggle && emailPanel) {
      emailToggle.addEventListener('click', function () {
        pendingPdfAfterEmail = false;
        setEmailPanelOpen(!!emailPanel.hidden);
      });
    }
    Array.prototype.forEach.call(emailCloseBtns, function (btn) {
      btn.addEventListener('click', function () {
        pendingPdfAfterEmail = false;
        setEmailPanelOpen(false);
      });
    });

    if (emailForm) {
      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = emailForm.querySelector('input[type="email"]');
        var email = input ? String(input.value || '').trim() : '';
        var submitBtn = emailForm.querySelector('button[type="submit"]');
        if (!email || email.indexOf('@') === -1) {
          toastPdf('Enter a valid email address.', 'error');
          return;
        }
        if (!panel || !panel.classList.contains('d4-visible') || !panel.dataset.lastResult) {
          toastPdf('Calculate a result first, then email a copy.', 'info');
          return;
        }

        var last = {};
        try { last = JSON.parse(panel.dataset.lastResult || '{}') || {}; } catch (eParse) { last = {}; }
        var wantPdf = pendingPdfAfterEmail;
        pendingPdfAfterEmail = false;

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sending…';
        }

        emailCalcCopy({
          to: email,
          title: def.title,
          slug: slug,
          result: last,
          fields: def.fields,
          formRoot: formCard,
          calculate: def.calculate,
          srcUrl: global.location.href
        }).then(function (res) {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send';
          }
          // API failure: stay in modal, never surprise-launch Outlook / never force a download.
          if (res && (res.delivery === 'failed' || res.success === false)) {
            showEmailMailtoFallback(res.mailto);
            toastPdf('Couldn\u2019t send the PDF. Use “Open in email app” or Download PDF.', 'info');
            return;
          }
          toastPdf('PDF sent to ' + email, 'success');
          setEmailPanelOpen(false);
          // Soft-gate only: user asked for Download PDF first — honor that once after email.
          if (wantPdf) return runPdfDownload();
        }).catch(function (err) {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send';
          }
          toastPdf((err && err.message) || 'Couldn\u2019t send email. Please try again.', 'error');
          if (wantPdf) runPdfDownload();
        });
      });
    }

    var saveBtn = root.querySelector('[data-save]');
    if (saveBtn) {
      function setSaveLabel(text) {
        var label = saveBtn.querySelector('[data-save-label]');
        if (label) label.textContent = text;
        else if (!saveBtn.querySelector('.calc-d4-capture-btn__icon')) saveBtn.textContent = text;
      }
      function paintSaveIdle() {
        saveBtn.disabled = false;
        setSaveLabel('Save to Library');
      }
      function buildCalcSavePayload() {
        var text = (body && (body.innerText || body.textContent) || '').trim();
        return {
          title: def.title + ' · ' + new Date().toLocaleDateString('en-US'),
          content: text,
          body_markdown: text,
          input_payload: collectInputs(formCard, def.fields),
          metadata: { kind: 'calculator', source: 'calc_export_strip', tool_slug: slug }
        };
      }
      saveBtn.addEventListener('click', function () {
        if (!panel || !panel.classList.contains('d4-visible') || !panel.dataset.lastResult) {
          toastPdf('Calculate a result first, then save.', 'info');
          return;
        }
        var payload = buildCalcSavePayload();
        if (!payload.content || payload.content.length < 10) {
          toastPdf('Nothing to save yet — run Calculate first.', 'info');
          return;
        }

        // Same as SOW Save: in-place Clerk popup; redirect only if OporaAuth missing
        if (!isSignedIn()) {
          function runCalcLibrarySave() {
            if (!global.OporaSave || typeof global.OporaSave.save !== 'function') {
              toastPdf('Save is unavailable right now.', 'error');
              return;
            }
            saveBtn.disabled = true;
            setSaveLabel('Saving…');
            Promise.resolve(global.OporaSave.save(slug, payload)).then(function () {
              setSaveLabel('Saved to Library');
              setTimeout(paintSaveIdle, 2800);
            }).catch(function (err) {
              paintSaveIdle();
              if (err && err.status === 402) toastPdf('You’ve hit your plan limit. Upgrade to save more.', 'error');
              else toastPdf((err && err.message) || 'Save failed — please try again.', 'error');
            });
          }
          if (global.OporaActionBar && typeof global.OporaActionBar.openGuestSaveInPlace === 'function') {
            global.OporaActionBar.openGuestSaveInPlace(slug, payload, {
              returnToTool: true,
              title: 'Save this result',
              tagline: 'Create a free account to edit, duplicate, and access this result across devices.',
              onAuthed: runCalcLibrarySave
            });
            return;
          }
          if (global.OporaAuth && typeof global.OporaAuth.openModal === 'function') {
            try {
              sessionStorage.setItem('opora_pending_save_d4', JSON.stringify({ toolSlug: slug, payload: payload }));
            } catch (eStash) { /* noop */ }
            try {
              document.cookie = 'opora_post_save_dest=; path=/; domain=.oporasupply.com; max-age=0; Secure';
            } catch (eCookie) { /* noop */ }
            global.OporaAuth.openModal({
              intent: 'sign-up',
              inPlace: true,
              title: 'Save this result',
              tagline: 'Create a free account to edit, duplicate, and access this result across devices.',
              onAuthed: runCalcLibrarySave
            });
            return;
          }
          if (global.OporaActionBar && typeof global.OporaActionBar.guestSaveThenAuth === 'function') {
            global.OporaActionBar.guestSaveThenAuth(slug, payload, 'sign-up', { returnToTool: true });
            return;
          }
          requireSignedIn('Sign in to save');
          return;
        }

        if (!global.OporaSave || typeof global.OporaSave.save !== 'function') {
          toastPdf('Save is unavailable right now.', 'error');
          return;
        }
        saveBtn.disabled = true;
        setSaveLabel('Saving…');
        Promise.resolve(global.OporaSave.save(slug, payload)).then(function () {
          setSaveLabel('Saved to Library');
          toastPdf('Saved to your Opora library', 'success');
          setTimeout(paintSaveIdle, 2800);
        }).catch(function (err) {
          paintSaveIdle();
          if (err && err.status === 402) {
            toastPdf('You’ve hit your plan limit. Upgrade to save more.', 'error');
          } else {
            toastPdf((err && err.message) || 'Save failed — please try again.', 'error');
          }
        });
      });
    }

    bindRunCounts(root, slug);
    syncExportAuthUI(root);
    document.addEventListener('clerk:loaded', function () { syncExportAuthUI(root); });
    if (global.Clerk && typeof global.Clerk.addListener === 'function') {
      try {
        global.Clerk.addListener(function () { syncExportAuthUI(root); });
      } catch (e) { /* noop */ }
    }

    // Prefill defaults → labeled Sample until Calculate; email/Save stay hidden
    run({ record: false });

    /* Hire Right → 1099: after sessionStorage/URL prefill, run once with real numbers */
    if (slug === '1099-vs-w2-calculator') {
      try {
        var autoKey = 'opora_autorun_1099-vs-w2-calculator';
        if (sessionStorage.getItem(autoKey) === '1') {
          sessionStorage.removeItem(autoKey);
          setTimeout(function () { run({ record: true, scroll: false }); }, 480);
        }
      } catch (eAuto) { /* noop */ }
    }
  }

  function boot() {
    document.querySelectorAll('.opora-calc, [data-opora-calc]').forEach(mount);
  }

  global.OporaCalc = {
    register: register,
    get: get,
    mount: mount,
    boot: boot,
    _registry: registry
  };

  function scheduleBoot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      setTimeout(boot, 0);
    }
  }

  scheduleBoot();
})(window);
